/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 81);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(89)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 2 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(63);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Nav_vue__ = __webpack_require__(40);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab44cd22_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Nav_vue__ = __webpack_require__(104);
function injectStyle (ssrContext) {
  __webpack_require__(102)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Nav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab44cd22_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Nav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hero_vue__ = __webpack_require__(42);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d65c112_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hero_vue__ = __webpack_require__(107);
function injectStyle (ssrContext) {
  __webpack_require__(105)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6d65c112"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hero_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d65c112_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hero_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4eb5bd53_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(111);
function injectStyle (ssrContext) {
  __webpack_require__(108)
}
var normalizeComponent = __webpack_require__(2)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4eb5bd53"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4eb5bd53_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WidgetProviders_vue__ = __webpack_require__(46);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9f4d09dc_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WidgetProviders_vue__ = __webpack_require__(133);
function injectStyle (ssrContext) {
  __webpack_require__(126)
  __webpack_require__(128)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9f4d09dc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WidgetProviders_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9f4d09dc_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WidgetProviders_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(99);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("51e168fa", content, true, {});

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(100);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("2f786ece", content, true, {});

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(101);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("13db944e", content, true, {});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subhero_vue__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subhero_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subhero_vue__);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_593b0e68_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subhero_vue__ = __webpack_require__(114);
function injectStyle (ssrContext) {
  __webpack_require__(112)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-593b0e68"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subhero_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_593b0e68_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subhero_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d964b2e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WidgetAuthor_vue__ = __webpack_require__(117);
function injectStyle (ssrContext) {
  __webpack_require__(115)
}
var normalizeComponent = __webpack_require__(2)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4d964b2e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d964b2e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WidgetAuthor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WidgetFeaturedBlock_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WidgetFeaturedBlock_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WidgetFeaturedBlock_vue__);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_131d7e5d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WidgetFeaturedBlock_vue__ = __webpack_require__(122);
function injectStyle (ssrContext) {
  __webpack_require__(118)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-131d7e5d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WidgetFeaturedBlock_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_131d7e5d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WidgetFeaturedBlock_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WidgetFeaturedOn_vue__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WidgetFeaturedOn_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WidgetFeaturedOn_vue__);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02b0e71f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WidgetFeaturedOn_vue__ = __webpack_require__(125);
function injectStyle (ssrContext) {
  __webpack_require__(123)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-02b0e71f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WidgetFeaturedOn_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02b0e71f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WidgetFeaturedOn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9ddf212_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WidgetFaq_vue__ = __webpack_require__(136);
function injectStyle (ssrContext) {
  __webpack_require__(134)
}
var normalizeComponent = __webpack_require__(2)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f9ddf212"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9ddf212_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WidgetFaq_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WidgetArticlesRelated_vue__ = __webpack_require__(49);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fd4444a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WidgetArticlesRelated_vue__ = __webpack_require__(139);
function injectStyle (ssrContext) {
  __webpack_require__(137)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1fd4444a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WidgetArticlesRelated_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fd4444a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WidgetArticlesRelated_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = function escape(url) {
    if (typeof url !== 'string') {
        return url
    }
    // If url is already wrapped in quotes, remove them
    if (/^['"].*['"]$/.test(url)) {
        url = url.slice(1, -1);
    }
    // Should url be wrapped?
    // See https://drafts.csswg.org/css-values-3/#urls
    if (/["'() \t\n]/.test(url)) {
        return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"'
    }

    return url
}


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "arrow_form.svg?123bd9a3b5c18f4a106e956ddd34c8f8";

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "flag_france.png?8608e4ab3f000af77e4e2c8a35703cac";

/***/ }),
/* 20 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "flag_uk.png?95f5a216dd59fe47ef783612f860380a";

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WidgetIllustrations_vue__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WidgetIllustrations_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WidgetIllustrations_vue__);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dfe695a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WidgetIllustrations_vue__ = __webpack_require__(149);
function injectStyle (ssrContext) {
  __webpack_require__(144)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1dfe695a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WidgetIllustrations_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dfe695a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WidgetIllustrations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WidgetSliderMonitoScore_vue__ = __webpack_require__(75);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38e172a0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WidgetSliderMonitoScore_vue__ = __webpack_require__(233);
function injectStyle (ssrContext) {
  __webpack_require__(229)
  __webpack_require__(231)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-38e172a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WidgetSliderMonitoScore_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38e172a0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WidgetSliderMonitoScore_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WidgetDetailsMonitoScore_vue__ = __webpack_require__(76);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_523bef48_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WidgetDetailsMonitoScore_vue__ = __webpack_require__(236);
function injectStyle (ssrContext) {
  __webpack_require__(234)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-523bef48"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WidgetDetailsMonitoScore_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_523bef48_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WidgetDetailsMonitoScore_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WidgetBreadcrum_vue__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WidgetBreadcrum_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WidgetBreadcrum_vue__);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fb60fcd_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WidgetBreadcrum_vue__ = __webpack_require__(239);
function injectStyle (ssrContext) {
  __webpack_require__(237)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6fb60fcd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WidgetBreadcrum_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fb60fcd_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WidgetBreadcrum_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 26 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "monito_logo.svg?a102c5fd1d1189a6fbd893a6acf107fc";

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "arrow_down.svg?640ef204446d6f703aff3868b5535649";

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "flag_usa.png?f12ac269d6bb87056e499db9f38b4d36";

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "flag_phil.png?16e152137eb1d5d98601c162b8b5e70e";

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "flag_new_zealand.png?a9545be326cf9efaca8d3c53ee28359c";

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "flag_cameroun.png?3ba7416d385e520a4f36c0f78fca6c1d";

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "flag_aus.png?eacdd6d979461a1830530935f43de4a6";

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "flag_sgp.png?45dfbe41c1510aa088ec62c62baff3e7";

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "flag_ind.png?7a6c6ac6b10190b48ebfb7e8f325b38a";

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "flag_swiss.png?6758dc2142507249024737cde79aedae";

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
     data: function data() {
          return {
               form: false
          };
     }
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_scss_toolbox_fonts_scss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_scss_toolbox_fonts_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_scss_toolbox_fonts_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_scss_toolbox_margin_padding_scss__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_scss_toolbox_margin_padding_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_scss_toolbox_margin_padding_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_scss_toolbox_layout_scss__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_scss_toolbox_layout_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_scss_toolbox_layout_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Nav_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Hero_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Footer_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Subhero_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__WidgetAuthor_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__WidgetFeaturedBlock_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__WidgetFeaturedOn_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__WidgetProviders_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__WidgetFaq_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__WidgetArticlesRelated_vue__ = __webpack_require__(16);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      herotype: 'darkmode',
      heroForm: true,
      extForm: true,
      scrollingActive: true,
      sliderForm: false,
      urlBackground: 'https://images.prismic.io/monito/9104871750b618a803702b821c687eea5f0c73c1_venmo-international-money-transfer.jpeg',
      providers: [{ logo: 'public/review_ria.png',
        url: 'https://www.monito.com/en/send-money-with/ria?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=provider_carousel',
        score: '5.8' }, { logo: 'public/review_worldremit.png',
        url: 'https://www.monito.com/en/send-money-with/worldremit?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=provider_carousel',
        score: '8.3' }, { logo: 'public/review_paypal.png',
        url: 'https://www.monito.com/en/send-money-with/paypal?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=provider_carousel',
        score: '5.1' }, { logo: 'public/review_remitly.png',
        url: 'https://www.monito.com/en/send-money-with/remitly?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=provider_carousel',
        score: '7.6' }, { logo: 'public/review_transferwise.png',
        url: 'https://www.monito.com/en/send-money-with/transferwise?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=provider_carousel',
        score: '8.8' }, { logo: 'public/review_skrill.png',
        url: 'https://www.monito.com/en/send-money-with/skrill?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=provider_carousel',
        score: '8.3' }],
      articles: [{ cover: 'https://images.prismic.io/monito/dd9100c21fa169148f105678a8ba45047025dce4_keyboard-typing-sending-money-online.jpg',
        url: 'https://www.monito.com/en/wiki/what-is-the-cheapest-way-to-send-money-abroad?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=related_content',
        title: 'Find the Cheapest Way to Send Money Abroad',
        date_author: 'Apr. 15, 2019  -  by François Briod' }, { cover: 'https://images.prismic.io/monito/b8d2f5539c4cbf71088d90a7985ba1d37ffade26_artem-bali-659437-unsplash-5.jpg',
        url: 'https://www.monito.com/en/wiki/zelle-international-money-transfer-alternatives?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=related_content',
        title: 'Can I use Zelle to send money Internationally? No! Find alternatives now',
        date_author: 'Mar. 28, 2019  -  by François Briod' }, { cover: 'https://images.prismic.io/monito/d2d5b77ee0ed5cbc9494376cdd1ad510409469c7_cheetah-running-hero.jpg',
        url: 'https://www.monito.com/en/wiki/what-is-the-fastest-way-to-send-money-abroad?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=related_content',
        title: 'Find the Fastest Way to Send Money Abroad',
        date_author: 'Nov. 14, 2019' }, { cover: 'https://www.monito.com/tawipages/images/prismic/eaee3cd7169be1fe0363a708de2e97fa4622501c_best-international-bank-accounts-for-digital-nomads-laptop-money.jpg',
        url: 'https://www.monito.com/en/wiki/what-is-the-fastest-way-to-send-money-abroad?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=related_content',
        title: 'The best international bank accounts for digital nomads, travelers & expats',
        date_author: 'Nov. 14, 2018  -  by Caroline Sieg' }]
    };
  },

  methods: {
    handleScroll: function handleScroll(event) {
      // hauteur de la zone de scroll
      //this.scroll_zone = this.$refs.scroll_zone.clientHeight;
      var bodyRect = document.body.getBoundingClientRect(),
          container_width = this.$refs.main.clientWidth,
          aside = this.$refs.scroll_widgets.getBoundingClientRect(),
          scroll_zone = this.$refs.scroll_zone.getBoundingClientRect(),
          left = scroll_zone.right,
          aside_width = this.$refs.scroll_widgets.clientWidth,
          scroll_zone_width = this.$refs.scroll_zone.clientWidth,
          aside_height = this.$refs.scroll_widgets.clientHeight,
          scroll_zone_height = this.$refs.scroll_zone.clientHeight,


      // position top de la zone de scroll
      offset_scroll_zone = scroll_zone.top - bodyRect.top;
      var position_x_aside = scroll_zone.top - bodyRect.top;

      var bottom_main_content = offset_scroll_zone + scroll_zone_height;
      var windows_width = window.innerWidth;

      // valeur du scoll de la page
      var y = window.scrollY;
      var debut_scroll = 0;

      if (windows_width > 980) {
        this.scrollingActive = true;
      } else {
        this.scrollingActive = false;
      }

      if (this.scrollingActive == true) {
        if (y > position_x_aside - 20) {
          if (y <= bottom_main_content - aside_height - 20) {
            this.$refs.scroll_widgets.style.position = 'fixed';
            this.$refs.scroll_widgets.style.left = left + (container_width - (scroll_zone_width + aside_width)) + 'px';
            this.$refs.scroll_widgets.style.top = 20 + 'px';
          } else {
            this.$refs.scroll_widgets.style.top = scroll_zone_height - aside_height + 'px';
            this.$refs.scroll_widgets.style.position = 'absolute';
            this.$refs.scroll_widgets.style.left = '';
          }
        } else {
          this.$refs.scroll_widgets.style.top = '0px';
          this.$refs.scroll_widgets.style.position = 'absolute';
          this.$refs.scroll_widgets.style.left = '';
        }
      } else {
        this.$refs.scroll_widgets.style.top = '';
        this.$refs.scroll_widgets.style.position = 'relative';
        this.$refs.scroll_widgets.style.left = '';
      }
    }
  },
  components: {
    'app-navigation': __WEBPACK_IMPORTED_MODULE_3__Nav_vue__["a" /* default */],
    'app-hero-section': __WEBPACK_IMPORTED_MODULE_4__Hero_vue__["a" /* default */],
    'app-subhero-section': __WEBPACK_IMPORTED_MODULE_6__Subhero_vue__["default"],
    'widget-text-featured-block': __WEBPACK_IMPORTED_MODULE_8__WidgetFeaturedBlock_vue__["default"],
    'widget-featured-on': __WEBPACK_IMPORTED_MODULE_9__WidgetFeaturedOn_vue__["default"],
    'widget-providers': __WEBPACK_IMPORTED_MODULE_10__WidgetProviders_vue__["a" /* default */],
    'widget-articles': __WEBPACK_IMPORTED_MODULE_12__WidgetArticlesRelated_vue__["a" /* default */],
    'app-footer': __WEBPACK_IMPORTED_MODULE_5__Footer_vue__["a" /* default */],
    'widget-faq': __WEBPACK_IMPORTED_MODULE_11__WidgetFaq_vue__["a" /* default */],
    'widget-author': __WEBPACK_IMPORTED_MODULE_7__WidgetAuthor_vue__["a" /* default */]
  },
  created: function created() {
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleScroll);
  }
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
     data: function data() {
          return {};
     }
});

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "arrow_hero_looping.svg?56b735a17191570fe67ffd734394963b";

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  props: ['herotype', 'urlBackground']
});

/***/ }),
/* 43 */
/***/ (function(module, exports) {

//
//
//
//
//
//

/***/ }),
/* 44 */
/***/ (function(module, exports) {

//
//
//
//
//
//

/***/ }),
/* 45 */
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CircleScore_vue__ = __webpack_require__(47);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['providers'],
	components: {
		'element-circle-score': __WEBPACK_IMPORTED_MODULE_0__CircleScore_vue__["a" /* default */]
	}
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CircleScore_vue__ = __webpack_require__(48);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_324120ca_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CircleScore_vue__ = __webpack_require__(132);
function injectStyle (ssrContext) {
  __webpack_require__(130)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-324120ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CircleScore_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_324120ca_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CircleScore_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({

  props: ['score', 'width', 'stroke', 'size'],
  methods: {
    getColorScore: function getColorScore(score) {
      if (score >= '8.0') {
        return 'excellent';
      } else if (score >= '7.0') {
        return 'good';
      } else if (score >= '6.5') {
        return 'average';
      } else if (score >= '5.0') {
        return 'poor';
      } else {
        return 'bad';
      }
    },
    half: function half(nombre) {
      return nombre / 2;
    },
    getMonitoScore: function getMonitoScore(score) {
      var value = score * 10 * (Math.round(2 * Math.PI * (this.half(this.width) - this.stroke)) / 100);
      return value;
    }
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['articles'],
	methods: {
		nbrArticle: function nbrArticle(list) {
			if (list.length <= 7) {
				if (list.length == 4) {
					return 'grid-4';
				} else if (list.length == 3) {
					return 'grid-3';
				} else {
					return 'grid-7';
				}
			}
		}
	}
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_scss_toolbox_fonts_scss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_scss_toolbox_fonts_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_scss_toolbox_fonts_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_scss_toolbox_margin_padding_scss__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_scss_toolbox_margin_padding_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_scss_toolbox_margin_padding_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_scss_toolbox_layout_scss__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_scss_toolbox_layout_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_scss_toolbox_layout_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Nav_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Hero_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Footer_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Subhero_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__WidgetAuthor_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__WidgetFeaturedBlock_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__WidgetIllustrations_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__WidgetFeaturedOn_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__WidgetProviders_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__WidgetFaq_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__WidgetArticlesRelated_vue__ = __webpack_require__(16);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      herotype: 'home',
      urlBackground: '',
      providers: [{ logo: 'public/review_ria.png', url: 'ria.com', score: '5.8' }, { logo: 'public/review_worldremit.png', url: 'paypal.com', score: '8.3' }, { logo: 'public/review_paypal.png', url: 'paypal.com', score: '5.1' }, { logo: 'public/review_remitly.png', url: 'paypal.com', score: '7.6' }, { logo: 'public/review_transfergo.png', url: 'paypal.com', score: '8.2' }, { logo: 'public/review_western.png', url: 'paypal.com', score: '7.9' }, { logo: 'public/review_transferwise.png', url: 'paypal.com', score: '8.8' }, { logo: 'public/review_xendpay.png', url: 'paypal.com', score: '6.6' }, { logo: 'public/review_skrill.png', url: 'paypal.com', score: '8.3' }],
      articles: [{ cover: 'https://images.prismic.io/monito/dd9100c21fa169148f105678a8ba45047025dce4_keyboard-typing-sending-money-online.jpg',
        url: 'https://www.monito.com/en/wiki/what-is-the-cheapest-way-to-send-money-abroad',
        title: 'Find the Cheapest Way to Send Money Abroad',
        date_author: 'Apr. 15, 2019  -  by François Briod' }, { cover: 'https://images.prismic.io/monito/b8d2f5539c4cbf71088d90a7985ba1d37ffade26_artem-bali-659437-unsplash-5.jpg',
        url: 'https://www.monito.com/en/wiki/zelle-international-money-transfer-alternatives',
        title: 'Can I use Zelle to send money Internationally? No! Find alternatives now',
        date_author: 'Mar. 28, 2019  -  by François Briod' }, { cover: 'https://images.prismic.io/monito/prismic/d2d5b77ee0ed5cbc9494376cdd1ad510409469c7_cheetah-running-hero.jpg',
        url: 'https://www.monito.com/en/wiki/what-is-the-fastest-way-to-send-money-abroad',
        title: 'Find the Fastest Way to Send Money Abroad',
        date_author: 'Nov. 14, 2019' }, { cover: '',
        url: 'https://www.monito.com/en/wiki/square-cash-international-money-transfer-alternatives',
        title: 'Can I use Square Cash to send money Internationally?',
        date_author: 'Oct. 01, 2019' }, { cover: 'https://images.prismic.io/monito/eaee3cd7169be1fe0363a708de2e97fa4622501c_best-international-bank-accounts-for-digital-nomads-laptop-money.jpg',
        url: 'https://www.monito.com/en/wiki/what-is-the-fastest-way-to-send-money-abroad',
        title: 'The best international bank accounts for digital nomads, travelers & expats',
        date_author: 'Nov. 14, 2018  -  by Caroline Sieg' }]
    };
  },

  methods: {
    handleScroll: function handleScroll(event) {
      // hauteur de la zone de scroll
      //this.scroll_zone = this.$refs.scroll_zone.clientHeight;
      var bodyRect = document.body.getBoundingClientRect(),
          container_width = this.$refs.main.clientWidth,
          aside = this.$refs.scroll_widgets.getBoundingClientRect(),
          scroll_zone = this.$refs.scroll_zone.getBoundingClientRect(),
          left = scroll_zone.right,
          aside_width = this.$refs.scroll_widgets.clientWidth,
          scroll_zone_width = this.$refs.scroll_zone.clientWidth,
          aside_height = this.$refs.scroll_widgets.clientHeight,
          scroll_zone_height = this.$refs.main.clientHeight,


      // position top de la zone de scroll
      offset_scroll_zone = scroll_zone.top - bodyRect.top;
      var position_x_aside = scroll_zone.top - bodyRect.top;

      var bottom_main_content = offset_scroll_zone + scroll_zone_height;

      // valeur du scoll de la page
      var y = window.scrollY;
      var debut_scroll = 0;

      if (y > position_x_aside - 20) {
        if (y <= bottom_main_content - aside_height - 20) {
          this.$refs.scroll_widgets.style.position = 'fixed';
          this.$refs.scroll_widgets.style.left = left + (container_width - (scroll_zone_width + aside_width)) + 'px';
          this.$refs.scroll_widgets.style.top = 20 + 'px';
        } else {
          this.$refs.scroll_widgets.style.top = scroll_zone_height - aside_height + 'px';
          this.$refs.scroll_widgets.style.position = 'absolute';
          this.$refs.scroll_widgets.style.left = '';
        }
      } else {
        this.$refs.scroll_widgets.style.top = '0px';
        this.$refs.scroll_widgets.style.position = 'absolute';
        this.$refs.scroll_widgets.style.left = '';
      }
    }
  },
  components: {
    'app-navigation': __WEBPACK_IMPORTED_MODULE_3__Nav_vue__["a" /* default */],
    'app-hero-section': __WEBPACK_IMPORTED_MODULE_4__Hero_vue__["a" /* default */],
    'app-subhero-section': __WEBPACK_IMPORTED_MODULE_6__Subhero_vue__["default"],
    'widget-text-featured-block': __WEBPACK_IMPORTED_MODULE_8__WidgetFeaturedBlock_vue__["default"],
    'widget-featured-on': __WEBPACK_IMPORTED_MODULE_10__WidgetFeaturedOn_vue__["default"],
    'widget-providers': __WEBPACK_IMPORTED_MODULE_11__WidgetProviders_vue__["a" /* default */],
    'widget-articles': __WEBPACK_IMPORTED_MODULE_13__WidgetArticlesRelated_vue__["a" /* default */],
    'app-footer': __WEBPACK_IMPORTED_MODULE_5__Footer_vue__["a" /* default */],
    'widget-faq': __WEBPACK_IMPORTED_MODULE_12__WidgetFaq_vue__["a" /* default */],
    'widget-author': __WEBPACK_IMPORTED_MODULE_7__WidgetAuthor_vue__["a" /* default */],
    'widget-illustrations': __WEBPACK_IMPORTED_MODULE_9__WidgetIllustrations_vue__["default"]
  },
  created: function created() {
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleScroll);
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

//
//
//
//
//
//

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_scss_toolbox_fonts_scss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_scss_toolbox_fonts_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_scss_toolbox_fonts_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_scss_toolbox_margin_padding_scss__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_scss_toolbox_margin_padding_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_scss_toolbox_margin_padding_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_scss_toolbox_layout_scss__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_scss_toolbox_layout_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_scss_toolbox_layout_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Nav_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Hero_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Footer_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Subhero_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__WidgetAuthor_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__WidgetFeaturedBlock_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__WidgetIllustrations_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__WidgetFeaturedOn_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__WidgetProviders_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__WidgetFaq_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__WidgetArticlesRelated_vue__ = __webpack_require__(16);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      herotype: 'home',
      urlBackground: '',
      providers: [{ logo: 'public/review_ria.png', url: 'ria.com', score: '5.8' }, { logo: 'public/review_worldremit.png', url: 'paypal.com', score: '8.3' }, { logo: 'public/review_paypal.png', url: 'paypal.com', score: '5.1' }, { logo: 'public/review_remitly.png', url: 'paypal.com', score: '7.6' }, { logo: 'public/review_transfergo.png', url: 'paypal.com', score: '8.2' }, { logo: 'public/review_western.png', url: 'paypal.com', score: '7.9' }, { logo: 'public/review_transferwise.png', url: 'paypal.com', score: '8.8' }, { logo: 'public/review_xendpay.png', url: 'paypal.com', score: '6.6' }, { logo: 'public/review_skrill.png', url: 'paypal.com', score: '8.3' }],
      articles: [{ cover: 'https://images.prismic.io/monito/dd9100c21fa169148f105678a8ba45047025dce4_keyboard-typing-sending-money-online.jpg',
        url: 'https://www.monito.com/en/wiki/what-is-the-cheapest-way-to-send-money-abroad',
        title: 'Find the Cheapest Way to Send Money Abroad',
        date_author: 'Apr. 15, 2019  -  by François Briod' }, { cover: 'https://images.prismic.io/monito/b8d2f5539c4cbf71088d90a7985ba1d37ffade26_artem-bali-659437-unsplash-5.jpg',
        url: 'https://www.monito.com/en/wiki/zelle-international-money-transfer-alternatives',
        title: 'Can I use Zelle to send money Internationally? No! Find alternatives now',
        date_author: 'Mar. 28, 2019  -  by François Briod' }, { cover: 'https://images.prismic.io/monito/prismic/d2d5b77ee0ed5cbc9494376cdd1ad510409469c7_cheetah-running-hero.jpg',
        url: 'https://www.monito.com/en/wiki/what-is-the-fastest-way-to-send-money-abroad',
        title: 'Find the Fastest Way to Send Money Abroad',
        date_author: 'Nov. 14, 2019' }, { cover: '',
        url: 'https://www.monito.com/en/wiki/square-cash-international-money-transfer-alternatives',
        title: 'Can I use Square Cash to send money Internationally?',
        date_author: 'Oct. 01, 2019' }, { cover: 'https://images.prismic.io/monito/eaee3cd7169be1fe0363a708de2e97fa4622501c_best-international-bank-accounts-for-digital-nomads-laptop-money.jpg',
        url: 'https://www.monito.com/en/wiki/what-is-the-fastest-way-to-send-money-abroad',
        title: 'The best international bank accounts for digital nomads, travelers & expats',
        date_author: 'Nov. 14, 2018  -  by Caroline Sieg' }]
    };
  },

  methods: {
    handleScroll: function handleScroll(event) {
      // hauteur de la zone de scroll
      //this.scroll_zone = this.$refs.scroll_zone.clientHeight;
      var bodyRect = document.body.getBoundingClientRect(),
          container_width = this.$refs.main.clientWidth,
          aside = this.$refs.scroll_widgets.getBoundingClientRect(),
          scroll_zone = this.$refs.scroll_zone.getBoundingClientRect(),
          left = scroll_zone.right,
          aside_width = this.$refs.scroll_widgets.clientWidth,
          scroll_zone_width = this.$refs.scroll_zone.clientWidth,
          aside_height = this.$refs.scroll_widgets.clientHeight,
          scroll_zone_height = this.$refs.main.clientHeight,


      // position top de la zone de scroll
      offset_scroll_zone = scroll_zone.top - bodyRect.top;
      var position_x_aside = scroll_zone.top - bodyRect.top;

      var bottom_main_content = offset_scroll_zone + scroll_zone_height;

      // valeur du scoll de la page
      var y = window.scrollY;
      var debut_scroll = 0;

      if (y > position_x_aside - 20) {
        if (y <= bottom_main_content - aside_height - 20) {
          this.$refs.scroll_widgets.style.position = 'fixed';
          this.$refs.scroll_widgets.style.left = left + (container_width - (scroll_zone_width + aside_width)) + 'px';
          this.$refs.scroll_widgets.style.top = 20 + 'px';
        } else {
          this.$refs.scroll_widgets.style.top = scroll_zone_height - aside_height + 'px';
          this.$refs.scroll_widgets.style.position = 'absolute';
          this.$refs.scroll_widgets.style.left = '';
        }
      } else {
        this.$refs.scroll_widgets.style.top = '0px';
        this.$refs.scroll_widgets.style.position = 'absolute';
        this.$refs.scroll_widgets.style.left = '';
      }
    }
  },
  components: {
    'app-navigation': __WEBPACK_IMPORTED_MODULE_3__Nav_vue__["a" /* default */],
    'app-hero-section': __WEBPACK_IMPORTED_MODULE_4__Hero_vue__["a" /* default */],
    'app-subhero-section': __WEBPACK_IMPORTED_MODULE_6__Subhero_vue__["default"],
    'widget-text-featured-block': __WEBPACK_IMPORTED_MODULE_8__WidgetFeaturedBlock_vue__["default"],
    'widget-featured-on': __WEBPACK_IMPORTED_MODULE_10__WidgetFeaturedOn_vue__["default"],
    'widget-providers': __WEBPACK_IMPORTED_MODULE_11__WidgetProviders_vue__["a" /* default */],
    'widget-articles': __WEBPACK_IMPORTED_MODULE_13__WidgetArticlesRelated_vue__["a" /* default */],
    'app-footer': __WEBPACK_IMPORTED_MODULE_5__Footer_vue__["a" /* default */],
    'widget-faq': __WEBPACK_IMPORTED_MODULE_12__WidgetFaq_vue__["a" /* default */],
    'widget-author': __WEBPACK_IMPORTED_MODULE_7__WidgetAuthor_vue__["a" /* default */],
    'widget-illustrations': __WEBPACK_IMPORTED_MODULE_9__WidgetIllustrations_vue__["default"]
  },
  created: function created() {
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleScroll);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Loading_vue__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Cheap_vue__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Fast_vue__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BestRated_vue__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PickPayout_vue__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PickInterestFull_vue__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PickPayin_vue__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Nav_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Hero_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__WidgetProviders_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Footer_vue__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      info: [],
      listsProvider: [],
      dataFetch: false,
      minimumLoading: true,
      fake_loading: false,
      onbording_filters: false,
      credit_card: true,
      debit_card: false,
      cheapView: true,
      fastView: false,
      bestView: false,
      minAmount: '',
      maxAmount: '',
      herotype: 'corridor',
      bank_transfer: true,
      pickReceiving: 'Bank transfer',
      pickInterest: 'cheap',
      scroll_zone: '0',
      providers: [{ logo: '/public/review_ria.png', url: 'ria.com', score: '5.8' }, { logo: '/public/review_worldremit.png', url: 'paypal.com', score: '8.3' }, { logo: '/public/review_paypal.png', url: 'paypal.com', score: '5.1' }, { logo: '/public/review_remitly.png', url: 'paypal.com', score: '7.6' }, { logo: '/public/review_transfergo.png', url: 'paypal.com', score: '8.2' }, { logo: '/public/review_western.png', url: 'paypal.com', score: '7.9' }, { logo: '/public/review_transferwise.png', url: 'paypal.com', score: '8.8' }, { logo: '/public/review_xendpay.png', url: 'paypal.com', score: '6.6' }, { logo: '/public/review_skrill.png', url: 'paypal.com', score: '8.3' }]
    };
  },

  methods: {
    closeOnbording: function closeOnbording() {
      this.onbording_filters = false, this.fake_loading = false;
    },
    getSpeedLabel: function getSpeedLabel(speed) {
      if (speed == '10') {
        return 'within minutes';
      }
      if (speed == '20') {
        return 'the same day';
      }
      if (speed == '30') {
        return 'the next day';
      }
      if (speed == '40') {
        return 'within 2 days';
      }
      if (speed == '50') {
        return 'within 3 to 5 days';
      }
    },
    getPayinLabelBlack: function getPayinLabelBlack(payin) {
      if (payin == 'bank_transfer') {
        return 'by bank transfer';
      }
      if (payin == 'credit_card') {
        return 'by credit card';
      }
      if (payin == 'debit_card') {
        return 'by debit card';
      }
    },
    getPayoutLabelBlack: function getPayoutLabelBlack(payout) {
      if (payout == 'bank_account') {
        return 'to a bank account';
      }
      if (payout == 'cash_pickup') {
        return 'to a cash pick-up location';
      }
      return payout;
    },
    getTransferBar: function getTransferBar(amount) {
      return 100 - (this.max - amount) / ((this.max - this.min) / 100) + '%';
    },
    getPspName: function getPspName(pspId) {
      return this.info.psp_list.find(function (item) {
        return item.id == pspId;
      }).info.label;
    },
    getPspLink: function getPspLink(pspId) {
      return this.info.psp_list.find(function (item) {
        return item.id == pspId;
      }).links.external;
    },
    getFrom: function getFrom(iso) {
      return this.country.find(function (item) {
        return item.iso == iso;
      }).label.from;
    },
    getTo: function getTo(iso) {
      return this.country.find(function (item) {
        return item.iso == iso;
      }).label.to;
    },
    getLogoPsp: function getLogoPsp(pspId) {
      return this.info.psp_list.find(function (item) {
        return item.id == pspId;
      }).info.img.md;
    },
    virgule: function virgule(value) {
      return value.toFixed(2) + ' ' + this.info.corridor.currency_from.iso_code;
    },
    handleScroll: function handleScroll(event) {
      // hauteur de la zone de scroll
      //this.scroll_zone = this.$refs.scroll_zone.clientHeight;
      var bodyRect = document.body.getBoundingClientRect(),
          container_width = this.$refs.main.clientWidth,
          aside = this.$refs.scroll_widgets.getBoundingClientRect(),
          scroll_zone = this.$refs.scroll_zone.getBoundingClientRect(),
          left = scroll_zone.right,
          aside_width = this.$refs.scroll_widgets.clientWidth,
          scroll_zone_width = this.$refs.scroll_zone.clientWidth,
          aside_height = this.$refs.scroll_widgets.clientHeight,
          scroll_zone_height = this.$refs.main.clientHeight,
          hauteur_zone_scroll = this.$refs.scroll_zone.clientHeight,


      // position top de la zone de scroll
      offset_scroll_zone = scroll_zone.top - bodyRect.top;
      var position_x_aside = scroll_zone.top - bodyRect.top;

      var bottom_main_content = offset_scroll_zone + scroll_zone_height;

      // valeur du scoll de la page
      var y = window.scrollY;
      var debut_scroll = 0;

      if (y > position_x_aside + 30) {
        if (y <= bottom_main_content - aside_height - 20) {
          this.$refs.scroll_widgets.style.position = 'fixed';
          this.$refs.scroll_widgets.style.left = left + (container_width - (scroll_zone_width + aside_width)) + 'px';
          this.$refs.scroll_widgets.style.top = 20 + 'px';
        } else {
          this.$refs.scroll_widgets.style.top = scroll_zone_height - aside_height + 'px';
          this.$refs.scroll_widgets.style.position = 'absolute';
          this.$refs.scroll_widgets.style.left = '';
        }
      } else {
        this.$refs.scroll_widgets.style.top = '50px';
        this.$refs.scroll_widgets.style.position = 'absolute';
        this.$refs.scroll_widgets.style.left = '';
      }
    },
    getTransferScore: function getTransferScore(amount) {
      function getBaseLog(x, y) {
        return Math.log(y) / Math.log(x);
      }
      if (0.5 / getBaseLog(1000, this.base_amount) * this.base_amount / 100 >= this.base_amount - amount) {
        return 'excellent';
      } else if (1.5 / getBaseLog(1000, this.base_amount) * this.base_amount / 100 >= this.base_amount - amount) {
        return 'good';
      } else if (2.5 / getBaseLog(1000, this.base_amount) * this.base_amount / 100 >= this.base_amount - amount) {
        return 'average';
      } else if (4 / getBaseLog(1000, this.base_amount) * this.base_amount / 100 >= this.base_amount - amount) {
        return 'poor';
      } else {
        return 'bad';
      }
    },
    virgule_rec: function virgule_rec(somme) {
      somme = somme.toFixed(0);
      var cut = 3;
      if (somme.length > 6) {
        var first_cut = somme.length - cut;
        var second_cut = somme.length - cut - cut;
        var start = somme.substring(0, second_cut);
        var middle = somme.substring(second_cut, first_cut);
        var end = somme.substring(first_cut, somme.length);
        somme = '' + start + ',' + middle + ',' + end + '';
        //somme = (''+start+','+end+'');
      } else if (somme.length > 3) {
        var first_cut = somme.length - cut;
        var start = somme.substring(0, first_cut);
        var end = somme.substring(first_cut, somme.length);
        somme = '' + start + ',' + end + '';
        //somme = (''+start+','+end+'');
      }
      return somme + ' ' + this.info.corridor.currency_to.iso_code;
    },
    virgule_amount_send: function virgule_amount_send(somme) {
      somme = somme.toFixed(0);
      var cut = 3;
      if (somme.length > 6) {
        var first_cut = somme.length - cut;
        var second_cut = somme.length - cut - cut;
        var start = somme.substring(0, second_cut);
        var middle = somme.substring(second_cut, first_cut);
        var end = somme.substring(first_cut, somme.length);
        somme = '' + start + ',' + middle + ',' + end + '';
        //somme = (''+start+','+end+'');
      } else if (somme.length > 3) {
        var first_cut = somme.length - cut;
        var start = somme.substring(0, first_cut);
        var end = somme.substring(first_cut, somme.length);
        somme = '' + start + ',' + end + '';
        //somme = (''+start+','+end+'');
      }
      return somme + ' ' + this.info.corridor.currency_from.iso_code;
    },
    premierProvider: function premierProvider(pspId) {
      if (this.listsProvider.indexOf(pspId) != -1) {} else {
        this.listsProvider.push(pspId);
      }
    },
    adapte: function adapte() {
      if (this.pickInterest == 'cheap') {
        this.cheapView = true;
        this.fastView = false;
        this.bestView = false;
      }
      if (this.pickInterest == 'fast') {
        this.cheapView = false;
        this.fastView = true;
        this.bestView = false;
      }
      if (this.pickInterest == 'best') {
        this.cheapView = false;
        this.fastView = false;
        this.bestView = true;
      }
    },

    randomIndex: function randomIndex() {
      return Math.floor(Math.random() * this.items.length);
    },
    amount: function amount(somme) {},

    add: function add() {
      this.items.splice(this.randomIndex(), 0, this.nextNum++);
    },
    remove: function remove() {
      this.items.splice(this.randomIndex(), 1);
    },
    shuffle: function shuffle() {
      this.items = _.shuffle(this.items);
    },
    test: function test() {
      var johns = _.map(this.info.results, function (o) {
        if (o.psp_id == "3") return o;
      });
    }
  },
  components: {
    'app-loading': __WEBPACK_IMPORTED_MODULE_0__Loading_vue__["a" /* default */],
    'app-cheap': __WEBPACK_IMPORTED_MODULE_1__Cheap_vue__["a" /* default */],
    'app-fast': __WEBPACK_IMPORTED_MODULE_2__Fast_vue__["a" /* default */],
    'app-best-rated': __WEBPACK_IMPORTED_MODULE_3__BestRated_vue__["a" /* default */],
    'app-pick-payout': __WEBPACK_IMPORTED_MODULE_4__PickPayout_vue__["a" /* default */],
    'app-pick-interest': __WEBPACK_IMPORTED_MODULE_5__PickInterestFull_vue__["a" /* default */],
    'app-pick-payin': __WEBPACK_IMPORTED_MODULE_6__PickPayin_vue__["a" /* default */],
    'app-navigation': __WEBPACK_IMPORTED_MODULE_8__Nav_vue__["a" /* default */],
    'app-hero-section': __WEBPACK_IMPORTED_MODULE_9__Hero_vue__["a" /* default */],
    'widget-providers': __WEBPACK_IMPORTED_MODULE_10__WidgetProviders_vue__["a" /* default */],
    'app-footer': __WEBPACK_IMPORTED_MODULE_11__Footer_vue__["a" /* default */]
  },
  watch: {
    pickInterest: 'adapte'

  },
  computed: {
    min: function min() {
      var vm = this;
      function min(a, b) {
        if (a < b) return -1;
        if (a > b) return 1;
        return 0;
      }

      function amount(data) {
        var a = [];
        if (data !== undefined) {
          for (var i = 0; i < data.length; i++) {
            a.push(data[i].costs.total_received_destination.toFixed(2));
          }
        }
        return a;
      }
      return amount(this.info.results).sort(min)[0];
    },
    base_amount: function base_amount() {
      return this.info.amount_usd.toFixed(2);
    },
    max: function max() {
      var vm = this;
      function max(a, b) {
        if (a > b) return -1;
        if (a < b) return 1;
        return 0;
      }

      function amount(data) {
        var a = [];
        if (data !== undefined) {
          for (var i = 0; i < data.length; i++) {
            a.push(data[i].costs.total_received_destination.toFixed(0));
          }
        }
        return a;
      }
      return amount(this.info.results).sort(max)[0];
    },
    list_payout: function list_payout() {
      var vm = this;
      function keep_one_payout(data) {
        var a = [];
        if (data !== undefined) {
          for (var i = 0; i < data.length; i++) {
            if (a.indexOf(Object.values(data[i].options.receiving)[0]) == '-1') {
              a.push(Object.values(data[i].options.receiving)[0]);
            }
          }
        }
        return a;
      }
      return keep_one_payout(this.info.results);
    },
    transferSpeed: function transferSpeed() {
      var vm = this;

      var a = [];
      for (var i = 0; i < data.length; i++) {
        if (data[i].transfer_time_product_rate == speed) {
          a.push(data[i]);
        }
      }
      return a;
    },
    sortedArray: function sortedArray() {
      var vm = this;
      function compare_cheap(a, b) {
        if (a.costs.total_fees < b.costs.total_fees) return -1;
        if (a.costs.total_fees > b.costs.total_fees) return 1;
        return 0;
      }

      function compare_fast(a, b) {
        if (a.transfer_time_product_rate < b.transfer_time_product_rate) return -1;
        if (a.transfer_time_product_rate > b.transfer_time_product_rate) return 1;
        if (a.costs.total_fees < b.costs.total_fees) return -1;
        if (a.costs.total_fees > b.costs.total_fees) return 1;
        return 0;
      }

      function compare_best(a, b) {
        if (vm.info.psp_list.find(function (item) {
          return item.id == a.psp_id;
        }).reviews.score.global > vm.info.psp_list.find(function (item) {
          return item.id == b.psp_id;
        }).reviews.score.global) return -1;
        if (vm.info.psp_list.find(function (item) {
          return item.id == a.psp_id;
        }).reviews.score.global < vm.info.psp_list.find(function (item) {
          return item.id == b.psp_id;
        }).reviews.score.global) return 1;
        if (a.costs.total_fees < b.costs.total_fees) return -1;
        if (a.costs.total_fees > b.costs.total_fees) return 1;
        return 0;
      }

      function psp_cheap(a, b) {
        if (a.psp_id < b.psp_id) return -1;
        if (a.psp_id > b.psp_id) return 1;
        if (a.costs.total_fees < b.costs.total_fees) return -1;
        if (a.costs.total_fees > b.costs.total_fees) return 1;
        return 0;
      }

      function psp_fast(a, b) {
        if (a.psp_id < b.psp_id) return -1;
        if (a.psp_id > b.psp_id) return 1;
        if (a.transfer_time_product_rate < b.transfer_time_product_rate) return -1;
        if (a.transfer_time_product_rate > b.transfer_time_product_rate) return 1;
        if (a.costs.total_fees < b.costs.total_fees) return -1;
        if (a.costs.total_fees > b.costs.total_fees) return 1;
        return 0;
      }

      function psp_best(a, b) {
        if (a.psp_id < b.psp_id) return -1;
        if (a.psp_id > b.psp_id) return 1;
        if (a.transfer_time_product_rate < b.transfer_time_product_rate) return -1;
        if (a.transfer_time_product_rate > b.transfer_time_product_rate) return 1;
        if (a.costs.total_fees < b.costs.total_fees) return -1;
        if (a.costs.total_fees > b.costs.total_fees) return 1;
        return 0;
      }

      function onlyScored(data) {

        var a = [],
            prev;
        for (var i = 0; i < data.length; i++) {
          if (vm.info.psp_list.find(function (item) {
            return item.id == data[i].psp_id;
          }).reviews.hasOwnProperty("score") == true) {
            a.push(data[i]);
          }
        }
        return a;
      }

      function keep_one_of_each(data) {

        var a = [],
            prev;
        for (var i = 0; i < data.length; i++) {
          if (data[i].psp_id !== prev) {
            a.push(data[i]);
          }
          prev = data[i].psp_id;
        }
        return a;
      }

      function pay_in(data) {

        var a = [];
        for (var i = 0; i < data.length; i++) {
          if (Object.keys(data[i].options.sending)[0] == 'bank_transfer' && vm.bank_transfer == true) {
            a.push(data[i]);
          }
          if (Object.keys(data[i].options.sending)[0] == 'credit_card' && vm.credit_card == true) {
            a.push(data[i]);
          }
          if (Object.keys(data[i].options.sending)[0] == 'debit_card' && vm.debit_card == true) {
            a.push(data[i]);
          }
        }
        return a;
      }

      function payout(element, index, array) {
        return Object.values(element.options.receiving)[0] == vm.pickReceiving;
      }

      function payin(element, index, array) {
        return Object.keys(element.options.sending)[0] == 'bank_transfer', 'debit_card';
      }

      if (this.cheapView == true) {
        var cheapList = pay_in(this.info.results.filter(payout).sort(psp_cheap));
        return keep_one_of_each(cheapList).sort(compare_cheap);
      } else if (this.fastView == true) {
        var fastList = pay_in(this.info.results.filter(payout).sort(psp_fast));
        return keep_one_of_each(fastList).sort(compare_fast);
      } else {
        var bestList = pay_in(this.info.results.filter(payout).sort(psp_best));
        return keep_one_of_each(onlyScored(bestList).sort(compare_best));
      }
    }
  },
  created: function created() {
    var _this = this;

    window.addEventListener('scroll', this.handleScroll);
    __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get('https://monito.com/v3/searches?country_fromUS&country_to=GB&currency_from=USD&currency_to=GBP&amount=400&locale=en').then(function (response) {
      return _this.info = JSON.parse(atob(response.data['d'].reduce(function (p, n) {
        return p + 'I' + n;
      }, '').slice(1))), console.log(_this.info);
    });
  },
  mounted: function mounted() {
    //this.handleScroll();
  }
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
     data: function data() {
          return {};
     }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProviderResult_vue__ = __webpack_require__(167);
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {};
	},

	props: ['info'],
	methods: {
		foisSix: function foisSix(value) {
			return value * 6;
		}
	},
	components: {
		'app-provider-result': __WEBPACK_IMPORTED_MODULE_0__ProviderResult_vue__["a" /* default */]
	}
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {};
	},

	props: ['info', 'dataFetch', 'minimumLoading'],
	methods: {
		sortedArrayCheap: function sortedArrayCheap() {
			function compare(a, b) {
				if (a.costs.total_fees < b.costs.total_fees) return -1;
				if (a.costs.total_fees > b.costs.total_fees) return 1;
				return 0;
			}
			return this.info.results.sort(compare);
		}
	}
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  props: ['sortedArray', 'getTransferScore', 'getLogoPsp', 'getTransferBar', 'virgule_rec', 'virgule', 'getPspLink', 'getPspName'],
  computed: {
    minutes: function minutes() {
      function time(element, index, array) {
        return element.transfer_time_product_rate == 10;
      }
      return this.sortedArray.filter(time);
    },
    sameDay: function sameDay() {
      function time(element, index, array) {
        return element.transfer_time_product_rate == 20;
      }
      return this.sortedArray.filter(time);
    },
    nextDay: function nextDay() {
      function time(element, index, array) {
        return element.transfer_time_product_rate == 30;
      }
      return this.sortedArray.filter(time);
    },
    twoDays: function twoDays() {
      function time(element, index, array) {
        return element.transfer_time_product_rate == 40;
      }
      return this.sortedArray.filter(time);
    },
    plusThreeDays: function plusThreeDays() {
      function time(element, index, array) {
        return element.transfer_time_product_rate == 50;
      }
      return this.sortedArray.filter(time);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {};
	},

	methods: {
		getScore: function getScore(psp_id) {
			if (this.info.psp_list.find(function (item) {
				return item.id == psp_id;
			}).reviews.hasOwnProperty("score") == true) {
				return this.info.psp_list.find(function (item) {
					return item.id == psp_id;
				}).reviews.score.global;
			}
			//
		},
		hasMonitoScore: function hasMonitoScore(psp_id) {
			this.info.psp_list.find(function (item) {
				return item.id == psp_id;
			}).reviews.hasOwnProperty("score");
		},
		getMonitoScore: function getMonitoScore(score) {
			var essai = score * 10 * 1.25;
			return essai;
		},
		getColorScore: function getColorScore(score) {
			if (score > '8.5') {
				return 'excellent';
			} else if (score > '7') {
				return 'good';
			} else if (score > '6') {
				return 'average';
			} else if (score > '5') {
				return 'poor';
			} else {
				return 'bad';
			}
		}
	},
	props: ['sortedArray', 'getTransferScore', 'info', 'getLogoPsp', 'getTransferBar', 'virgule_rec', 'virgule', 'getPspLink', 'getPspName']
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  props: ['list_payout', 'pickReceiving'],

  methods: {
    changePayout: function changePayout(value) {
      this.$emit('changePayout', value);
    },
    labelPayout: function labelPayout(value) {
      if (value == 'Bank transfer') {
        return 'Transfer to a bank account';
      } else if (value == 'Cash pickup') {
        return 'Transfer to a cash pick-up location';
      } else if (value == 'Cash home delivery') {
        return 'By cash home delivery';
      } else if (value == 'Mobile wallet') {
        return 'Via mobile wallet';
      } else if (value == 'Cash home delivery') {
        return 'By cash home delivery';
      } else if (value == 'Airtime top-up') {
        return 'Adding credit to a pre-paid phone';
      } else {
        return value;
      }
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {};
	},

	props: ['pickInterest'],
	methods: {
		changeInterest: function changeInterest(value) {
			this.$emit('changeInterest', value);
		}
	}
});

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icon_bank_account.svg?acaf0aeb757596f7ee5b554f9b9106e0";

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {};
	},

	props: ['credit_card', 'debit_card', 'bank_transfer'],

	methods: {
		creditCard: function creditCard() {
			if (this.bank_transfer == false && this.debit_card == false) {
				this.$emit('changeCreditCard', !this.credit_card);
				this.$emit('changeBankTransfer', !this.bank_transfer);
			}
			this.$emit('changeCreditCard', !this.credit_card);
		},
		debitCard: function debitCard() {
			if (this.bank_transfer == false && this.credit_card == false) {
				this.$emit('changeDebitCard', !this.debit_card);
				this.$emit('changeCreditCard', !this.credit_card);
			}
			this.$emit('changeDebitCard', !this.debit_card);
		},
		bankTransfer: function bankTransfer() {
			if (this.debit_card == false && this.credit_card == false) {
				this.$emit('changeBankTransfer', !this.bank_transfer);
				this.$emit('changeDebitCard', !this.debit_card);
			}
			this.$emit('changeBankTransfer', !this.bank_transfer);
		}
	}
});

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(3);
var normalizeHeaderName = __webpack_require__(202);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(67);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(67);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3);
var settle = __webpack_require__(203);
var buildURL = __webpack_require__(64);
var buildFullPath = __webpack_require__(205);
var parseHeaders = __webpack_require__(208);
var isURLSameOrigin = __webpack_require__(209);
var createError = __webpack_require__(68);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(210);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(204);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_scss_toolbox_fonts_scss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_scss_toolbox_fonts_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_scss_toolbox_fonts_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_scss_toolbox_margin_padding_scss__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_scss_toolbox_margin_padding_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_scss_toolbox_margin_padding_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_scss_toolbox_layout_scss__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_scss_toolbox_layout_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_scss_toolbox_layout_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Nav_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Hero_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Footer_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Subhero_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__WidgetAuthor_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__WidgetFeaturedBlock_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__WidgetFeaturedOn_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__WidgetProviders_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__WidgetFaq_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__WidgetArticlesRelated_vue__ = __webpack_require__(16);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      herotype: 'contentpage',
      scrollingActive: true,
      anchor: '01',
      urlBackground: 'https://images.prismic.io/monito/595e5e4bf13c1e6e728aceae610bb5ed7b216739_bank-londong-metro-station.jpg',
      providers: [{ logo: 'public/review_ria.png', url: 'ria.com', score: '5.8' }, { logo: 'public/review_worldremit.png', url: 'paypal.com', score: '8.3' }, { logo: 'public/review_paypal.png', url: 'paypal.com', score: '5.1' }, { logo: 'public/review_remitly.png', url: 'paypal.com', score: '7.6' }, { logo: 'public/review_transferwise.png', url: 'paypal.com', score: '8.8' }, { logo: 'public/review_skrill.png', url: 'paypal.com', score: '8.3' }],
      articles: [{ cover: 'https://images.prismic.io/monito/2c88dce81622b53cdb86db00c5c24fcde3758a11_home-office-2452806_1280.jpg',
        url: 'https://www.monito.com/en/wiki/best-way-freelancers-get-paid?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=related_content',
        title: 'The best way for freelancers to get paid',
        date_author: 'Apr. 15, 2019  -  by François Briod' }, { cover: 'https://images.prismic.io/monito/effa81034b062cc66ed8b15f32fd6e106112868e_buildings_usa.jpg',
        url: 'https://www.monito.com/en/wiki/open-bank-account-us-even-without-proof-residency?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=related_content',
        title: 'How to open a bank account online in the U.S. without proof of residency',
        date_author: 'Mar. 28, 2019  -  by François Briod' }, { cover: 'https://images.prismic.io/monito/f1e8a7c63bb75c8846f14a6ce4da502fbf2d3772_top-tips-for-digital-nomads-finance-money-transfers.png',
        url: 'https://www.monito.com/en/wiki/digital-nomads-getting-finances-right?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=related_content',
        title: 'Digital Nomads — Getting Your Finances Right',
        date_author: 'Feb. 28, 2020  -  by François Briod' }, { cover: 'https://images.prismic.io/monito/a56593dc-c364-433e-b8af-63bca2948b2f_denise-jans--gmtAa0Q5MI-unsplash.jpg',
        url: 'https://www.monito.com/en/wiki/open-bank-account-australia-even-without-proof-residency?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=related_content',
        title: 'How to open a bank account online in Australia without proof of residency',
        date_author: 'Jan. 20, 2020  -  by François Briod' }, { cover: '',
        url: 'https://www.monito.com/en/wiki/living-in-france',
        title: 'Living in France',
        date_author: 'Nov. 14, 2018' }, { cover: 'https://images.prismic.io/monito/eaee3cd7169be1fe0363a708de2e97fa4622501c_best-international-bank-accounts-for-digital-nomads-laptop-money.jpg',
        url: 'https://www.monito.com/en/wiki/best-international-bank-accounts-digital-nomads?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=related_content',
        title: 'The best international bank accounts for digital nomads, travelers & expats',
        date_author: 'Nov. 14, 2018' }, { cover: 'https://images.prismic.io/monito/c6446110f7fd98ea86127c6981abf32927e07f5e_toronto.jpg',
        url: 'https://www.monito.com/en/wiki/open-bank-account-canada-even-without-proof-residency',
        title: 'How to open a bank account in Canada without proof of residency',
        date_author: 'Jul. 17, 2019  -  by François Briod' }]
    };
  },

  methods: {
    handleScroll: function handleScroll(event) {
      // hauteur de la zone de scroll
      //this.scroll_zone = this.$refs.scroll_zone.clientHeight;

      var bodyRect = document.body.getBoundingClientRect(),
          container_width = this.$refs.main.clientWidth,
          aside = this.$refs.scroll_widgets.getBoundingClientRect(),
          anchor02 = this.$refs.anchor02.getBoundingClientRect(),
          anchor03 = this.$refs.anchor03.getBoundingClientRect(),
          anchor04 = this.$refs.anchor04.getBoundingClientRect(),
          scroll_zone = this.$refs.scroll_zone.getBoundingClientRect(),
          left = scroll_zone.right,
          aside_width = this.$refs.scroll_widgets.clientWidth,
          scroll_zone_width = this.$refs.scroll_zone.clientWidth,
          aside_height = this.$refs.scroll_widgets.clientHeight,
          scroll_zone_height = this.$refs.scroll_zone.clientHeight,


      // position top de la zone de scroll
      offset_scroll_zone = scroll_zone.top - bodyRect.top;
      var position_x_aside = scroll_zone.top - bodyRect.top;

      var bottom_main_content = offset_scroll_zone + scroll_zone_height;
      var windows_width = window.innerWidth;

      // valeur du scoll de la page
      var y = window.scrollY;
      var debut_scroll = 0;

      if (windows_width > 980) {
        this.scrollingActive = true;
      } else {
        this.scrollingActive = false;
      }

      if (this.scrollingActive == true) {
        if (y > position_x_aside - 20 + 655) {
          if (y <= bottom_main_content - aside_height - 20) {
            this.$refs.scroll_widgets.style.position = 'fixed';
            this.$refs.scroll_widgets.style.left = left + (container_width - (scroll_zone_width + aside_width)) + 'px';
            this.$refs.scroll_widgets.style.top = 20 + 'px';
          } else {
            this.$refs.scroll_widgets.style.top = scroll_zone_height - aside_height + 'px';
            this.$refs.scroll_widgets.style.position = 'absolute';
            this.$refs.scroll_widgets.style.left = '';
          }
        } else {
          this.$refs.scroll_widgets.style.top = '655px';
          this.$refs.scroll_widgets.style.position = 'absolute';
          this.$refs.scroll_widgets.style.left = '';
        }
      } else {
        this.$refs.scroll_widgets.style.position = 'relative';
        this.$refs.scroll_widgets.style.left = '';
        this.$refs.scroll_widgets.style.top = '';
      }

      if (anchor02.top < 190 && anchor03.top > 200) {
        $(".article_content ul li").removeClass('active');
        $(".article_content ul li:nth-child(2)").addClass('active');
      } else if (anchor03.top < 200 && anchor04.top > 300) {
        $(".article_content ul li").removeClass('active');
        $(".article_content ul li:nth-child(3)").addClass('active');
      } else if (anchor04.top < 300) {
        $(".article_content ul li").removeClass('active');
        $(".article_content ul li:nth-child(4)").addClass('active');
      } else if (anchor02.top > 190) {
        $(".article_content ul li").removeClass('active');
        $(".article_content ul li:nth-child(1)").addClass('active');
      } else {
        $(".article_content ul li").removeClass('active');
        $(".article_content ul li").css({ "background": "" });
        $("#anchor02").css({ "padding-right": "", "background": "", "left": "", "padding-left": "" });
      }

      if (anchor03.top < 200) {
        $(".article_content ul li a.btn_cta").removeClass('hide');
        $(".article_content ul li a.btn_cta").addClass('anime');
      } else {
        $(".article_content ul li a.btn_cta").addClass('hide');
      }
    },
    anchor01: function anchor01() {
      $([document.documentElement, document.body]).animate({
        scrollTop: $("#anchor01").offset().top - 40
      }, 1000);
    },
    anchor02: function anchor02() {
      $([document.documentElement, document.body]).animate({
        scrollTop: $("#anchor02").offset().top - 142
      }, 1000);
    },
    anchor03: function anchor03() {
      $([document.documentElement, document.body]).animate({
        scrollTop: $("#anchor03").offset().top - 40
      }, 1000);
    },
    anchor04: function anchor04() {
      $([document.documentElement, document.body]).animate({
        scrollTop: $("#anchor04").offset().top - 40
      }, 1000);
    }
  },
  components: {
    'app-navigation': __WEBPACK_IMPORTED_MODULE_3__Nav_vue__["a" /* default */],
    'app-hero-section': __WEBPACK_IMPORTED_MODULE_4__Hero_vue__["a" /* default */],
    'app-subhero-section': __WEBPACK_IMPORTED_MODULE_6__Subhero_vue__["default"],
    'widget-text-featured-block': __WEBPACK_IMPORTED_MODULE_8__WidgetFeaturedBlock_vue__["default"],
    'widget-featured-on': __WEBPACK_IMPORTED_MODULE_9__WidgetFeaturedOn_vue__["default"],
    'widget-providers': __WEBPACK_IMPORTED_MODULE_10__WidgetProviders_vue__["a" /* default */],
    'widget-articles': __WEBPACK_IMPORTED_MODULE_12__WidgetArticlesRelated_vue__["a" /* default */],
    'app-footer': __WEBPACK_IMPORTED_MODULE_5__Footer_vue__["a" /* default */],
    'widget-faq': __WEBPACK_IMPORTED_MODULE_11__WidgetFaq_vue__["a" /* default */],
    'widget-author': __WEBPACK_IMPORTED_MODULE_7__WidgetAuthor_vue__["a" /* default */]
  },
  created: function created() {
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleScroll);
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_scss_toolbox_fonts_scss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_scss_toolbox_fonts_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_scss_toolbox_fonts_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_scss_toolbox_margin_padding_scss__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_scss_toolbox_margin_padding_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_scss_toolbox_margin_padding_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_scss_toolbox_layout_scss__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_scss_toolbox_layout_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_scss_toolbox_layout_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Nav_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Hero_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Footer_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Subhero_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__WidgetAuthor_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__WidgetFeaturedBlock_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__WidgetFeaturedOn_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__WidgetProviders_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__WidgetFaq_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__WidgetArticlesRelated_vue__ = __webpack_require__(16);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      herotype: 'contentpage',
      scrollingActive: true,
      anchor: '01',
      urlBackground: 'https://images.prismic.io/monito/595e5e4bf13c1e6e728aceae610bb5ed7b216739_bank-londong-metro-station.jpg',
      providers: [{ logo: 'public/review_ria.png', url: 'ria.com', score: '5.8' }, { logo: 'public/review_worldremit.png', url: 'paypal.com', score: '8.3' }, { logo: 'public/review_paypal.png', url: 'paypal.com', score: '5.1' }, { logo: 'public/review_remitly.png', url: 'paypal.com', score: '7.6' }, { logo: 'public/review_transferwise.png', url: 'paypal.com', score: '8.8' }, { logo: 'public/review_skrill.png', url: 'paypal.com', score: '8.3' }],
      articles: [{ cover: 'https://images.prismic.io/monito/2c88dce81622b53cdb86db00c5c24fcde3758a11_home-office-2452806_1280.jpg',
        url: 'https://www.monito.com/en/wiki/best-way-freelancers-get-paid?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=related_content',
        title: 'The best way for freelancers to get paid',
        date_author: 'Apr. 15, 2019  -  by François Briod' }, { cover: 'https://images.prismic.io/monito/effa81034b062cc66ed8b15f32fd6e106112868e_buildings_usa.jpg',
        url: 'https://www.monito.com/en/wiki/open-bank-account-us-even-without-proof-residency?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=related_content',
        title: 'How to open a bank account online in the U.S. without proof of residency',
        date_author: 'Mar. 28, 2019  -  by François Briod' }, { cover: 'https://images.prismic.io/monito/f1e8a7c63bb75c8846f14a6ce4da502fbf2d3772_top-tips-for-digital-nomads-finance-money-transfers.png',
        url: 'https://www.monito.com/en/wiki/digital-nomads-getting-finances-right?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=related_content',
        title: 'Digital Nomads — Getting Your Finances Right',
        date_author: 'Feb. 28, 2020  -  by François Briod' }, { cover: 'https://images.prismic.io/monito/a56593dc-c364-433e-b8af-63bca2948b2f_denise-jans--gmtAa0Q5MI-unsplash.jpg',
        url: 'https://www.monito.com/en/wiki/open-bank-account-australia-even-without-proof-residency?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=related_content',
        title: 'How to open a bank account online in Australia without proof of residency',
        date_author: 'Jan. 20, 2020  -  by François Briod' }, { cover: '',
        url: 'https://www.monito.com/en/wiki/living-in-france',
        title: 'Living in France',
        date_author: 'Nov. 14, 2018' }, { cover: 'https://images.prismic.io/monito/eaee3cd7169be1fe0363a708de2e97fa4622501c_best-international-bank-accounts-for-digital-nomads-laptop-money.jpg',
        url: 'https://www.monito.com/en/wiki/best-international-bank-accounts-digital-nomads?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=related_content',
        title: 'The best international bank accounts for digital nomads, travelers & expats',
        date_author: 'Nov. 14, 2018' }, { cover: 'https://images.prismic.io/monito/c6446110f7fd98ea86127c6981abf32927e07f5e_toronto.jpg',
        url: 'https://www.monito.com/en/wiki/open-bank-account-canada-even-without-proof-residency',
        title: 'How to open a bank account in Canada without proof of residency',
        date_author: 'Jul. 17, 2019  -  by François Briod' }]
    };
  },

  methods: {
    handleScroll: function handleScroll(event) {
      // hauteur de la zone de scroll
      //this.scroll_zone = this.$refs.scroll_zone.clientHeight;

      var bodyRect = document.body.getBoundingClientRect(),
          container_width = this.$refs.main.clientWidth,
          aside = this.$refs.scroll_widgets.getBoundingClientRect(),
          anchor02 = this.$refs.anchor02.getBoundingClientRect(),
          anchor03 = this.$refs.anchor03.getBoundingClientRect(),
          anchor04 = this.$refs.anchor04.getBoundingClientRect(),
          anchor05 = this.$refs.anchor05.getBoundingClientRect(),
          anchor06 = this.$refs.anchor06.getBoundingClientRect(),
          scroll_zone = this.$refs.scroll_zone.getBoundingClientRect(),
          left = scroll_zone.right,
          aside_width = this.$refs.scroll_widgets.clientWidth,
          scroll_zone_width = this.$refs.scroll_zone.clientWidth,
          aside_height = this.$refs.scroll_widgets.clientHeight,
          scroll_zone_height = this.$refs.scroll_zone.clientHeight,


      // position top de la zone de scroll
      offset_scroll_zone = scroll_zone.top - bodyRect.top;
      var position_x_aside = scroll_zone.top - bodyRect.top;

      var bottom_main_content = offset_scroll_zone + scroll_zone_height;
      var windows_width = window.innerWidth;

      // valeur du scoll de la page
      var y = window.scrollY;
      var debut_scroll = 0;

      if (windows_width > 980) {
        this.scrollingActive = true;
      } else {
        this.scrollingActive = false;
      }

      if (this.scrollingActive == true) {
        if (y > position_x_aside - 20 + 232) {
          if (y <= bottom_main_content - aside_height - 20) {
            this.$refs.scroll_widgets.style.position = 'fixed';
            this.$refs.scroll_widgets.style.left = left + (container_width - (scroll_zone_width + aside_width)) + 'px';
            this.$refs.scroll_widgets.style.top = 20 + 'px';
          } else {
            this.$refs.scroll_widgets.style.top = scroll_zone_height - aside_height + 'px';
            this.$refs.scroll_widgets.style.position = 'absolute';
            this.$refs.scroll_widgets.style.left = '';
          }
        } else {
          this.$refs.scroll_widgets.style.top = '232px';
          this.$refs.scroll_widgets.style.position = 'absolute';
          this.$refs.scroll_widgets.style.left = '';
        }
      } else {
        this.$refs.scroll_widgets.style.position = 'relative';
        this.$refs.scroll_widgets.style.left = '';
        this.$refs.scroll_widgets.style.top = '';
      }

      if (anchor02.top < 190 && anchor03.top > 190) {
        $(".article_content ul li").removeClass('active');
        $(".article_content ul li:nth-child(2)").addClass('active');
      } else if (anchor03.top < 200 && anchor04.top > 200) {
        $(".article_content ul li").removeClass('active');
        $(".article_content ul li:nth-child(3)").addClass('active');
      } else if (anchor04.top < 200 && anchor05.top > 200) {
        $(".article_content ul li").removeClass('active');
        $(".article_content ul li:nth-child(4)").addClass('active');
      } else if (anchor05.top < 200 && anchor06.top > 200) {
        $(".article_content ul li").removeClass('active');
        $(".article_content ul li:nth-child(5)").addClass('active');
      } else if (anchor06.top < 200) {
        $(".article_content ul li").removeClass('active');
        $(".article_content ul li:nth-child(6)").addClass('active');
      } else {
        $(".article_content ul li").removeClass('active');
        $(".article_content ul li:nth-child(1)").addClass('active');
      }

      if (anchor02.bottom < 0) {
        $(".article_content ul li a.btn_cta").removeClass('hide');
        $(".article_content ul li a.btn_cta").addClass('anime');
      } else {
        $(".article_content ul li a.btn_cta").addClass('hide');
      }
    },
    anchor01: function anchor01() {
      $([document.documentElement, document.body]).animate({
        scrollTop: $("#anchor01").offset().top - 40
      }, 1000);
    },
    anchor02: function anchor02() {
      $([document.documentElement, document.body]).animate({
        scrollTop: $("#anchor02").offset().top - 142
      }, 1000);
    },
    anchor03: function anchor03() {
      $([document.documentElement, document.body]).animate({
        scrollTop: $("#anchor03").offset().top - 80
      }, 1000);
    },
    anchor04: function anchor04() {
      $([document.documentElement, document.body]).animate({
        scrollTop: $("#anchor04").offset().top - 80
      }, 1000);
    },
    anchor05: function anchor05() {
      $([document.documentElement, document.body]).animate({
        scrollTop: $("#anchor05").offset().top - 80
      }, 1000);
    },
    anchor06: function anchor06() {
      $([document.documentElement, document.body]).animate({
        scrollTop: $("#anchor06").offset().top - 80
      }, 1000);
    }
  },
  components: {
    'app-navigation': __WEBPACK_IMPORTED_MODULE_3__Nav_vue__["a" /* default */],
    'app-hero-section': __WEBPACK_IMPORTED_MODULE_4__Hero_vue__["a" /* default */],
    'app-subhero-section': __WEBPACK_IMPORTED_MODULE_6__Subhero_vue__["default"],
    'widget-text-featured-block': __WEBPACK_IMPORTED_MODULE_8__WidgetFeaturedBlock_vue__["default"],
    'widget-featured-on': __WEBPACK_IMPORTED_MODULE_9__WidgetFeaturedOn_vue__["default"],
    'widget-providers': __WEBPACK_IMPORTED_MODULE_10__WidgetProviders_vue__["a" /* default */],
    'widget-articles': __WEBPACK_IMPORTED_MODULE_12__WidgetArticlesRelated_vue__["a" /* default */],
    'app-footer': __WEBPACK_IMPORTED_MODULE_5__Footer_vue__["a" /* default */],
    'widget-faq': __WEBPACK_IMPORTED_MODULE_11__WidgetFaq_vue__["a" /* default */],
    'widget-author': __WEBPACK_IMPORTED_MODULE_7__WidgetAuthor_vue__["a" /* default */]
  },
  created: function created() {
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleScroll);
  }
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_scss_toolbox_fonts_scss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_scss_toolbox_fonts_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_scss_toolbox_fonts_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_scss_toolbox_margin_padding_scss__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_scss_toolbox_margin_padding_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_scss_toolbox_margin_padding_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_scss_toolbox_layout_scss__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_scss_toolbox_layout_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_scss_toolbox_layout_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Nav_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Hero_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Footer_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Subhero_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__WidgetAuthor_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__WidgetFeaturedBlock_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__WidgetFeaturedOn_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__WidgetProviders_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__WidgetFaq_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__WidgetArticlesRelated_vue__ = __webpack_require__(16);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      herotype: 'contentpage',
      scrollingActive: true,
      anchor: '01',
      urlBackground: 'https://images.prismic.io/monito/595e5e4bf13c1e6e728aceae610bb5ed7b216739_bank-londong-metro-station.jpg',
      providers: [{ logo: 'https://assets.monito.com/en/wiki/reduce-paypal-conversion-fees-tricks-save-money-exchange-money/ab-test/public/review_ria.png', url: 'ria.com', score: '5.8' }, { logo: 'https://assets.monito.com/en/wiki/reduce-paypal-conversion-fees-tricks-save-money-exchange-money/ab-test/public/review_worldremit.png', url: 'paypal.com', score: '8.3' }, { logo: 'https://assets.monito.com/en/wiki/reduce-paypal-conversion-fees-tricks-save-money-exchange-money/ab-test/public/review_paypal.png', url: 'paypal.com', score: '5.1' }, { logo: 'https://assets.monito.com/en/wiki/reduce-paypal-conversion-fees-tricks-save-money-exchange-money/ab-test/public/review_remitly.png', url: 'paypal.com', score: '7.6' }, { logo: 'https://assets.monito.com/en/wiki/reduce-paypal-conversion-fees-tricks-save-money-exchange-money/ab-test/public/review_transferwise.png', url: 'paypal.com', score: '8.8' }, { logo: 'https://assets.monito.com/en/wiki/reduce-paypal-conversion-fees-tricks-save-money-exchange-money/ab-test/public/review_skrill.png', url: 'paypal.com', score: '8.3' }],
      articles: [{ cover: 'https://images.prismic.io/monito/2c88dce81622b53cdb86db00c5c24fcde3758a11_home-office-2452806_1280.jpg',
        url: 'https://www.monito.com/en/wiki/best-way-freelancers-get-paid?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=related_content',
        title: 'The best way for freelancers to get paid',
        date_author: 'Apr. 15, 2019  -  by François Briod' }, { cover: 'https://images.prismic.io/monito/effa81034b062cc66ed8b15f32fd6e106112868e_buildings_usa.jpg',
        url: 'https://www.monito.com/en/wiki/open-bank-account-us-even-without-proof-residency?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=related_content',
        title: 'How to open a bank account online in the U.S. without proof of residency',
        date_author: 'Mar. 28, 2019  -  by François Briod' }, { cover: 'https://images.prismic.io/monito/f1e8a7c63bb75c8846f14a6ce4da502fbf2d3772_top-tips-for-digital-nomads-finance-money-transfers.png',
        url: 'https://www.monito.com/en/wiki/digital-nomads-getting-finances-right?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=related_content',
        title: 'Digital Nomads — Getting Your Finances Right',
        date_author: 'Feb. 28, 2020  -  by François Briod' }, { cover: 'https://images.prismic.io/monito/a56593dc-c364-433e-b8af-63bca2948b2f_denise-jans--gmtAa0Q5MI-unsplash.jpg',
        url: 'https://www.monito.com/en/wiki/open-bank-account-australia-even-without-proof-residency?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=related_content',
        title: 'How to open a bank account online in Australia without proof of residency',
        date_author: 'Jan. 20, 2020  -  by François Briod' }, { cover: '',
        url: 'https://www.monito.com/en/wiki/living-in-france',
        title: 'Living in France',
        date_author: 'Nov. 14, 2018' }, { cover: 'https://images.prismic.io/monito/eaee3cd7169be1fe0363a708de2e97fa4622501c_best-international-bank-accounts-for-digital-nomads-laptop-money.jpg',
        url: 'https://www.monito.com/en/wiki/best-international-bank-accounts-digital-nomads?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=related_content',
        title: 'The best international bank accounts for digital nomads, travelers & expats',
        date_author: 'Nov. 14, 2018' }, { cover: 'https://images.prismic.io/monito/c6446110f7fd98ea86127c6981abf32927e07f5e_toronto.jpg',
        url: 'https://www.monito.com/en/wiki/open-bank-account-canada-even-without-proof-residency',
        title: 'How to open a bank account in Canada without proof of residency',
        date_author: 'Jul. 17, 2019  -  by François Briod' }]
    };
  },

  methods: {
    handleScroll: function handleScroll(event) {
      // hauteur de la zone de scroll
      //this.scroll_zone = this.$refs.scroll_zone.clientHeight;

      var bodyRect = document.body.getBoundingClientRect(),
          container_width = this.$refs.main.clientWidth,
          aside = this.$refs.scroll_widgets.getBoundingClientRect(),
          anchor02 = this.$refs.anchor02.getBoundingClientRect(),
          anchor03 = this.$refs.anchor03.getBoundingClientRect(),
          anchor04 = this.$refs.anchor04.getBoundingClientRect(),
          scroll_zone = this.$refs.scroll_zone.getBoundingClientRect(),
          left = scroll_zone.right,
          aside_width = this.$refs.scroll_widgets.clientWidth,
          scroll_zone_width = this.$refs.scroll_zone.clientWidth,
          aside_height = this.$refs.scroll_widgets.clientHeight,
          scroll_zone_height = this.$refs.scroll_zone.clientHeight,


      // position top de la zone de scroll
      offset_scroll_zone = scroll_zone.top - bodyRect.top;
      var position_x_aside = scroll_zone.top - bodyRect.top;

      var bottom_main_content = offset_scroll_zone + scroll_zone_height;
      var windows_width = window.innerWidth;

      // valeur du scoll de la page
      var y = window.scrollY;
      var debut_scroll = 0;

      if (windows_width > 980) {
        this.scrollingActive = true;
      } else {
        this.scrollingActive = false;
      }

      if (this.scrollingActive == true) {
        if (y > position_x_aside - 20 + 558) {
          if (y <= bottom_main_content - aside_height - 20) {
            this.$refs.scroll_widgets.style.position = 'fixed';
            this.$refs.scroll_widgets.style.left = left + (container_width - (scroll_zone_width + aside_width)) + 'px';
            this.$refs.scroll_widgets.style.top = 20 + 'px';
          } else {
            this.$refs.scroll_widgets.style.top = scroll_zone_height - aside_height + 'px';
            this.$refs.scroll_widgets.style.position = 'absolute';
            this.$refs.scroll_widgets.style.left = '';
          }
        } else {
          this.$refs.scroll_widgets.style.top = '558px';
          this.$refs.scroll_widgets.style.position = 'absolute';
          this.$refs.scroll_widgets.style.left = '';
        }
      } else {
        this.$refs.scroll_widgets.style.position = 'relative';
        this.$refs.scroll_widgets.style.left = '';
        this.$refs.scroll_widgets.style.top = '';
      }

      if (anchor02.top < 190 && anchor03.top > 200) {
        $(".article_content ul li").removeClass('active');
        $(".article_content ul li:nth-child(2)").addClass('active');
      } else if (anchor03.top < 200 && anchor04.top > 300) {
        $(".article_content ul li").removeClass('active');
        $(".article_content ul li:nth-child(3)").addClass('active');
      } else if (anchor04.top < 300) {
        $(".article_content ul li").removeClass('active');
        $(".article_content ul li:nth-child(4)").addClass('active');
      } else if (anchor02.top > 190) {
        $(".article_content ul li").removeClass('active');
        $(".article_content ul li:nth-child(1)").addClass('active');
      } else {
        $(".article_content ul li").removeClass('active');
        $(".article_content ul li").css({ "background": "" });
        $("#anchor02").css({ "padding-right": "", "background": "", "left": "", "padding-left": "" });
      }

      if (anchor03.top < 200) {
        $(".article_content ul li a.btn_cta").removeClass('hide');
        $(".article_content ul li a.btn_cta").addClass('anime');
      } else {
        $(".article_content ul li a.btn_cta").addClass('hide');
      }
    },
    anchor01: function anchor01() {
      $([document.documentElement, document.body]).animate({
        scrollTop: $("#anchor01").offset().top - 40
      }, 1000);
    },
    anchor02: function anchor02() {
      $([document.documentElement, document.body]).animate({
        scrollTop: $("#anchor02").offset().top - 142
      }, 1000);
    },
    anchor03: function anchor03() {
      $([document.documentElement, document.body]).animate({
        scrollTop: $("#anchor03").offset().top - 40
      }, 1000);
    },
    anchor04: function anchor04() {
      $([document.documentElement, document.body]).animate({
        scrollTop: $("#anchor04").offset().top - 40
      }, 1000);
    }
  },
  components: {
    'app-navigation': __WEBPACK_IMPORTED_MODULE_3__Nav_vue__["a" /* default */],
    'app-hero-section': __WEBPACK_IMPORTED_MODULE_4__Hero_vue__["a" /* default */],
    'app-subhero-section': __WEBPACK_IMPORTED_MODULE_6__Subhero_vue__["default"],
    'widget-text-featured-block': __WEBPACK_IMPORTED_MODULE_8__WidgetFeaturedBlock_vue__["default"],
    'widget-featured-on': __WEBPACK_IMPORTED_MODULE_9__WidgetFeaturedOn_vue__["default"],
    'widget-providers': __WEBPACK_IMPORTED_MODULE_10__WidgetProviders_vue__["a" /* default */],
    'widget-articles': __WEBPACK_IMPORTED_MODULE_12__WidgetArticlesRelated_vue__["a" /* default */],
    'app-footer': __WEBPACK_IMPORTED_MODULE_5__Footer_vue__["a" /* default */],
    'widget-faq': __WEBPACK_IMPORTED_MODULE_11__WidgetFaq_vue__["a" /* default */],
    'widget-author': __WEBPACK_IMPORTED_MODULE_7__WidgetAuthor_vue__["a" /* default */]
  },
  created: function created() {
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleScroll);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_scss_toolbox_fonts_scss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_scss_toolbox_fonts_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_scss_toolbox_fonts_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_scss_toolbox_margin_padding_scss__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_scss_toolbox_margin_padding_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_scss_toolbox_margin_padding_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_scss_toolbox_layout_scss__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_scss_toolbox_layout_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_scss_toolbox_layout_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Nav_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Hero_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Footer_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Subhero_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__WidgetAuthor_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__WidgetFeaturedBlock_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__WidgetFeaturedOn_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__WidgetProviders_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__WidgetFaq_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__WidgetArticlesRelated_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__WidgetSliderMonitoScore_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__WidgetDetailsMonitoScore_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__WidgetBreadcrum_vue__ = __webpack_require__(25);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      herotype: 'contentpage',
      scrollingActive: true,
      anchor: '01',
      scroll_history: '0',
      scroll_direction: 'down',
      aside_stack: '',
      stick_pos: '1',
      stick_pos_1: '1',
      aside_state: '',
      aside_state_down: '',
      details_trust: [{ label: 'Monito’s background check', score: '10', infos: 'TransferWise passed our background check, which means they are duely regulated and authorized in all the countries they operate in and follow security best practices. Transferwise is also part of Monito\'s trusted network of partners. Screen reader support enabled.' }, { label: 'Number of positive reviews', score: '10', infos: 'TransferWise has more than 50,000 positive customer reviews' }, { label: 'Number of customers', score: '10', infos: 'TransferWise has more than 7 million customers' }, { label: 'Years in business', score: '8.5', infos: 'TransferWise exists since 2015' }, { label: 'Transparent pricing', score: '10', infos: 'TransferWise doesn\'t take a margin on the exchange rate and communicate their pricing 100% transparently' }],
      small_trust: '<p class="f_body">Our users often ask us, is TransferWise safe? Like all companies listed on our site, they must meet strict criteria to make them safe and trustworthy in our eyes.</p><p class="f_body">TransferWise is a licensed Authorised Electronic Money Institution—which means they are regulated by the FCA (Financial Conduct Authority) and HMRC (Her Majesty\'s Revenue and Customs) in the United Kingdom (where its headquarters are located) as well as by a variety of other regulatory institutions in other countries. For example, TransferWise Ltd Australia is regulated by the Australian Securities and Investments Commission (ASIC).</p>',
      trust: '<p class="f_body">Our users often ask us, is TransferWise safe? Like all companies listed on our site, they must meet strict criteria to make them safe and trustworthy in our eyes.</p><p class="f_body">TransferWise is a licensed Authorised Electronic Money Institution—which means they are regulated by the FCA (Financial Conduct Authority) and HMRC (Her Majesty\'s Revenue and Customs) in the United Kingdom (where its headquarters are located) as well as by a variety of other regulatory institutions in other countries. For example, TransferWise Ltd Australia is regulated by the Australian Securities and Investments Commission (ASIC). In the US, they are registered with the Financial Intelligence Unit (AUSTRAC) as money remitter TransferWise Inc. and are registered with the Financial Crimes Enforcement Network (FinCEN). TransferWise Inc is also licensed as a money transmitter in individual American states—in other words, they aresupervised by regulatory authorities in each of the states they operate in.</p><p class="f_body">They offer institutional grade security for their service and take preventative measures, such as 2-step login and verification procedures.</p><p class="f_body">As per FCA regulations, clients’ funds are held completely separate from TransferWise’s own business accounts, in so-called segregated accounts. Should the company have any financial difficulties, your money will be safe.</p><p class="f_body">TransferWise employs around 1000 people from over 60 nationalities across its nine offices around the world. Employees give the company close to 5 star rating on the employer review site Glassdoor, and describe the team as a “great company that is doing an awesome job” full of “smart and motivated people,” a company that is “super customer-focused” with an “excellent culture.” One employee wrote they are “Impressed by the professionalism everyone has, alongside an innate sense of trust and drive to achieve the mission”  and another said “The product is honest so there\'s no trying to cheat customers, it\'s work you can feel good about doing.“ Overall, it’s clear that employees love working there and that they feel that they are on a mission to make sending money as cheap and convenient as possible.</p><p class="f_body">TransferWise has raised over $396M dollars from major investors including Virgin Group / Sir Richard Branson, Andreessen Horowitz, IVP (Institutional Venture Partners), Max Levchin of PayPal, Sapphire and Seedcamp, which has helped the startup sustain its phenomenal growth. For example, in 2016 they saw a growth rate of approximately 150% and in the 2017 fiscal year their revenues more than doubled! Overall, the company reported revenues of £67 million (US $94 million) for 2017, and made an adjusted operating profit of £2 million.</p><p class="f_body">So, is TransferWise safe? Absolutely, we wouldn’t hesitate to trust them even with transfers of large amounts. In fact, we have used them ourselves for many of our own international payments.</p><p class="f_body">Authorised by the UK Financial Conduct Authority (FCA)</p><p class="f_body">Firm Reference : 900507</p>',

      details_service: [{ label: 'Monito\'s Expert Analysis', score: '10', infos: 'Our user experience experts rated TransferWise “Best in class” and didn’t find any user experience issues' }, { label: 'International transfer to bank account', score: '9.5', infos: 'TransferWise offers multiple pay-in options and fast transfers to a bank account.' }, { label: 'Travel Card', score: '8.1', infos: 'TransferWise\'s offers a multi-currency credit card that is available for 30+ currencies' }, { label: 'Multi-currency account', score: '9.4', infos: 'TransferWise\'s borderless account offers everything you need in an online bank account' }],
      small_service: '<p class="f_body">TransferWise currently supports sending money to 71 countries and sending money from 43 countries. The company covers 1000+ routes (country combinations) across 57 currencies, and they are also one of the few companies offering the true mid-market rate.</p>',
      service: '<p class="f_body">TransferWise currently supports sending money to 71 countries and sending money from 43 countries. The company covers 1000+ routes (country combinations) across 57 currencies, and they are also one of the few companies offering the true mid-market rate.</p><p class="f_body">Most currencies supported by TransferWise offer one option: a bank transfer from one bank to another. For some currencies, you can pay with debit and credit cards or use a SOFORT transfer option. Apple Pay or Android Pay is also available for certain currencies via TransferWise iOS and Android apps. In most cases, the recipient will get the money within one to two business days.</p><p class="f_body">TransferWise is a top choice for international money transfers. They are known for their great customer service, have excellent reviews on Trustpilot, and provide speedy transfers. And the cherry on the cake? They also provide spectacular user experience, from an easy sign-up process to efficient transfers, as evidenced in our <a target="_blank" href="https://www.monito.com/en/wiki/transferwise-usability-user-experience/">in-depth UX analysis of what first-time users think of TransferWise</a>. Some users were so impressed they thought it is too good to be true. Yes, it’s good, but it’s also true!</p>',

      details_customer: [{ label: 'Customer review score', score: '9.5', infos: 'TransferWise has 95% of 4 of 5 stars customer reviews' }, { label: 'Recommendation success rate', score: '8.5', infos: 'A lot of users we redirect to TransferWise end up opening an account and making a transfer' }],
      small_customer: '<p class="f_body">TransferWise has excellent customer reviews on Trustpilot. Nearly 90% of the feedback rating the company 5 stars on 56,619 reviews. Here’s what some TransferWise customers say:</p>',
      customer: '<p class="f_body">TransferWise has excellent customer reviews on Trustpilot. Nearly 90% of the feedback rating the company 5 stars on 56,619 reviews. Here’s what some TransferWise customers say:</p><h3 class="f_subtitle_2">Positive</h3><ul class="f_body pros"><li>It works!!! Trustable.</li><li>It\'s wonderful: Fast, transparent, inexpensive.</li><li>Quick, simple easy to use, self-explanatory. It’s also safe and efficient.</li><li>Fast, simple, user-friendly and with no hidden fees!</li><li>Very good customer service, helpful and knowledgeable.</li></ul><h3 class="f_subtitle_2">Negative</h3><ul class="f_body cons"><li>Sometimes there is a delay</li><li>Some frustrations with the required documentation required to verify identities</li></ul>',

      details_fees: [{ label: 'International transfer to bank account', score: '9.5', infos: 'TransferWise is the cheapest provider in 64% of searches and among the most competitive providers in 97% of searches on Monito.' }, { label: 'Travel Card', score: '9.6', infos: 'TransferWise ranked excellent against our standardised travel card pricing analysis.' }, { label: 'Multi-currency account', score: '9.4', infos: 'TransferWise ranked excellent against our standardised multi-currency account pricing analysis.' }],
      small_fees: '<h3 class="f_subtitle_2">TransferWise Transfer fees</h3><p class="f_body">TransferWise fees are low and fully transparent. They charge a percent of the transfer amount, and a flat fee for certain transfer routes (country combinations). The minimum TransferWise fees and percent depend on the currencies you are sending from and to and certain currencies have variable fees depending on the total amount being sent.</p>',

      fees: '<h3 class="f_subtitle_2">TransferWise Transfer fees</h3><p class="f_body">TransferWise fees are low and fully transparent. They charge a percent of the transfer amount, and a flat fee for certain transfer routes (country combinations). The minimum TransferWise fees and percent depend on the currencies you are sending from and to and certain currencies have variable fees depending on the total amount being sent.</p><p class="f_body">For example, from GBP (British Pound) to EUR (Euro), you will pay 0.35% of the transfer amount with a fee of £0.80. The reverse, EUR (Euro) to GBP (British costs 0.5% of the transfer amount with a flat fee of €2. Sending DKK (Danish Kroner), to Euros will cost you 0.5% of the transfer amount on the initial DKK 50,000 and 0.3% on anything over that amount.</p><h3 class="f_subtitle_2">TransferWise Exchange rate</h3><p class="f_body">TransferWise converts your money using the true mid-market rate when they receive and process your money. This means that the TransferWise exchange rate is the fairest, most accurate exchange rate you can hope for. Bonus: TransferWise will automatically lock the exchange rate for a specified time frame, from 24 hours for most countries, and 48 hours for several others and 72 hours for BRL (Brazilian Reals) so you’re not exposed to exchange rate fluctuations (they call this the “guaranteed rate” feature). This is one way to ensure that your recipient receives a specific amount. Caveat: your money must be received by TransferWise within the specified time frame, or else the exchange rate - and therefore also the amount received - will no longer be guaranteed.</p><h3 class="f_subtitle_2">Other fees</h3><p class="f_body">In most cases, TransferWise uses local accounts to collect and send funds. This means that there should be no fees charged by the sending or receiving banks, and no intermediary bank fees.</p><p class="f_body">If you’re paying by credit card, you will be charged a credit card fee of 0.3% - 2% depending on the currency you’re sending from and the type of credit card you are using. Debit card payments are free from certain currencies or incur a debit card fee of 0.15% - 2%.</p><p class="f_body">TransferWise sends certain currencies via the international SWIFT network, which most banks will charge a fee to receive. If you’re sending to these currencies, make sure you check with the receiving bank how much they charge for incoming SWIFT payments. TransferWise SWIFT currencies are: JPY (Japanese Yen) over 1 million and ZAR (South African Rand) or a USD transfer to a bank account outside of US, we send it to your recipient as a SWIFT transfer.</p><p class="f_body">TransferWise can also receive USD (US Dollars) via SWIFT. If you live in the US, you will not want to do this since your bank will likely charge you fees to make a SWIFT payment, and free or cheaper alternatives are available (domestic wire and ACH direct debit). You’ll only want to send USD to TransferWise via SWIFT if your payment is coming from outside the US.</p>',

      urlBackground: '/public/illu_transferwise.jpg',
      provider: { logo: '/public/review_transferwise.png', url: 'https://go.monito.com/transferwise', score: '9.5', name: 'TransferWise', sub_score_01: '9.8', sub_score_02: '9.5', sub_score_03: '9.0', sub_score_04: '9.5', country: '<span>Available from the UK, the US, </span>and 25 other countries to 54 countries', country_score: ' excellent', cost: 'Among the cheapest providers for <span>85% of searches</span> on Monito', cost_score: ' excellent' },
      providers: [{ logo: '../public/review_ria.png',
        url: 'https://www.monito.com/en/send-money-with/ria?utm_source=internal&utm_medium=internal&utm_campaign=ABTestReview&utm_content=provider_carousel',
        score: '5.8' }, { logo: '../public/review_worldremit.png',
        url: 'https://www.monito.com/en/send-money-with/worldremit?utm_source=internal&utm_medium=internal&utm_campaign=ABTestReview&utm_content=provider_carousel',
        score: '8.3' }, { logo: '../public/review_paypal.png',
        url: 'https://www.monito.com/en/send-money-with/paypal?utm_source=internal&utm_medium=internal&utm_campaign=ABTestReview&utm_content=provider_carousel',
        score: '5.1' }, { logo: '../public/review_remitly.png',
        url: 'https://www.monito.com/en/send-money-with/remitly?utm_source=internal&utm_medium=internal&utm_campaign=ABTestReview&utm_content=provider_carousel',
        score: '7.7  ' }, { logo: '../public/review_skrill.png',
        url: 'https://www.monito.com/en/send-money-with/skrill?utm_source=internal&utm_medium=internal&utm_campaign=ABTestReview&utm_content=provider_carousel',
        score: '8.3' }, { logo: '../public/review_transfergo.png',
        url: 'https://www.monito.com/en/send-money-with/transfergo?utm_source=internal&utm_medium=internal&utm_campaign=ABTestReview&utm_content=provider_carousel',
        score: '8.2' }, { logo: '../public/review_western.png',
        url: 'https://www.monito.com/en/send-money-with/western-union?utm_source=internal&utm_medium=internal&utm_campaign=ABTestReview&utm_content=provider_carousel',
        score: '7.9' }]
    };
  },

  methods: {
    handleScroll: function handleScroll(e) {
      if (window.innerWidth > 990) {
        this.scrollingActive = true;
      } else {
        this.scrollingActive = false;
      }

      var main = $("main").get(0);
      var aside = $("aside").get(0);
      console.log(aside.getBoundingClientRect().bottom);
      if (main.getBoundingClientRect().bottom > 100 && aside.getBoundingClientRect().bottom < -10) {
        $(".cta_sticky").addClass('active');
        $(".cta_sticky").removeClass('remove');
      } else if ($(".cta_sticky").hasClass('active')) {
        $(".cta_sticky").addClass('remove');
        $(".cta_sticky").removeClass('active');
      }

      var anchor01 = $("#anchor01").get(0);
      var anchor02 = $("#anchor02").get(0);
      var anchor03 = $("#anchor03").get(0);
      var anchor04 = $("#anchor04").get(0);
      if (this.scrollingActive) {
        if (anchor01.getBoundingClientRect().top < 200 & anchor01.getBoundingClientRect().bottom > 100) {
          $(".monito_score ul li").removeClass('active');
          $(".monito_score ul li:nth-child(1)").addClass('active');
        } else if (anchor02.getBoundingClientRect().top < 200 & anchor02.getBoundingClientRect().bottom > 100) {
          $(".monito_score ul li").removeClass('active');
          $(".monito_score ul li:nth-child(2)").addClass('active');
        } else if (anchor03.getBoundingClientRect().top < 200 & anchor03.getBoundingClientRect().bottom > 100) {
          $(".monito_score ul li").removeClass('active');
          $(".monito_score ul li:nth-child(3)").addClass('active');
        } else if (anchor04.getBoundingClientRect().top < 200) {
          $(".monito_score ul li").removeClass('active');
          $(".monito_score ul li:nth-child(4)").addClass('active');
        } else {
          $(".monito_score ul li").removeClass('active');
        }
      }

      if (this.scrollingActive) {
        var element_aside = $("main aside");
        var _aside = $("main aside").get(0);

        if (_aside.getBoundingClientRect().height + 70 > window.innerHeight) {
          console.log(this.stick_pos);
          if (window.scrollY < this.prevScrollY) {
            this.stick_pos = this.scrollUpwards(this.stick_pos, element_aside);
          } else {
            this.stick_pos = this.scrollDownwards(this.stick_pos, element_aside);
          }
          this.prevScrollY = window.scrollY;
        } else {
          element_aside.css("position", "sticky").css("top", '50px').css("bottom", '').css("align-self", "flex-start");
        }
      }

      if (this.scrollingActive) {
        var element_aside_1 = $(".container_layout aside");
        var aside_1 = $(".container_layout aside").get(0);

        if (aside_1.getBoundingClientRect().height + 70 > window.innerHeight) {
          console.log(this.stick_pos);
          if (window.scrollY < this.prevScrollY) {
            this.stick_pos_1 = this.scrollUpwards(this.stick_pos_1, element_aside_1);
          } else {
            this.stick_pos_1 = this.scrollDownwards(this.stick_pos_1, element_aside_1);
          }
          this.prevScrollY = window.scrollY;
        } else {
          element_aside_1.css("position", "sticky").css("top", '50px').css("bottom", '').css("align-self", "flex-start");
        }
      }
    },
    scrollDownwards: function scrollDownwards(stick_pos, element_aside) {
      if (stick_pos === -1) return stick_pos;
      // Figure out where the new window will be after scroll
      var aside = element_aside.get(0);
      var browser_bottom = window.innerHeight;
      var aside_bottom = aside.getBoundingClientRect().top + aside.offsetHeight;
      var belowAside = browser_bottom > aside_bottom;
      // If we are going below the element then we know we must stick
      // it to the bottom.
      if (belowAside) {
        element_aside.css("position", "sticky").css("top", 'auto').css("bottom", '20px').css("align-self", "flex-end");
        return -1;
      }
      // If it will still be above the bottom of the element, then we
      // must absolutely position it to its current position - if it already is absolutely positioned then we do    nothing
      if (stick_pos == 0) return stick_pos;

      // Undo the stick to the top
      // First get the current position
      // $("aside").css("position", "absolute")
      // .css("top", aside.offsetTop);
      element_aside.css("top", aside.offsetTop).css("position", "absolute").css("bottom", '').css("right", '0').css("align-self", "");
      return 0;
    },
    scrollUpwards: function scrollUpwards(stick_pos, element_aside) {
      if (stick_pos === 1) return stick_pos;
      // Figure out where the new window will be after scrol
      var aside = element_aside.get(0);
      var aboveAside = aside.getBoundingClientRect().top;
      // If we are going above the element then we know we must sticks
      // it to the top
      if (aboveAside) {
        element_aside.css("position", "sticky").css("top", '50px').css("bottom", '').css("align-self", "flex-start");
        return 1;
      }

      if (stick_pos == 0) return stick_pos;

      // Undo the stick to the bottom
      // First get the current position
      element_aside.css("top", aside.offsetTop).css("position", "absolute").css("bottom", '').css("right", '0').css("align-self", "");
      return 0;
    }
  },
  components: {
    'app-navigation': __WEBPACK_IMPORTED_MODULE_3__Nav_vue__["a" /* default */],
    'app-hero-section': __WEBPACK_IMPORTED_MODULE_4__Hero_vue__["a" /* default */],
    'app-subhero-section': __WEBPACK_IMPORTED_MODULE_6__Subhero_vue__["default"],
    'widget-text-featured-block': __WEBPACK_IMPORTED_MODULE_8__WidgetFeaturedBlock_vue__["default"],
    'widget-featured-on': __WEBPACK_IMPORTED_MODULE_9__WidgetFeaturedOn_vue__["default"],
    'widget-providers': __WEBPACK_IMPORTED_MODULE_10__WidgetProviders_vue__["a" /* default */],
    'widget-articles': __WEBPACK_IMPORTED_MODULE_12__WidgetArticlesRelated_vue__["a" /* default */],
    'app-footer': __WEBPACK_IMPORTED_MODULE_5__Footer_vue__["a" /* default */],
    'widget-faq': __WEBPACK_IMPORTED_MODULE_11__WidgetFaq_vue__["a" /* default */],
    'widget-author': __WEBPACK_IMPORTED_MODULE_7__WidgetAuthor_vue__["a" /* default */],
    'widget-monito-score': __WEBPACK_IMPORTED_MODULE_13__WidgetSliderMonitoScore_vue__["a" /* default */],
    'widget-detail-monito-score': __WEBPACK_IMPORTED_MODULE_14__WidgetDetailsMonitoScore_vue__["a" /* default */],
    'widget-breadcrum': __WEBPACK_IMPORTED_MODULE_15__WidgetBreadcrum_vue__["default"]
  },
  created: function created() {
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleScroll);
    this.handleScroll();
  }
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CircleScore_vue__ = __webpack_require__(47);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['provider', 'scrollingActive'],
    components: {
        'element-circle-score': __WEBPACK_IMPORTED_MODULE_0__CircleScore_vue__["a" /* default */]
    },
    methods: {
        getColorScore: function getColorScore(score) {
            if (score >= '9.5') {
                return 'excellent';
            } else if (score >= '8') {
                return 'good';
            } else if (score >= '6.5') {
                return 'average';
            } else if (score >= '5.0') {
                return 'poor';
            } else {
                return 'bad';
            }
        },
        anchor01: function anchor01() {
            if (this.scrollingActive) {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $("#anchor01").offset().top - 60
                }, 1000);
            } else {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $(".flex .box:nth-child(1)").offset().top - 20
                }, 1000);
            }
        },
        anchor02: function anchor02() {
            if (this.scrollingActive) {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $("#anchor02").offset().top - 60
                }, 1000);
            } else {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $(".flex .box:nth-child(2)").offset().top - 20
                }, 1000);
            }
        },
        anchor03: function anchor03() {
            if (this.scrollingActive) {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $("#anchor03").offset().top - 60
                }, 1000);
            } else {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $(".flex .box:nth-child(3)").offset().top - 20
                }, 1000);
            }
        },
        anchor04: function anchor04() {
            if (this.scrollingActive) {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $("#anchor04").offset().top - 60
                }, 1000);
            } else {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $(".flex .box:nth-child(4)").offset().top - 20
                }, 1000);
            }
        }
    }
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['scrollingActive', 'provider', 'details_trust', 'details_service', 'details_customer', 'details_fees', 'fees', 'trust', 'customer', 'service', 'small_fees', 'small_trust', 'small_customer', 'small_service'],
  data: function data() {
    return {
      paragraph_01: false,
      paragraph_02: false,
      paragraph_03: false,
      paragraph_04: false
    };
  },

  methods: {
    getColorScore: function getColorScore(score) {
      if (score >= '9.5') {
        return 'excellent';
      } else if (score >= '8') {
        return 'good';
      } else if (score >= '6.5') {
        return 'average';
      } else if (score >= '5.0') {
        return 'poor';
      } else if (score == '10') {
        return 'excellent';
      } else {
        return 'bad';
      }
    },
    anchor01: function anchor01() {
      $([document.documentElement, document.body]).animate({
        scrollTop: $("#anchor01").offset().top - 60
      }, 1000);
    },
    anchor02: function anchor02() {
      $([document.documentElement, document.body]).animate({
        scrollTop: $("#anchor02").offset().top - 60
      }, 1000);
    },
    anchor03: function anchor03() {
      $([document.documentElement, document.body]).animate({
        scrollTop: $("#anchor03").offset().top - 60
      }, 1000);
    },
    anchor04: function anchor04() {
      $([document.documentElement, document.body]).animate({
        scrollTop: $("#anchor04").offset().top - 60
      }, 1000);
    }
  }
});

/***/ }),
/* 77 */
/***/ (function(module, exports) {

//
//
//
//
//
//

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_scss_toolbox_fonts_scss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_scss_toolbox_fonts_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_scss_toolbox_fonts_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_scss_toolbox_margin_padding_scss__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_scss_toolbox_margin_padding_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_scss_toolbox_margin_padding_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_scss_toolbox_layout_scss__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_scss_toolbox_layout_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_scss_toolbox_layout_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Nav_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Hero_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Footer_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Subhero_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__WidgetAuthor_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__WidgetFeaturedBlock_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__WidgetFeaturedOn_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__WidgetProviders_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__WidgetFaq_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__WidgetArticlesRelated_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__WidgetSliderMonitoScore_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__WidgetDetailsMonitoScore_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__WidgetBreadcrum_vue__ = __webpack_require__(25);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      herotype: 'contentpage',
      scrollingActive: true,
      anchor: '01',
      scroll_history: '0',
      scroll_direction: 'down',
      aside_stack: '',
      stick_pos: '1',
      stick_pos_1: '1',
      aside_state: '',
      aside_state_down: '',
      details_trust: [{ label: 'Monito’s background check', score: '6', infos: 'PayPal is one of the largest independent, publicly traded, consumer financial technology companies in the world. They passed our background check.' }, { label: 'Number of positive reviews', score: '10', infos: 'PayPal has less than 1,500 positive customer reviews' }, { label: 'Number of customers', score: '10', infos: 'PayPal has more than 200 million customers' }, { label: 'Years in business', score: '10', infos: 'PayPal exists since 1998' }, { label: 'Transparent pricing', score: '3', infos: 'Most of the cost of a transfer is hidden in the exchange rate margin and some fees are not explicitly communicated' }],
      small_trust: '<p class="f_body">Our users often ask us, is TransferWise safe? Like all companies listed on our site, they must meet strict criteria to make them safe and trustworthy in our eyes.</p><p class="f_body">TransferWise is a licensed Authorised Electronic Money Institution—which means they are regulated by the FCA (Financial Conduct Authority) and HMRC (Her Majesty\'s Revenue and Customs) in the United Kingdom (where its headquarters are located) as well as by a variety of other regulatory institutions in other countries. For example, TransferWise Ltd Australia is regulated by the Australian Securities and Investments Commission (ASIC).</p>',
      trust: '<p class="f_body">Our users often ask us, is TransferWise safe? Like all companies listed on our site, they must meet strict criteria to make them safe and trustworthy in our eyes.</p><p class="f_body">TransferWise is a licensed Authorised Electronic Money Institution—which means they are regulated by the FCA (Financial Conduct Authority) and HMRC (Her Majesty\'s Revenue and Customs) in the United Kingdom (where its headquarters are located) as well as by a variety of other regulatory institutions in other countries. For example, TransferWise Ltd Australia is regulated by the Australian Securities and Investments Commission (ASIC). In the US, they are registered with the Financial Intelligence Unit (AUSTRAC) as money remitter TransferWise Inc. and are registered with the Financial Crimes Enforcement Network (FinCEN). TransferWise Inc is also licensed as a money transmitter in individual American states—in other words, they aresupervised by regulatory authorities in each of the states they operate in.</p><p class="f_body">They offer institutional grade security for their service and take preventative measures, such as 2-step login and verification procedures.</p><p class="f_body">As per FCA regulations, clients’ funds are held completely separate from TransferWise’s own business accounts, in so-called segregated accounts. Should the company have any financial difficulties, your money will be safe.</p><p class="f_body">TransferWise employs around 1000 people from over 60 nationalities across its nine offices around the world. Employees give the company close to 5 star rating on the employer review site Glassdoor, and describe the team as a “great company that is doing an awesome job” full of “smart and motivated people,” a company that is “super customer-focused” with an “excellent culture.” One employee wrote they are “Impressed by the professionalism everyone has, alongside an innate sense of trust and drive to achieve the mission”  and another said “The product is honest so there\'s no trying to cheat customers, it\'s work you can feel good about doing.“ Overall, it’s clear that employees love working there and that they feel that they are on a mission to make sending money as cheap and convenient as possible.</p><p class="f_body">TransferWise has raised over $396M dollars from major investors including Virgin Group / Sir Richard Branson, Andreessen Horowitz, IVP (Institutional Venture Partners), Max Levchin of PayPal, Sapphire and Seedcamp, which has helped the startup sustain its phenomenal growth. For example, in 2016 they saw a growth rate of approximately 150% and in the 2017 fiscal year their revenues more than doubled! Overall, the company reported revenues of £67 million (US $94 million) for 2017, and made an adjusted operating profit of £2 million.</p><p class="f_body">So, is TransferWise safe? Absolutely, we wouldn’t hesitate to trust them even with transfers of large amounts. In fact, we have used them ourselves for many of our own international payments.</p><p class="f_body">Authorised by the UK Financial Conduct Authority (FCA)</p><p class="f_body">Firm Reference : 900507</p>',

      details_service: [{ label: 'Monito\'s Expert Analysis', score: '6', infos: 'Our user experience experts found quite a few elements that could be improve on PayPal\'s website to make it more intuitive.' }, { label: 'International transfer to bank account', score: '4', infos: 'Getting money in and out of your PayPal account to a bank account is a bit tedious and transfer can be long' }, { label: 'International transfer to cash pick-up', score: '', infos: 'PayPal doesn\'t offer cash pick-up service' }, { label: 'International Airtime top-up', score: '', infos: 'PayPal doesn\'t offer airtime top-up services' }, { label: 'Travel Card', score: '', infos: 'PayPal doesn\'t offer airtime top-up services' }, { label: 'Multi-currency account', score: '3', infos: 'PayPal\'s ability to hold account in multiple currencies is limited and not convenient' }],
      small_service: '<p class="f_body">TransferWise currently supports sending money to 71 countries and sending money from 43 countries. The company covers 1000+ routes (country combinations) across 57 currencies, and they are also one of the few companies offering the true mid-market rate.</p>',
      service: '<p class="f_body">TransferWise currently supports sending money to 71 countries and sending money from 43 countries. The company covers 1000+ routes (country combinations) across 57 currencies, and they are also one of the few companies offering the true mid-market rate.</p><p class="f_body">Most currencies supported by TransferWise offer one option: a bank transfer from one bank to another. For some currencies, you can pay with debit and credit cards or use a SOFORT transfer option. Apple Pay or Android Pay is also available for certain currencies via TransferWise iOS and Android apps. In most cases, the recipient will get the money within one to two business days.</p><p class="f_body">TransferWise is a top choice for international money transfers. They are known for their great customer service, have excellent reviews on Trustpilot, and provide speedy transfers. And the cherry on the cake? They also provide spectacular user experience, from an easy sign-up process to efficient transfers, as evidenced in our <a target="_blank" href="https://www.monito.com/en/wiki/transferwise-usability-user-experience/">in-depth UX analysis of what first-time users think of TransferWise</a>. Some users were so impressed they thought it is too good to be true. Yes, it’s good, but it’s also true!</p>',

      details_customer: [{ label: 'Customer review score', score: '1.4', infos: 'PayPal has 14% of 4 of 5 stars customer reviews' }, { label: 'Recommendation success rate', score: '', infos: 'We don\'t track the number of users who make a transfer with PayPal' }],
      small_customer: '<p class="f_body">TransferWise has excellent customer reviews on Trustpilot. Nearly 90% of the feedback rating the company 5 stars on 56,619 reviews. Here’s what some TransferWise customers say:</p>',
      customer: '<p class="f_body">TransferWise has excellent customer reviews on Trustpilot. Nearly 90% of the feedback rating the company 5 stars on 56,619 reviews. Here’s what some TransferWise customers say:</p><h3 class="f_subtitle_2">Positive</h3><ul class="f_body pros"><li>It works!!! Trustable.</li><li>It\'s wonderful: Fast, transparent, inexpensive.</li><li>Quick, simple easy to use, self-explanatory. It’s also safe and efficient.</li><li>Fast, simple, user-friendly and with no hidden fees!</li><li>Very good customer service, helpful and knowledgeable.</li></ul><h3 class="f_subtitle_2">Negative</h3><ul class="f_body cons"><li>Sometimes there is a delay</li><li>Some frustrations with the required documentation required to verify identities</li></ul>',

      details_fees: [{ label: 'International transfer to bank account', score: '1', infos: 'PayPal is the cheapest option in only 1% of the searches and is never competitive' }, { label: 'International transfer to cash pick-up', score: '', infos: 'PayPal doesn\'t offer cash pick-up services' }, { label: 'Airtime top-up', score: '', infos: 'PayPal doesn\'t offer airtime top-up services' }, { label: 'Travel Card', score: '', infos: 'PayPal doesn\'t offer travel card services' }, { label: 'Multi-currency account', score: '', infos: 'PayPal doesn\'t Multi-currency account services' }],
      small_fees: '<h3 class="f_subtitle_2">TransferWise Transfer fees</h3><p class="f_body">TransferWise fees are low and fully transparent. They charge a percent of the transfer amount, and a flat fee for certain transfer routes (country combinations). The minimum TransferWise fees and percent depend on the currencies you are sending from and to and certain currencies have variable fees depending on the total amount being sent.</p>',

      fees: '<h3 class="f_subtitle_2">TransferWise Transfer fees</h3><p class="f_body">TransferWise fees are low and fully transparent. They charge a percent of the transfer amount, and a flat fee for certain transfer routes (country combinations). The minimum TransferWise fees and percent depend on the currencies you are sending from and to and certain currencies have variable fees depending on the total amount being sent.</p><p class="f_body">For example, from GBP (British Pound) to EUR (Euro), you will pay 0.35% of the transfer amount with a fee of £0.80. The reverse, EUR (Euro) to GBP (British costs 0.5% of the transfer amount with a flat fee of €2. Sending DKK (Danish Kroner), to Euros will cost you 0.5% of the transfer amount on the initial DKK 50,000 and 0.3% on anything over that amount.</p><h3 class="f_subtitle_2">TransferWise Exchange rate</h3><p class="f_body">TransferWise converts your money using the true mid-market rate when they receive and process your money. This means that the TransferWise exchange rate is the fairest, most accurate exchange rate you can hope for. Bonus: TransferWise will automatically lock the exchange rate for a specified time frame, from 24 hours for most countries, and 48 hours for several others and 72 hours for BRL (Brazilian Reals) so you’re not exposed to exchange rate fluctuations (they call this the “guaranteed rate” feature). This is one way to ensure that your recipient receives a specific amount. Caveat: your money must be received by TransferWise within the specified time frame, or else the exchange rate - and therefore also the amount received - will no longer be guaranteed.</p><h3 class="f_subtitle_2">Other fees</h3><p class="f_body">In most cases, TransferWise uses local accounts to collect and send funds. This means that there should be no fees charged by the sending or receiving banks, and no intermediary bank fees.</p><p class="f_body">If you’re paying by credit card, you will be charged a credit card fee of 0.3% - 2% depending on the currency you’re sending from and the type of credit card you are using. Debit card payments are free from certain currencies or incur a debit card fee of 0.15% - 2%.</p><p class="f_body">TransferWise sends certain currencies via the international SWIFT network, which most banks will charge a fee to receive. If you’re sending to these currencies, make sure you check with the receiving bank how much they charge for incoming SWIFT payments. TransferWise SWIFT currencies are: JPY (Japanese Yen) over 1 million and ZAR (South African Rand) or a USD transfer to a bank account outside of US, we send it to your recipient as a SWIFT transfer.</p><p class="f_body">TransferWise can also receive USD (US Dollars) via SWIFT. If you live in the US, you will not want to do this since your bank will likely charge you fees to make a SWIFT payment, and free or cheaper alternatives are available (domestic wire and ACH direct debit). You’ll only want to send USD to TransferWise via SWIFT if your payment is coming from outside the US.</p>',

      urlBackground: 'https://images.prismic.io/monito/595e5e4bf13c1e6e728aceae610bb5ed7b216739_bank-londong-metro-station.jpg',
      provider: { logo: '/public/review_paypal.png', url: 'paypal.com', score: '3.9', name: 'PayPal', sub_score_01: '8.6', sub_score_02: '4.8', sub_score_03: '1.4', sub_score_04: '1.0', country: '<span>Available from the UK</span> and 25 other countries to 54 countries', country_score: ' excellent', cost: 'Never the cheapest providers for <span>all searches</span> on Monito', cost_score: ' bad' },
      providers: [{ logo: '../public/review_ria.png',
        url: 'https://www.monito.com/en/send-money-with/ria?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=provider_carousel',
        score: '5.8' }, { logo: '../public/review_worldremit.png',
        url: 'https://www.monito.com/en/send-money-with/worldremit?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=provider_carousel',
        score: '8.3' }, { logo: '../public/review_paypal.png',
        url: 'https://www.monito.com/en/send-money-with/paypal?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=provider_carousel',
        score: '5.1' }, { logo: '../public/review_remitly.png',
        url: 'https://www.monito.com/en/send-money-with/remitly?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=provider_carousel',
        score: '7.6' }, { logo: '../public/review_skrill.png',
        url: 'https://www.monito.com/en/send-money-with/skrill?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=provider_carousel',
        score: '8.9' }, { logo: '../public/review_transfergo.png',
        url: 'https://www.monito.com/en/send-money-with/skrill?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=provider_carousel',
        score: '8.1' }, { logo: '../public/review_western.png',
        url: 'https://www.monito.com/en/send-money-with/skrill?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=provider_carousel',
        score: '8.3' }]
    };
  },

  methods: {
    handleScroll: function handleScroll(e) {
      if (window.innerWidth > 990) {
        this.scrollingActive = true;
      } else {
        this.scrollingActive = false;
      }

      var main = $("main").get(0);
      var aside = $("aside").get(0);
      console.log(aside.getBoundingClientRect().bottom);
      if (main.getBoundingClientRect().bottom > 100 && aside.getBoundingClientRect().bottom < -10) {
        $(".cta_sticky").addClass('active');
        $(".cta_sticky").removeClass('remove');
      } else if ($(".cta_sticky").hasClass('active')) {
        $(".cta_sticky").addClass('remove');
        $(".cta_sticky").removeClass('active');
      }

      var anchor01 = $("#anchor01").get(0);
      var anchor02 = $("#anchor02").get(0);
      var anchor03 = $("#anchor03").get(0);
      var anchor04 = $("#anchor04").get(0);
      if (this.scrollingActive) {
        if (anchor01.getBoundingClientRect().top < 200 & anchor01.getBoundingClientRect().bottom > 100) {
          $(".monito_score ul li").removeClass('active');
          $(".monito_score ul li:nth-child(1)").addClass('active');
        } else if (anchor02.getBoundingClientRect().top < 200 & anchor02.getBoundingClientRect().bottom > 100) {
          $(".monito_score ul li").removeClass('active');
          $(".monito_score ul li:nth-child(2)").addClass('active');
        } else if (anchor03.getBoundingClientRect().top < 200 & anchor03.getBoundingClientRect().bottom > 100) {
          $(".monito_score ul li").removeClass('active');
          $(".monito_score ul li:nth-child(3)").addClass('active');
        } else if (anchor04.getBoundingClientRect().top < 200) {
          $(".monito_score ul li").removeClass('active');
          $(".monito_score ul li:nth-child(4)").addClass('active');
        } else {
          $(".monito_score ul li").removeClass('active');
        }
      }

      if (this.scrollingActive) {
        var element_aside = $("main aside");
        var _aside = $("main aside").get(0);

        if (_aside.getBoundingClientRect().height + 70 > window.innerHeight) {
          console.log(this.stick_pos);
          if (window.scrollY < this.prevScrollY) {
            this.stick_pos = this.scrollUpwards(this.stick_pos, element_aside);
          } else {
            this.stick_pos = this.scrollDownwards(this.stick_pos, element_aside);
          }
          this.prevScrollY = window.scrollY;
        } else {
          element_aside.css("position", "sticky").css("top", '50px').css("bottom", '').css("align-self", "flex-start");
        }
      }

      if (this.scrollingActive) {
        var element_aside_1 = $(".container_layout aside");
        var aside_1 = $(".container_layout aside").get(0);

        if (aside_1.getBoundingClientRect().height + 70 > window.innerHeight) {
          console.log(this.stick_pos);
          if (window.scrollY < this.prevScrollY) {
            this.stick_pos_1 = this.scrollUpwards(this.stick_pos_1, element_aside_1);
          } else {
            this.stick_pos_1 = this.scrollDownwards(this.stick_pos_1, element_aside_1);
          }
          this.prevScrollY = window.scrollY;
        } else {
          element_aside_1.css("position", "sticky").css("top", '50px').css("bottom", '').css("align-self", "flex-start");
        }
      }
    },
    scrollDownwards: function scrollDownwards(stick_pos, element_aside) {
      if (stick_pos === -1) return stick_pos;
      // Figure out where the new window will be after scroll
      var aside = element_aside.get(0);
      var browser_bottom = window.innerHeight;
      var aside_bottom = aside.getBoundingClientRect().top + aside.offsetHeight;
      var belowAside = browser_bottom > aside_bottom;
      // If we are going below the element then we know we must stick
      // it to the bottom.
      if (belowAside) {
        element_aside.css("position", "sticky").css("top", 'auto').css("bottom", '20px').css("align-self", "flex-end");
        return -1;
      }
      // If it will still be above the bottom of the element, then we
      // must absolutely position it to its current position - if it already is absolutely positioned then we do    nothing
      if (stick_pos == 0) return stick_pos;

      // Undo the stick to the top
      // First get the current position
      // $("aside").css("position", "absolute")
      // .css("top", aside.offsetTop);
      element_aside.css("top", aside.offsetTop).css("position", "absolute").css("bottom", '').css("right", '0').css("align-self", "");
      return 0;
    },
    scrollUpwards: function scrollUpwards(stick_pos, element_aside) {
      if (stick_pos === 1) return stick_pos;
      // Figure out where the new window will be after scrol        let aboveAside = aside.getBoundingClientRect().top > 50;
      // If we are going above the element then we know we must sticks
      // it to the top
      if (aboveAside) {
        element_aside.css("position", "sticky").css("top", '50px').css("bottom", '').css("align-self", "flex-start");
        return 1;
      }

      if (stick_pos == 0) return stick_pos;

      // Undo the stick to the bottom
      // First get the current position
      element_aside.css("top", aside.offsetTop).css("position", "absolute").css("bottom", '').css("right", '0').css("align-self", "");
      return 0;
    }
  },
  components: {
    'app-navigation': __WEBPACK_IMPORTED_MODULE_3__Nav_vue__["a" /* default */],
    'app-hero-section': __WEBPACK_IMPORTED_MODULE_4__Hero_vue__["a" /* default */],
    'app-subhero-section': __WEBPACK_IMPORTED_MODULE_6__Subhero_vue__["default"],
    'widget-text-featured-block': __WEBPACK_IMPORTED_MODULE_8__WidgetFeaturedBlock_vue__["default"],
    'widget-featured-on': __WEBPACK_IMPORTED_MODULE_9__WidgetFeaturedOn_vue__["default"],
    'widget-providers': __WEBPACK_IMPORTED_MODULE_10__WidgetProviders_vue__["a" /* default */],
    'widget-articles': __WEBPACK_IMPORTED_MODULE_12__WidgetArticlesRelated_vue__["a" /* default */],
    'app-footer': __WEBPACK_IMPORTED_MODULE_5__Footer_vue__["a" /* default */],
    'widget-faq': __WEBPACK_IMPORTED_MODULE_11__WidgetFaq_vue__["a" /* default */],
    'widget-author': __WEBPACK_IMPORTED_MODULE_7__WidgetAuthor_vue__["a" /* default */],
    'widget-monito-score': __WEBPACK_IMPORTED_MODULE_13__WidgetSliderMonitoScore_vue__["a" /* default */],
    'widget-detail-monito-score': __WEBPACK_IMPORTED_MODULE_14__WidgetDetailsMonitoScore_vue__["a" /* default */],
    'widget-breadcrum': __WEBPACK_IMPORTED_MODULE_15__WidgetBreadcrum_vue__["default"]
  },
  created: function created() {
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleScroll);
    this.handleScroll();
  }
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_scss_toolbox_fonts_scss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_scss_toolbox_fonts_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_scss_toolbox_fonts_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_scss_toolbox_margin_padding_scss__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_scss_toolbox_margin_padding_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_scss_toolbox_margin_padding_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_scss_toolbox_layout_scss__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_scss_toolbox_layout_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_scss_toolbox_layout_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Nav_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Hero_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Footer_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Subhero_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__WidgetAuthor_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__WidgetFeaturedBlock_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__WidgetFeaturedOn_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__WidgetProviders_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__WidgetFaq_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__WidgetArticlesRelated_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__WidgetSliderMonitoScore_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__WidgetDetailsMonitoScore_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__WidgetBreadcrum_vue__ = __webpack_require__(25);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      herotype: 'contentpage',
      scrollingActive: true,
      anchor: '01',
      scroll_history: '0',
      scroll_direction: 'down',
      aside_stack: '',
      stick_pos: '1',
      stick_pos_1: '1',
      aside_state: '',
      aside_state_down: '',
      details_trust: [{ label: 'Monito’s background check', score: '10', infos: 'Western Union is the largest money transfer provider in the world. They passed our background check and can be trusted.' }, { label: 'Number of positive reviews', score: '6', infos: 'Western Union has more than 2,000 positive customer reviews' }, { label: 'Number of customers', score: '10', infos: 'Western Union has more than 150 million customers' }, { label: 'Years in business', score: '10', infos: 'PayPal exists since 1998' }, { label: 'Transparent pricing', score: '6', infos: 'The margin on the exchange rate is not explicitly communicated and accounts for most of the total cost of a transfer with Western Union' }],
      small_trust: '<p class="f_body">Our users often ask us, is TransferWise safe? Like all companies listed on our site, they must meet strict criteria to make them safe and trustworthy in our eyes.</p><p class="f_body">TransferWise is a licensed Authorised Electronic Money Institution—which means they are regulated by the FCA (Financial Conduct Authority) and HMRC (Her Majesty\'s Revenue and Customs) in the United Kingdom (where its headquarters are located) as well as by a variety of other regulatory institutions in other countries. For example, TransferWise Ltd Australia is regulated by the Australian Securities and Investments Commission (ASIC).</p>',
      trust: '<p class="f_body">Our users often ask us, is TransferWise safe? Like all companies listed on our site, they must meet strict criteria to make them safe and trustworthy in our eyes.</p><p class="f_body">TransferWise is a licensed Authorised Electronic Money Institution—which means they are regulated by the FCA (Financial Conduct Authority) and HMRC (Her Majesty\'s Revenue and Customs) in the United Kingdom (where its headquarters are located) as well as by a variety of other regulatory institutions in other countries. For example, TransferWise Ltd Australia is regulated by the Australian Securities and Investments Commission (ASIC). In the US, they are registered with the Financial Intelligence Unit (AUSTRAC) as money remitter TransferWise Inc. and are registered with the Financial Crimes Enforcement Network (FinCEN). TransferWise Inc is also licensed as a money transmitter in individual American states—in other words, they aresupervised by regulatory authorities in each of the states they operate in.</p><p class="f_body">They offer institutional grade security for their service and take preventative measures, such as 2-step login and verification procedures.</p><p class="f_body">As per FCA regulations, clients’ funds are held completely separate from TransferWise’s own business accounts, in so-called segregated accounts. Should the company have any financial difficulties, your money will be safe.</p><p class="f_body">TransferWise employs around 1000 people from over 60 nationalities across its nine offices around the world. Employees give the company close to 5 star rating on the employer review site Glassdoor, and describe the team as a “great company that is doing an awesome job” full of “smart and motivated people,” a company that is “super customer-focused” with an “excellent culture.” One employee wrote they are “Impressed by the professionalism everyone has, alongside an innate sense of trust and drive to achieve the mission”  and another said “The product is honest so there\'s no trying to cheat customers, it\'s work you can feel good about doing.“ Overall, it’s clear that employees love working there and that they feel that they are on a mission to make sending money as cheap and convenient as possible.</p><p class="f_body">TransferWise has raised over $396M dollars from major investors including Virgin Group / Sir Richard Branson, Andreessen Horowitz, IVP (Institutional Venture Partners), Max Levchin of PayPal, Sapphire and Seedcamp, which has helped the startup sustain its phenomenal growth. For example, in 2016 they saw a growth rate of approximately 150% and in the 2017 fiscal year their revenues more than doubled! Overall, the company reported revenues of £67 million (US $94 million) for 2017, and made an adjusted operating profit of £2 million.</p><p class="f_body">So, is TransferWise safe? Absolutely, we wouldn’t hesitate to trust them even with transfers of large amounts. In fact, we have used them ourselves for many of our own international payments.</p><p class="f_body">Authorised by the UK Financial Conduct Authority (FCA)</p><p class="f_body">Firm Reference : 900507</p>',

      details_service: [{ label: 'Monito\'s Expert Analysis', score: '8', infos: 'Our user experience experts found only a few elements that could be improve on Western Union\'s webdsit to make it more intuitive. ' }, { label: 'International transfer to bank account', score: '10', infos: 'Western Union offers multiple pay-in options and fast transfers to a bank account.' }, { label: 'International transfer to cash pick-up', score: '10', infos: 'Western Union has the larget network of cash pick-up locations and offer instant transfer to most destinations' }, { label: 'International Airtime top-up', score: '', infos: 'Western Union doesn\'t offer airtime top-up services' }, { label: 'Travel Card', score: '', infos: 'Western Union doesn\'t offer a travel card' }, { label: 'Multi-currency account', score: '', infos: 'Western Union doesn\'t offer a multi-currency account' }],
      small_service: '<p class="f_body">TransferWise currently supports sending money to 71 countries and sending money from 43 countries. The company covers 1000+ routes (country combinations) across 57 currencies, and they are also one of the few companies offering the true mid-market rate.</p>',
      service: '<p class="f_body">TransferWise currently supports sending money to 71 countries and sending money from 43 countries. The company covers 1000+ routes (country combinations) across 57 currencies, and they are also one of the few companies offering the true mid-market rate.</p><p class="f_body">Most currencies supported by TransferWise offer one option: a bank transfer from one bank to another. For some currencies, you can pay with debit and credit cards or use a SOFORT transfer option. Apple Pay or Android Pay is also available for certain currencies via TransferWise iOS and Android apps. In most cases, the recipient will get the money within one to two business days.</p><p class="f_body">TransferWise is a top choice for international money transfers. They are known for their great customer service, have excellent reviews on Trustpilot, and provide speedy transfers. And the cherry on the cake? They also provide spectacular user experience, from an easy sign-up process to efficient transfers, as evidenced in our <a target="_blank" href="https://www.monito.com/en/wiki/transferwise-usability-user-experience/">in-depth UX analysis of what first-time users think of TransferWise</a>. Some users were so impressed they thought it is too good to be true. Yes, it’s good, but it’s also true!</p>',

      details_customer: [{ label: 'Customer review score', score: '8.3', infos: 'TransferWise has 83% of 4 of 5 stars customer reviews' }, { label: 'Recommendation success rate', score: '8.5', infos: 'A lot of users we redirect to Western Union end up opening an account and making a transfer' }],
      small_customer: '<p class="f_body">TransferWise has excellent customer reviews on Trustpilot. Nearly 90% of the feedback rating the company 5 stars on 56,619 reviews. Here’s what some TransferWise customers say:</p>',
      customer: '<p class="f_body">TransferWise has excellent customer reviews on Trustpilot. Nearly 90% of the feedback rating the company 5 stars on 56,619 reviews. Here’s what some TransferWise customers say:</p><h3 class="f_subtitle_2">Positive</h3><ul class="f_body pros"><li>It works!!! Trustable.</li><li>It\'s wonderful: Fast, transparent, inexpensive.</li><li>Quick, simple easy to use, self-explanatory. It’s also safe and efficient.</li><li>Fast, simple, user-friendly and with no hidden fees!</li><li>Very good customer service, helpful and knowledgeable.</li></ul><h3 class="f_subtitle_2">Negative</h3><ul class="f_body cons"><li>Sometimes there is a delay</li><li>Some frustrations with the required documentation required to verify identities</li></ul>',

      details_fees: [{ label: 'International transfer to bank account', score: '9', infos: 'Western Union is the cheapest provider in 26% of searches and has competitive pricing in 90% of searches on Monito.' }, { label: 'International transfer to cash pick-up', score: '', infos: 'Western Union doesn\'t offer cash pick-up services' }, { label: 'Airtime top-up', score: '', infos: 'Western Union doesn\'t offer airtime top-up services' }, { label: 'Travel Card', score: '', infos: 'Western Union doesn\'t offer a travel card' }, { label: 'Multi-currency account', score: '', infos: 'Western Union doesn\'t offer a multi-currency account' }],
      small_fees: '<h3 class="f_subtitle_2">TransferWise Transfer fees</h3><p class="f_body">TransferWise fees are low and fully transparent. They charge a percent of the transfer amount, and a flat fee for certain transfer routes (country combinations). The minimum TransferWise fees and percent depend on the currencies you are sending from and to and certain currencies have variable fees depending on the total amount being sent.</p>',

      fees: '<h3 class="f_subtitle_2">TransferWise Transfer fees</h3><p class="f_body">TransferWise fees are low and fully transparent. They charge a percent of the transfer amount, and a flat fee for certain transfer routes (country combinations). The minimum TransferWise fees and percent depend on the currencies you are sending from and to and certain currencies have variable fees depending on the total amount being sent.</p><p class="f_body">For example, from GBP (British Pound) to EUR (Euro), you will pay 0.35% of the transfer amount with a fee of £0.80. The reverse, EUR (Euro) to GBP (British costs 0.5% of the transfer amount with a flat fee of €2. Sending DKK (Danish Kroner), to Euros will cost you 0.5% of the transfer amount on the initial DKK 50,000 and 0.3% on anything over that amount.</p><h3 class="f_subtitle_2">TransferWise Exchange rate</h3><p class="f_body">TransferWise converts your money using the true mid-market rate when they receive and process your money. This means that the TransferWise exchange rate is the fairest, most accurate exchange rate you can hope for. Bonus: TransferWise will automatically lock the exchange rate for a specified time frame, from 24 hours for most countries, and 48 hours for several others and 72 hours for BRL (Brazilian Reals) so you’re not exposed to exchange rate fluctuations (they call this the “guaranteed rate” feature). This is one way to ensure that your recipient receives a specific amount. Caveat: your money must be received by TransferWise within the specified time frame, or else the exchange rate - and therefore also the amount received - will no longer be guaranteed.</p><h3 class="f_subtitle_2">Other fees</h3><p class="f_body">In most cases, TransferWise uses local accounts to collect and send funds. This means that there should be no fees charged by the sending or receiving banks, and no intermediary bank fees.</p><p class="f_body">If you’re paying by credit card, you will be charged a credit card fee of 0.3% - 2% depending on the currency you’re sending from and the type of credit card you are using. Debit card payments are free from certain currencies or incur a debit card fee of 0.15% - 2%.</p><p class="f_body">TransferWise sends certain currencies via the international SWIFT network, which most banks will charge a fee to receive. If you’re sending to these currencies, make sure you check with the receiving bank how much they charge for incoming SWIFT payments. TransferWise SWIFT currencies are: JPY (Japanese Yen) over 1 million and ZAR (South African Rand) or a USD transfer to a bank account outside of US, we send it to your recipient as a SWIFT transfer.</p><p class="f_body">TransferWise can also receive USD (US Dollars) via SWIFT. If you live in the US, you will not want to do this since your bank will likely charge you fees to make a SWIFT payment, and free or cheaper alternatives are available (domestic wire and ACH direct debit). You’ll only want to send USD to TransferWise via SWIFT if your payment is coming from outside the US.</p>',

      urlBackground: 'https://images.prismic.io/monito/595e5e4bf13c1e6e728aceae610bb5ed7b216739_bank-londong-metro-station.jpg',
      provider: { logo: '/public/review_western.png', url: 'https://go.monito.com/western-union', score: '8.9', name: 'Western Union', sub_score_01: '9.0', sub_score_02: '9.0', sub_score_03: '8.4', sub_score_04: '9.0', country: '<span>Available from the UK</span> and 25 other countries to 54 countries', country_score: ' excellent', cost: 'Western Union is the <span>cheapest provider in 26% of searches</span> and has <span>competitive pricing in 90% of searches </span>on Monito.', cost_score: ' excellent' },

      providers: [{ logo: '../public/review_ria.png',
        url: 'https://www.monito.com/en/send-money-with/ria?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=provider_carousel',
        score: '5.8' }, { logo: '../public/review_worldremit.png',
        url: 'https://www.monito.com/en/send-money-with/worldremit?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=provider_carousel',
        score: '8.3' }, { logo: '../public/review_paypal.png',
        url: 'https://www.monito.com/en/send-money-with/paypal?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=provider_carousel',
        score: '5.1' }, { logo: '../public/review_remitly.png',
        url: 'https://www.monito.com/en/send-money-with/remitly?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=provider_carousel',
        score: '7.6' }, { logo: '../public/review_skrill.png',
        url: 'https://www.monito.com/en/send-money-with/skrill?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=provider_carousel',
        score: '8.9' }, { logo: '../public/review_transfergo.png',
        url: 'https://www.monito.com/en/send-money-with/skrill?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=provider_carousel',
        score: '8.1' }, { logo: '../public/review_western.png',
        url: 'https://www.monito.com/en/send-money-with/skrill?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=provider_carousel',
        score: '8.3' }]
    };
  },

  methods: {
    handleScroll: function handleScroll(e) {
      if (window.innerWidth > 990) {
        this.scrollingActive = true;
      } else {
        this.scrollingActive = false;
      }

      var main_top = $("main").get(0);
      var aside_top = $("aside").get(0);
      console.log(aside_top.getBoundingClientRect().bottom);
      if (main_top.getBoundingClientRect().bottom > 100 && aside_top.getBoundingClientRect().bottom < -10) {
        $(".cta_sticky").addClass('active');
        $(".cta_sticky").removeClass('remove');
      } else if ($(".cta_sticky").hasClass('active')) {
        $(".cta_sticky").addClass('remove');
        $(".cta_sticky").removeClass('active');
      }

      var anchor01 = $("#anchor01").get(0);
      var anchor02 = $("#anchor02").get(0);
      var anchor03 = $("#anchor03").get(0);
      var anchor04 = $("#anchor04").get(0);
      if (this.scrollingActive) {
        if (anchor01.getBoundingClientRect().top < 200 & anchor01.getBoundingClientRect().bottom > 100) {
          $(".monito_score ul li").removeClass('active');
          $(".monito_score ul li:nth-child(1)").addClass('active');
        } else if (anchor02.getBoundingClientRect().top < 200 & anchor02.getBoundingClientRect().bottom > 100) {
          $(".monito_score ul li").removeClass('active');
          $(".monito_score ul li:nth-child(2)").addClass('active');
        } else if (anchor03.getBoundingClientRect().top < 200 & anchor03.getBoundingClientRect().bottom > 100) {
          $(".monito_score ul li").removeClass('active');
          $(".monito_score ul li:nth-child(3)").addClass('active');
        } else if (anchor04.getBoundingClientRect().top < 200) {
          $(".monito_score ul li").removeClass('active');
          $(".monito_score ul li:nth-child(4)").addClass('active');
        } else {
          $(".monito_score ul li").removeClass('active');
        }
      }

      if (this.scrollingActive) {
        var element_aside = $("main aside");
        var aside = $("main aside").get(0);

        if (aside.getBoundingClientRect().height + 70 > window.innerHeight) {
          console.log(this.stick_pos);
          if (window.scrollY < this.prevScrollY) {
            this.stick_pos = this.scrollUpwards(this.stick_pos, element_aside);
          } else {
            this.stick_pos = this.scrollDownwards(this.stick_pos, element_aside);
          }
          this.prevScrollY = window.scrollY;
        } else {
          element_aside.css("position", "sticky").css("top", '50px').css("bottom", '').css("align-self", "flex-start");
        }
      }

      if (this.scrollingActive) {
        var element_aside_1 = $(".container_layout aside");
        var aside_1 = $(".container_layout aside").get(0);

        if (aside_1.getBoundingClientRect().height + 70 > window.innerHeight) {
          console.log(this.stick_pos);
          if (window.scrollY < this.prevScrollY) {
            this.stick_pos_1 = this.scrollUpwards(this.stick_pos_1, element_aside_1);
          } else {
            this.stick_pos_1 = this.scrollDownwards(this.stick_pos_1, element_aside_1);
          }
          this.prevScrollY = window.scrollY;
        } else {
          element_aside_1.css("position", "sticky").css("top", '50px').css("bottom", '').css("align-self", "flex-start");
        }
      }
    },
    scrollDownwards: function scrollDownwards(stick_pos, element_aside) {
      if (stick_pos === -1) return stick_pos;
      // Figure out where the new window will be after scroll
      var aside = element_aside.get(0);
      var browser_bottom = window.innerHeight;
      var aside_bottom = aside.getBoundingClientRect().top + aside.offsetHeight;
      var belowAside = browser_bottom > aside_bottom;
      // If we are going below the element then we know we must stick
      // it to the bottom.
      if (belowAside) {
        element_aside.css("position", "sticky").css("top", 'auto').css("bottom", '20px').css("align-self", "flex-end");
        return -1;
      }
      // If it will still be above the bottom of the element, then we
      // must absolutely position it to its current position - if it already is absolutely positioned then we do    nothing
      if (stick_pos == 0) return stick_pos;

      // Undo the stick to the top
      // First get the current position
      // $("aside").css("position", "absolute")
      // .css("top", aside.offsetTop);
      element_aside.css("top", aside.offsetTop).css("position", "absolute").css("bottom", '').css("right", '0').css("align-self", "");
      return 0;
    },
    scrollUpwards: function scrollUpwards(stick_pos, element_aside) {
      if (stick_pos === 1) return stick_pos;
      // Figure out where the new window will be after scrol    
      var aside = element_aside.get(0);
      var aboveAside = aside.getBoundingClientRect().top;
      // If we are going above the element then we know we must sticks
      // it to the top
      if (aboveAside) {
        element_aside.css("position", "sticky").css("top", '50px').css("bottom", '').css("align-self", "flex-start");
        return 1;
      }

      if (stick_pos == 0) return stick_pos;

      // Undo the stick to the bottom
      // First get the current position
      element_aside.css("top", aside.offsetTop).css("position", "absolute").css("bottom", '').css("right", '0').css("align-self", "");
      return 0;
    }
  },
  components: {
    'app-navigation': __WEBPACK_IMPORTED_MODULE_3__Nav_vue__["a" /* default */],
    'app-hero-section': __WEBPACK_IMPORTED_MODULE_4__Hero_vue__["a" /* default */],
    'app-subhero-section': __WEBPACK_IMPORTED_MODULE_6__Subhero_vue__["default"],
    'widget-text-featured-block': __WEBPACK_IMPORTED_MODULE_8__WidgetFeaturedBlock_vue__["default"],
    'widget-featured-on': __WEBPACK_IMPORTED_MODULE_9__WidgetFeaturedOn_vue__["default"],
    'widget-providers': __WEBPACK_IMPORTED_MODULE_10__WidgetProviders_vue__["a" /* default */],
    'widget-articles': __WEBPACK_IMPORTED_MODULE_12__WidgetArticlesRelated_vue__["a" /* default */],
    'app-footer': __WEBPACK_IMPORTED_MODULE_5__Footer_vue__["a" /* default */],
    'widget-faq': __WEBPACK_IMPORTED_MODULE_11__WidgetFaq_vue__["a" /* default */],
    'widget-author': __WEBPACK_IMPORTED_MODULE_7__WidgetAuthor_vue__["a" /* default */],
    'widget-monito-score': __WEBPACK_IMPORTED_MODULE_13__WidgetSliderMonitoScore_vue__["a" /* default */],
    'widget-detail-monito-score': __WEBPACK_IMPORTED_MODULE_14__WidgetDetailsMonitoScore_vue__["a" /* default */],
    'widget-breadcrum': __WEBPACK_IMPORTED_MODULE_15__WidgetBreadcrum_vue__["default"]
  },
  created: function created() {
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleScroll);
    this.handleScroll();
  }
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_scss_toolbox_fonts_scss__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_scss_toolbox_fonts_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_scss_toolbox_fonts_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_scss_toolbox_margin_padding_scss__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_scss_toolbox_margin_padding_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_scss_toolbox_margin_padding_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_scss_toolbox_layout_scss__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_scss_toolbox_layout_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_scss_toolbox_layout_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Nav_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Hero_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Footer_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Subhero_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__WidgetAuthor_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__WidgetFeaturedBlock_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__WidgetIllustrations_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__WidgetFeaturedOn_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__WidgetProviders_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__WidgetFaq_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__WidgetArticlesRelated_vue__ = __webpack_require__(16);
//
//
//
//
//
//
//
//
//
//
















/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      herotype: 'home',
      urlBackground: '',
      providers: [{ logo: 'public/review_ria.png', url: 'ria.com', score: '5.8' }, { logo: 'public/review_worldremit.png', url: 'paypal.com', score: '8.3' }, { logo: 'public/review_paypal.png', url: 'paypal.com', score: '5.1' }, { logo: 'public/review_remitly.png', url: 'paypal.com', score: '7.6' }, { logo: 'public/review_transfergo.png', url: 'paypal.com', score: '8.2' }, { logo: 'public/review_western.png', url: 'paypal.com', score: '7.9' }, { logo: 'public/review_transferwise.png', url: 'paypal.com', score: '8.8' }, { logo: 'public/review_xendpay.png', url: 'paypal.com', score: '6.6' }, { logo: 'public/review_skrill.png', url: 'paypal.com', score: '8.3' }],
      articles: [{ cover: 'https://images.prismic.io/monito/dd9100c21fa169148f105678a8ba45047025dce4_keyboard-typing-sending-money-online.jpg',
        url: 'https://www.monito.com/en/wiki/what-is-the-cheapest-way-to-send-money-abroad',
        title: 'Find the Cheapest Way to Send Money Abroad',
        date_author: 'Apr. 15, 2019  -  by François Briod' }, { cover: 'https://images.prismic.io/monito/b8d2f5539c4cbf71088d90a7985ba1d37ffade26_artem-bali-659437-unsplash-5.jpg',
        url: 'https://www.monito.com/en/wiki/zelle-international-money-transfer-alternatives',
        title: 'Can I use Zelle to send money Internationally? No! Find alternatives now',
        date_author: 'Mar. 28, 2019  -  by François Briod' }, { cover: 'https://images.prismic.io/monito/prismic/d2d5b77ee0ed5cbc9494376cdd1ad510409469c7_cheetah-running-hero.jpg',
        url: 'https://www.monito.com/en/wiki/what-is-the-fastest-way-to-send-money-abroad',
        title: 'Find the Fastest Way to Send Money Abroad',
        date_author: 'Nov. 14, 2019' }, { cover: '',
        url: 'https://www.monito.com/en/wiki/square-cash-international-money-transfer-alternatives',
        title: 'Can I use Square Cash to send money Internationally?',
        date_author: 'Oct. 01, 2019' }, { cover: 'https://images.prismic.io/monito/eaee3cd7169be1fe0363a708de2e97fa4622501c_best-international-bank-accounts-for-digital-nomads-laptop-money.jpg',
        url: 'https://www.monito.com/en/wiki/what-is-the-fastest-way-to-send-money-abroad',
        title: 'The best international bank accounts for digital nomads, travelers & expats',
        date_author: 'Nov. 14, 2018  -  by Caroline Sieg' }]
    };
  },

  methods: {
    handleScroll: function handleScroll(event) {
      // hauteur de la zone de scroll
      //this.scroll_zone = this.$refs.scroll_zone.clientHeight;
      var bodyRect = document.body.getBoundingClientRect(),
          container_width = this.$refs.main.clientWidth,
          aside = this.$refs.scroll_widgets.getBoundingClientRect(),
          scroll_zone = this.$refs.scroll_zone.getBoundingClientRect(),
          left = scroll_zone.right,
          aside_width = this.$refs.scroll_widgets.clientWidth,
          scroll_zone_width = this.$refs.scroll_zone.clientWidth,
          aside_height = this.$refs.scroll_widgets.clientHeight,
          scroll_zone_height = this.$refs.main.clientHeight,


      // position top de la zone de scroll
      offset_scroll_zone = scroll_zone.top - bodyRect.top;
      var position_x_aside = scroll_zone.top - bodyRect.top;

      var bottom_main_content = offset_scroll_zone + scroll_zone_height;

      // valeur du scoll de la page
      var y = window.scrollY;
      var debut_scroll = 0;

      if (y > position_x_aside - 20) {
        if (y <= bottom_main_content - aside_height - 20) {
          this.$refs.scroll_widgets.style.position = 'fixed';
          this.$refs.scroll_widgets.style.left = left + (container_width - (scroll_zone_width + aside_width)) + 'px';
          this.$refs.scroll_widgets.style.top = 20 + 'px';
        } else {
          this.$refs.scroll_widgets.style.top = scroll_zone_height - aside_height + 'px';
          this.$refs.scroll_widgets.style.position = 'absolute';
          this.$refs.scroll_widgets.style.left = '';
        }
      } else {
        this.$refs.scroll_widgets.style.top = '0px';
        this.$refs.scroll_widgets.style.position = 'absolute';
        this.$refs.scroll_widgets.style.left = '';
      }
    }
  },
  components: {
    'app-navigation': __WEBPACK_IMPORTED_MODULE_3__Nav_vue__["a" /* default */],
    'app-hero-section': __WEBPACK_IMPORTED_MODULE_4__Hero_vue__["a" /* default */],
    'app-subhero-section': __WEBPACK_IMPORTED_MODULE_6__Subhero_vue__["default"],
    'widget-text-featured-block': __WEBPACK_IMPORTED_MODULE_8__WidgetFeaturedBlock_vue__["default"],
    'widget-featured-on': __WEBPACK_IMPORTED_MODULE_10__WidgetFeaturedOn_vue__["default"],
    'widget-providers': __WEBPACK_IMPORTED_MODULE_11__WidgetProviders_vue__["a" /* default */],
    'widget-articles': __WEBPACK_IMPORTED_MODULE_13__WidgetArticlesRelated_vue__["a" /* default */],
    'app-footer': __WEBPACK_IMPORTED_MODULE_5__Footer_vue__["a" /* default */],
    'widget-faq': __WEBPACK_IMPORTED_MODULE_12__WidgetFaq_vue__["a" /* default */],
    'widget-author': __WEBPACK_IMPORTED_MODULE_7__WidgetAuthor_vue__["a" /* default */],
    'widget-illustrations': __WEBPACK_IMPORTED_MODULE_9__WidgetIllustrations_vue__["default"]
  },
  created: function created() {
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleScroll);
  }
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_vue__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Header_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routes__ = __webpack_require__(95);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('app-header', __WEBPACK_IMPORTED_MODULE_3__components_Header_vue__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_4__routes__["a" /* routes */],
  mode: 'history'
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: router,
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_2__App_vue__["a" /* default */]);
  }
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(20), __webpack_require__(83).setImmediate))

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(84);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(20)))

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(20), __webpack_require__(26)))

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
  * vue-router v3.5.1
  * (c) 2021 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function extend (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
    .replace(encodeReserveRE, encodeReserveReplacer)
    .replace(commaRE, ','); };

function decode (str) {
  try {
    return decodeURIComponent(str)
  } catch (err) {
    if (false) {
      warn(false, ("Error decoding \"" + str + "\". Leaving it intact."));
    }
  }
  return str
}

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    var value = extraQuery[key];
    parsedQuery[key] = Array.isArray(value)
      ? value.map(castQueryParamValue)
      : castQueryParamValue(value);
  }
  return parsedQuery
}

var castQueryParamValue = function (value) { return (value == null || typeof value === 'object' ? value : String(value)); };

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0 ? decode(parts.join('=')) : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj
    ? Object.keys(obj)
      .map(function (key) {
        var val = obj[key];

        if (val === undefined) {
          return ''
        }

        if (val === null) {
          return encode(key)
        }

        if (Array.isArray(val)) {
          var result = [];
          val.forEach(function (val2) {
            if (val2 === undefined) {
              return
            }
            if (val2 === null) {
              result.push(encode(key));
            } else {
              result.push(encode(key) + '=' + encode(val2));
            }
          });
          return result.join('&')
        }

        return encode(key) + '=' + encode(val)
      })
      .filter(function (x) { return x.length > 0; })
      .join('&')
    : null;
  return res ? ("?" + res) : ''
}

/*  */

var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b, onlyPath) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') && (onlyPath ||
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query))
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      (onlyPath || (
        a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params))
      )
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a).sort();
  var bKeys = Object.keys(b).sort();
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key, i) {
    var aVal = a[key];
    var bKey = bKeys[i];
    if (bKey !== key) { return false }
    var bVal = b[key];
    // query values can be null and undefined
    if (aVal == null || bVal == null) { return aVal === bVal }
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

function handleRouteEntered (route) {
  for (var i = 0; i < route.matched.length; i++) {
    var record = route.matched[i];
    for (var name in record.instances) {
      var instance = record.instances[name];
      var cbs = record.enteredCbs[name];
      if (!instance || !cbs) { continue }
      delete record.enteredCbs[name];
      for (var i$1 = 0; i$1 < cbs.length; i$1++) {
        if (!instance._isBeingDestroyed) { cbs[i$1](instance); }
      }
    }
  }
}

var View = {
  name: 'RouterView',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    // used by devtools to display a router-view badge
    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      var vnodeData = parent.$vnode ? parent.$vnode.data : {};
      if (vnodeData.routerView) {
        depth++;
      }
      if (vnodeData.keepAlive && parent._directInactive && parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      var cachedData = cache[name];
      var cachedComponent = cachedData && cachedData.component;
      if (cachedComponent) {
        // #2301
        // pass props
        if (cachedData.configProps) {
          fillPropsinData(cachedComponent, data, cachedData.route, cachedData.configProps);
        }
        return h(cachedComponent, data, children)
      } else {
        // render previous empty view
        return h()
      }
    }

    var matched = route.matched[depth];
    var component = matched && matched.components[name];

    // render empty node if no matched route or no config component
    if (!matched || !component) {
      cache[name] = null;
      return h()
    }

    // cache component
    cache[name] = { component: component };

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // register instance in init hook
    // in case kept-alive component be actived when routes changed
    data.hook.init = function (vnode) {
      if (vnode.data.keepAlive &&
        vnode.componentInstance &&
        vnode.componentInstance !== matched.instances[name]
      ) {
        matched.instances[name] = vnode.componentInstance;
      }

      // if the route transition has already been confirmed then we weren't
      // able to call the cbs during confirmation as the component was not
      // registered yet, so we call it here.
      handleRouteEntered(route);
    };

    var configProps = matched.props && matched.props[name];
    // save route and configProps in cache
    if (configProps) {
      extend(cache[name], {
        route: route,
        configProps: configProps
      });
      fillPropsinData(component, data, route, configProps);
    }

    return h(component, data, children)
  }
};

function fillPropsinData (component, data, route, configProps) {
  // resolve props
  var propsToPass = data.props = resolveProps(route, configProps);
  if (propsToPass) {
    // clone to prevent mutation
    propsToPass = data.props = extend({}, propsToPass);
    // pass non-declared props as attrs
    var attrs = data.attrs = data.attrs || {};
    for (var key in propsToPass) {
      if (!component.props || !(key in component.props)) {
        attrs[key] = propsToPass[key];
        delete propsToPass[key];
      }
    }
  }
}

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options));
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}
pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  params = params || {};
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));

    // Fix #2505 resolving asterisk routes { name: 'not-found', params: { pathMatch: '/not-found' }}
    // and fix #3106 so that you can work with location descriptor object having params.pathMatch equal to empty string
    if (typeof params.pathMatch === 'string') { params[0] = params.pathMatch; }

    return filler(params, { pretty: true })
  } catch (e) {
    if (false) {
      // Fix #3072 no warn if `pathMatch` is string
      warn(typeof params.pathMatch === 'string', ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  } finally {
    // delete the 0 if it was added
    delete params[0];
  }
}

/*  */

function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next._normalized) {
    return next
  } else if (next.name) {
    next = extend({}, raw);
    var params = next.params;
    if (params && typeof params === 'object') {
      next.params = extend({}, params);
    }
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = extend({}, next);
    next._normalized = true;
    var params$1 = extend(extend({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params$1;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params$1, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var noop = function () {};

var warnedCustomSlot;
var warnedTagProp;
var warnedEventProp;

var Link = {
  name: 'RouterLink',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    custom: Boolean,
    exact: Boolean,
    exactPath: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    ariaCurrentValue: {
      type: String,
      default: 'page'
    },
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(
      this.to,
      current,
      this.append
    );
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback =
      globalActiveClass == null ? 'router-link-active' : globalActiveClass;
    var exactActiveClassFallback =
      globalExactActiveClass == null
        ? 'router-link-exact-active'
        : globalExactActiveClass;
    var activeClass =
      this.activeClass == null ? activeClassFallback : this.activeClass;
    var exactActiveClass =
      this.exactActiveClass == null
        ? exactActiveClassFallback
        : this.exactActiveClass;

    var compareTarget = route.redirectedFrom
      ? createRoute(null, normalizeLocation(route.redirectedFrom), null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget, this.exactPath);
    classes[activeClass] = this.exact || this.exactPath
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var ariaCurrentValue = classes[exactActiveClass] ? this.ariaCurrentValue : null;

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location, noop);
        } else {
          router.push(location, noop);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) {
        on[e] = handler;
      });
    } else {
      on[this.event] = handler;
    }

    var data = { class: classes };

    var scopedSlot =
      !this.$scopedSlots.$hasNormal &&
      this.$scopedSlots.default &&
      this.$scopedSlots.default({
        href: href,
        route: route,
        navigate: handler,
        isActive: classes[activeClass],
        isExactActive: classes[exactActiveClass]
      });

    if (scopedSlot) {
      if (false) {
        !warnedCustomSlot && warn(false, 'In Vue Router 4, the v-slot API will by default wrap its content with an <a> element. Use the custom prop to remove this warning:\n<router-link v-slot="{ navigate, href }" custom></router-link>\n');
        warnedCustomSlot = true;
      }
      if (scopedSlot.length === 1) {
        return scopedSlot[0]
      } else if (scopedSlot.length > 1 || !scopedSlot.length) {
        if (false) {
          warn(
            false,
            ("<router-link> with to=\"" + (this.to) + "\" is trying to use a scoped slot but it didn't provide exactly one child. Wrapping the content with a span element.")
          );
        }
        return scopedSlot.length === 0 ? h() : h('span', {}, scopedSlot)
      }
    }

    if (false) {
      if ('tag' in this.$options.propsData && !warnedTagProp) {
        warn(
          false,
          "<router-link>'s tag prop is deprecated and has been removed in Vue Router 4. Use the v-slot API to remove this warning: https://next.router.vuejs.org/guide/migration/#removal-of-event-and-tag-props-in-router-link."
        );
        warnedTagProp = true;
      }
      if ('event' in this.$options.propsData && !warnedEventProp) {
        warn(
          false,
          "<router-link>'s event prop is deprecated and has been removed in Vue Router 4. Use the v-slot API to remove this warning: https://next.router.vuejs.org/guide/migration/#removal-of-event-and-tag-props-in-router-link."
        );
        warnedEventProp = true;
      }
    }

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href, 'aria-current': ariaCurrentValue };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var aData = (a.data = extend({}, a.data));
        aData.on = aData.on || {};
        // transform existing events in both objects into arrays so we can push later
        for (var event in aData.on) {
          var handler$1 = aData.on[event];
          if (event in on) {
            aData.on[event] = Array.isArray(handler$1) ? handler$1 : [handler$1];
          }
        }
        // append new listeners for router-link
        for (var event$1 in on) {
          if (event$1 in aData.on) {
            // on[event] is always a function
            aData.on[event$1].push(on[event$1]);
          } else {
            aData.on[event$1] = handler;
          }
        }

        var aAttrs = (a.data.attrs = extend({}, a.data.attrs));
        aAttrs.href = href;
        aAttrs['aria-current'] = ariaCurrentValue;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('RouterView', View);
  Vue.component('RouterLink', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap,
  parentRoute
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route, parentRoute);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  if (false) {
    // warn if routes do not include leading slashes
    var found = pathList
    // check for missing leading slash
      .filter(function (path) { return path && path.charAt(0) !== '*' && path.charAt(0) !== '/'; });

    if (found.length > 0) {
      var pathNames = found.map(function (path) { return ("- " + path); }).join('\n');
      warn(false, ("Non-nested routes must include a leading slash character. Fix the following routes: \n" + pathNames));
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(
        path || name
      )) + " cannot be a " + "string id. Use an actual component instead."
    );

    warn(
      // eslint-disable-next-line no-control-regex
      !/[^\u0000-\u007F]+/.test(path),
      "Route with path \"" + path + "\" contains unencoded characters, make sure " +
        "your path is correctly encoded before passing it to the router. Use " +
        "encodeURI to encode static segments of your path."
    );
  }

  var pathToRegexpOptions =
    route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(path, parent, pathToRegexpOptions.strict);

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    alias: route.alias
      ? typeof route.alias === 'string'
        ? [route.alias]
        : route.alias
      : [],
    instances: {},
    enteredCbs: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props:
      route.props == null
        ? {}
        : route.components
          ? route.props
          : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (
        route.name &&
        !route.redirect &&
        route.children.some(function (child) { return /^\/?$/.test(child.path); })
      ) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
            "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
            "the default child route will not be rendered. Remove the name from " +
            "this route and use the name of the default child route for named " +
            "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias) ? route.alias : [route.alias];
    for (var i = 0; i < aliases.length; ++i) {
      var alias = aliases[i];
      if (false) {
        warn(
          false,
          ("Found an alias with the same value as the path: \"" + path + "\". You have to remove that alias. It will be ignored in development.")
        );
        // skip in dev to make it work
        continue
      }

      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    }
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
          "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (
  path,
  pathToRegexpOptions
) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(
        !keys[key.name],
        ("Duplicate param keys in route with path: \"" + path + "\"")
      );
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (
  path,
  parent,
  strict
) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */



function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function addRoute (parentOrRoute, route) {
    var parent = (typeof parentOrRoute !== 'object') ? nameMap[parentOrRoute] : undefined;
    // $flow-disable-line
    createRouteMap([route || parentOrRoute], pathList, pathMap, nameMap, parent);

    // add aliases of parent
    if (parent) {
      createRouteMap(
        // $flow-disable-line route is defined if parent is
        parent.alias.map(function (alias) { return ({ path: alias, children: [route] }); }),
        pathList,
        pathMap,
        nameMap,
        parent
      );
    }
  }

  function getRoutes () {
    return pathList.map(function (path) { return pathMap[path]; })
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
      return _createRoute(record, location, redirectedFrom)
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
      ? originalRedirect(createRoute(record, location, null, router))
      : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoute: addRoute,
    getRoutes: getRoutes,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    if (key) {
      // Fix #1994: using * with props: true generates a param named 0
      params[key.name || 'pathMatch'] = typeof m[i] === 'string' ? decode(m[i]) : m[i];
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */

// use User Timing api (if present) for more accurate key precision
var Time =
  inBrowser && window.performance && window.performance.now
    ? window.performance
    : Date;

function genStateKey () {
  return Time.now().toFixed(3)
}

var _key = genStateKey();

function getStateKey () {
  return _key
}

function setStateKey (key) {
  return (_key = key)
}

/*  */

var positionStore = Object.create(null);

function setupScroll () {
  // Prevent browser scroll behavior on History popstate
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }
  // Fix for #1585 for Firefox
  // Fix for #2195 Add optional third attribute to workaround a bug in safari https://bugs.webkit.org/show_bug.cgi?id=182678
  // Fix for #2774 Support for apps loaded from Windows file shares not mapped to network drives: replaced location.origin with
  // window.location.protocol + '//' + window.location.host
  // location.host contains the port and location.hostname doesn't
  var protocolAndPath = window.location.protocol + '//' + window.location.host;
  var absolutePath = window.location.href.replace(protocolAndPath, '');
  // preserve existing history state as it could be overriden by the user
  var stateCopy = extend({}, window.history.state);
  stateCopy.key = getStateKey();
  window.history.replaceState(stateCopy, '', absolutePath);
  window.addEventListener('popstate', handlePopState);
  return function () {
    window.removeEventListener('popstate', handlePopState);
  }
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior.call(
      router,
      to,
      from,
      isPop ? position : null
    );

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll
        .then(function (shouldScroll) {
          scrollToPosition((shouldScroll), position);
        })
        .catch(function (err) {
          if (false) {
            assert(false, err.toString());
          }
        });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function handlePopState (e) {
  saveScrollPosition();
  if (e.state && e.state.key) {
    setStateKey(e.state.key);
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

var hashStartsWithNumberRE = /^#\d/;

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    // getElementById would still fail if the selector contains a more complicated query like #main[data-attr]
    // but at the same time, it doesn't make much sense to select an element with an id and an extra selector
    var el = hashStartsWithNumberRE.test(shouldScroll.selector) // $flow-disable-line
      ? document.getElementById(shouldScroll.selector.slice(1)) // $flow-disable-line
      : document.querySelector(shouldScroll.selector);

    if (el) {
      var offset =
        shouldScroll.offset && typeof shouldScroll.offset === 'object'
          ? shouldScroll.offset
          : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    // $flow-disable-line
    if ('scrollBehavior' in document.documentElement.style) {
      window.scrollTo({
        left: position.x,
        top: position.y,
        // $flow-disable-line
        behavior: shouldScroll.behavior
      });
    } else {
      window.scrollTo(position.x, position.y);
    }
  }
}

/*  */

var supportsPushState =
  inBrowser &&
  (function () {
    var ua = window.navigator.userAgent;

    if (
      (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
      ua.indexOf('Mobile Safari') !== -1 &&
      ua.indexOf('Chrome') === -1 &&
      ua.indexOf('Windows Phone') === -1
    ) {
      return false
    }

    return window.history && typeof window.history.pushState === 'function'
  })();

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      // preserve existing history state as it could be overriden by the user
      var stateCopy = extend({}, history.state);
      stateCopy.key = getStateKey();
      history.replaceState(stateCopy, '', url);
    } else {
      history.pushState({ key: setStateKey(genStateKey()) }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

// When changing thing, also edit router.d.ts
var NavigationFailureType = {
  redirected: 2,
  aborted: 4,
  cancelled: 8,
  duplicated: 16
};

function createNavigationRedirectedError (from, to) {
  return createRouterError(
    from,
    to,
    NavigationFailureType.redirected,
    ("Redirected when going from \"" + (from.fullPath) + "\" to \"" + (stringifyRoute(
      to
    )) + "\" via a navigation guard.")
  )
}

function createNavigationDuplicatedError (from, to) {
  var error = createRouterError(
    from,
    to,
    NavigationFailureType.duplicated,
    ("Avoided redundant navigation to current location: \"" + (from.fullPath) + "\".")
  );
  // backwards compatible with the first introduction of Errors
  error.name = 'NavigationDuplicated';
  return error
}

function createNavigationCancelledError (from, to) {
  return createRouterError(
    from,
    to,
    NavigationFailureType.cancelled,
    ("Navigation cancelled from \"" + (from.fullPath) + "\" to \"" + (to.fullPath) + "\" with a new navigation.")
  )
}

function createNavigationAbortedError (from, to) {
  return createRouterError(
    from,
    to,
    NavigationFailureType.aborted,
    ("Navigation aborted from \"" + (from.fullPath) + "\" to \"" + (to.fullPath) + "\" via a navigation guard.")
  )
}

function createRouterError (from, to, type, message) {
  var error = new Error(message);
  error._isRouter = true;
  error.from = from;
  error.to = to;
  error.type = type;

  return error
}

var propertiesToLog = ['params', 'query', 'hash'];

function stringifyRoute (to) {
  if (typeof to === 'string') { return to }
  if ('path' in to) { return to.path }
  var location = {};
  propertiesToLog.forEach(function (key) {
    if (key in to) { location[key] = to[key]; }
  });
  return JSON.stringify(location, null, 2)
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

function isNavigationFailure (err, errorType) {
  return (
    isError(err) &&
    err._isRouter &&
    (errorType == null || err.type === errorType)
  )
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
  this.listeners = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (
  location,
  onComplete,
  onAbort
) {
    var this$1 = this;

  var route;
  // catch redirect option https://github.com/vuejs/vue-router/issues/3201
  try {
    route = this.router.match(location, this.current);
  } catch (e) {
    this.errorCbs.forEach(function (cb) {
      cb(e);
    });
    // Exception should still be thrown
    throw e
  }
  var prev = this.current;
  this.confirmTransition(
    route,
    function () {
      this$1.updateRoute(route);
      onComplete && onComplete(route);
      this$1.ensureURL();
      this$1.router.afterHooks.forEach(function (hook) {
        hook && hook(route, prev);
      });

      // fire ready cbs once
      if (!this$1.ready) {
        this$1.ready = true;
        this$1.readyCbs.forEach(function (cb) {
          cb(route);
        });
      }
    },
    function (err) {
      if (onAbort) {
        onAbort(err);
      }
      if (err && !this$1.ready) {
        // Initial redirection should not mark the history as ready yet
        // because it's triggered by the redirection instead
        // https://github.com/vuejs/vue-router/issues/3225
        // https://github.com/vuejs/vue-router/issues/3331
        if (!isNavigationFailure(err, NavigationFailureType.redirected) || prev !== START) {
          this$1.ready = true;
          this$1.readyErrorCbs.forEach(function (cb) {
            cb(err);
          });
        }
      }
    }
  );
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  this.pending = route;
  var abort = function (err) {
    // changed after adding errors with
    // https://github.com/vuejs/vue-router/pull/3047 before that change,
    // redirect and aborted navigation would produce an err == null
    if (!isNavigationFailure(err) && isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) {
          cb(err);
        });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  var lastRouteIndex = route.matched.length - 1;
  var lastCurrentIndex = current.matched.length - 1;
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    lastRouteIndex === lastCurrentIndex &&
    route.matched[lastRouteIndex] === current.matched[lastCurrentIndex]
  ) {
    this.ensureURL();
    return abort(createNavigationDuplicatedError(current, route))
  }

  var ref = resolveQueue(
    this.current.matched,
    route.matched
  );
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort(createNavigationCancelledError(current, route))
    }
    try {
      hook(route, current, function (to) {
        if (to === false) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(createNavigationAbortedError(current, route));
        } else if (isError(to)) {
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' &&
            (typeof to.path === 'string' || typeof to.name === 'string'))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort(createNavigationRedirectedError(current, route));
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort(createNavigationCancelledError(current, route))
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          handleRouteEntered(route);
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  this.current = route;
  this.cb && this.cb(route);
};

History.prototype.setupListeners = function setupListeners () {
  // Default implementation is empty
};

History.prototype.teardown = function teardown () {
  // clean up event listeners
  // https://github.com/vuejs/vue-router/issues/2341
  this.listeners.forEach(function (cleanupListener) {
    cleanupListener();
  });
  this.listeners = [];

  // reset current history route
  // https://github.com/vuejs/vue-router/issues/3294
  this.current = START;
  this.pending = null;
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated
) {
  return extractGuards(
    activated,
    'beforeRouteEnter',
    function (guard, _, match, key) {
      return bindEnterGuard(guard, match, key)
    }
  )
}

function bindEnterGuard (
  guard,
  match,
  key
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      if (typeof cb === 'function') {
        if (!match.enteredCbs[key]) {
          match.enteredCbs[key] = [];
        }
        match.enteredCbs[key].push(cb);
      }
      next(cb);
    })
  }
}

/*  */

var HTML5History = /*@__PURE__*/(function (History) {
  function HTML5History (router, base) {
    History.call(this, router, base);

    this._startLocation = getLocation(this.base);
  }

  if ( History ) HTML5History.__proto__ = History;
  HTML5History.prototype = Object.create( History && History.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    if (this.listeners.length > 0) {
      return
    }

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      this.listeners.push(setupScroll());
    }

    var handleRoutingEvent = function () {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === this$1._startLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (supportsScroll) {
          handleScroll(router, route, current, true);
        }
      });
    };
    window.addEventListener('popstate', handleRoutingEvent);
    this.listeners.push(function () {
      window.removeEventListener('popstate', handleRoutingEvent);
    });
  };

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.toLowerCase().indexOf(base.toLowerCase()) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */

var HashHistory = /*@__PURE__*/(function (History) {
  function HashHistory (router, base, fallback) {
    History.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History ) HashHistory.__proto__ = History;
  HashHistory.prototype = Object.create( History && History.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    if (this.listeners.length > 0) {
      return
    }

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      this.listeners.push(setupScroll());
    }

    var handleRoutingEvent = function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    };
    var eventType = supportsPushState ? 'popstate' : 'hashchange';
    window.addEventListener(
      eventType,
      handleRoutingEvent
    );
    this.listeners.push(function () {
      window.removeEventListener(eventType, handleRoutingEvent);
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(
      location,
      function (route) {
        pushHash(route.fullPath);
        handleScroll(this$1.router, route, fromRoute, false);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(
      location,
      function (route) {
        replaceHash(route.fullPath);
        handleScroll(this$1.router, route, fromRoute, false);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(cleanPath(base + '/#' + location));
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  // empty path
  if (index < 0) { return '' }

  href = href.slice(index + 1);

  return href
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */

var AbstractHistory = /*@__PURE__*/(function (History) {
  function AbstractHistory (router, base) {
    History.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History ) AbstractHistory.__proto__ = History;
  AbstractHistory.prototype = Object.create( History && History.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(
      location,
      function (route) {
        this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
        this$1.index++;
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(
      location,
      function (route) {
        this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(
      route,
      function () {
        var prev = this$1.current;
        this$1.index = targetIndex;
        this$1.updateRoute(route);
        this$1.router.afterHooks.forEach(function (hook) {
          hook && hook(route, prev);
        });
      },
      function (err) {
        if (isNavigationFailure(err, NavigationFailureType.duplicated)) {
          this$1.index = targetIndex;
        }
      }
    );
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback =
    mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (raw, current, redirectedFrom) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' &&
    assert(
      install.installed,
      "not installed. Make sure to call `Vue.use(VueRouter)` " +
        "before creating root instance."
    );

  this.apps.push(app);

  // set up app destroyed handler
  // https://github.com/vuejs/vue-router/issues/2639
  app.$once('hook:destroyed', function () {
    // clean out app from this.apps array once destroyed
    var index = this$1.apps.indexOf(app);
    if (index > -1) { this$1.apps.splice(index, 1); }
    // ensure we still have a main app or null if no apps
    // we do not release the router so it can be reused
    if (this$1.app === app) { this$1.app = this$1.apps[0] || null; }

    if (!this$1.app) { this$1.history.teardown(); }
  });

  // main app previously initialized
  // return as we don't need to set up new history listener
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History || history instanceof HashHistory) {
    var handleInitialScroll = function (routeOrError) {
      var from = history.current;
      var expectScroll = this$1.options.scrollBehavior;
      var supportsScroll = supportsPushState && expectScroll;

      if (supportsScroll && 'fullPath' in routeOrError) {
        handleScroll(this$1, routeOrError, from, false);
      }
    };
    var setupListeners = function (routeOrError) {
      history.setupListeners();
      handleInitialScroll(routeOrError);
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupListeners,
      setupListeners
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

  // $flow-disable-line
  if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      this$1.history.push(location, resolve, reject);
    })
  } else {
    this.history.push(location, onComplete, onAbort);
  }
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

  // $flow-disable-line
  if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      this$1.history.replace(location, resolve, reject);
    })
  } else {
    this.history.replace(location, onComplete, onAbort);
  }
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply(
    [],
    route.matched.map(function (m) {
      return Object.keys(m.components).map(function (key) {
        return m.components[key]
      })
    })
  )
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  current = current || this.history.current;
  var location = normalizeLocation(to, current, append, this);
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.getRoutes = function getRoutes () {
  return this.matcher.getRoutes()
};

VueRouter.prototype.addRoute = function addRoute (parentOrRoute, route) {
  this.matcher.addRoute(parentOrRoute, route);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  if (false) {
    warn(false, 'router.addRoutes() is deprecated and has been removed in Vue Router 4. Use router.addRoute() instead.');
  }
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '3.5.1';
VueRouter.isNavigationFailure = isNavigationFailure;
VueRouter.NavigationFailureType = NavigationFailureType;
VueRouter.START_LOCATION = START;

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(27);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4216424a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(90);
function injectStyle (ssrContext) {
  __webpack_require__(87)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4216424a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(88);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("38638fd0", content, true, {});

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "body{margin:0;padding:0}", ""]);

// exports


/***/ }),
/* 89 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(38);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fbbbdb0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(94);
function injectStyle (ssrContext) {
  __webpack_require__(92)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fbbbdb0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(93);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("b16708a6", content, true, {});

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(17);
exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "body{background:#f8f8f8;font-family:Avenir Next,-apple-system,system-ui,Segoe UI,Roboto,Ubuntu,Cantarell,Noto Sans,sans-serif;box-sizing:border-box;padding:0;color:#353c45;max-width:100vw;overflow-x:hidden;margin:0}body,header{position:relative}header{border-top:3px solid #8cc42d;z-index:1000}header:before{z-index:-1;top:-927px;background:#fff;width:5452px;height:1050px;left:calc(((5452px - 100vw) / 2) * -1);-webkit-border-radius:150%/95%;-moz-border-radius:150%/95%;border-radius:150%/95%;-webkit-box-shadow:0 3px 20px 0 rgba(0,0,0,.1);-moz-box-shadow:0 3px 20px 0 rgba(0,0,0,.1);box-shadow:0 3px 20px 0 rgba(0,0,0,.1)}header:after,header:before{content:\"\";position:absolute}header:after{z-index:3000px;left:0;height:3px;background-color:#8cc42d;width:100vw;top:-3px}header .hero_element{z-index:-10;position:absolute;width:100%;top:0;height:600px;background-image:linear-gradient(90deg,#81ca00,#8cce02,#97d304,#a2d707,#addb0c)}header .hero_element div{width:1200px;padding-right:30%;box-sizing:border-box;margin:0 auto;position:relative}header .hero_element div:after{content:\"\";width:200px;height:100px;left:590px;bottom:-120px;display:block;position:absolute;background-size:contain;background-repeat:no-repeat}header .hero_element h1{color:#fff}header .hero_element:after{content:\"\";position:absolute;z-index:-2;transform:rotate(-2.6deg);display:block;width:120%;height:200px;bottom:-100px;left:-20px;background:#f8f8f8}.shadow{box-sizing:border-box;-webkit-box-shadow:0 3px 20px 0 rgba(0,0,0,.1);-moz-box-shadow:0 3px 20px 0 rgba(0,0,0,.1);box-shadow:0 3px 20px 0 rgba(0,0,0,.1)}.soft_shadow{-webkit-box-shadow:0 3px 20px 0 rgba(0,0,0,.03);-moz-box-shadow:0 3px 20px 0 rgba(0,0,0,.03);box-shadow:0 3px 20px 0 rgba(0,0,0,.03)}main,nav{max-width:1200px;width:100%;margin:0 auto;overflow:clip}nav{display:flex;justify-content:space-between;align-content:center;margin-top:31px;margin-bottom:72px}nav #logo_monito{display:inline-block;text-indent:-1000px;font-size:1px;background-image:url(" + escape(__webpack_require__(28)) + ");background-repeat:no-repeat;width:190px;margin-left:12px;height:52px;background-size:contain;background-position:50%;z-index:100;vertical-align:middle}nav ul{list-style:none}nav ul,nav ul li{display:inline-block}nav ul li{padding:0 36px}nav ul li:last-child{padding-right:10px}nav ul li a{text-decoration:none;color:#cdcdcd;font-size:12px;color:#6f747a;font-family:Avenir Next,-apple-system,system-ui,Segoe UI,Roboto,Ubuntu,Cantarell,Noto Sans,sans-serif;font-weight:700;letter-spacing:.045em;text-transform:uppercase}nav ul li.langage a{color:#000}nav ul li.langage:after{content:\"\";background-image:url(" + escape(__webpack_require__(29)) + ");background-position:top;margin-left:3px;background-repeat:no-repeat;background-size:contain;width:10px;height:8px;display:inline-block}nav ul li:hover a{transition:all .3s ease;color:#000}.form{flex:none;width:1260px;margin:0 auto;margin-top:82px;margin-bottom:48px;display:block;background:#fff;height:80px;border-radius:10px;left:calc(((100vw - 1260px) / 2) * 1)}.form .country{width:265px;display:inline-block;padding-left:25px;position:relative;height:80px;border-right:4px solid #f4f4f4}.form .country:after{content:\"\";display:block;position:absolute;right:23px;top:43px;width:15px;height:10px;background-image:url(" + escape(__webpack_require__(18)) + ");background-repeat:no-repeat;background-size:contain}.form .country span:not(.label){padding-top:4px}.form .country span:not(.label):before{display:inline-block;content:\"\";position:relative;top:-3px;padding-right:10px;left:-4px;width:28px;height:23px;background-image:url(" + escape(__webpack_require__(21)) + ");background-position:50%;background-size:contain;background-repeat:no-repeat;vertical-align:middle}.form .country.to span:not(.label):before{background-image:url(" + escape(__webpack_require__(19)) + ")}.form .country span{display:block;letter-spacing:.03em;font-size:19px;font-family:Avenir Next;font-weight:700;color:#353c45}.form .country span.label{padding-top:15px;padding-bottom:2px;text-transform:uppercase;font-size:11px;font-family:Avenir Next,-apple-system,system-ui,Segoe UI,Roboto,Ubuntu,Cantarell,Noto Sans,sans-serif;font-weight:700;color:#797e83cf;letter-spacing:.045em}.form .country.usa span:not(.label):before{background-image:url(" + escape(__webpack_require__(30)) + ")}.form .country.phil span:not(.label):before{background-image:url(" + escape(__webpack_require__(31)) + ")}.form .country.nz span:not(.label):before{background-image:url(" + escape(__webpack_require__(32)) + ")}.form .country.fr span:not(.label):before{background-image:url(" + escape(__webpack_require__(19)) + ")}.form .country.cam span:not(.label):before{background-image:url(" + escape(__webpack_require__(33)) + ")}.form .country.aus span:not(.label):before{background-image:url(" + escape(__webpack_require__(34)) + ")}.form .country.sgp span:not(.label):before{background-image:url(" + escape(__webpack_require__(35)) + ")}.form .country.ind span:not(.label):before{background-image:url(" + escape(__webpack_require__(36)) + ")}.form .country.chf span:not(.label):before{background-image:url(" + escape(__webpack_require__(37)) + ");width:23px;padding-right:9px}.form .amount{display:inline-block;box-sizing:border-box;padding-top:12px;position:relative;vertical-align:middle;margin:0 20px 22px;height:54px;width:184px;border:3px solid #e4e4e4;font-size:18px;font-family:Avenir Next;font-weight:700;border-radius:6px}.form .amount span:not(.currency){padding-left:13px;color:rgba(53,60,69,.5)}.form .amount.from{position:relative;margin-right:30px}.form .amount.from:after{content:\"TO\";font-size:12px;font-family:Avenir Next;font-weight:700;color:#797e83cf;letter-spacing:.045em;right:-40px;top:16px;position:absolute}.form .amount.active{border-color:#79ca0c;padding-left:0}.form .amount.active span:not(.currency){color:#353c45}.form .amount.active span:not(.currency):before{display:none}.form .amount .currency{font-size:16px;position:relative}.form .amount .currency:after{content:\"\";display:block;position:absolute;right:-20px;top:6px;width:13px;height:8px;background-image:url(" + escape(__webpack_require__(18)) + ");background-repeat:no-repeat;background-size:contain}.form .amount span:not(.currency){display:inline-block;width:115px;box-sizing:border-box;padding-left:20px;position:relative}.form .amount span:not(.currency):before{content:\"~\";position:relative;left:-5px}.form .amount span:not(.currency):after{content:\"\";display:block;position:absolute;width:2px;height:28px;background:#e8e6e6;right:10px;top:-1px}.form .button{display:inline-block;background:#ff9a00;cursor:pointer;border-radius:6px;height:56px;width:180px;color:#fff;vertical-align:top;margin-top:12px;box-sizing:border-box;font-size:18px;text-align:center;padding-top:16px;letter-spacing:.035em;font-family:Avenir Next;font-weight:600}", ""]);

// exports


/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('nav',[_c('h1',{attrs:{"id":"logo_monito"}},[_vm._v("Monito")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("About us")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Providers")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Alerts")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Wiki")])]),_vm._v(" "),_c('li',{staticClass:"langage"},[_c('a',{attrs:{"href":"#"}},[_vm._v("EN")])])])]),_vm._v(" "),_c('section',{staticClass:"form shadow"},[_c('div',{staticClass:"from country"},[_c('span',{staticClass:"label"},[_vm._v("Sending From")]),_vm._v(" "),_c('span',[_vm._v("United Kingdom")])]),_vm._v(" "),_c('div',{staticClass:"to country"},[_c('span',{staticClass:"label"},[_vm._v("Sending to")]),_vm._v(" "),_c('span',[_vm._v("France")])]),_vm._v(" "),_c('div',{staticClass:"amount from active"},[_c('span',[_vm._v("1,200")]),_c('span',{staticClass:"currency"},[_vm._v("GBP")])]),_vm._v(" "),_c('div',{staticClass:"amount to"},[_c('span',[_vm._v("1,397")]),_c('span',{staticClass:"currency"},[_vm._v("EUR")])]),_vm._v(" "),_c('div',{staticClass:"button shadow"},[_vm._v("Compare")])]),_vm._v(" "),_c('div',{staticClass:"hero_element",staticStyle:{"height":"620px"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return routes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Venmo_vue__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Home_vue__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home_old_vue__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Corridor_vue__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ContentPage_vue__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_BureauChange_vue__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ReducePaypal_vue__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ReviewTransferwise_vue__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ReviewPaypal_vue__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ReviewWesternunion_vue__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_RelatedContent_vue__ = __webpack_require__(249);












var routes = [{ path: '', component: __WEBPACK_IMPORTED_MODULE_1__components_Home_vue__["a" /* default */] }, { path: '/venmo', component: __WEBPACK_IMPORTED_MODULE_0__components_Venmo_vue__["a" /* default */] }, { path: '/open-bank-account-UK', component: __WEBPACK_IMPORTED_MODULE_4__components_ContentPage_vue__["a" /* default */] }, { path: '/home_v1', component: __WEBPACK_IMPORTED_MODULE_2__components_Home_old_vue__["a" /* default */] }, { path: '/content-page', component: __WEBPACK_IMPORTED_MODULE_4__components_ContentPage_vue__["a" /* default */] }, { path: '/send-money/gb', component: __WEBPACK_IMPORTED_MODULE_3__components_Corridor_vue__["a" /* default */] }, { path: '/review/transferwise', component: __WEBPACK_IMPORTED_MODULE_7__components_ReviewTransferwise_vue__["a" /* default */] }, { path: '/review/western-union', component: __WEBPACK_IMPORTED_MODULE_9__components_ReviewWesternunion_vue__["a" /* default */] }, { path: '/review/paypal', component: __WEBPACK_IMPORTED_MODULE_8__components_ReviewPaypal_vue__["a" /* default */] }, { path: '/bureau-de-change-a-paris-ou-trouver-le-meilleur-taux', component: __WEBPACK_IMPORTED_MODULE_5__components_BureauChange_vue__["a" /* default */] }, { path: '/related_content', component: __WEBPACK_IMPORTED_MODULE_10__components_RelatedContent_vue__["a" /* default */] }, { path: '/reduce-paypal-conversion-fees-tricks-save-money-exchange-money', component: __WEBPACK_IMPORTED_MODULE_6__components_ReducePaypal_vue__["a" /* default */] }, { path: '/*', component: __WEBPACK_IMPORTED_MODULE_1__components_Home_vue__["a" /* default */] }];

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Venmo_vue__ = __webpack_require__(39);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7aa79f6d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Venmo_vue__ = __webpack_require__(140);
function injectStyle (ssrContext) {
  __webpack_require__(97)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Venmo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7aa79f6d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Venmo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(98);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("19b40d50", content, true, {});

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "main{position:relative;z-index:10000}.scroller{width:352px;box-sizing:border-box;position:absolute;right:0;top:0}aside.mobile{display:none!important}@media (max-width:768px){body{overflow:scrollY}body,main{width:100%}main h1{text-align:center}aside.mobile{display:block!important}.scroller{width:95%;margin-left:2.5%;position:relative!important}}", ""]);

// exports


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports
exports.push([module.i, "@import url(http://fast.fonts.net/t/1.css?apiType=css&projectid=7865f54e-0046-47e7-ab48-d6f80c71f79b);", ""]);

// module
exports.push([module.i, "@font-face{font-family:Monito;src:local(\"Avenir Next\"),\"/_comp/fonts/avenir/7db1f672-3a8f-4d19-9c49-7f61aed450b5-1560902400.woffurl2\" format(\"woff2\"),url(\"/_comp/fonts/avenir/4ab86b35-c0c2-42b5-98ad-4b6eba66b197-1560902400.woff\") format(\"woff\");font-weight:400;font-style:normal;font-display:swap}@font-face{font-family:Monito;src:local(\"Avenir Next\"),\"/_comp/fonts/avenir/7db1f672-3a8f-4d19-9c49-7f61aed450b5-1560902400.woffurl2\" format(\"woff2\"),url(\"/_comp/fonts/avenir/4ab86b35-c0c2-42b5-98ad-4b6eba66b197-1560902400.woff\") format(\"woff\");font-weight:500;font-style:normal;font-display:swap}@font-face{font-family:Monito;src:local(\"Avenir Next\"),url(\"/_comp/fonts/avenir/40d36b4a-60c6-460a-bf43-4c948c23563e-1560902400.woff2\") format(\"woff2\"),url(\"/_comp/fonts/avenir/45b78f45-e639-4836-8612-e0892e120f14-1560902400.woff\") format(\"woff\");font-weight:600;font-style:normal;font-display:swap}@font-face{font-family:Monito;src:local(\"Avenir Next\"),url(\"/_comp/fonts/avenir/4c04fb14-abdb-4f93-82bb-734d1b84307b-1560902400.woff2\") format(\"woff2\"),url(\"/_comp/fonts/avenir/04d2f223-2786-40c9-8481-be9dd47d8e7f-1560902400.woff\") format(\"woff\");font-weight:700;font-style:normal;font-display:swap}b,h1,h2,h3,h4,h5,h6,i,p,span{margin:0;padding:0;vertical-align:baseline}.f-anti{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.f_title{font-size:38px;top:5px;line-height:48px;color:#25292fF2}.f_subtitle_1,.f_title{position:relative;font-family:Avenir Next,-apple-system,system-ui,Segoe UI,Roboto,Ubuntu,Cantarell,Noto Sans,sans-serif;font-weight:700;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.f_subtitle_1{top:1px;vertical-align:baseline;box-sizing:border-box;font-size:24px;line-height:30px}.f_subtitle_1,.f_subtitle_2{max-width:90%;letter-spacing:.03em;margin-top:60px}.f_subtitle_2{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-size:20px;font-family:Avenir Next,-apple-system,system-ui,Segoe UI,Roboto,Ubuntu,Cantarell,Noto Sans,sans-serif;font-weight:700;line-height:27px}.f_chapo,b{font-weight:600}.f_body,.f_chapo,b{position:relative;vertical-align:baseline;font-size:18px;margin-top:24px;line-height:27px;letter-spacing:.015em}.f_body{overflow:hidden;font-weight:500;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.f_body,.f_label{font-family:Avenir Next,-apple-system,system-ui,Segoe UI,Roboto,Ubuntu,Cantarell,Noto Sans,sans-serif}.f_label{vertical-align:baseline;font-size:11px}@media (max-width:990px){.f_title{vertical-align:baseline;box-sizing:border-box;font-size:32px;position:relative;top:5px;line-height:42px;font-family:Avenir Next,-apple-system,system-ui,Segoe UI,Roboto,Ubuntu,Cantarell,Noto Sans,sans-serif;font-weight:700;color:#25292f}}@media (max-width:500px){.f_title{font-size:28px;line-height:36px}.f_subtitle_1{font-family:Avenir Next,-apple-system,system-ui,Segoe UI,Roboto,Ubuntu,Cantarell,Noto Sans,sans-serif;font-weight:700;line-height:30px}.f_subtitle_2{font-size:20px;line-height:30px}.f_body{font-size:18px;line-height:27px;font-weight:500;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}}.fs-7{font-size:7px}.fs-8{font-size:8px}.fs-9{font-size:9px}.fs-10{font-size:10px}.fs-11{font-size:11px}.fs-12{font-size:12px}.fs-13{font-size:13px}.fs-14{font-size:14px}.fs-15{font-size:15px}.fs-16{font-size:16px}.fs-17{font-size:17px}.fs-18{font-size:18px}.fs-19{font-size:19px}.fs-20{font-size:20px}.fs-21{font-size:21px}.fs-22{font-size:22px}.fs-23{font-size:23px}.fs-24{font-size:24px}.fs-25{font-size:25px}.fs-26{font-size:26px}.fs-27{font-size:27px}.fs-28{font-size:28px}.fs-29{font-size:29px}.fs-30{font-size:30px}.fs-31{font-size:31px}.fs-32{font-size:32px}.fs-33{font-size:33px}.fs-34{font-size:34px}.fs-35{font-size:35px}.fs-36{font-size:36px}.fs-37{font-size:37px}.fs-38{font-size:38px}.fs-39{font-size:39px}.fs-40{font-size:40px}.fs-41{font-size:41px}.fs-42{font-size:42px}.fs-43{font-size:43px}.fs-44{font-size:44px}.fs-45{font-size:45px}.fs-46{font-size:46px}.fs-47{font-size:47px}.fs-48{font-size:48px}.fs-49{font-size:49px}.fs-50{font-size:50px}.fs-51{font-size:51px}.fs-52{font-size:52px}.fs-53{font-size:53px}.fs-54{font-size:54px}.fs-55{font-size:55px}a{color:inherit;font-weight:600;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.underline{text-decoration:underline}.underline:hover{cursor:pointer}.fw-bold{font-weight:700}.fw-demi-bold{font-weight:600}.fw-medium{font-weight:500}.fw-regular{font-weight:400}.italic{font-style:italic}.normal{font-style:normal}.ls-1{letter-spacing:.02em}.ls-2{letter-spacing:.03em}.ls-3{letter-spacing:.04em}.lh-1{line-height:6px}.lh-2{line-height:12px}.lh-3{line-height:18px}.lh-4{line-height:24px}.lh-5{line-height:30px}.lh-6{line-height:36px}.lh-7{line-height:42px}.lh-8{line-height:48px}.lh-9{line-height:54px}@media (max-width:500px){.fs-sm-7{font-size:7px}.fs-sm-8{font-size:8px}.fs-sm-9{font-size:9px}.fs-sm-10{font-size:10px}.fs-sm-11{font-size:11px}.fs-sm-12{font-size:12px}.fs-sm-13{font-size:13px}.fs-sm-14{font-size:14px}.fs-sm-15{font-size:15px}.fs-sm-16{font-size:16px}.fs-sm-17{font-size:17px}.fs-sm-18{font-size:18px}.fs-sm-19{font-size:19px}.fs-sm-20{font-size:20px}.fs-sm-21{font-size:21px}.fs-sm-22{font-size:22px}.fs-sm-23{font-size:23px}.fs-sm-24{font-size:24px}.fs-sm-25{font-size:25px}.fs-sm-26{font-size:26px}.fs-sm-27{font-size:27px}.fs-sm-28{font-size:28px}.fs-sm-29{font-size:29px}.fs-sm-30{font-size:30px}.fs-sm-31{font-size:31px}.fs-sm-32{font-size:32px}.fs-sm-33{font-size:33px}.fs-sm-34{font-size:34px}.fs-sm-35{font-size:35px}.fs-sm-36{font-size:36px}.fs-sm-37{font-size:37px}.fs-sm-38{font-size:38px}.fs-sm-39{font-size:39px}.fs-sm-40{font-size:40px}.fs-sm-41{font-size:41px}.fs-sm-42{font-size:42px}.fs-sm-43{font-size:43px}.fs-sm-44{font-size:44px}.fs-sm-45{font-size:45px}.fs-sm-46{font-size:46px}.fs-sm-47{font-size:47px}.fs-sm-48{font-size:48px}.fs-sm-49{font-size:49px}.fs-sm-50{font-size:50px}.fs-sm-51{font-size:51px}.fs-sm-52{font-size:52px}.fs-sm-53{font-size:53px}.fs-sm-54{font-size:54px}.fs-sm-55{font-size:55px}.fw-sm-bold{font-weight:700}.fw-sm-demi-bold{font-weight:600}.fw-sm-medium{font-weight:500}.fw-sm-regular{font-weight:400}.italic-sm{font-style:italic}.normal-sm{font-style:normal}.ls-sm-1{letter-spacing:.02em}.ls-sm-2{letter-spacing:.03em}.ls-sm-3{letter-spacing:.04em}.lh-sm-1{line-height:6px}.lh-sm-2{line-height:12px}.lh-sm-3{line-height:18px}.lh-sm-4{line-height:24px}.lh-sm-5{line-height:30px}.lh-sm-6{line-height:36px}.lh-sm-7{line-height:42px}.lh-sm-8{line-height:48px}}@media (min-width:501px) and (max-width:990px){.fs-md-7{font-size:7px}.fs-md-8{font-size:8px}.fs-md-9{font-size:9px}.fs-md-10{font-size:10px}.fs-md-11{font-size:11px}.fs-md-12{font-size:12px}.fs-md-13{font-size:13px}.fs-md-14{font-size:14px}.fs-md-15{font-size:15px}.fs-md-16{font-size:16px}.fs-md-17{font-size:17px}.fs-md-18{font-size:18px}.fs-md-19{font-size:19px}.fs-md-20{font-size:20px}.fs-md-21{font-size:21px}.fs-md-22{font-size:22px}.fs-md-23{font-size:23px}.fs-md-24{font-size:24px}.fs-md-25{font-size:25px}.fs-md-26{font-size:26px}.fs-md-27{font-size:27px}.fs-md-28{font-size:28px}.fs-md-29{font-size:29px}.fs-md-30{font-size:30px}.fs-md-31{font-size:31px}.fs-md-32{font-size:32px}.fs-md-33{font-size:33px}.fs-md-34{font-size:34px}.fs-md-35{font-size:35px}.fs-md-36{font-size:36px}.fs-md-37{font-size:37px}.fs-md-38{font-size:38px}.fs-md-39{font-size:39px}.fs-md-40{font-size:40px}.fs-md-41{font-size:41px}.fs-md-42{font-size:42px}.fs-md-43{font-size:43px}.fs-md-44{font-size:44px}.fs-md-45{font-size:45px}.fs-md-46{font-size:46px}.fs-md-47{font-size:47px}.fs-md-48{font-size:48px}.fs-md-49{font-size:49px}.fs-md-50{font-size:50px}.fs-md-51{font-size:51px}.fs-md-52{font-size:52px}.fs-md-53{font-size:53px}.fs-md-54{font-size:54px}.fs-md-55{font-size:55px}.fw-md-bold-md{font-weight:700}.fw-md-demi-bold{font-weight:600}.fw-md-medium{font-weight:500}.fw-md-regular{font-weight:400}.italic-md{font-style:italic}.normal-md{font-style:normal}.ls-md-1{letter-spacing:.02em}.ls-md-2{letter-spacing:.03em}.ls-md-3{letter-spacing:.04em}.lh-md-1{line-height:6px}.lh-md-2{line-height:12px}.lh-md-3{line-height:18px}.lh-md-4{line-height:24px}.lh-md-5{line-height:30px}.lh-md-6{line-height:36px}.lh-md-7{line-height:42px}.lh-md-8{line-height:48px}}@media (min-width:991px) and (max-width:1280px){.fs-lg-7{font-size:7px}.fs-lg-8{font-size:8px}.fs-lg-9{font-size:9px}.fs-lg-10{font-size:10px}.fs-lg-11{font-size:11px}.fs-lg-12{font-size:12px}.fs-lg-13{font-size:13px}.fs-lg-14{font-size:14px}.fs-lg-15{font-size:15px}.fs-lg-16{font-size:16px}.fs-lg-17{font-size:17px}.fs-lg-18{font-size:18px}.fs-lg-19{font-size:19px}.fs-lg-20{font-size:20px}.fs-lg-21{font-size:21px}.fs-lg-22{font-size:22px}.fs-lg-23{font-size:23px}.fs-lg-24{font-size:24px}.fs-lg-25{font-size:25px}.fs-lg-26{font-size:26px}.fs-lg-27{font-size:27px}.fs-lg-28{font-size:28px}.fs-lg-29{font-size:29px}.fs-lg-30{font-size:30px}.fs-lg-31{font-size:31px}.fs-lg-32{font-size:32px}.fs-lg-33{font-size:33px}.fs-lg-34{font-size:34px}.fs-lg-35{font-size:35px}.fs-lg-36{font-size:36px}.fs-lg-37{font-size:37px}.fs-lg-38{font-size:38px}.fs-lg-39{font-size:39px}.fs-lg-40{font-size:40px}.fs-lg-41{font-size:41px}.fs-lg-42{font-size:42px}.fs-lg-43{font-size:43px}.fs-lg-44{font-size:44px}.fs-lg-45{font-size:45px}.fs-lg-46{font-size:46px}.fs-lg-47{font-size:47px}.fs-lg-48{font-size:48px}.fs-lg-49{font-size:49px}.fs-lg-50{font-size:50px}.fs-lg-51{font-size:51px}.fs-lg-52{font-size:52px}.fs-lg-53{font-size:53px}.fs-lg-54{font-size:54px}.fs-lg-55{font-size:55px}.fw-lg-bold{font-weight:700}.fw-lg-demi-bold{font-weight:600}.fw-lg-medium{font-weight:500}.fw-lg-regular{font-weight:400}.italic-lg{font-style:italic}.normal-lg{font-style:normal}.ls-lg-1{letter-spacing:.02em}.ls-lg-2{letter-spacing:.03em}.ls-lg-3{letter-spacing:.04em}.lh-lg-1{line-height:6px}.lh-lg-2{line-height:12px}.lh-lg-3{line-height:18px}.lh-lg-4{line-height:24px}.lh-lg-5{line-height:30px}.lh-lg-6{line-height:36px}.lh-lg-7{line-height:42px}.lh-lg-8{line-height:48px}}", ""]);

// exports


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "#h_grid{z-index:10000000;width:100vw;position:absolute;opacity:.3;display:block;margin:0;padding:0;top:0}#h_grid li{display:block;width:100%;height:6px}#h_grid li:nth-child(2n){background:rgba(10,255,10,.5)}#v_grid{z-index:10000000;width:1200px;overflow:hidden;height:100vh;position:fixed;opacity:.3;display:block;margin:0 auto;padding:0;top:0;left:calc(((100vw - 1200px) / 2))}#v_grid li{display:inline-block;width:12px;height:1000px}#v_grid li:nth-child(2n){background:rgba(57,247,255,.8)}#v_grid li:nth-child(odd){background:rgba(247,57,255,.3)}.mb-0{margin-bottom:0px}.mt-0{margin-top:0px}.ml-0{margin-left:0px}.mr-0{margin-right:0px}.pb-0{padding-bottom:0px}.pt-0{padding-top:0px}.pl-0{padding-left:0px}.pr-0{padding-right:0px}.mb-1{margin-bottom:6px}.mt-1{margin-top:6px}.ml-1{margin-left:12px}.mr-1{margin-right:12px}.pb-1{padding-bottom:6px}.pt-1{padding-top:6px}.pl-1{padding-left:12px}.pr-1{padding-right:12px}.mb-2{margin-bottom:12px}.mt-2{margin-top:12px}.ml-2{margin-left:24px}.mr-2{margin-right:24px}.pb-2{padding-bottom:12px}.pt-2{padding-top:12px}.pl-2{padding-left:24px}.pr-2{padding-right:24px}.mb-3{margin-bottom:18px}.mt-3{margin-top:18px}.ml-3{margin-left:36px}.mr-3{margin-right:36px}.pb-3{padding-bottom:18px}.pt-3{padding-top:18px}.pl-3{padding-left:36px}.pr-3{padding-right:36px}.mb-4{margin-bottom:24px}.mt-4{margin-top:24px}.ml-4{margin-left:48px}.mr-4{margin-right:48px}.pb-4{padding-bottom:24px}.pt-4{padding-top:24px}.pl-4{padding-left:48px}.pr-4{padding-right:48px}.mb-5{margin-bottom:30px}.mt-5{margin-top:30px}.ml-5{margin-left:60px}.mr-5{margin-right:60px}.pb-5{padding-bottom:30px}.pt-5{padding-top:30px}.pl-5{padding-left:60px}.pr-5{padding-right:60px}.mb-6{margin-bottom:36px}.mt-6{margin-top:36px}.ml-6{margin-left:72px}.mr-6{margin-right:72px}.pb-6{padding-bottom:36px}.pt-6{padding-top:36px}.pl-6{padding-left:72px}.pr-6{padding-right:72px}.mb-7{margin-bottom:42px}.mt-7{margin-top:42px}.ml-7{margin-left:84px}.mr-7{margin-right:84px}.pb-7{padding-bottom:42px}.pt-7{padding-top:42px}.pl-7{padding-left:84px}.pr-7{padding-right:84px}.mb-8{margin-bottom:48px}.mt-8{margin-top:48px}.ml-8{margin-left:96px}.mr-8{margin-right:96px}.pb-8{padding-bottom:48px}.pt-8{padding-top:48px}.pl-8{padding-left:96px}.pr-8{padding-right:96px}.mb-9{margin-bottom:54px}.mt-9{margin-top:54px}.ml-9{margin-left:108px}.mr-9{margin-right:108px}.pb-9{padding-bottom:54px}.pt-9{padding-top:54px}.pl-9{padding-left:108px}.pr-9{padding-right:108px}.mb-10{margin-bottom:60px}.mt-10{margin-top:60px}.ml-10{margin-left:120px}.mr-10{margin-right:120px}.pb-10{padding-bottom:60px}.pt-10{padding-top:60px}.pl-10{padding-left:120px}.pr-10{padding-right:120px}.mb-11{margin-bottom:66px}.mt-11{margin-top:66px}.ml-11{margin-left:132px}.mr-11{margin-right:132px}.pb-11{padding-bottom:66px}.pt-11{padding-top:66px}.pl-11{padding-left:132px}.pr-11{padding-right:132px}.mb-12{margin-bottom:72px}.mt-12{margin-top:72px}.ml-12{margin-left:144px}.mr-12{margin-right:144px}.pb-12{padding-bottom:72px}.pt-12{padding-top:72px}.pl-12{padding-left:144px}.pr-12{padding-right:144px}.mb-13{margin-bottom:78px}.mt-13{margin-top:78px}.ml-13{margin-left:156px}.mr-13{margin-right:156px}.pb-13{padding-bottom:78px}.pt-13{padding-top:78px}.pl-13{padding-left:156px}.pr-13{padding-right:156px}.mb-14{margin-bottom:84px}.mt-14{margin-top:84px}.ml-14{margin-left:168px}.mr-14{margin-right:168px}.pb-14{padding-bottom:84px}.pt-14{padding-top:84px}.pl-14{padding-left:168px}.pr-14{padding-right:168px}.mb-15{margin-bottom:90px}.mt-15{margin-top:90px}.ml-15{margin-left:180px}.mr-15{margin-right:180px}.pb-15{padding-bottom:90px}.pt-15{padding-top:90px}.pl-15{padding-left:180px}.pr-15{padding-right:180px}.mb-16{margin-bottom:96px}.mt-16{margin-top:96px}.ml-16{margin-left:192px}.mr-16{margin-right:192px}.pb-16{padding-bottom:96px}.pt-16{padding-top:96px}.pl-16{padding-left:192px}.pr-16{padding-right:192px}.mb-17{margin-bottom:102px}.mt-17{margin-top:102px}.ml-17{margin-left:204px}.mr-17{margin-right:204px}.pb-17{padding-bottom:102px}.pt-17{padding-top:102px}.pl-17{padding-left:204px}.pr-17{padding-right:204px}.mb-18{margin-bottom:108px}.mt-18{margin-top:108px}.ml-18{margin-left:216px}.mr-18{margin-right:216px}.pb-18{padding-bottom:108px}.pt-18{padding-top:108px}.pl-18{padding-left:216px}.pr-18{padding-right:216px}.mb-19{margin-bottom:114px}.mt-19{margin-top:114px}.ml-19{margin-left:228px}.mr-19{margin-right:228px}.pb-19{padding-bottom:114px}.pt-19{padding-top:114px}.pl-19{padding-left:228px}.pr-19{padding-right:228px}.mb-20{margin-bottom:120px}.mt-20{margin-top:120px}.ml-20{margin-left:240px}.mr-20{margin-right:240px}.pb-20{padding-bottom:120px}.pt-20{padding-top:120px}.pl-20{padding-left:240px}.pr-20{padding-right:240px}.mb-21{margin-bottom:126px}.mt-21{margin-top:126px}.ml-21{margin-left:252px}.mr-21{margin-right:252px}.pb-21{padding-bottom:126px}.pt-21{padding-top:126px}.pl-21{padding-left:252px}.pr-21{padding-right:252px}.mb-22{margin-bottom:132px}.mt-22{margin-top:132px}.ml-22{margin-left:264px}.mr-22{margin-right:264px}.pb-22{padding-bottom:132px}.pt-22{padding-top:132px}.pl-22{padding-left:264px}.pr-22{padding-right:264px}.mb-23{margin-bottom:138px}.mt-23{margin-top:138px}.ml-23{margin-left:276px}.mr-23{margin-right:276px}.pb-23{padding-bottom:138px}.pt-23{padding-top:138px}.pl-23{padding-left:276px}.pr-23{padding-right:276px}.mb-24{margin-bottom:144px}.mt-24{margin-top:144px}.ml-24{margin-left:288px}.mr-24{margin-right:288px}.pb-24{padding-bottom:144px}.pt-24{padding-top:144px}.pl-24{padding-left:288px}.pr-24{padding-right:288px}.mb-25{margin-bottom:150px}.mt-25{margin-top:150px}.ml-25{margin-left:300px}.mr-25{margin-right:300px}.pb-25{padding-bottom:150px}.pt-25{padding-top:150px}.pl-25{padding-left:300px}.pr-25{padding-right:300px}.mb-26{margin-bottom:156px}.mt-26{margin-top:156px}.ml-26{margin-left:312px}.mr-26{margin-right:312px}.pb-26{padding-bottom:156px}.pt-26{padding-top:156px}.pl-26{padding-left:312px}.pr-26{padding-right:312px}.mb-27{margin-bottom:162px}.mt-27{margin-top:162px}.ml-27{margin-left:324px}.mr-27{margin-right:324px}.pb-27{padding-bottom:162px}.pt-27{padding-top:162px}.pl-27{padding-left:324px}.pr-27{padding-right:324px}.mb-28{margin-bottom:168px}.mt-28{margin-top:168px}.ml-28{margin-left:336px}.mr-28{margin-right:336px}.pb-28{padding-bottom:168px}.pt-28{padding-top:168px}.pl-28{padding-left:336px}.pr-28{padding-right:336px}.mb-29{margin-bottom:174px}.mt-29{margin-top:174px}.ml-29{margin-left:348px}.mr-29{margin-right:348px}.pb-29{padding-bottom:174px}.pt-29{padding-top:174px}.pl-29{padding-left:348px}.pr-29{padding-right:348px}.mb-30{margin-bottom:180px}.mt-30{margin-top:180px}.ml-30{margin-left:360px}.mr-30{margin-right:360px}.pb-30{padding-bottom:180px}.pt-30{padding-top:180px}.pl-30{padding-left:360px}.pr-30{padding-right:360px}.mb-31{margin-bottom:186px}.mt-31{margin-top:186px}.ml-31{margin-left:372px}.mr-31{margin-right:372px}.pb-31{padding-bottom:186px}.pt-31{padding-top:186px}.pl-31{padding-left:372px}.pr-31{padding-right:372px}.mb-32{margin-bottom:192px}.mt-32{margin-top:192px}.ml-32{margin-left:384px}.mr-32{margin-right:384px}.pb-32{padding-bottom:192px}.pt-32{padding-top:192px}.pl-32{padding-left:384px}.pr-32{padding-right:384px}.mb-33{margin-bottom:198px}.mt-33{margin-top:198px}.ml-33{margin-left:396px}.mr-33{margin-right:396px}.pb-33{padding-bottom:198px}.pt-33{padding-top:198px}.pl-33{padding-left:396px}.pr-33{padding-right:396px}.mb-34{margin-bottom:204px}.mt-34{margin-top:204px}.ml-34{margin-left:408px}.mr-34{margin-right:408px}.pb-34{padding-bottom:204px}.pt-34{padding-top:204px}.pl-34{padding-left:408px}.pr-34{padding-right:408px}.mb-35{margin-bottom:210px}.mt-35{margin-top:210px}.ml-35{margin-left:420px}.mr-35{margin-right:420px}.pb-35{padding-bottom:210px}.pt-35{padding-top:210px}.pl-35{padding-left:420px}.pr-35{padding-right:420px}.mb-36{margin-bottom:216px}.mt-36{margin-top:216px}.ml-36{margin-left:432px}.mr-36{margin-right:432px}.pb-36{padding-bottom:216px}.pt-36{padding-top:216px}.pl-36{padding-left:432px}.pr-36{padding-right:432px}.mb-37{margin-bottom:222px}.mt-37{margin-top:222px}.ml-37{margin-left:444px}.mr-37{margin-right:444px}.pb-37{padding-bottom:222px}.pt-37{padding-top:222px}.pl-37{padding-left:444px}.pr-37{padding-right:444px}.mb-38{margin-bottom:228px}.mt-38{margin-top:228px}.ml-38{margin-left:456px}.mr-38{margin-right:456px}.pb-38{padding-bottom:228px}.pt-38{padding-top:228px}.pl-38{padding-left:456px}.pr-38{padding-right:456px}.mb-39{margin-bottom:234px}.mt-39{margin-top:234px}.ml-39{margin-left:468px}.mr-39{margin-right:468px}.pb-39{padding-bottom:234px}.pt-39{padding-top:234px}.pl-39{padding-left:468px}.pr-39{padding-right:468px}.mb-40{margin-bottom:240px}.mt-40{margin-top:240px}.ml-40{margin-left:480px}.mr-40{margin-right:480px}.pb-40{padding-bottom:240px}.pt-40{padding-top:240px}.pl-40{padding-left:480px}.pr-40{padding-right:480px}.mb-41{margin-bottom:246px}.mt-41{margin-top:246px}.ml-41{margin-left:492px}.mr-41{margin-right:492px}.pb-41{padding-bottom:246px}.pt-41{padding-top:246px}.pl-41{padding-left:492px}.pr-41{padding-right:492px}.mb-42{margin-bottom:252px}.mt-42{margin-top:252px}.ml-42{margin-left:504px}.mr-42{margin-right:504px}.pb-42{padding-bottom:252px}.pt-42{padding-top:252px}.pl-42{padding-left:504px}.pr-42{padding-right:504px}.mb-43{margin-bottom:258px}.mt-43{margin-top:258px}.ml-43{margin-left:516px}.mr-43{margin-right:516px}.pb-43{padding-bottom:258px}.pt-43{padding-top:258px}.pl-43{padding-left:516px}.pr-43{padding-right:516px}.mb-44{margin-bottom:264px}.mt-44{margin-top:264px}.ml-44{margin-left:528px}.mr-44{margin-right:528px}.pb-44{padding-bottom:264px}.pt-44{padding-top:264px}.pl-44{padding-left:528px}.pr-44{padding-right:528px}.mb-45{margin-bottom:270px}.mt-45{margin-top:270px}.ml-45{margin-left:540px}.mr-45{margin-right:540px}.pb-45{padding-bottom:270px}.pt-45{padding-top:270px}.pl-45{padding-left:540px}.pr-45{padding-right:540px}.mb-46{margin-bottom:276px}.mt-46{margin-top:276px}.ml-46{margin-left:552px}.mr-46{margin-right:552px}.pb-46{padding-bottom:276px}.pt-46{padding-top:276px}.pl-46{padding-left:552px}.pr-46{padding-right:552px}.mb-47{margin-bottom:282px}.mt-47{margin-top:282px}.ml-47{margin-left:564px}.mr-47{margin-right:564px}.pb-47{padding-bottom:282px}.pt-47{padding-top:282px}.pl-47{padding-left:564px}.pr-47{padding-right:564px}.mb-48{margin-bottom:288px}.mt-48{margin-top:288px}.ml-48{margin-left:576px}.mr-48{margin-right:576px}.pb-48{padding-bottom:288px}.pt-48{padding-top:288px}.pl-48{padding-left:576px}.pr-48{padding-right:576px}.mb-49{margin-bottom:294px}.mt-49{margin-top:294px}.ml-49{margin-left:588px}.mr-49{margin-right:588px}.pb-49{padding-bottom:294px}.pt-49{padding-top:294px}.pl-49{padding-left:588px}.pr-49{padding-right:588px}.mb-50{margin-bottom:300px}.mt-50{margin-top:300px}.ml-50{margin-left:600px}.mr-50{margin-right:600px}.pb-50{padding-bottom:300px}.pt-50{padding-top:300px}.pl-50{padding-left:600px}.pr-50{padding-right:600px}.mb-51{margin-bottom:306px}.mt-51{margin-top:306px}.ml-51{margin-left:612px}.mr-51{margin-right:612px}.pb-51{padding-bottom:306px}.pt-51{padding-top:306px}.pl-51{padding-left:612px}.pr-51{padding-right:612px}.mb-52{margin-bottom:312px}.mt-52{margin-top:312px}.ml-52{margin-left:624px}.mr-52{margin-right:624px}.pb-52{padding-bottom:312px}.pt-52{padding-top:312px}.pl-52{padding-left:624px}.pr-52{padding-right:624px}.mb-53{margin-bottom:318px}.mt-53{margin-top:318px}.ml-53{margin-left:636px}.mr-53{margin-right:636px}.pb-53{padding-bottom:318px}.pt-53{padding-top:318px}.pl-53{padding-left:636px}.pr-53{padding-right:636px}.mb-54{margin-bottom:324px}.mt-54{margin-top:324px}.ml-54{margin-left:648px}.mr-54{margin-right:648px}.pb-54{padding-bottom:324px}.pt-54{padding-top:324px}.pl-54{padding-left:648px}.pr-54{padding-right:648px}.mb-55{margin-bottom:330px}.mt-55{margin-top:330px}.ml-55{margin-left:660px}.mr-55{margin-right:660px}.pb-55{padding-bottom:330px}.pt-55{padding-top:330px}.pl-55{padding-left:660px}.pr-55{padding-right:660px}.mb-56{margin-bottom:336px}.mt-56{margin-top:336px}.ml-56{margin-left:672px}.mr-56{margin-right:672px}.pb-56{padding-bottom:336px}.pt-56{padding-top:336px}.pl-56{padding-left:672px}.pr-56{padding-right:672px}.mb-57{margin-bottom:342px}.mt-57{margin-top:342px}.ml-57{margin-left:684px}.mr-57{margin-right:684px}.pb-57{padding-bottom:342px}.pt-57{padding-top:342px}.pl-57{padding-left:684px}.pr-57{padding-right:684px}.mb-58{margin-bottom:348px}.mt-58{margin-top:348px}.ml-58{margin-left:696px}.mr-58{margin-right:696px}.pb-58{padding-bottom:348px}.pt-58{padding-top:348px}.pl-58{padding-left:696px}.pr-58{padding-right:696px}.mb-59{margin-bottom:354px}.mt-59{margin-top:354px}.ml-59{margin-left:708px}.mr-59{margin-right:708px}.pb-59{padding-bottom:354px}.pt-59{padding-top:354px}.pl-59{padding-left:708px}.pr-59{padding-right:708px}.mb-60{margin-bottom:360px}.mt-60{margin-top:360px}.ml-60{margin-left:720px}.mr-60{margin-right:720px}.pb-60{padding-bottom:360px}.pt-60{padding-top:360px}.pl-60{padding-left:720px}.pr-60{padding-right:720px}.mb-61{margin-bottom:366px}.mt-61{margin-top:366px}.ml-61{margin-left:732px}.mr-61{margin-right:732px}.pb-61{padding-bottom:366px}.pt-61{padding-top:366px}.pl-61{padding-left:732px}.pr-61{padding-right:732px}.mb-62{margin-bottom:372px}.mt-62{margin-top:372px}.ml-62{margin-left:744px}.mr-62{margin-right:744px}.pb-62{padding-bottom:372px}.pt-62{padding-top:372px}.pl-62{padding-left:744px}.pr-62{padding-right:744px}.mb-63{margin-bottom:378px}.mt-63{margin-top:378px}.ml-63{margin-left:756px}.mr-63{margin-right:756px}.pb-63{padding-bottom:378px}.pt-63{padding-top:378px}.pl-63{padding-left:756px}.pr-63{padding-right:756px}.mb-64{margin-bottom:384px}.mt-64{margin-top:384px}.ml-64{margin-left:768px}.mr-64{margin-right:768px}.pb-64{padding-bottom:384px}.pt-64{padding-top:384px}.pl-64{padding-left:768px}.pr-64{padding-right:768px}.mb-65{margin-bottom:390px}.mt-65{margin-top:390px}.ml-65{margin-left:780px}.mr-65{margin-right:780px}.pb-65{padding-bottom:390px}.pt-65{padding-top:390px}.pl-65{padding-left:780px}.pr-65{padding-right:780px}.mb-66{margin-bottom:396px}.mt-66{margin-top:396px}.ml-66{margin-left:792px}.mr-66{margin-right:792px}.pb-66{padding-bottom:396px}.pt-66{padding-top:396px}.pl-66{padding-left:792px}.pr-66{padding-right:792px}.mb-67{margin-bottom:402px}.mt-67{margin-top:402px}.ml-67{margin-left:804px}.mr-67{margin-right:804px}.pb-67{padding-bottom:402px}.pt-67{padding-top:402px}.pl-67{padding-left:804px}.pr-67{padding-right:804px}.mb-68{margin-bottom:408px}.mt-68{margin-top:408px}.ml-68{margin-left:816px}.mr-68{margin-right:816px}.pb-68{padding-bottom:408px}.pt-68{padding-top:408px}.pl-68{padding-left:816px}.pr-68{padding-right:816px}.mb-69{margin-bottom:414px}.mt-69{margin-top:414px}.ml-69{margin-left:828px}.mr-69{margin-right:828px}.pb-69{padding-bottom:414px}.pt-69{padding-top:414px}.pl-69{padding-left:828px}.pr-69{padding-right:828px}.mb-70{margin-bottom:420px}.mt-70{margin-top:420px}.ml-70{margin-left:840px}.mr-70{margin-right:840px}.pb-70{padding-bottom:420px}.pt-70{padding-top:420px}.pl-70{padding-left:840px}.pr-70{padding-right:840px}.mb-71{margin-bottom:426px}.mt-71{margin-top:426px}.ml-71{margin-left:852px}.mr-71{margin-right:852px}.pb-71{padding-bottom:426px}.pt-71{padding-top:426px}.pl-71{padding-left:852px}.pr-71{padding-right:852px}.mb-72{margin-bottom:432px}.mt-72{margin-top:432px}.ml-72{margin-left:864px}.mr-72{margin-right:864px}.pb-72{padding-bottom:432px}.pt-72{padding-top:432px}.pl-72{padding-left:864px}.pr-72{padding-right:864px}.mb-73{margin-bottom:438px}.mt-73{margin-top:438px}.ml-73{margin-left:876px}.mr-73{margin-right:876px}.pb-73{padding-bottom:438px}.pt-73{padding-top:438px}.pl-73{padding-left:876px}.pr-73{padding-right:876px}.mb-74{margin-bottom:444px}.mt-74{margin-top:444px}.ml-74{margin-left:888px}.mr-74{margin-right:888px}.pb-74{padding-bottom:444px}.pt-74{padding-top:444px}.pl-74{padding-left:888px}.pr-74{padding-right:888px}.mb-75{margin-bottom:450px}.mt-75{margin-top:450px}.ml-75{margin-left:900px}.mr-75{margin-right:900px}.pb-75{padding-bottom:450px}.pt-75{padding-top:450px}.pl-75{padding-left:900px}.pr-75{padding-right:900px}.mb-76{margin-bottom:456px}.mt-76{margin-top:456px}.ml-76{margin-left:912px}.mr-76{margin-right:912px}.pb-76{padding-bottom:456px}.pt-76{padding-top:456px}.pl-76{padding-left:912px}.pr-76{padding-right:912px}.mb-77{margin-bottom:462px}.mt-77{margin-top:462px}.ml-77{margin-left:924px}.mr-77{margin-right:924px}.pb-77{padding-bottom:462px}.pt-77{padding-top:462px}.pl-77{padding-left:924px}.pr-77{padding-right:924px}.mb-78{margin-bottom:468px}.mt-78{margin-top:468px}.ml-78{margin-left:936px}.mr-78{margin-right:936px}.pb-78{padding-bottom:468px}.pt-78{padding-top:468px}.pl-78{padding-left:936px}.pr-78{padding-right:936px}.mb-79{margin-bottom:474px}.mt-79{margin-top:474px}.ml-79{margin-left:948px}.mr-79{margin-right:948px}.pb-79{padding-bottom:474px}.pt-79{padding-top:474px}.pl-79{padding-left:948px}.pr-79{padding-right:948px}.mb-80{margin-bottom:480px}.mt-80{margin-top:480px}.ml-80{margin-left:960px}.mr-80{margin-right:960px}.pb-80{padding-bottom:480px}.pt-80{padding-top:480px}.pl-80{padding-left:960px}.pr-80{padding-right:960px}@media (max-width:500px){.mb-sm-0{margin-bottom:0px}.mt-sm-0{margin-top:0px}.ml-sm-0{margin-left:0px}.mr-sm-0{margin-right:0px}.pb-sm-0{padding-bottom:0px}.pt-sm-0{padding-top:0px}.pl-sm-0{padding-left:0px}.pr-sm-0{padding-right:0px}.mb-sm-1{margin-bottom:6px}.mt-sm-1{margin-top:6px}.ml-sm-1{margin-left:12px}.mr-sm-1{margin-right:12px}.pb-sm-1{padding-bottom:6px}.pt-sm-1{padding-top:6px}.pl-sm-1{padding-left:12px}.pr-sm-1{padding-right:12px}.mb-sm-2{margin-bottom:12px}.mt-sm-2{margin-top:12px}.ml-sm-2{margin-left:24px}.mr-sm-2{margin-right:24px}.pb-sm-2{padding-bottom:12px}.pt-sm-2{padding-top:12px}.pl-sm-2{padding-left:24px}.pr-sm-2{padding-right:24px}.mb-sm-3{margin-bottom:18px}.mt-sm-3{margin-top:18px}.ml-sm-3{margin-left:36px}.mr-sm-3{margin-right:36px}.pb-sm-3{padding-bottom:18px}.pt-sm-3{padding-top:18px}.pl-sm-3{padding-left:36px}.pr-sm-3{padding-right:36px}.mb-sm-4{margin-bottom:24px}.mt-sm-4{margin-top:24px}.ml-sm-4{margin-left:48px}.mr-sm-4{margin-right:48px}.pb-sm-4{padding-bottom:24px}.pt-sm-4{padding-top:24px}.pl-sm-4{padding-left:48px}.pr-sm-4{padding-right:48px}.mb-sm-5{margin-bottom:30px}.mt-sm-5{margin-top:30px}.ml-sm-5{margin-left:60px}.mr-sm-5{margin-right:60px}.pb-sm-5{padding-bottom:30px}.pt-sm-5{padding-top:30px}.pl-sm-5{padding-left:60px}.pr-sm-5{padding-right:60px}.mb-sm-6{margin-bottom:36px}.mt-sm-6{margin-top:36px}.ml-sm-6{margin-left:72px}.mr-sm-6{margin-right:72px}.pb-sm-6{padding-bottom:36px}.pt-sm-6{padding-top:36px}.pl-sm-6{padding-left:72px}.pr-sm-6{padding-right:72px}.mb-sm-7{margin-bottom:42px}.mt-sm-7{margin-top:42px}.ml-sm-7{margin-left:84px}.mr-sm-7{margin-right:84px}.pb-sm-7{padding-bottom:42px}.pt-sm-7{padding-top:42px}.pl-sm-7{padding-left:84px}.pr-sm-7{padding-right:84px}.mb-sm-8{margin-bottom:48px}.mt-sm-8{margin-top:48px}.ml-sm-8{margin-left:96px}.mr-sm-8{margin-right:96px}.pb-sm-8{padding-bottom:48px}.pt-sm-8{padding-top:48px}.pl-sm-8{padding-left:96px}.pr-sm-8{padding-right:96px}.mb-sm-9{margin-bottom:54px}.mt-sm-9{margin-top:54px}.ml-sm-9{margin-left:108px}.mr-sm-9{margin-right:108px}.pb-sm-9{padding-bottom:54px}.pt-sm-9{padding-top:54px}.pl-sm-9{padding-left:108px}.pr-sm-9{padding-right:108px}.mb-sm-10{margin-bottom:60px}.mt-sm-10{margin-top:60px}.ml-sm-10{margin-left:120px}.mr-sm-10{margin-right:120px}.pb-sm-10{padding-bottom:60px}.pt-sm-10{padding-top:60px}.pl-sm-10{padding-left:120px}.pr-sm-10{padding-right:120px}.mb-sm-11{margin-bottom:66px}.mt-sm-11{margin-top:66px}.ml-sm-11{margin-left:132px}.mr-sm-11{margin-right:132px}.pb-sm-11{padding-bottom:66px}.pt-sm-11{padding-top:66px}.pl-sm-11{padding-left:132px}.pr-sm-11{padding-right:132px}.mb-sm-12{margin-bottom:72px}.mt-sm-12{margin-top:72px}.ml-sm-12{margin-left:144px}.mr-sm-12{margin-right:144px}.pb-sm-12{padding-bottom:72px}.pt-sm-12{padding-top:72px}.pl-sm-12{padding-left:144px}.pr-sm-12{padding-right:144px}.mb-sm-13{margin-bottom:78px}.mt-sm-13{margin-top:78px}.ml-sm-13{margin-left:156px}.mr-sm-13{margin-right:156px}.pb-sm-13{padding-bottom:78px}.pt-sm-13{padding-top:78px}.pl-sm-13{padding-left:156px}.pr-sm-13{padding-right:156px}.mb-sm-14{margin-bottom:84px}.mt-sm-14{margin-top:84px}.ml-sm-14{margin-left:168px}.mr-sm-14{margin-right:168px}.pb-sm-14{padding-bottom:84px}.pt-sm-14{padding-top:84px}.pl-sm-14{padding-left:168px}.pr-sm-14{padding-right:168px}.mb-sm-15{margin-bottom:90px}.mt-sm-15{margin-top:90px}.ml-sm-15{margin-left:180px}.mr-sm-15{margin-right:180px}.pb-sm-15{padding-bottom:90px}.pt-sm-15{padding-top:90px}.pl-sm-15{padding-left:180px}.pr-sm-15{padding-right:180px}.mb-sm-16{margin-bottom:96px}.mt-sm-16{margin-top:96px}.ml-sm-16{margin-left:192px}.mr-sm-16{margin-right:192px}.pb-sm-16{padding-bottom:96px}.pt-sm-16{padding-top:96px}.pl-sm-16{padding-left:192px}.pr-sm-16{padding-right:192px}.mb-sm-17{margin-bottom:102px}.mt-sm-17{margin-top:102px}.ml-sm-17{margin-left:204px}.mr-sm-17{margin-right:204px}.pb-sm-17{padding-bottom:102px}.pt-sm-17{padding-top:102px}.pl-sm-17{padding-left:204px}.pr-sm-17{padding-right:204px}.mb-sm-18{margin-bottom:108px}.mt-sm-18{margin-top:108px}.ml-sm-18{margin-left:216px}.mr-sm-18{margin-right:216px}.pb-sm-18{padding-bottom:108px}.pt-sm-18{padding-top:108px}.pl-sm-18{padding-left:216px}.pr-sm-18{padding-right:216px}.mb-sm-19{margin-bottom:114px}.mt-sm-19{margin-top:114px}.ml-sm-19{margin-left:228px}.mr-sm-19{margin-right:228px}.pb-sm-19{padding-bottom:114px}.pt-sm-19{padding-top:114px}.pl-sm-19{padding-left:228px}.pr-sm-19{padding-right:228px}.mb-sm-20{margin-bottom:120px}.mt-sm-20{margin-top:120px}.ml-sm-20{margin-left:240px}.mr-sm-20{margin-right:240px}.pb-sm-20{padding-bottom:120px}.pt-sm-20{padding-top:120px}.pl-sm-20{padding-left:240px}.pr-sm-20{padding-right:240px}.mb-sm-21{margin-bottom:126px}.mt-sm-21{margin-top:126px}.ml-sm-21{margin-left:252px}.mr-sm-21{margin-right:252px}.pb-sm-21{padding-bottom:126px}.pt-sm-21{padding-top:126px}.pl-sm-21{padding-left:252px}.pr-sm-21{padding-right:252px}.mb-sm-22{margin-bottom:132px}.mt-sm-22{margin-top:132px}.ml-sm-22{margin-left:264px}.mr-sm-22{margin-right:264px}.pb-sm-22{padding-bottom:132px}.pt-sm-22{padding-top:132px}.pl-sm-22{padding-left:264px}.pr-sm-22{padding-right:264px}.mb-sm-23{margin-bottom:138px}.mt-sm-23{margin-top:138px}.ml-sm-23{margin-left:276px}.mr-sm-23{margin-right:276px}.pb-sm-23{padding-bottom:138px}.pt-sm-23{padding-top:138px}.pl-sm-23{padding-left:276px}.pr-sm-23{padding-right:276px}.mb-sm-24{margin-bottom:144px}.mt-sm-24{margin-top:144px}.ml-sm-24{margin-left:288px}.mr-sm-24{margin-right:288px}.pb-sm-24{padding-bottom:144px}.pt-sm-24{padding-top:144px}.pl-sm-24{padding-left:288px}.pr-sm-24{padding-right:288px}.mb-sm-25{margin-bottom:150px}.mt-sm-25{margin-top:150px}.ml-sm-25{margin-left:300px}.mr-sm-25{margin-right:300px}.pb-sm-25{padding-bottom:150px}.pt-sm-25{padding-top:150px}.pl-sm-25{padding-left:300px}.pr-sm-25{padding-right:300px}.mb-sm-26{margin-bottom:156px}.mt-sm-26{margin-top:156px}.ml-sm-26{margin-left:312px}.mr-sm-26{margin-right:312px}.pb-sm-26{padding-bottom:156px}.pt-sm-26{padding-top:156px}.pl-sm-26{padding-left:312px}.pr-sm-26{padding-right:312px}.mb-sm-27{margin-bottom:162px}.mt-sm-27{margin-top:162px}.ml-sm-27{margin-left:324px}.mr-sm-27{margin-right:324px}.pb-sm-27{padding-bottom:162px}.pt-sm-27{padding-top:162px}.pl-sm-27{padding-left:324px}.pr-sm-27{padding-right:324px}.mb-sm-28{margin-bottom:168px}.mt-sm-28{margin-top:168px}.ml-sm-28{margin-left:336px}.mr-sm-28{margin-right:336px}.pb-sm-28{padding-bottom:168px}.pt-sm-28{padding-top:168px}.pl-sm-28{padding-left:336px}.pr-sm-28{padding-right:336px}.mb-sm-29{margin-bottom:174px}.mt-sm-29{margin-top:174px}.ml-sm-29{margin-left:348px}.mr-sm-29{margin-right:348px}.pb-sm-29{padding-bottom:174px}.pt-sm-29{padding-top:174px}.pl-sm-29{padding-left:348px}.pr-sm-29{padding-right:348px}.mb-sm-30{margin-bottom:180px}.mt-sm-30{margin-top:180px}.ml-sm-30{margin-left:360px}.mr-sm-30{margin-right:360px}.pb-sm-30{padding-bottom:180px}.pt-sm-30{padding-top:180px}.pl-sm-30{padding-left:360px}.pr-sm-30{padding-right:360px}.mb-sm-31{margin-bottom:186px}.mt-sm-31{margin-top:186px}.ml-sm-31{margin-left:372px}.mr-sm-31{margin-right:372px}.pb-sm-31{padding-bottom:186px}.pt-sm-31{padding-top:186px}.pl-sm-31{padding-left:372px}.pr-sm-31{padding-right:372px}.mb-sm-32{margin-bottom:192px}.mt-sm-32{margin-top:192px}.ml-sm-32{margin-left:384px}.mr-sm-32{margin-right:384px}.pb-sm-32{padding-bottom:192px}.pt-sm-32{padding-top:192px}.pl-sm-32{padding-left:384px}.pr-sm-32{padding-right:384px}.mb-sm-33{margin-bottom:198px}.mt-sm-33{margin-top:198px}.ml-sm-33{margin-left:396px}.mr-sm-33{margin-right:396px}.pb-sm-33{padding-bottom:198px}.pt-sm-33{padding-top:198px}.pl-sm-33{padding-left:396px}.pr-sm-33{padding-right:396px}.mb-sm-34{margin-bottom:204px}.mt-sm-34{margin-top:204px}.ml-sm-34{margin-left:408px}.mr-sm-34{margin-right:408px}.pb-sm-34{padding-bottom:204px}.pt-sm-34{padding-top:204px}.pl-sm-34{padding-left:408px}.pr-sm-34{padding-right:408px}.mb-sm-35{margin-bottom:210px}.mt-sm-35{margin-top:210px}.ml-sm-35{margin-left:420px}.mr-sm-35{margin-right:420px}.pb-sm-35{padding-bottom:210px}.pt-sm-35{padding-top:210px}.pl-sm-35{padding-left:420px}.pr-sm-35{padding-right:420px}.mb-sm-36{margin-bottom:216px}.mt-sm-36{margin-top:216px}.ml-sm-36{margin-left:432px}.mr-sm-36{margin-right:432px}.pb-sm-36{padding-bottom:216px}.pt-sm-36{padding-top:216px}.pl-sm-36{padding-left:432px}.pr-sm-36{padding-right:432px}.mb-sm-37{margin-bottom:222px}.mt-sm-37{margin-top:222px}.ml-sm-37{margin-left:444px}.mr-sm-37{margin-right:444px}.pb-sm-37{padding-bottom:222px}.pt-sm-37{padding-top:222px}.pl-sm-37{padding-left:444px}.pr-sm-37{padding-right:444px}.mb-sm-38{margin-bottom:228px}.mt-sm-38{margin-top:228px}.ml-sm-38{margin-left:456px}.mr-sm-38{margin-right:456px}.pb-sm-38{padding-bottom:228px}.pt-sm-38{padding-top:228px}.pl-sm-38{padding-left:456px}.pr-sm-38{padding-right:456px}.mb-sm-39{margin-bottom:234px}.mt-sm-39{margin-top:234px}.ml-sm-39{margin-left:468px}.mr-sm-39{margin-right:468px}.pb-sm-39{padding-bottom:234px}.pt-sm-39{padding-top:234px}.pl-sm-39{padding-left:468px}.pr-sm-39{padding-right:468px}.mb-sm-40{margin-bottom:240px}.mt-sm-40{margin-top:240px}.ml-sm-40{margin-left:480px}.mr-sm-40{margin-right:480px}.pb-sm-40{padding-bottom:240px}.pt-sm-40{padding-top:240px}.pl-sm-40{padding-left:480px}.pr-sm-40{padding-right:480px}.mb-sm-41{margin-bottom:246px}.mt-sm-41{margin-top:246px}.ml-sm-41{margin-left:492px}.mr-sm-41{margin-right:492px}.pb-sm-41{padding-bottom:246px}.pt-sm-41{padding-top:246px}.pl-sm-41{padding-left:492px}.pr-sm-41{padding-right:492px}.mb-sm-42{margin-bottom:252px}.mt-sm-42{margin-top:252px}.ml-sm-42{margin-left:504px}.mr-sm-42{margin-right:504px}.pb-sm-42{padding-bottom:252px}.pt-sm-42{padding-top:252px}.pl-sm-42{padding-left:504px}.pr-sm-42{padding-right:504px}.mb-sm-43{margin-bottom:258px}.mt-sm-43{margin-top:258px}.ml-sm-43{margin-left:516px}.mr-sm-43{margin-right:516px}.pb-sm-43{padding-bottom:258px}.pt-sm-43{padding-top:258px}.pl-sm-43{padding-left:516px}.pr-sm-43{padding-right:516px}.mb-sm-44{margin-bottom:264px}.mt-sm-44{margin-top:264px}.ml-sm-44{margin-left:528px}.mr-sm-44{margin-right:528px}.pb-sm-44{padding-bottom:264px}.pt-sm-44{padding-top:264px}.pl-sm-44{padding-left:528px}.pr-sm-44{padding-right:528px}.mb-sm-45{margin-bottom:270px}.mt-sm-45{margin-top:270px}.ml-sm-45{margin-left:540px}.mr-sm-45{margin-right:540px}.pb-sm-45{padding-bottom:270px}.pt-sm-45{padding-top:270px}.pl-sm-45{padding-left:540px}.pr-sm-45{padding-right:540px}.mb-sm-46{margin-bottom:276px}.mt-sm-46{margin-top:276px}.ml-sm-46{margin-left:552px}.mr-sm-46{margin-right:552px}.pb-sm-46{padding-bottom:276px}.pt-sm-46{padding-top:276px}.pl-sm-46{padding-left:552px}.pr-sm-46{padding-right:552px}.mb-sm-47{margin-bottom:282px}.mt-sm-47{margin-top:282px}.ml-sm-47{margin-left:564px}.mr-sm-47{margin-right:564px}.pb-sm-47{padding-bottom:282px}.pt-sm-47{padding-top:282px}.pl-sm-47{padding-left:564px}.pr-sm-47{padding-right:564px}.mb-sm-48{margin-bottom:288px}.mt-sm-48{margin-top:288px}.ml-sm-48{margin-left:576px}.mr-sm-48{margin-right:576px}.pb-sm-48{padding-bottom:288px}.pt-sm-48{padding-top:288px}.pl-sm-48{padding-left:576px}.pr-sm-48{padding-right:576px}.mb-sm-49{margin-bottom:294px}.mt-sm-49{margin-top:294px}.ml-sm-49{margin-left:588px}.mr-sm-49{margin-right:588px}.pb-sm-49{padding-bottom:294px}.pt-sm-49{padding-top:294px}.pl-sm-49{padding-left:588px}.pr-sm-49{padding-right:588px}.mb-sm-50{margin-bottom:300px}.mt-sm-50{margin-top:300px}.ml-sm-50{margin-left:600px}.mr-sm-50{margin-right:600px}.pb-sm-50{padding-bottom:300px}.pt-sm-50{padding-top:300px}.pl-sm-50{padding-left:600px}.pr-sm-50{padding-right:600px}.mb-sm-51{margin-bottom:306px}.mt-sm-51{margin-top:306px}.ml-sm-51{margin-left:612px}.mr-sm-51{margin-right:612px}.pb-sm-51{padding-bottom:306px}.pt-sm-51{padding-top:306px}.pl-sm-51{padding-left:612px}.pr-sm-51{padding-right:612px}.mb-sm-52{margin-bottom:312px}.mt-sm-52{margin-top:312px}.ml-sm-52{margin-left:624px}.mr-sm-52{margin-right:624px}.pb-sm-52{padding-bottom:312px}.pt-sm-52{padding-top:312px}.pl-sm-52{padding-left:624px}.pr-sm-52{padding-right:624px}.mb-sm-53{margin-bottom:318px}.mt-sm-53{margin-top:318px}.ml-sm-53{margin-left:636px}.mr-sm-53{margin-right:636px}.pb-sm-53{padding-bottom:318px}.pt-sm-53{padding-top:318px}.pl-sm-53{padding-left:636px}.pr-sm-53{padding-right:636px}.mb-sm-54{margin-bottom:324px}.mt-sm-54{margin-top:324px}.ml-sm-54{margin-left:648px}.mr-sm-54{margin-right:648px}.pb-sm-54{padding-bottom:324px}.pt-sm-54{padding-top:324px}.pl-sm-54{padding-left:648px}.pr-sm-54{padding-right:648px}.mb-sm-55{margin-bottom:330px}.mt-sm-55{margin-top:330px}.ml-sm-55{margin-left:660px}.mr-sm-55{margin-right:660px}.pb-sm-55{padding-bottom:330px}.pt-sm-55{padding-top:330px}.pl-sm-55{padding-left:660px}.pr-sm-55{padding-right:660px}.mb-sm-56{margin-bottom:336px}.mt-sm-56{margin-top:336px}.ml-sm-56{margin-left:672px}.mr-sm-56{margin-right:672px}.pb-sm-56{padding-bottom:336px}.pt-sm-56{padding-top:336px}.pl-sm-56{padding-left:672px}.pr-sm-56{padding-right:672px}.mb-sm-57{margin-bottom:342px}.mt-sm-57{margin-top:342px}.ml-sm-57{margin-left:684px}.mr-sm-57{margin-right:684px}.pb-sm-57{padding-bottom:342px}.pt-sm-57{padding-top:342px}.pl-sm-57{padding-left:684px}.pr-sm-57{padding-right:684px}.mb-sm-58{margin-bottom:348px}.mt-sm-58{margin-top:348px}.ml-sm-58{margin-left:696px}.mr-sm-58{margin-right:696px}.pb-sm-58{padding-bottom:348px}.pt-sm-58{padding-top:348px}.pl-sm-58{padding-left:696px}.pr-sm-58{padding-right:696px}.mb-sm-59{margin-bottom:354px}.mt-sm-59{margin-top:354px}.ml-sm-59{margin-left:708px}.mr-sm-59{margin-right:708px}.pb-sm-59{padding-bottom:354px}.pt-sm-59{padding-top:354px}.pl-sm-59{padding-left:708px}.pr-sm-59{padding-right:708px}.mb-sm-60{margin-bottom:360px}.mt-sm-60{margin-top:360px}.ml-sm-60{margin-left:720px}.mr-sm-60{margin-right:720px}.pb-sm-60{padding-bottom:360px}.pt-sm-60{padding-top:360px}.pl-sm-60{padding-left:720px}.pr-sm-60{padding-right:720px}.mb-sm-61{margin-bottom:366px}.mt-sm-61{margin-top:366px}.ml-sm-61{margin-left:732px}.mr-sm-61{margin-right:732px}.pb-sm-61{padding-bottom:366px}.pt-sm-61{padding-top:366px}.pl-sm-61{padding-left:732px}.pr-sm-61{padding-right:732px}.mb-sm-62{margin-bottom:372px}.mt-sm-62{margin-top:372px}.ml-sm-62{margin-left:744px}.mr-sm-62{margin-right:744px}.pb-sm-62{padding-bottom:372px}.pt-sm-62{padding-top:372px}.pl-sm-62{padding-left:744px}.pr-sm-62{padding-right:744px}.mb-sm-63{margin-bottom:378px}.mt-sm-63{margin-top:378px}.ml-sm-63{margin-left:756px}.mr-sm-63{margin-right:756px}.pb-sm-63{padding-bottom:378px}.pt-sm-63{padding-top:378px}.pl-sm-63{padding-left:756px}.pr-sm-63{padding-right:756px}.mb-sm-64{margin-bottom:384px}.mt-sm-64{margin-top:384px}.ml-sm-64{margin-left:768px}.mr-sm-64{margin-right:768px}.pb-sm-64{padding-bottom:384px}.pt-sm-64{padding-top:384px}.pl-sm-64{padding-left:768px}.pr-sm-64{padding-right:768px}.mb-sm-65{margin-bottom:390px}.mt-sm-65{margin-top:390px}.ml-sm-65{margin-left:780px}.mr-sm-65{margin-right:780px}.pb-sm-65{padding-bottom:390px}.pt-sm-65{padding-top:390px}.pl-sm-65{padding-left:780px}.pr-sm-65{padding-right:780px}.mb-sm-66{margin-bottom:396px}.mt-sm-66{margin-top:396px}.ml-sm-66{margin-left:792px}.mr-sm-66{margin-right:792px}.pb-sm-66{padding-bottom:396px}.pt-sm-66{padding-top:396px}.pl-sm-66{padding-left:792px}.pr-sm-66{padding-right:792px}.mb-sm-67{margin-bottom:402px}.mt-sm-67{margin-top:402px}.ml-sm-67{margin-left:804px}.mr-sm-67{margin-right:804px}.pb-sm-67{padding-bottom:402px}.pt-sm-67{padding-top:402px}.pl-sm-67{padding-left:804px}.pr-sm-67{padding-right:804px}.mb-sm-68{margin-bottom:408px}.mt-sm-68{margin-top:408px}.ml-sm-68{margin-left:816px}.mr-sm-68{margin-right:816px}.pb-sm-68{padding-bottom:408px}.pt-sm-68{padding-top:408px}.pl-sm-68{padding-left:816px}.pr-sm-68{padding-right:816px}.mb-sm-69{margin-bottom:414px}.mt-sm-69{margin-top:414px}.ml-sm-69{margin-left:828px}.mr-sm-69{margin-right:828px}.pb-sm-69{padding-bottom:414px}.pt-sm-69{padding-top:414px}.pl-sm-69{padding-left:828px}.pr-sm-69{padding-right:828px}.mb-sm-70{margin-bottom:420px}.mt-sm-70{margin-top:420px}.ml-sm-70{margin-left:840px}.mr-sm-70{margin-right:840px}.pb-sm-70{padding-bottom:420px}.pt-sm-70{padding-top:420px}.pl-sm-70{padding-left:840px}.pr-sm-70{padding-right:840px}.mb-sm-71{margin-bottom:426px}.mt-sm-71{margin-top:426px}.ml-sm-71{margin-left:852px}.mr-sm-71{margin-right:852px}.pb-sm-71{padding-bottom:426px}.pt-sm-71{padding-top:426px}.pl-sm-71{padding-left:852px}.pr-sm-71{padding-right:852px}.mb-sm-72{margin-bottom:432px}.mt-sm-72{margin-top:432px}.ml-sm-72{margin-left:864px}.mr-sm-72{margin-right:864px}.pb-sm-72{padding-bottom:432px}.pt-sm-72{padding-top:432px}.pl-sm-72{padding-left:864px}.pr-sm-72{padding-right:864px}.mb-sm-73{margin-bottom:438px}.mt-sm-73{margin-top:438px}.ml-sm-73{margin-left:876px}.mr-sm-73{margin-right:876px}.pb-sm-73{padding-bottom:438px}.pt-sm-73{padding-top:438px}.pl-sm-73{padding-left:876px}.pr-sm-73{padding-right:876px}.mb-sm-74{margin-bottom:444px}.mt-sm-74{margin-top:444px}.ml-sm-74{margin-left:888px}.mr-sm-74{margin-right:888px}.pb-sm-74{padding-bottom:444px}.pt-sm-74{padding-top:444px}.pl-sm-74{padding-left:888px}.pr-sm-74{padding-right:888px}.mb-sm-75{margin-bottom:450px}.mt-sm-75{margin-top:450px}.ml-sm-75{margin-left:900px}.mr-sm-75{margin-right:900px}.pb-sm-75{padding-bottom:450px}.pt-sm-75{padding-top:450px}.pl-sm-75{padding-left:900px}.pr-sm-75{padding-right:900px}.mb-sm-76{margin-bottom:456px}.mt-sm-76{margin-top:456px}.ml-sm-76{margin-left:912px}.mr-sm-76{margin-right:912px}.pb-sm-76{padding-bottom:456px}.pt-sm-76{padding-top:456px}.pl-sm-76{padding-left:912px}.pr-sm-76{padding-right:912px}.mb-sm-77{margin-bottom:462px}.mt-sm-77{margin-top:462px}.ml-sm-77{margin-left:924px}.mr-sm-77{margin-right:924px}.pb-sm-77{padding-bottom:462px}.pt-sm-77{padding-top:462px}.pl-sm-77{padding-left:924px}.pr-sm-77{padding-right:924px}.mb-sm-78{margin-bottom:468px}.mt-sm-78{margin-top:468px}.ml-sm-78{margin-left:936px}.mr-sm-78{margin-right:936px}.pb-sm-78{padding-bottom:468px}.pt-sm-78{padding-top:468px}.pl-sm-78{padding-left:936px}.pr-sm-78{padding-right:936px}.mb-sm-79{margin-bottom:474px}.mt-sm-79{margin-top:474px}.ml-sm-79{margin-left:948px}.mr-sm-79{margin-right:948px}.pb-sm-79{padding-bottom:474px}.pt-sm-79{padding-top:474px}.pl-sm-79{padding-left:948px}.pr-sm-79{padding-right:948px}.mb-sm-80{margin-bottom:480px}.mt-sm-80{margin-top:480px}.ml-sm-80{margin-left:960px}.mr-sm-80{margin-right:960px}.pb-sm-80{padding-bottom:480px}.pt-sm-80{padding-top:480px}.pl-sm-80{padding-left:960px}.pr-sm-80{padding-right:960px}.mb-sm-0_p{margin-bottom:0%}.mt-sm-0_p{margin-top:0%}.ml-sm-0_p{margin-left:0%}.mr-sm-0_p{margin-right:0%}.pb-sm-0_p{padding-bottom:0%}.pt-sm-0_p{padding-top:0%}.pl-sm-0_p{padding-left:0%}.pr-sm-0_p{padding-right:0%}.mb-sm-1_p{margin-bottom:1%}.mt-sm-1_p{margin-top:1%}.ml-sm-1_p{margin-left:1%}.mr-sm-1_p{margin-right:1%}.pb-sm-1_p{padding-bottom:1%}.pt-sm-1_p{padding-top:1%}.pl-sm-1_p{padding-left:1%}.pr-sm-1_p{padding-right:1%}.mb-sm-2_p{margin-bottom:2%}.mt-sm-2_p{margin-top:2%}.ml-sm-2_p{margin-left:2%}.mr-sm-2_p{margin-right:2%}.pb-sm-2_p{padding-bottom:2%}.pt-sm-2_p{padding-top:2%}.pl-sm-2_p{padding-left:2%}.pr-sm-2_p{padding-right:2%}.mb-sm-3_p{margin-bottom:3%}.mt-sm-3_p{margin-top:3%}.ml-sm-3_p{margin-left:3%}.mr-sm-3_p{margin-right:3%}.pb-sm-3_p{padding-bottom:3%}.pt-sm-3_p{padding-top:3%}.pl-sm-3_p{padding-left:3%}.pr-sm-3_p{padding-right:3%}.mb-sm-4_p{margin-bottom:4%}.mt-sm-4_p{margin-top:4%}.ml-sm-4_p{margin-left:4%}.mr-sm-4_p{margin-right:4%}.pb-sm-4_p{padding-bottom:4%}.pt-sm-4_p{padding-top:4%}.pl-sm-4_p{padding-left:4%}.pr-sm-4_p{padding-right:4%}.mb-sm-5_p{margin-bottom:5%}.mt-sm-5_p{margin-top:5%}.ml-sm-5_p{margin-left:5%}.mr-sm-5_p{margin-right:5%}.pb-sm-5_p{padding-bottom:5%}.pt-sm-5_p{padding-top:5%}.pl-sm-5_p{padding-left:5%}.pr-sm-5_p{padding-right:5%}.mb-sm-6_p{margin-bottom:6%}.mt-sm-6_p{margin-top:6%}.ml-sm-6_p{margin-left:6%}.mr-sm-6_p{margin-right:6%}.pb-sm-6_p{padding-bottom:6%}.pt-sm-6_p{padding-top:6%}.pl-sm-6_p{padding-left:6%}.pr-sm-6_p{padding-right:6%}.mb-sm-7_p{margin-bottom:7%}.mt-sm-7_p{margin-top:7%}.ml-sm-7_p{margin-left:7%}.mr-sm-7_p{margin-right:7%}.pb-sm-7_p{padding-bottom:7%}.pt-sm-7_p{padding-top:7%}.pl-sm-7_p{padding-left:7%}.pr-sm-7_p{padding-right:7%}.mb-sm-8_p{margin-bottom:8%}.mt-sm-8_p{margin-top:8%}.ml-sm-8_p{margin-left:8%}.mr-sm-8_p{margin-right:8%}.pb-sm-8_p{padding-bottom:8%}.pt-sm-8_p{padding-top:8%}.pl-sm-8_p{padding-left:8%}.pr-sm-8_p{padding-right:8%}.mb-sm-9_p{margin-bottom:9%}.mt-sm-9_p{margin-top:9%}.ml-sm-9_p{margin-left:9%}.mr-sm-9_p{margin-right:9%}.pb-sm-9_p{padding-bottom:9%}.pt-sm-9_p{padding-top:9%}.pl-sm-9_p{padding-left:9%}.pr-sm-9_p{padding-right:9%}.mb-sm-10_p{margin-bottom:10%}.mt-sm-10_p{margin-top:10%}.ml-sm-10_p{margin-left:10%}.mr-sm-10_p{margin-right:10%}.pb-sm-10_p{padding-bottom:10%}.pt-sm-10_p{padding-top:10%}.pl-sm-10_p{padding-left:10%}.pr-sm-10_p{padding-right:10%}.mb-sm-11_p{margin-bottom:11%}.mt-sm-11_p{margin-top:11%}.ml-sm-11_p{margin-left:11%}.mr-sm-11_p{margin-right:11%}.pb-sm-11_p{padding-bottom:11%}.pt-sm-11_p{padding-top:11%}.pl-sm-11_p{padding-left:11%}.pr-sm-11_p{padding-right:11%}.mb-sm-12_p{margin-bottom:12%}.mt-sm-12_p{margin-top:12%}.ml-sm-12_p{margin-left:12%}.mr-sm-12_p{margin-right:12%}.pb-sm-12_p{padding-bottom:12%}.pt-sm-12_p{padding-top:12%}.pl-sm-12_p{padding-left:12%}.pr-sm-12_p{padding-right:12%}.mb-sm-13_p{margin-bottom:13%}.mt-sm-13_p{margin-top:13%}.ml-sm-13_p{margin-left:13%}.mr-sm-13_p{margin-right:13%}.pb-sm-13_p{padding-bottom:13%}.pt-sm-13_p{padding-top:13%}.pl-sm-13_p{padding-left:13%}.pr-sm-13_p{padding-right:13%}.mb-sm-14_p{margin-bottom:14%}.mt-sm-14_p{margin-top:14%}.ml-sm-14_p{margin-left:14%}.mr-sm-14_p{margin-right:14%}.pb-sm-14_p{padding-bottom:14%}.pt-sm-14_p{padding-top:14%}.pl-sm-14_p{padding-left:14%}.pr-sm-14_p{padding-right:14%}.mb-sm-15_p{margin-bottom:15%}.mt-sm-15_p{margin-top:15%}.ml-sm-15_p{margin-left:15%}.mr-sm-15_p{margin-right:15%}.pb-sm-15_p{padding-bottom:15%}.pt-sm-15_p{padding-top:15%}.pl-sm-15_p{padding-left:15%}.pr-sm-15_p{padding-right:15%}.mb-sm-16_p{margin-bottom:16%}.mt-sm-16_p{margin-top:16%}.ml-sm-16_p{margin-left:16%}.mr-sm-16_p{margin-right:16%}.pb-sm-16_p{padding-bottom:16%}.pt-sm-16_p{padding-top:16%}.pl-sm-16_p{padding-left:16%}.pr-sm-16_p{padding-right:16%}.mb-sm-17_p{margin-bottom:17%}.mt-sm-17_p{margin-top:17%}.ml-sm-17_p{margin-left:17%}.mr-sm-17_p{margin-right:17%}.pb-sm-17_p{padding-bottom:17%}.pt-sm-17_p{padding-top:17%}.pl-sm-17_p{padding-left:17%}.pr-sm-17_p{padding-right:17%}.mb-sm-18_p{margin-bottom:18%}.mt-sm-18_p{margin-top:18%}.ml-sm-18_p{margin-left:18%}.mr-sm-18_p{margin-right:18%}.pb-sm-18_p{padding-bottom:18%}.pt-sm-18_p{padding-top:18%}.pl-sm-18_p{padding-left:18%}.pr-sm-18_p{padding-right:18%}.mb-sm-19_p{margin-bottom:19%}.mt-sm-19_p{margin-top:19%}.ml-sm-19_p{margin-left:19%}.mr-sm-19_p{margin-right:19%}.pb-sm-19_p{padding-bottom:19%}.pt-sm-19_p{padding-top:19%}.pl-sm-19_p{padding-left:19%}.pr-sm-19_p{padding-right:19%}.mb-sm-20_p{margin-bottom:20%}.mt-sm-20_p{margin-top:20%}.ml-sm-20_p{margin-left:20%}.mr-sm-20_p{margin-right:20%}.pb-sm-20_p{padding-bottom:20%}.pt-sm-20_p{padding-top:20%}.pl-sm-20_p{padding-left:20%}.pr-sm-20_p{padding-right:20%}.mb-sm-21_p{margin-bottom:21%}.mt-sm-21_p{margin-top:21%}.ml-sm-21_p{margin-left:21%}.mr-sm-21_p{margin-right:21%}.pb-sm-21_p{padding-bottom:21%}.pt-sm-21_p{padding-top:21%}.pl-sm-21_p{padding-left:21%}.pr-sm-21_p{padding-right:21%}.mb-sm-22_p{margin-bottom:22%}.mt-sm-22_p{margin-top:22%}.ml-sm-22_p{margin-left:22%}.mr-sm-22_p{margin-right:22%}.pb-sm-22_p{padding-bottom:22%}.pt-sm-22_p{padding-top:22%}.pl-sm-22_p{padding-left:22%}.pr-sm-22_p{padding-right:22%}.mb-sm-23_p{margin-bottom:23%}.mt-sm-23_p{margin-top:23%}.ml-sm-23_p{margin-left:23%}.mr-sm-23_p{margin-right:23%}.pb-sm-23_p{padding-bottom:23%}.pt-sm-23_p{padding-top:23%}.pl-sm-23_p{padding-left:23%}.pr-sm-23_p{padding-right:23%}.mb-sm-24_p{margin-bottom:24%}.mt-sm-24_p{margin-top:24%}.ml-sm-24_p{margin-left:24%}.mr-sm-24_p{margin-right:24%}.pb-sm-24_p{padding-bottom:24%}.pt-sm-24_p{padding-top:24%}.pl-sm-24_p{padding-left:24%}.pr-sm-24_p{padding-right:24%}.mb-sm-25_p{margin-bottom:25%}.mt-sm-25_p{margin-top:25%}.ml-sm-25_p{margin-left:25%}.mr-sm-25_p{margin-right:25%}.pb-sm-25_p{padding-bottom:25%}.pt-sm-25_p{padding-top:25%}.pl-sm-25_p{padding-left:25%}.pr-sm-25_p{padding-right:25%}.mb-sm-26_p{margin-bottom:26%}.mt-sm-26_p{margin-top:26%}.ml-sm-26_p{margin-left:26%}.mr-sm-26_p{margin-right:26%}.pb-sm-26_p{padding-bottom:26%}.pt-sm-26_p{padding-top:26%}.pl-sm-26_p{padding-left:26%}.pr-sm-26_p{padding-right:26%}.mb-sm-27_p{margin-bottom:27%}.mt-sm-27_p{margin-top:27%}.ml-sm-27_p{margin-left:27%}.mr-sm-27_p{margin-right:27%}.pb-sm-27_p{padding-bottom:27%}.pt-sm-27_p{padding-top:27%}.pl-sm-27_p{padding-left:27%}.pr-sm-27_p{padding-right:27%}.mb-sm-28_p{margin-bottom:28%}.mt-sm-28_p{margin-top:28%}.ml-sm-28_p{margin-left:28%}.mr-sm-28_p{margin-right:28%}.pb-sm-28_p{padding-bottom:28%}.pt-sm-28_p{padding-top:28%}.pl-sm-28_p{padding-left:28%}.pr-sm-28_p{padding-right:28%}.mb-sm-29_p{margin-bottom:29%}.mt-sm-29_p{margin-top:29%}.ml-sm-29_p{margin-left:29%}.mr-sm-29_p{margin-right:29%}.pb-sm-29_p{padding-bottom:29%}.pt-sm-29_p{padding-top:29%}.pl-sm-29_p{padding-left:29%}.pr-sm-29_p{padding-right:29%}.mb-sm-30_p{margin-bottom:30%}.mt-sm-30_p{margin-top:30%}.ml-sm-30_p{margin-left:30%}.mr-sm-30_p{margin-right:30%}.pb-sm-30_p{padding-bottom:30%}.pt-sm-30_p{padding-top:30%}.pl-sm-30_p{padding-left:30%}.pr-sm-30_p{padding-right:30%}.mb-sm-31_p{margin-bottom:31%}.mt-sm-31_p{margin-top:31%}.ml-sm-31_p{margin-left:31%}.mr-sm-31_p{margin-right:31%}.pb-sm-31_p{padding-bottom:31%}.pt-sm-31_p{padding-top:31%}.pl-sm-31_p{padding-left:31%}.pr-sm-31_p{padding-right:31%}.mb-sm-32_p{margin-bottom:32%}.mt-sm-32_p{margin-top:32%}.ml-sm-32_p{margin-left:32%}.mr-sm-32_p{margin-right:32%}.pb-sm-32_p{padding-bottom:32%}.pt-sm-32_p{padding-top:32%}.pl-sm-32_p{padding-left:32%}.pr-sm-32_p{padding-right:32%}.mb-sm-33_p{margin-bottom:33%}.mt-sm-33_p{margin-top:33%}.ml-sm-33_p{margin-left:33%}.mr-sm-33_p{margin-right:33%}.pb-sm-33_p{padding-bottom:33%}.pt-sm-33_p{padding-top:33%}.pl-sm-33_p{padding-left:33%}.pr-sm-33_p{padding-right:33%}.mb-sm-34_p{margin-bottom:34%}.mt-sm-34_p{margin-top:34%}.ml-sm-34_p{margin-left:34%}.mr-sm-34_p{margin-right:34%}.pb-sm-34_p{padding-bottom:34%}.pt-sm-34_p{padding-top:34%}.pl-sm-34_p{padding-left:34%}.pr-sm-34_p{padding-right:34%}.mb-sm-35_p{margin-bottom:35%}.mt-sm-35_p{margin-top:35%}.ml-sm-35_p{margin-left:35%}.mr-sm-35_p{margin-right:35%}.pb-sm-35_p{padding-bottom:35%}.pt-sm-35_p{padding-top:35%}.pl-sm-35_p{padding-left:35%}.pr-sm-35_p{padding-right:35%}.mb-sm-36_p{margin-bottom:36%}.mt-sm-36_p{margin-top:36%}.ml-sm-36_p{margin-left:36%}.mr-sm-36_p{margin-right:36%}.pb-sm-36_p{padding-bottom:36%}.pt-sm-36_p{padding-top:36%}.pl-sm-36_p{padding-left:36%}.pr-sm-36_p{padding-right:36%}.mb-sm-37_p{margin-bottom:37%}.mt-sm-37_p{margin-top:37%}.ml-sm-37_p{margin-left:37%}.mr-sm-37_p{margin-right:37%}.pb-sm-37_p{padding-bottom:37%}.pt-sm-37_p{padding-top:37%}.pl-sm-37_p{padding-left:37%}.pr-sm-37_p{padding-right:37%}.mb-sm-38_p{margin-bottom:38%}.mt-sm-38_p{margin-top:38%}.ml-sm-38_p{margin-left:38%}.mr-sm-38_p{margin-right:38%}.pb-sm-38_p{padding-bottom:38%}.pt-sm-38_p{padding-top:38%}.pl-sm-38_p{padding-left:38%}.pr-sm-38_p{padding-right:38%}.mb-sm-39_p{margin-bottom:39%}.mt-sm-39_p{margin-top:39%}.ml-sm-39_p{margin-left:39%}.mr-sm-39_p{margin-right:39%}.pb-sm-39_p{padding-bottom:39%}.pt-sm-39_p{padding-top:39%}.pl-sm-39_p{padding-left:39%}.pr-sm-39_p{padding-right:39%}.mb-sm-40_p{margin-bottom:40%}.mt-sm-40_p{margin-top:40%}.ml-sm-40_p{margin-left:40%}.mr-sm-40_p{margin-right:40%}.pb-sm-40_p{padding-bottom:40%}.pt-sm-40_p{padding-top:40%}.pl-sm-40_p{padding-left:40%}.pr-sm-40_p{padding-right:40%}.mb-sm-41_p{margin-bottom:41%}.mt-sm-41_p{margin-top:41%}.ml-sm-41_p{margin-left:41%}.mr-sm-41_p{margin-right:41%}.pb-sm-41_p{padding-bottom:41%}.pt-sm-41_p{padding-top:41%}.pl-sm-41_p{padding-left:41%}.pr-sm-41_p{padding-right:41%}.mb-sm-42_p{margin-bottom:42%}.mt-sm-42_p{margin-top:42%}.ml-sm-42_p{margin-left:42%}.mr-sm-42_p{margin-right:42%}.pb-sm-42_p{padding-bottom:42%}.pt-sm-42_p{padding-top:42%}.pl-sm-42_p{padding-left:42%}.pr-sm-42_p{padding-right:42%}.mb-sm-43_p{margin-bottom:43%}.mt-sm-43_p{margin-top:43%}.ml-sm-43_p{margin-left:43%}.mr-sm-43_p{margin-right:43%}.pb-sm-43_p{padding-bottom:43%}.pt-sm-43_p{padding-top:43%}.pl-sm-43_p{padding-left:43%}.pr-sm-43_p{padding-right:43%}.mb-sm-44_p{margin-bottom:44%}.mt-sm-44_p{margin-top:44%}.ml-sm-44_p{margin-left:44%}.mr-sm-44_p{margin-right:44%}.pb-sm-44_p{padding-bottom:44%}.pt-sm-44_p{padding-top:44%}.pl-sm-44_p{padding-left:44%}.pr-sm-44_p{padding-right:44%}.mb-sm-45_p{margin-bottom:45%}.mt-sm-45_p{margin-top:45%}.ml-sm-45_p{margin-left:45%}.mr-sm-45_p{margin-right:45%}.pb-sm-45_p{padding-bottom:45%}.pt-sm-45_p{padding-top:45%}.pl-sm-45_p{padding-left:45%}.pr-sm-45_p{padding-right:45%}.mb-sm-46_p{margin-bottom:46%}.mt-sm-46_p{margin-top:46%}.ml-sm-46_p{margin-left:46%}.mr-sm-46_p{margin-right:46%}.pb-sm-46_p{padding-bottom:46%}.pt-sm-46_p{padding-top:46%}.pl-sm-46_p{padding-left:46%}.pr-sm-46_p{padding-right:46%}.mb-sm-47_p{margin-bottom:47%}.mt-sm-47_p{margin-top:47%}.ml-sm-47_p{margin-left:47%}.mr-sm-47_p{margin-right:47%}.pb-sm-47_p{padding-bottom:47%}.pt-sm-47_p{padding-top:47%}.pl-sm-47_p{padding-left:47%}.pr-sm-47_p{padding-right:47%}.mb-sm-48_p{margin-bottom:48%}.mt-sm-48_p{margin-top:48%}.ml-sm-48_p{margin-left:48%}.mr-sm-48_p{margin-right:48%}.pb-sm-48_p{padding-bottom:48%}.pt-sm-48_p{padding-top:48%}.pl-sm-48_p{padding-left:48%}.pr-sm-48_p{padding-right:48%}.mb-sm-49_p{margin-bottom:49%}.mt-sm-49_p{margin-top:49%}.ml-sm-49_p{margin-left:49%}.mr-sm-49_p{margin-right:49%}.pb-sm-49_p{padding-bottom:49%}.pt-sm-49_p{padding-top:49%}.pl-sm-49_p{padding-left:49%}.pr-sm-49_p{padding-right:49%}.mb-sm-50_p{margin-bottom:50%}.mt-sm-50_p{margin-top:50%}.ml-sm-50_p{margin-left:50%}.mr-sm-50_p{margin-right:50%}.pb-sm-50_p{padding-bottom:50%}.pt-sm-50_p{padding-top:50%}.pl-sm-50_p{padding-left:50%}.pr-sm-50_p{padding-right:50%}.mb-sm-51_p{margin-bottom:51%}.mt-sm-51_p{margin-top:51%}.ml-sm-51_p{margin-left:51%}.mr-sm-51_p{margin-right:51%}.pb-sm-51_p{padding-bottom:51%}.pt-sm-51_p{padding-top:51%}.pl-sm-51_p{padding-left:51%}.pr-sm-51_p{padding-right:51%}.mb-sm-52_p{margin-bottom:52%}.mt-sm-52_p{margin-top:52%}.ml-sm-52_p{margin-left:52%}.mr-sm-52_p{margin-right:52%}.pb-sm-52_p{padding-bottom:52%}.pt-sm-52_p{padding-top:52%}.pl-sm-52_p{padding-left:52%}.pr-sm-52_p{padding-right:52%}.mb-sm-53_p{margin-bottom:53%}.mt-sm-53_p{margin-top:53%}.ml-sm-53_p{margin-left:53%}.mr-sm-53_p{margin-right:53%}.pb-sm-53_p{padding-bottom:53%}.pt-sm-53_p{padding-top:53%}.pl-sm-53_p{padding-left:53%}.pr-sm-53_p{padding-right:53%}.mb-sm-54_p{margin-bottom:54%}.mt-sm-54_p{margin-top:54%}.ml-sm-54_p{margin-left:54%}.mr-sm-54_p{margin-right:54%}.pb-sm-54_p{padding-bottom:54%}.pt-sm-54_p{padding-top:54%}.pl-sm-54_p{padding-left:54%}.pr-sm-54_p{padding-right:54%}.mb-sm-55_p{margin-bottom:55%}.mt-sm-55_p{margin-top:55%}.ml-sm-55_p{margin-left:55%}.mr-sm-55_p{margin-right:55%}.pb-sm-55_p{padding-bottom:55%}.pt-sm-55_p{padding-top:55%}.pl-sm-55_p{padding-left:55%}.pr-sm-55_p{padding-right:55%}.mb-sm-56_p{margin-bottom:56%}.mt-sm-56_p{margin-top:56%}.ml-sm-56_p{margin-left:56%}.mr-sm-56_p{margin-right:56%}.pb-sm-56_p{padding-bottom:56%}.pt-sm-56_p{padding-top:56%}.pl-sm-56_p{padding-left:56%}.pr-sm-56_p{padding-right:56%}.mb-sm-57_p{margin-bottom:57%}.mt-sm-57_p{margin-top:57%}.ml-sm-57_p{margin-left:57%}.mr-sm-57_p{margin-right:57%}.pb-sm-57_p{padding-bottom:57%}.pt-sm-57_p{padding-top:57%}.pl-sm-57_p{padding-left:57%}.pr-sm-57_p{padding-right:57%}.mb-sm-58_p{margin-bottom:58%}.mt-sm-58_p{margin-top:58%}.ml-sm-58_p{margin-left:58%}.mr-sm-58_p{margin-right:58%}.pb-sm-58_p{padding-bottom:58%}.pt-sm-58_p{padding-top:58%}.pl-sm-58_p{padding-left:58%}.pr-sm-58_p{padding-right:58%}.mb-sm-59_p{margin-bottom:59%}.mt-sm-59_p{margin-top:59%}.ml-sm-59_p{margin-left:59%}.mr-sm-59_p{margin-right:59%}.pb-sm-59_p{padding-bottom:59%}.pt-sm-59_p{padding-top:59%}.pl-sm-59_p{padding-left:59%}.pr-sm-59_p{padding-right:59%}.mb-sm-60_p{margin-bottom:60%}.mt-sm-60_p{margin-top:60%}.ml-sm-60_p{margin-left:60%}.mr-sm-60_p{margin-right:60%}.pb-sm-60_p{padding-bottom:60%}.pt-sm-60_p{padding-top:60%}.pl-sm-60_p{padding-left:60%}.pr-sm-60_p{padding-right:60%}.mb-sm-61_p{margin-bottom:61%}.mt-sm-61_p{margin-top:61%}.ml-sm-61_p{margin-left:61%}.mr-sm-61_p{margin-right:61%}.pb-sm-61_p{padding-bottom:61%}.pt-sm-61_p{padding-top:61%}.pl-sm-61_p{padding-left:61%}.pr-sm-61_p{padding-right:61%}.mb-sm-62_p{margin-bottom:62%}.mt-sm-62_p{margin-top:62%}.ml-sm-62_p{margin-left:62%}.mr-sm-62_p{margin-right:62%}.pb-sm-62_p{padding-bottom:62%}.pt-sm-62_p{padding-top:62%}.pl-sm-62_p{padding-left:62%}.pr-sm-62_p{padding-right:62%}.mb-sm-63_p{margin-bottom:63%}.mt-sm-63_p{margin-top:63%}.ml-sm-63_p{margin-left:63%}.mr-sm-63_p{margin-right:63%}.pb-sm-63_p{padding-bottom:63%}.pt-sm-63_p{padding-top:63%}.pl-sm-63_p{padding-left:63%}.pr-sm-63_p{padding-right:63%}.mb-sm-64_p{margin-bottom:64%}.mt-sm-64_p{margin-top:64%}.ml-sm-64_p{margin-left:64%}.mr-sm-64_p{margin-right:64%}.pb-sm-64_p{padding-bottom:64%}.pt-sm-64_p{padding-top:64%}.pl-sm-64_p{padding-left:64%}.pr-sm-64_p{padding-right:64%}.mb-sm-65_p{margin-bottom:65%}.mt-sm-65_p{margin-top:65%}.ml-sm-65_p{margin-left:65%}.mr-sm-65_p{margin-right:65%}.pb-sm-65_p{padding-bottom:65%}.pt-sm-65_p{padding-top:65%}.pl-sm-65_p{padding-left:65%}.pr-sm-65_p{padding-right:65%}.mb-sm-66_p{margin-bottom:66%}.mt-sm-66_p{margin-top:66%}.ml-sm-66_p{margin-left:66%}.mr-sm-66_p{margin-right:66%}.pb-sm-66_p{padding-bottom:66%}.pt-sm-66_p{padding-top:66%}.pl-sm-66_p{padding-left:66%}.pr-sm-66_p{padding-right:66%}.mb-sm-67_p{margin-bottom:67%}.mt-sm-67_p{margin-top:67%}.ml-sm-67_p{margin-left:67%}.mr-sm-67_p{margin-right:67%}.pb-sm-67_p{padding-bottom:67%}.pt-sm-67_p{padding-top:67%}.pl-sm-67_p{padding-left:67%}.pr-sm-67_p{padding-right:67%}.mb-sm-68_p{margin-bottom:68%}.mt-sm-68_p{margin-top:68%}.ml-sm-68_p{margin-left:68%}.mr-sm-68_p{margin-right:68%}.pb-sm-68_p{padding-bottom:68%}.pt-sm-68_p{padding-top:68%}.pl-sm-68_p{padding-left:68%}.pr-sm-68_p{padding-right:68%}.mb-sm-69_p{margin-bottom:69%}.mt-sm-69_p{margin-top:69%}.ml-sm-69_p{margin-left:69%}.mr-sm-69_p{margin-right:69%}.pb-sm-69_p{padding-bottom:69%}.pt-sm-69_p{padding-top:69%}.pl-sm-69_p{padding-left:69%}.pr-sm-69_p{padding-right:69%}.mb-sm-70_p{margin-bottom:70%}.mt-sm-70_p{margin-top:70%}.ml-sm-70_p{margin-left:70%}.mr-sm-70_p{margin-right:70%}.pb-sm-70_p{padding-bottom:70%}.pt-sm-70_p{padding-top:70%}.pl-sm-70_p{padding-left:70%}.pr-sm-70_p{padding-right:70%}.mb-sm-71_p{margin-bottom:71%}.mt-sm-71_p{margin-top:71%}.ml-sm-71_p{margin-left:71%}.mr-sm-71_p{margin-right:71%}.pb-sm-71_p{padding-bottom:71%}.pt-sm-71_p{padding-top:71%}.pl-sm-71_p{padding-left:71%}.pr-sm-71_p{padding-right:71%}.mb-sm-72_p{margin-bottom:72%}.mt-sm-72_p{margin-top:72%}.ml-sm-72_p{margin-left:72%}.mr-sm-72_p{margin-right:72%}.pb-sm-72_p{padding-bottom:72%}.pt-sm-72_p{padding-top:72%}.pl-sm-72_p{padding-left:72%}.pr-sm-72_p{padding-right:72%}.mb-sm-73_p{margin-bottom:73%}.mt-sm-73_p{margin-top:73%}.ml-sm-73_p{margin-left:73%}.mr-sm-73_p{margin-right:73%}.pb-sm-73_p{padding-bottom:73%}.pt-sm-73_p{padding-top:73%}.pl-sm-73_p{padding-left:73%}.pr-sm-73_p{padding-right:73%}.mb-sm-74_p{margin-bottom:74%}.mt-sm-74_p{margin-top:74%}.ml-sm-74_p{margin-left:74%}.mr-sm-74_p{margin-right:74%}.pb-sm-74_p{padding-bottom:74%}.pt-sm-74_p{padding-top:74%}.pl-sm-74_p{padding-left:74%}.pr-sm-74_p{padding-right:74%}.mb-sm-75_p{margin-bottom:75%}.mt-sm-75_p{margin-top:75%}.ml-sm-75_p{margin-left:75%}.mr-sm-75_p{margin-right:75%}.pb-sm-75_p{padding-bottom:75%}.pt-sm-75_p{padding-top:75%}.pl-sm-75_p{padding-left:75%}.pr-sm-75_p{padding-right:75%}.mb-sm-76_p{margin-bottom:76%}.mt-sm-76_p{margin-top:76%}.ml-sm-76_p{margin-left:76%}.mr-sm-76_p{margin-right:76%}.pb-sm-76_p{padding-bottom:76%}.pt-sm-76_p{padding-top:76%}.pl-sm-76_p{padding-left:76%}.pr-sm-76_p{padding-right:76%}.mb-sm-77_p{margin-bottom:77%}.mt-sm-77_p{margin-top:77%}.ml-sm-77_p{margin-left:77%}.mr-sm-77_p{margin-right:77%}.pb-sm-77_p{padding-bottom:77%}.pt-sm-77_p{padding-top:77%}.pl-sm-77_p{padding-left:77%}.pr-sm-77_p{padding-right:77%}.mb-sm-78_p{margin-bottom:78%}.mt-sm-78_p{margin-top:78%}.ml-sm-78_p{margin-left:78%}.mr-sm-78_p{margin-right:78%}.pb-sm-78_p{padding-bottom:78%}.pt-sm-78_p{padding-top:78%}.pl-sm-78_p{padding-left:78%}.pr-sm-78_p{padding-right:78%}.mb-sm-79_p{margin-bottom:79%}.mt-sm-79_p{margin-top:79%}.ml-sm-79_p{margin-left:79%}.mr-sm-79_p{margin-right:79%}.pb-sm-79_p{padding-bottom:79%}.pt-sm-79_p{padding-top:79%}.pl-sm-79_p{padding-left:79%}.pr-sm-79_p{padding-right:79%}.mb-sm-80_p{margin-bottom:80%}.mt-sm-80_p{margin-top:80%}.ml-sm-80_p{margin-left:80%}.mr-sm-80_p{margin-right:80%}.pb-sm-80_p{padding-bottom:80%}.pt-sm-80_p{padding-top:80%}.pl-sm-80_p{padding-left:80%}.pr-sm-80_p{padding-right:80%}.mb-sm-81_p{margin-bottom:81%}.mt-sm-81_p{margin-top:81%}.ml-sm-81_p{margin-left:81%}.mr-sm-81_p{margin-right:81%}.pb-sm-81_p{padding-bottom:81%}.pt-sm-81_p{padding-top:81%}.pl-sm-81_p{padding-left:81%}.pr-sm-81_p{padding-right:81%}.mb-sm-82_p{margin-bottom:82%}.mt-sm-82_p{margin-top:82%}.ml-sm-82_p{margin-left:82%}.mr-sm-82_p{margin-right:82%}.pb-sm-82_p{padding-bottom:82%}.pt-sm-82_p{padding-top:82%}.pl-sm-82_p{padding-left:82%}.pr-sm-82_p{padding-right:82%}.mb-sm-83_p{margin-bottom:83%}.mt-sm-83_p{margin-top:83%}.ml-sm-83_p{margin-left:83%}.mr-sm-83_p{margin-right:83%}.pb-sm-83_p{padding-bottom:83%}.pt-sm-83_p{padding-top:83%}.pl-sm-83_p{padding-left:83%}.pr-sm-83_p{padding-right:83%}.mb-sm-84_p{margin-bottom:84%}.mt-sm-84_p{margin-top:84%}.ml-sm-84_p{margin-left:84%}.mr-sm-84_p{margin-right:84%}.pb-sm-84_p{padding-bottom:84%}.pt-sm-84_p{padding-top:84%}.pl-sm-84_p{padding-left:84%}.pr-sm-84_p{padding-right:84%}.mb-sm-85_p{margin-bottom:85%}.mt-sm-85_p{margin-top:85%}.ml-sm-85_p{margin-left:85%}.mr-sm-85_p{margin-right:85%}.pb-sm-85_p{padding-bottom:85%}.pt-sm-85_p{padding-top:85%}.pl-sm-85_p{padding-left:85%}.pr-sm-85_p{padding-right:85%}.mb-sm-86_p{margin-bottom:86%}.mt-sm-86_p{margin-top:86%}.ml-sm-86_p{margin-left:86%}.mr-sm-86_p{margin-right:86%}.pb-sm-86_p{padding-bottom:86%}.pt-sm-86_p{padding-top:86%}.pl-sm-86_p{padding-left:86%}.pr-sm-86_p{padding-right:86%}.mb-sm-87_p{margin-bottom:87%}.mt-sm-87_p{margin-top:87%}.ml-sm-87_p{margin-left:87%}.mr-sm-87_p{margin-right:87%}.pb-sm-87_p{padding-bottom:87%}.pt-sm-87_p{padding-top:87%}.pl-sm-87_p{padding-left:87%}.pr-sm-87_p{padding-right:87%}.mb-sm-88_p{margin-bottom:88%}.mt-sm-88_p{margin-top:88%}.ml-sm-88_p{margin-left:88%}.mr-sm-88_p{margin-right:88%}.pb-sm-88_p{padding-bottom:88%}.pt-sm-88_p{padding-top:88%}.pl-sm-88_p{padding-left:88%}.pr-sm-88_p{padding-right:88%}.mb-sm-89_p{margin-bottom:89%}.mt-sm-89_p{margin-top:89%}.ml-sm-89_p{margin-left:89%}.mr-sm-89_p{margin-right:89%}.pb-sm-89_p{padding-bottom:89%}.pt-sm-89_p{padding-top:89%}.pl-sm-89_p{padding-left:89%}.pr-sm-89_p{padding-right:89%}.mb-sm-90_p{margin-bottom:90%}.mt-sm-90_p{margin-top:90%}.ml-sm-90_p{margin-left:90%}.mr-sm-90_p{margin-right:90%}.pb-sm-90_p{padding-bottom:90%}.pt-sm-90_p{padding-top:90%}.pl-sm-90_p{padding-left:90%}.pr-sm-90_p{padding-right:90%}.mb-sm-91_p{margin-bottom:91%}.mt-sm-91_p{margin-top:91%}.ml-sm-91_p{margin-left:91%}.mr-sm-91_p{margin-right:91%}.pb-sm-91_p{padding-bottom:91%}.pt-sm-91_p{padding-top:91%}.pl-sm-91_p{padding-left:91%}.pr-sm-91_p{padding-right:91%}.mb-sm-92_p{margin-bottom:92%}.mt-sm-92_p{margin-top:92%}.ml-sm-92_p{margin-left:92%}.mr-sm-92_p{margin-right:92%}.pb-sm-92_p{padding-bottom:92%}.pt-sm-92_p{padding-top:92%}.pl-sm-92_p{padding-left:92%}.pr-sm-92_p{padding-right:92%}.mb-sm-93_p{margin-bottom:93%}.mt-sm-93_p{margin-top:93%}.ml-sm-93_p{margin-left:93%}.mr-sm-93_p{margin-right:93%}.pb-sm-93_p{padding-bottom:93%}.pt-sm-93_p{padding-top:93%}.pl-sm-93_p{padding-left:93%}.pr-sm-93_p{padding-right:93%}.mb-sm-94_p{margin-bottom:94%}.mt-sm-94_p{margin-top:94%}.ml-sm-94_p{margin-left:94%}.mr-sm-94_p{margin-right:94%}.pb-sm-94_p{padding-bottom:94%}.pt-sm-94_p{padding-top:94%}.pl-sm-94_p{padding-left:94%}.pr-sm-94_p{padding-right:94%}.mb-sm-95_p{margin-bottom:95%}.mt-sm-95_p{margin-top:95%}.ml-sm-95_p{margin-left:95%}.mr-sm-95_p{margin-right:95%}.pb-sm-95_p{padding-bottom:95%}.pt-sm-95_p{padding-top:95%}.pl-sm-95_p{padding-left:95%}.pr-sm-95_p{padding-right:95%}.mb-sm-96_p{margin-bottom:96%}.mt-sm-96_p{margin-top:96%}.ml-sm-96_p{margin-left:96%}.mr-sm-96_p{margin-right:96%}.pb-sm-96_p{padding-bottom:96%}.pt-sm-96_p{padding-top:96%}.pl-sm-96_p{padding-left:96%}.pr-sm-96_p{padding-right:96%}.mb-sm-97_p{margin-bottom:97%}.mt-sm-97_p{margin-top:97%}.ml-sm-97_p{margin-left:97%}.mr-sm-97_p{margin-right:97%}.pb-sm-97_p{padding-bottom:97%}.pt-sm-97_p{padding-top:97%}.pl-sm-97_p{padding-left:97%}.pr-sm-97_p{padding-right:97%}.mb-sm-98_p{margin-bottom:98%}.mt-sm-98_p{margin-top:98%}.ml-sm-98_p{margin-left:98%}.mr-sm-98_p{margin-right:98%}.pb-sm-98_p{padding-bottom:98%}.pt-sm-98_p{padding-top:98%}.pl-sm-98_p{padding-left:98%}.pr-sm-98_p{padding-right:98%}.mb-sm-99_p{margin-bottom:99%}.mt-sm-99_p{margin-top:99%}.ml-sm-99_p{margin-left:99%}.mr-sm-99_p{margin-right:99%}.pb-sm-99_p{padding-bottom:99%}.pt-sm-99_p{padding-top:99%}.pl-sm-99_p{padding-left:99%}.pr-sm-99_p{padding-right:99%}.mb-sm-100_p{margin-bottom:100%}.mt-sm-100_p{margin-top:100%}.ml-sm-100_p{margin-left:100%}.mr-sm-100_p{margin-right:100%}.pb-sm-100_p{padding-bottom:100%}.pt-sm-100_p{padding-top:100%}.pl-sm-100_p{padding-left:100%}.pr-sm-100_p{padding-right:100%}}@media (min-width:501px) and (max-width:990px){.mb-md-0{margin-bottom:0px}.mt-md-0{margin-top:0px}.ml-md-0{margin-left:0px}.mr-md-0{margin-right:0px}.pb-md-0{padding-bottom:0px}.pt-md-0{padding-top:0px}.pl-md-0{padding-left:0px}.pr-md-0{padding-right:0px}.mb-md-1{margin-bottom:6px}.mt-md-1{margin-top:6px}.ml-md-1{margin-left:12px}.mr-md-1{margin-right:12px}.pb-md-1{padding-bottom:6px}.pt-md-1{padding-top:6px}.pl-md-1{padding-left:12px}.pr-md-1{padding-right:12px}.mb-md-2{margin-bottom:12px}.mt-md-2{margin-top:12px}.ml-md-2{margin-left:24px}.mr-md-2{margin-right:24px}.pb-md-2{padding-bottom:12px}.pt-md-2{padding-top:12px}.pl-md-2{padding-left:24px}.pr-md-2{padding-right:24px}.mb-md-3{margin-bottom:18px}.mt-md-3{margin-top:18px}.ml-md-3{margin-left:36px}.mr-md-3{margin-right:36px}.pb-md-3{padding-bottom:18px}.pt-md-3{padding-top:18px}.pl-md-3{padding-left:36px}.pr-md-3{padding-right:36px}.mb-md-4{margin-bottom:24px}.mt-md-4{margin-top:24px}.ml-md-4{margin-left:48px}.mr-md-4{margin-right:48px}.pb-md-4{padding-bottom:24px}.pt-md-4{padding-top:24px}.pl-md-4{padding-left:48px}.pr-md-4{padding-right:48px}.mb-md-5{margin-bottom:30px}.mt-md-5{margin-top:30px}.ml-md-5{margin-left:60px}.mr-md-5{margin-right:60px}.pb-md-5{padding-bottom:30px}.pt-md-5{padding-top:30px}.pl-md-5{padding-left:60px}.pr-md-5{padding-right:60px}.mb-md-6{margin-bottom:36px}.mt-md-6{margin-top:36px}.ml-md-6{margin-left:72px}.mr-md-6{margin-right:72px}.pb-md-6{padding-bottom:36px}.pt-md-6{padding-top:36px}.pl-md-6{padding-left:72px}.pr-md-6{padding-right:72px}.mb-md-7{margin-bottom:42px}.mt-md-7{margin-top:42px}.ml-md-7{margin-left:84px}.mr-md-7{margin-right:84px}.pb-md-7{padding-bottom:42px}.pt-md-7{padding-top:42px}.pl-md-7{padding-left:84px}.pr-md-7{padding-right:84px}.mb-md-8{margin-bottom:48px}.mt-md-8{margin-top:48px}.ml-md-8{margin-left:96px}.mr-md-8{margin-right:96px}.pb-md-8{padding-bottom:48px}.pt-md-8{padding-top:48px}.pl-md-8{padding-left:96px}.pr-md-8{padding-right:96px}.mb-md-9{margin-bottom:54px}.mt-md-9{margin-top:54px}.ml-md-9{margin-left:108px}.mr-md-9{margin-right:108px}.pb-md-9{padding-bottom:54px}.pt-md-9{padding-top:54px}.pl-md-9{padding-left:108px}.pr-md-9{padding-right:108px}.mb-md-10{margin-bottom:60px}.mt-md-10{margin-top:60px}.ml-md-10{margin-left:120px}.mr-md-10{margin-right:120px}.pb-md-10{padding-bottom:60px}.pt-md-10{padding-top:60px}.pl-md-10{padding-left:120px}.pr-md-10{padding-right:120px}.mb-md-11{margin-bottom:66px}.mt-md-11{margin-top:66px}.ml-md-11{margin-left:132px}.mr-md-11{margin-right:132px}.pb-md-11{padding-bottom:66px}.pt-md-11{padding-top:66px}.pl-md-11{padding-left:132px}.pr-md-11{padding-right:132px}.mb-md-12{margin-bottom:72px}.mt-md-12{margin-top:72px}.ml-md-12{margin-left:144px}.mr-md-12{margin-right:144px}.pb-md-12{padding-bottom:72px}.pt-md-12{padding-top:72px}.pl-md-12{padding-left:144px}.pr-md-12{padding-right:144px}.mb-md-13{margin-bottom:78px}.mt-md-13{margin-top:78px}.ml-md-13{margin-left:156px}.mr-md-13{margin-right:156px}.pb-md-13{padding-bottom:78px}.pt-md-13{padding-top:78px}.pl-md-13{padding-left:156px}.pr-md-13{padding-right:156px}.mb-md-14{margin-bottom:84px}.mt-md-14{margin-top:84px}.ml-md-14{margin-left:168px}.mr-md-14{margin-right:168px}.pb-md-14{padding-bottom:84px}.pt-md-14{padding-top:84px}.pl-md-14{padding-left:168px}.pr-md-14{padding-right:168px}.mb-md-15{margin-bottom:90px}.mt-md-15{margin-top:90px}.ml-md-15{margin-left:180px}.mr-md-15{margin-right:180px}.pb-md-15{padding-bottom:90px}.pt-md-15{padding-top:90px}.pl-md-15{padding-left:180px}.pr-md-15{padding-right:180px}.mb-md-16{margin-bottom:96px}.mt-md-16{margin-top:96px}.ml-md-16{margin-left:192px}.mr-md-16{margin-right:192px}.pb-md-16{padding-bottom:96px}.pt-md-16{padding-top:96px}.pl-md-16{padding-left:192px}.pr-md-16{padding-right:192px}.mb-md-17{margin-bottom:102px}.mt-md-17{margin-top:102px}.ml-md-17{margin-left:204px}.mr-md-17{margin-right:204px}.pb-md-17{padding-bottom:102px}.pt-md-17{padding-top:102px}.pl-md-17{padding-left:204px}.pr-md-17{padding-right:204px}.mb-md-18{margin-bottom:108px}.mt-md-18{margin-top:108px}.ml-md-18{margin-left:216px}.mr-md-18{margin-right:216px}.pb-md-18{padding-bottom:108px}.pt-md-18{padding-top:108px}.pl-md-18{padding-left:216px}.pr-md-18{padding-right:216px}.mb-md-19{margin-bottom:114px}.mt-md-19{margin-top:114px}.ml-md-19{margin-left:228px}.mr-md-19{margin-right:228px}.pb-md-19{padding-bottom:114px}.pt-md-19{padding-top:114px}.pl-md-19{padding-left:228px}.pr-md-19{padding-right:228px}.mb-md-20{margin-bottom:120px}.mt-md-20{margin-top:120px}.ml-md-20{margin-left:240px}.mr-md-20{margin-right:240px}.pb-md-20{padding-bottom:120px}.pt-md-20{padding-top:120px}.pl-md-20{padding-left:240px}.pr-md-20{padding-right:240px}.mb-md-21{margin-bottom:126px}.mt-md-21{margin-top:126px}.ml-md-21{margin-left:252px}.mr-md-21{margin-right:252px}.pb-md-21{padding-bottom:126px}.pt-md-21{padding-top:126px}.pl-md-21{padding-left:252px}.pr-md-21{padding-right:252px}.mb-md-22{margin-bottom:132px}.mt-md-22{margin-top:132px}.ml-md-22{margin-left:264px}.mr-md-22{margin-right:264px}.pb-md-22{padding-bottom:132px}.pt-md-22{padding-top:132px}.pl-md-22{padding-left:264px}.pr-md-22{padding-right:264px}.mb-md-23{margin-bottom:138px}.mt-md-23{margin-top:138px}.ml-md-23{margin-left:276px}.mr-md-23{margin-right:276px}.pb-md-23{padding-bottom:138px}.pt-md-23{padding-top:138px}.pl-md-23{padding-left:276px}.pr-md-23{padding-right:276px}.mb-md-24{margin-bottom:144px}.mt-md-24{margin-top:144px}.ml-md-24{margin-left:288px}.mr-md-24{margin-right:288px}.pb-md-24{padding-bottom:144px}.pt-md-24{padding-top:144px}.pl-md-24{padding-left:288px}.pr-md-24{padding-right:288px}.mb-md-25{margin-bottom:150px}.mt-md-25{margin-top:150px}.ml-md-25{margin-left:300px}.mr-md-25{margin-right:300px}.pb-md-25{padding-bottom:150px}.pt-md-25{padding-top:150px}.pl-md-25{padding-left:300px}.pr-md-25{padding-right:300px}.mb-md-26{margin-bottom:156px}.mt-md-26{margin-top:156px}.ml-md-26{margin-left:312px}.mr-md-26{margin-right:312px}.pb-md-26{padding-bottom:156px}.pt-md-26{padding-top:156px}.pl-md-26{padding-left:312px}.pr-md-26{padding-right:312px}.mb-md-27{margin-bottom:162px}.mt-md-27{margin-top:162px}.ml-md-27{margin-left:324px}.mr-md-27{margin-right:324px}.pb-md-27{padding-bottom:162px}.pt-md-27{padding-top:162px}.pl-md-27{padding-left:324px}.pr-md-27{padding-right:324px}.mb-md-28{margin-bottom:168px}.mt-md-28{margin-top:168px}.ml-md-28{margin-left:336px}.mr-md-28{margin-right:336px}.pb-md-28{padding-bottom:168px}.pt-md-28{padding-top:168px}.pl-md-28{padding-left:336px}.pr-md-28{padding-right:336px}.mb-md-29{margin-bottom:174px}.mt-md-29{margin-top:174px}.ml-md-29{margin-left:348px}.mr-md-29{margin-right:348px}.pb-md-29{padding-bottom:174px}.pt-md-29{padding-top:174px}.pl-md-29{padding-left:348px}.pr-md-29{padding-right:348px}.mb-md-30{margin-bottom:180px}.mt-md-30{margin-top:180px}.ml-md-30{margin-left:360px}.mr-md-30{margin-right:360px}.pb-md-30{padding-bottom:180px}.pt-md-30{padding-top:180px}.pl-md-30{padding-left:360px}.pr-md-30{padding-right:360px}.mb-md-31{margin-bottom:186px}.mt-md-31{margin-top:186px}.ml-md-31{margin-left:372px}.mr-md-31{margin-right:372px}.pb-md-31{padding-bottom:186px}.pt-md-31{padding-top:186px}.pl-md-31{padding-left:372px}.pr-md-31{padding-right:372px}.mb-md-32{margin-bottom:192px}.mt-md-32{margin-top:192px}.ml-md-32{margin-left:384px}.mr-md-32{margin-right:384px}.pb-md-32{padding-bottom:192px}.pt-md-32{padding-top:192px}.pl-md-32{padding-left:384px}.pr-md-32{padding-right:384px}.mb-md-33{margin-bottom:198px}.mt-md-33{margin-top:198px}.ml-md-33{margin-left:396px}.mr-md-33{margin-right:396px}.pb-md-33{padding-bottom:198px}.pt-md-33{padding-top:198px}.pl-md-33{padding-left:396px}.pr-md-33{padding-right:396px}.mb-md-34{margin-bottom:204px}.mt-md-34{margin-top:204px}.ml-md-34{margin-left:408px}.mr-md-34{margin-right:408px}.pb-md-34{padding-bottom:204px}.pt-md-34{padding-top:204px}.pl-md-34{padding-left:408px}.pr-md-34{padding-right:408px}.mb-md-35{margin-bottom:210px}.mt-md-35{margin-top:210px}.ml-md-35{margin-left:420px}.mr-md-35{margin-right:420px}.pb-md-35{padding-bottom:210px}.pt-md-35{padding-top:210px}.pl-md-35{padding-left:420px}.pr-md-35{padding-right:420px}.mb-md-36{margin-bottom:216px}.mt-md-36{margin-top:216px}.ml-md-36{margin-left:432px}.mr-md-36{margin-right:432px}.pb-md-36{padding-bottom:216px}.pt-md-36{padding-top:216px}.pl-md-36{padding-left:432px}.pr-md-36{padding-right:432px}.mb-md-37{margin-bottom:222px}.mt-md-37{margin-top:222px}.ml-md-37{margin-left:444px}.mr-md-37{margin-right:444px}.pb-md-37{padding-bottom:222px}.pt-md-37{padding-top:222px}.pl-md-37{padding-left:444px}.pr-md-37{padding-right:444px}.mb-md-38{margin-bottom:228px}.mt-md-38{margin-top:228px}.ml-md-38{margin-left:456px}.mr-md-38{margin-right:456px}.pb-md-38{padding-bottom:228px}.pt-md-38{padding-top:228px}.pl-md-38{padding-left:456px}.pr-md-38{padding-right:456px}.mb-md-39{margin-bottom:234px}.mt-md-39{margin-top:234px}.ml-md-39{margin-left:468px}.mr-md-39{margin-right:468px}.pb-md-39{padding-bottom:234px}.pt-md-39{padding-top:234px}.pl-md-39{padding-left:468px}.pr-md-39{padding-right:468px}.mb-md-40{margin-bottom:240px}.mt-md-40{margin-top:240px}.ml-md-40{margin-left:480px}.mr-md-40{margin-right:480px}.pb-md-40{padding-bottom:240px}.pt-md-40{padding-top:240px}.pl-md-40{padding-left:480px}.pr-md-40{padding-right:480px}.mb-md-41{margin-bottom:246px}.mt-md-41{margin-top:246px}.ml-md-41{margin-left:492px}.mr-md-41{margin-right:492px}.pb-md-41{padding-bottom:246px}.pt-md-41{padding-top:246px}.pl-md-41{padding-left:492px}.pr-md-41{padding-right:492px}.mb-md-42{margin-bottom:252px}.mt-md-42{margin-top:252px}.ml-md-42{margin-left:504px}.mr-md-42{margin-right:504px}.pb-md-42{padding-bottom:252px}.pt-md-42{padding-top:252px}.pl-md-42{padding-left:504px}.pr-md-42{padding-right:504px}.mb-md-43{margin-bottom:258px}.mt-md-43{margin-top:258px}.ml-md-43{margin-left:516px}.mr-md-43{margin-right:516px}.pb-md-43{padding-bottom:258px}.pt-md-43{padding-top:258px}.pl-md-43{padding-left:516px}.pr-md-43{padding-right:516px}.mb-md-44{margin-bottom:264px}.mt-md-44{margin-top:264px}.ml-md-44{margin-left:528px}.mr-md-44{margin-right:528px}.pb-md-44{padding-bottom:264px}.pt-md-44{padding-top:264px}.pl-md-44{padding-left:528px}.pr-md-44{padding-right:528px}.mb-md-45{margin-bottom:270px}.mt-md-45{margin-top:270px}.ml-md-45{margin-left:540px}.mr-md-45{margin-right:540px}.pb-md-45{padding-bottom:270px}.pt-md-45{padding-top:270px}.pl-md-45{padding-left:540px}.pr-md-45{padding-right:540px}.mb-md-46{margin-bottom:276px}.mt-md-46{margin-top:276px}.ml-md-46{margin-left:552px}.mr-md-46{margin-right:552px}.pb-md-46{padding-bottom:276px}.pt-md-46{padding-top:276px}.pl-md-46{padding-left:552px}.pr-md-46{padding-right:552px}.mb-md-47{margin-bottom:282px}.mt-md-47{margin-top:282px}.ml-md-47{margin-left:564px}.mr-md-47{margin-right:564px}.pb-md-47{padding-bottom:282px}.pt-md-47{padding-top:282px}.pl-md-47{padding-left:564px}.pr-md-47{padding-right:564px}.mb-md-48{margin-bottom:288px}.mt-md-48{margin-top:288px}.ml-md-48{margin-left:576px}.mr-md-48{margin-right:576px}.pb-md-48{padding-bottom:288px}.pt-md-48{padding-top:288px}.pl-md-48{padding-left:576px}.pr-md-48{padding-right:576px}.mb-md-49{margin-bottom:294px}.mt-md-49{margin-top:294px}.ml-md-49{margin-left:588px}.mr-md-49{margin-right:588px}.pb-md-49{padding-bottom:294px}.pt-md-49{padding-top:294px}.pl-md-49{padding-left:588px}.pr-md-49{padding-right:588px}.mb-md-50{margin-bottom:300px}.mt-md-50{margin-top:300px}.ml-md-50{margin-left:600px}.mr-md-50{margin-right:600px}.pb-md-50{padding-bottom:300px}.pt-md-50{padding-top:300px}.pl-md-50{padding-left:600px}.pr-md-50{padding-right:600px}.mb-md-51{margin-bottom:306px}.mt-md-51{margin-top:306px}.ml-md-51{margin-left:612px}.mr-md-51{margin-right:612px}.pb-md-51{padding-bottom:306px}.pt-md-51{padding-top:306px}.pl-md-51{padding-left:612px}.pr-md-51{padding-right:612px}.mb-md-52{margin-bottom:312px}.mt-md-52{margin-top:312px}.ml-md-52{margin-left:624px}.mr-md-52{margin-right:624px}.pb-md-52{padding-bottom:312px}.pt-md-52{padding-top:312px}.pl-md-52{padding-left:624px}.pr-md-52{padding-right:624px}.mb-md-53{margin-bottom:318px}.mt-md-53{margin-top:318px}.ml-md-53{margin-left:636px}.mr-md-53{margin-right:636px}.pb-md-53{padding-bottom:318px}.pt-md-53{padding-top:318px}.pl-md-53{padding-left:636px}.pr-md-53{padding-right:636px}.mb-md-54{margin-bottom:324px}.mt-md-54{margin-top:324px}.ml-md-54{margin-left:648px}.mr-md-54{margin-right:648px}.pb-md-54{padding-bottom:324px}.pt-md-54{padding-top:324px}.pl-md-54{padding-left:648px}.pr-md-54{padding-right:648px}.mb-md-55{margin-bottom:330px}.mt-md-55{margin-top:330px}.ml-md-55{margin-left:660px}.mr-md-55{margin-right:660px}.pb-md-55{padding-bottom:330px}.pt-md-55{padding-top:330px}.pl-md-55{padding-left:660px}.pr-md-55{padding-right:660px}.mb-md-56{margin-bottom:336px}.mt-md-56{margin-top:336px}.ml-md-56{margin-left:672px}.mr-md-56{margin-right:672px}.pb-md-56{padding-bottom:336px}.pt-md-56{padding-top:336px}.pl-md-56{padding-left:672px}.pr-md-56{padding-right:672px}.mb-md-57{margin-bottom:342px}.mt-md-57{margin-top:342px}.ml-md-57{margin-left:684px}.mr-md-57{margin-right:684px}.pb-md-57{padding-bottom:342px}.pt-md-57{padding-top:342px}.pl-md-57{padding-left:684px}.pr-md-57{padding-right:684px}.mb-md-58{margin-bottom:348px}.mt-md-58{margin-top:348px}.ml-md-58{margin-left:696px}.mr-md-58{margin-right:696px}.pb-md-58{padding-bottom:348px}.pt-md-58{padding-top:348px}.pl-md-58{padding-left:696px}.pr-md-58{padding-right:696px}.mb-md-59{margin-bottom:354px}.mt-md-59{margin-top:354px}.ml-md-59{margin-left:708px}.mr-md-59{margin-right:708px}.pb-md-59{padding-bottom:354px}.pt-md-59{padding-top:354px}.pl-md-59{padding-left:708px}.pr-md-59{padding-right:708px}.mb-md-60{margin-bottom:360px}.mt-md-60{margin-top:360px}.ml-md-60{margin-left:720px}.mr-md-60{margin-right:720px}.pb-md-60{padding-bottom:360px}.pt-md-60{padding-top:360px}.pl-md-60{padding-left:720px}.pr-md-60{padding-right:720px}.mb-md-61{margin-bottom:366px}.mt-md-61{margin-top:366px}.ml-md-61{margin-left:732px}.mr-md-61{margin-right:732px}.pb-md-61{padding-bottom:366px}.pt-md-61{padding-top:366px}.pl-md-61{padding-left:732px}.pr-md-61{padding-right:732px}.mb-md-62{margin-bottom:372px}.mt-md-62{margin-top:372px}.ml-md-62{margin-left:744px}.mr-md-62{margin-right:744px}.pb-md-62{padding-bottom:372px}.pt-md-62{padding-top:372px}.pl-md-62{padding-left:744px}.pr-md-62{padding-right:744px}.mb-md-63{margin-bottom:378px}.mt-md-63{margin-top:378px}.ml-md-63{margin-left:756px}.mr-md-63{margin-right:756px}.pb-md-63{padding-bottom:378px}.pt-md-63{padding-top:378px}.pl-md-63{padding-left:756px}.pr-md-63{padding-right:756px}.mb-md-64{margin-bottom:384px}.mt-md-64{margin-top:384px}.ml-md-64{margin-left:768px}.mr-md-64{margin-right:768px}.pb-md-64{padding-bottom:384px}.pt-md-64{padding-top:384px}.pl-md-64{padding-left:768px}.pr-md-64{padding-right:768px}.mb-md-65{margin-bottom:390px}.mt-md-65{margin-top:390px}.ml-md-65{margin-left:780px}.mr-md-65{margin-right:780px}.pb-md-65{padding-bottom:390px}.pt-md-65{padding-top:390px}.pl-md-65{padding-left:780px}.pr-md-65{padding-right:780px}.mb-md-66{margin-bottom:396px}.mt-md-66{margin-top:396px}.ml-md-66{margin-left:792px}.mr-md-66{margin-right:792px}.pb-md-66{padding-bottom:396px}.pt-md-66{padding-top:396px}.pl-md-66{padding-left:792px}.pr-md-66{padding-right:792px}.mb-md-67{margin-bottom:402px}.mt-md-67{margin-top:402px}.ml-md-67{margin-left:804px}.mr-md-67{margin-right:804px}.pb-md-67{padding-bottom:402px}.pt-md-67{padding-top:402px}.pl-md-67{padding-left:804px}.pr-md-67{padding-right:804px}.mb-md-68{margin-bottom:408px}.mt-md-68{margin-top:408px}.ml-md-68{margin-left:816px}.mr-md-68{margin-right:816px}.pb-md-68{padding-bottom:408px}.pt-md-68{padding-top:408px}.pl-md-68{padding-left:816px}.pr-md-68{padding-right:816px}.mb-md-69{margin-bottom:414px}.mt-md-69{margin-top:414px}.ml-md-69{margin-left:828px}.mr-md-69{margin-right:828px}.pb-md-69{padding-bottom:414px}.pt-md-69{padding-top:414px}.pl-md-69{padding-left:828px}.pr-md-69{padding-right:828px}.mb-md-70{margin-bottom:420px}.mt-md-70{margin-top:420px}.ml-md-70{margin-left:840px}.mr-md-70{margin-right:840px}.pb-md-70{padding-bottom:420px}.pt-md-70{padding-top:420px}.pl-md-70{padding-left:840px}.pr-md-70{padding-right:840px}.mb-md-71{margin-bottom:426px}.mt-md-71{margin-top:426px}.ml-md-71{margin-left:852px}.mr-md-71{margin-right:852px}.pb-md-71{padding-bottom:426px}.pt-md-71{padding-top:426px}.pl-md-71{padding-left:852px}.pr-md-71{padding-right:852px}.mb-md-72{margin-bottom:432px}.mt-md-72{margin-top:432px}.ml-md-72{margin-left:864px}.mr-md-72{margin-right:864px}.pb-md-72{padding-bottom:432px}.pt-md-72{padding-top:432px}.pl-md-72{padding-left:864px}.pr-md-72{padding-right:864px}.mb-md-73{margin-bottom:438px}.mt-md-73{margin-top:438px}.ml-md-73{margin-left:876px}.mr-md-73{margin-right:876px}.pb-md-73{padding-bottom:438px}.pt-md-73{padding-top:438px}.pl-md-73{padding-left:876px}.pr-md-73{padding-right:876px}.mb-md-74{margin-bottom:444px}.mt-md-74{margin-top:444px}.ml-md-74{margin-left:888px}.mr-md-74{margin-right:888px}.pb-md-74{padding-bottom:444px}.pt-md-74{padding-top:444px}.pl-md-74{padding-left:888px}.pr-md-74{padding-right:888px}.mb-md-75{margin-bottom:450px}.mt-md-75{margin-top:450px}.ml-md-75{margin-left:900px}.mr-md-75{margin-right:900px}.pb-md-75{padding-bottom:450px}.pt-md-75{padding-top:450px}.pl-md-75{padding-left:900px}.pr-md-75{padding-right:900px}.mb-md-76{margin-bottom:456px}.mt-md-76{margin-top:456px}.ml-md-76{margin-left:912px}.mr-md-76{margin-right:912px}.pb-md-76{padding-bottom:456px}.pt-md-76{padding-top:456px}.pl-md-76{padding-left:912px}.pr-md-76{padding-right:912px}.mb-md-77{margin-bottom:462px}.mt-md-77{margin-top:462px}.ml-md-77{margin-left:924px}.mr-md-77{margin-right:924px}.pb-md-77{padding-bottom:462px}.pt-md-77{padding-top:462px}.pl-md-77{padding-left:924px}.pr-md-77{padding-right:924px}.mb-md-78{margin-bottom:468px}.mt-md-78{margin-top:468px}.ml-md-78{margin-left:936px}.mr-md-78{margin-right:936px}.pb-md-78{padding-bottom:468px}.pt-md-78{padding-top:468px}.pl-md-78{padding-left:936px}.pr-md-78{padding-right:936px}.mb-md-79{margin-bottom:474px}.mt-md-79{margin-top:474px}.ml-md-79{margin-left:948px}.mr-md-79{margin-right:948px}.pb-md-79{padding-bottom:474px}.pt-md-79{padding-top:474px}.pl-md-79{padding-left:948px}.pr-md-79{padding-right:948px}.mb-md-80{margin-bottom:480px}.mt-md-80{margin-top:480px}.ml-md-80{margin-left:960px}.mr-md-80{margin-right:960px}.pb-md-80{padding-bottom:480px}.pt-md-80{padding-top:480px}.pl-md-80{padding-left:960px}.pr-md-80{padding-right:960px}}@media (min-width:991px) and (max-width:1280px){.mb-lg-0{margin-bottom:0px}.mt-lg-0{margin-top:0px}.ml-lg-0{margin-left:0px}.mr-lg-0{margin-right:0px}.pb-lg-0{padding-bottom:0px}.pt-lg-0{padding-top:0px}.pl-lg-0{padding-left:0px}.pr-lg-0{padding-right:0px}.mb-lg-1{margin-bottom:6px}.mt-lg-1{margin-top:6px}.ml-lg-1{margin-left:12px}.mr-lg-1{margin-right:12px}.pb-lg-1{padding-bottom:6px}.pt-lg-1{padding-top:6px}.pl-lg-1{padding-left:12px}.pr-lg-1{padding-right:12px}.mb-lg-2{margin-bottom:12px}.mt-lg-2{margin-top:12px}.ml-lg-2{margin-left:24px}.mr-lg-2{margin-right:24px}.pb-lg-2{padding-bottom:12px}.pt-lg-2{padding-top:12px}.pl-lg-2{padding-left:24px}.pr-lg-2{padding-right:24px}.mb-lg-3{margin-bottom:18px}.mt-lg-3{margin-top:18px}.ml-lg-3{margin-left:36px}.mr-lg-3{margin-right:36px}.pb-lg-3{padding-bottom:18px}.pt-lg-3{padding-top:18px}.pl-lg-3{padding-left:36px}.pr-lg-3{padding-right:36px}.mb-lg-4{margin-bottom:24px}.mt-lg-4{margin-top:24px}.ml-lg-4{margin-left:48px}.mr-lg-4{margin-right:48px}.pb-lg-4{padding-bottom:24px}.pt-lg-4{padding-top:24px}.pl-lg-4{padding-left:48px}.pr-lg-4{padding-right:48px}.mb-lg-5{margin-bottom:30px}.mt-lg-5{margin-top:30px}.ml-lg-5{margin-left:60px}.mr-lg-5{margin-right:60px}.pb-lg-5{padding-bottom:30px}.pt-lg-5{padding-top:30px}.pl-lg-5{padding-left:60px}.pr-lg-5{padding-right:60px}.mb-lg-6{margin-bottom:36px}.mt-lg-6{margin-top:36px}.ml-lg-6{margin-left:72px}.mr-lg-6{margin-right:72px}.pb-lg-6{padding-bottom:36px}.pt-lg-6{padding-top:36px}.pl-lg-6{padding-left:72px}.pr-lg-6{padding-right:72px}.mb-lg-7{margin-bottom:42px}.mt-lg-7{margin-top:42px}.ml-lg-7{margin-left:84px}.mr-lg-7{margin-right:84px}.pb-lg-7{padding-bottom:42px}.pt-lg-7{padding-top:42px}.pl-lg-7{padding-left:84px}.pr-lg-7{padding-right:84px}.mb-lg-8{margin-bottom:48px}.mt-lg-8{margin-top:48px}.ml-lg-8{margin-left:96px}.mr-lg-8{margin-right:96px}.pb-lg-8{padding-bottom:48px}.pt-lg-8{padding-top:48px}.pl-lg-8{padding-left:96px}.pr-lg-8{padding-right:96px}.mb-lg-9{margin-bottom:54px}.mt-lg-9{margin-top:54px}.ml-lg-9{margin-left:108px}.mr-lg-9{margin-right:108px}.pb-lg-9{padding-bottom:54px}.pt-lg-9{padding-top:54px}.pl-lg-9{padding-left:108px}.pr-lg-9{padding-right:108px}.mb-lg-10{margin-bottom:60px}.mt-lg-10{margin-top:60px}.ml-lg-10{margin-left:120px}.mr-lg-10{margin-right:120px}.pb-lg-10{padding-bottom:60px}.pt-lg-10{padding-top:60px}.pl-lg-10{padding-left:120px}.pr-lg-10{padding-right:120px}.mb-lg-11{margin-bottom:66px}.mt-lg-11{margin-top:66px}.ml-lg-11{margin-left:132px}.mr-lg-11{margin-right:132px}.pb-lg-11{padding-bottom:66px}.pt-lg-11{padding-top:66px}.pl-lg-11{padding-left:132px}.pr-lg-11{padding-right:132px}.mb-lg-12{margin-bottom:72px}.mt-lg-12{margin-top:72px}.ml-lg-12{margin-left:144px}.mr-lg-12{margin-right:144px}.pb-lg-12{padding-bottom:72px}.pt-lg-12{padding-top:72px}.pl-lg-12{padding-left:144px}.pr-lg-12{padding-right:144px}.mb-lg-13{margin-bottom:78px}.mt-lg-13{margin-top:78px}.ml-lg-13{margin-left:156px}.mr-lg-13{margin-right:156px}.pb-lg-13{padding-bottom:78px}.pt-lg-13{padding-top:78px}.pl-lg-13{padding-left:156px}.pr-lg-13{padding-right:156px}.mb-lg-14{margin-bottom:84px}.mt-lg-14{margin-top:84px}.ml-lg-14{margin-left:168px}.mr-lg-14{margin-right:168px}.pb-lg-14{padding-bottom:84px}.pt-lg-14{padding-top:84px}.pl-lg-14{padding-left:168px}.pr-lg-14{padding-right:168px}.mb-lg-15{margin-bottom:90px}.mt-lg-15{margin-top:90px}.ml-lg-15{margin-left:180px}.mr-lg-15{margin-right:180px}.pb-lg-15{padding-bottom:90px}.pt-lg-15{padding-top:90px}.pl-lg-15{padding-left:180px}.pr-lg-15{padding-right:180px}.mb-lg-16{margin-bottom:96px}.mt-lg-16{margin-top:96px}.ml-lg-16{margin-left:192px}.mr-lg-16{margin-right:192px}.pb-lg-16{padding-bottom:96px}.pt-lg-16{padding-top:96px}.pl-lg-16{padding-left:192px}.pr-lg-16{padding-right:192px}.mb-lg-17{margin-bottom:102px}.mt-lg-17{margin-top:102px}.ml-lg-17{margin-left:204px}.mr-lg-17{margin-right:204px}.pb-lg-17{padding-bottom:102px}.pt-lg-17{padding-top:102px}.pl-lg-17{padding-left:204px}.pr-lg-17{padding-right:204px}.mb-lg-18{margin-bottom:108px}.mt-lg-18{margin-top:108px}.ml-lg-18{margin-left:216px}.mr-lg-18{margin-right:216px}.pb-lg-18{padding-bottom:108px}.pt-lg-18{padding-top:108px}.pl-lg-18{padding-left:216px}.pr-lg-18{padding-right:216px}.mb-lg-19{margin-bottom:114px}.mt-lg-19{margin-top:114px}.ml-lg-19{margin-left:228px}.mr-lg-19{margin-right:228px}.pb-lg-19{padding-bottom:114px}.pt-lg-19{padding-top:114px}.pl-lg-19{padding-left:228px}.pr-lg-19{padding-right:228px}.mb-lg-20{margin-bottom:120px}.mt-lg-20{margin-top:120px}.ml-lg-20{margin-left:240px}.mr-lg-20{margin-right:240px}.pb-lg-20{padding-bottom:120px}.pt-lg-20{padding-top:120px}.pl-lg-20{padding-left:240px}.pr-lg-20{padding-right:240px}.mb-lg-21{margin-bottom:126px}.mt-lg-21{margin-top:126px}.ml-lg-21{margin-left:252px}.mr-lg-21{margin-right:252px}.pb-lg-21{padding-bottom:126px}.pt-lg-21{padding-top:126px}.pl-lg-21{padding-left:252px}.pr-lg-21{padding-right:252px}.mb-lg-22{margin-bottom:132px}.mt-lg-22{margin-top:132px}.ml-lg-22{margin-left:264px}.mr-lg-22{margin-right:264px}.pb-lg-22{padding-bottom:132px}.pt-lg-22{padding-top:132px}.pl-lg-22{padding-left:264px}.pr-lg-22{padding-right:264px}.mb-lg-23{margin-bottom:138px}.mt-lg-23{margin-top:138px}.ml-lg-23{margin-left:276px}.mr-lg-23{margin-right:276px}.pb-lg-23{padding-bottom:138px}.pt-lg-23{padding-top:138px}.pl-lg-23{padding-left:276px}.pr-lg-23{padding-right:276px}.mb-lg-24{margin-bottom:144px}.mt-lg-24{margin-top:144px}.ml-lg-24{margin-left:288px}.mr-lg-24{margin-right:288px}.pb-lg-24{padding-bottom:144px}.pt-lg-24{padding-top:144px}.pl-lg-24{padding-left:288px}.pr-lg-24{padding-right:288px}.mb-lg-25{margin-bottom:150px}.mt-lg-25{margin-top:150px}.ml-lg-25{margin-left:300px}.mr-lg-25{margin-right:300px}.pb-lg-25{padding-bottom:150px}.pt-lg-25{padding-top:150px}.pl-lg-25{padding-left:300px}.pr-lg-25{padding-right:300px}.mb-lg-26{margin-bottom:156px}.mt-lg-26{margin-top:156px}.ml-lg-26{margin-left:312px}.mr-lg-26{margin-right:312px}.pb-lg-26{padding-bottom:156px}.pt-lg-26{padding-top:156px}.pl-lg-26{padding-left:312px}.pr-lg-26{padding-right:312px}.mb-lg-27{margin-bottom:162px}.mt-lg-27{margin-top:162px}.ml-lg-27{margin-left:324px}.mr-lg-27{margin-right:324px}.pb-lg-27{padding-bottom:162px}.pt-lg-27{padding-top:162px}.pl-lg-27{padding-left:324px}.pr-lg-27{padding-right:324px}.mb-lg-28{margin-bottom:168px}.mt-lg-28{margin-top:168px}.ml-lg-28{margin-left:336px}.mr-lg-28{margin-right:336px}.pb-lg-28{padding-bottom:168px}.pt-lg-28{padding-top:168px}.pl-lg-28{padding-left:336px}.pr-lg-28{padding-right:336px}.mb-lg-29{margin-bottom:174px}.mt-lg-29{margin-top:174px}.ml-lg-29{margin-left:348px}.mr-lg-29{margin-right:348px}.pb-lg-29{padding-bottom:174px}.pt-lg-29{padding-top:174px}.pl-lg-29{padding-left:348px}.pr-lg-29{padding-right:348px}.mb-lg-30{margin-bottom:180px}.mt-lg-30{margin-top:180px}.ml-lg-30{margin-left:360px}.mr-lg-30{margin-right:360px}.pb-lg-30{padding-bottom:180px}.pt-lg-30{padding-top:180px}.pl-lg-30{padding-left:360px}.pr-lg-30{padding-right:360px}.mb-lg-31{margin-bottom:186px}.mt-lg-31{margin-top:186px}.ml-lg-31{margin-left:372px}.mr-lg-31{margin-right:372px}.pb-lg-31{padding-bottom:186px}.pt-lg-31{padding-top:186px}.pl-lg-31{padding-left:372px}.pr-lg-31{padding-right:372px}.mb-lg-32{margin-bottom:192px}.mt-lg-32{margin-top:192px}.ml-lg-32{margin-left:384px}.mr-lg-32{margin-right:384px}.pb-lg-32{padding-bottom:192px}.pt-lg-32{padding-top:192px}.pl-lg-32{padding-left:384px}.pr-lg-32{padding-right:384px}.mb-lg-33{margin-bottom:198px}.mt-lg-33{margin-top:198px}.ml-lg-33{margin-left:396px}.mr-lg-33{margin-right:396px}.pb-lg-33{padding-bottom:198px}.pt-lg-33{padding-top:198px}.pl-lg-33{padding-left:396px}.pr-lg-33{padding-right:396px}.mb-lg-34{margin-bottom:204px}.mt-lg-34{margin-top:204px}.ml-lg-34{margin-left:408px}.mr-lg-34{margin-right:408px}.pb-lg-34{padding-bottom:204px}.pt-lg-34{padding-top:204px}.pl-lg-34{padding-left:408px}.pr-lg-34{padding-right:408px}.mb-lg-35{margin-bottom:210px}.mt-lg-35{margin-top:210px}.ml-lg-35{margin-left:420px}.mr-lg-35{margin-right:420px}.pb-lg-35{padding-bottom:210px}.pt-lg-35{padding-top:210px}.pl-lg-35{padding-left:420px}.pr-lg-35{padding-right:420px}.mb-lg-36{margin-bottom:216px}.mt-lg-36{margin-top:216px}.ml-lg-36{margin-left:432px}.mr-lg-36{margin-right:432px}.pb-lg-36{padding-bottom:216px}.pt-lg-36{padding-top:216px}.pl-lg-36{padding-left:432px}.pr-lg-36{padding-right:432px}.mb-lg-37{margin-bottom:222px}.mt-lg-37{margin-top:222px}.ml-lg-37{margin-left:444px}.mr-lg-37{margin-right:444px}.pb-lg-37{padding-bottom:222px}.pt-lg-37{padding-top:222px}.pl-lg-37{padding-left:444px}.pr-lg-37{padding-right:444px}.mb-lg-38{margin-bottom:228px}.mt-lg-38{margin-top:228px}.ml-lg-38{margin-left:456px}.mr-lg-38{margin-right:456px}.pb-lg-38{padding-bottom:228px}.pt-lg-38{padding-top:228px}.pl-lg-38{padding-left:456px}.pr-lg-38{padding-right:456px}.mb-lg-39{margin-bottom:234px}.mt-lg-39{margin-top:234px}.ml-lg-39{margin-left:468px}.mr-lg-39{margin-right:468px}.pb-lg-39{padding-bottom:234px}.pt-lg-39{padding-top:234px}.pl-lg-39{padding-left:468px}.pr-lg-39{padding-right:468px}.mb-lg-40{margin-bottom:240px}.mt-lg-40{margin-top:240px}.ml-lg-40{margin-left:480px}.mr-lg-40{margin-right:480px}.pb-lg-40{padding-bottom:240px}.pt-lg-40{padding-top:240px}.pl-lg-40{padding-left:480px}.pr-lg-40{padding-right:480px}.mb-lg-41{margin-bottom:246px}.mt-lg-41{margin-top:246px}.ml-lg-41{margin-left:492px}.mr-lg-41{margin-right:492px}.pb-lg-41{padding-bottom:246px}.pt-lg-41{padding-top:246px}.pl-lg-41{padding-left:492px}.pr-lg-41{padding-right:492px}.mb-lg-42{margin-bottom:252px}.mt-lg-42{margin-top:252px}.ml-lg-42{margin-left:504px}.mr-lg-42{margin-right:504px}.pb-lg-42{padding-bottom:252px}.pt-lg-42{padding-top:252px}.pl-lg-42{padding-left:504px}.pr-lg-42{padding-right:504px}.mb-lg-43{margin-bottom:258px}.mt-lg-43{margin-top:258px}.ml-lg-43{margin-left:516px}.mr-lg-43{margin-right:516px}.pb-lg-43{padding-bottom:258px}.pt-lg-43{padding-top:258px}.pl-lg-43{padding-left:516px}.pr-lg-43{padding-right:516px}.mb-lg-44{margin-bottom:264px}.mt-lg-44{margin-top:264px}.ml-lg-44{margin-left:528px}.mr-lg-44{margin-right:528px}.pb-lg-44{padding-bottom:264px}.pt-lg-44{padding-top:264px}.pl-lg-44{padding-left:528px}.pr-lg-44{padding-right:528px}.mb-lg-45{margin-bottom:270px}.mt-lg-45{margin-top:270px}.ml-lg-45{margin-left:540px}.mr-lg-45{margin-right:540px}.pb-lg-45{padding-bottom:270px}.pt-lg-45{padding-top:270px}.pl-lg-45{padding-left:540px}.pr-lg-45{padding-right:540px}.mb-lg-46{margin-bottom:276px}.mt-lg-46{margin-top:276px}.ml-lg-46{margin-left:552px}.mr-lg-46{margin-right:552px}.pb-lg-46{padding-bottom:276px}.pt-lg-46{padding-top:276px}.pl-lg-46{padding-left:552px}.pr-lg-46{padding-right:552px}.mb-lg-47{margin-bottom:282px}.mt-lg-47{margin-top:282px}.ml-lg-47{margin-left:564px}.mr-lg-47{margin-right:564px}.pb-lg-47{padding-bottom:282px}.pt-lg-47{padding-top:282px}.pl-lg-47{padding-left:564px}.pr-lg-47{padding-right:564px}.mb-lg-48{margin-bottom:288px}.mt-lg-48{margin-top:288px}.ml-lg-48{margin-left:576px}.mr-lg-48{margin-right:576px}.pb-lg-48{padding-bottom:288px}.pt-lg-48{padding-top:288px}.pl-lg-48{padding-left:576px}.pr-lg-48{padding-right:576px}.mb-lg-49{margin-bottom:294px}.mt-lg-49{margin-top:294px}.ml-lg-49{margin-left:588px}.mr-lg-49{margin-right:588px}.pb-lg-49{padding-bottom:294px}.pt-lg-49{padding-top:294px}.pl-lg-49{padding-left:588px}.pr-lg-49{padding-right:588px}.mb-lg-50{margin-bottom:300px}.mt-lg-50{margin-top:300px}.ml-lg-50{margin-left:600px}.mr-lg-50{margin-right:600px}.pb-lg-50{padding-bottom:300px}.pt-lg-50{padding-top:300px}.pl-lg-50{padding-left:600px}.pr-lg-50{padding-right:600px}.mb-lg-51{margin-bottom:306px}.mt-lg-51{margin-top:306px}.ml-lg-51{margin-left:612px}.mr-lg-51{margin-right:612px}.pb-lg-51{padding-bottom:306px}.pt-lg-51{padding-top:306px}.pl-lg-51{padding-left:612px}.pr-lg-51{padding-right:612px}.mb-lg-52{margin-bottom:312px}.mt-lg-52{margin-top:312px}.ml-lg-52{margin-left:624px}.mr-lg-52{margin-right:624px}.pb-lg-52{padding-bottom:312px}.pt-lg-52{padding-top:312px}.pl-lg-52{padding-left:624px}.pr-lg-52{padding-right:624px}.mb-lg-53{margin-bottom:318px}.mt-lg-53{margin-top:318px}.ml-lg-53{margin-left:636px}.mr-lg-53{margin-right:636px}.pb-lg-53{padding-bottom:318px}.pt-lg-53{padding-top:318px}.pl-lg-53{padding-left:636px}.pr-lg-53{padding-right:636px}.mb-lg-54{margin-bottom:324px}.mt-lg-54{margin-top:324px}.ml-lg-54{margin-left:648px}.mr-lg-54{margin-right:648px}.pb-lg-54{padding-bottom:324px}.pt-lg-54{padding-top:324px}.pl-lg-54{padding-left:648px}.pr-lg-54{padding-right:648px}.mb-lg-55{margin-bottom:330px}.mt-lg-55{margin-top:330px}.ml-lg-55{margin-left:660px}.mr-lg-55{margin-right:660px}.pb-lg-55{padding-bottom:330px}.pt-lg-55{padding-top:330px}.pl-lg-55{padding-left:660px}.pr-lg-55{padding-right:660px}.mb-lg-56{margin-bottom:336px}.mt-lg-56{margin-top:336px}.ml-lg-56{margin-left:672px}.mr-lg-56{margin-right:672px}.pb-lg-56{padding-bottom:336px}.pt-lg-56{padding-top:336px}.pl-lg-56{padding-left:672px}.pr-lg-56{padding-right:672px}.mb-lg-57{margin-bottom:342px}.mt-lg-57{margin-top:342px}.ml-lg-57{margin-left:684px}.mr-lg-57{margin-right:684px}.pb-lg-57{padding-bottom:342px}.pt-lg-57{padding-top:342px}.pl-lg-57{padding-left:684px}.pr-lg-57{padding-right:684px}.mb-lg-58{margin-bottom:348px}.mt-lg-58{margin-top:348px}.ml-lg-58{margin-left:696px}.mr-lg-58{margin-right:696px}.pb-lg-58{padding-bottom:348px}.pt-lg-58{padding-top:348px}.pl-lg-58{padding-left:696px}.pr-lg-58{padding-right:696px}.mb-lg-59{margin-bottom:354px}.mt-lg-59{margin-top:354px}.ml-lg-59{margin-left:708px}.mr-lg-59{margin-right:708px}.pb-lg-59{padding-bottom:354px}.pt-lg-59{padding-top:354px}.pl-lg-59{padding-left:708px}.pr-lg-59{padding-right:708px}.mb-lg-60{margin-bottom:360px}.mt-lg-60{margin-top:360px}.ml-lg-60{margin-left:720px}.mr-lg-60{margin-right:720px}.pb-lg-60{padding-bottom:360px}.pt-lg-60{padding-top:360px}.pl-lg-60{padding-left:720px}.pr-lg-60{padding-right:720px}.mb-lg-61{margin-bottom:366px}.mt-lg-61{margin-top:366px}.ml-lg-61{margin-left:732px}.mr-lg-61{margin-right:732px}.pb-lg-61{padding-bottom:366px}.pt-lg-61{padding-top:366px}.pl-lg-61{padding-left:732px}.pr-lg-61{padding-right:732px}.mb-lg-62{margin-bottom:372px}.mt-lg-62{margin-top:372px}.ml-lg-62{margin-left:744px}.mr-lg-62{margin-right:744px}.pb-lg-62{padding-bottom:372px}.pt-lg-62{padding-top:372px}.pl-lg-62{padding-left:744px}.pr-lg-62{padding-right:744px}.mb-lg-63{margin-bottom:378px}.mt-lg-63{margin-top:378px}.ml-lg-63{margin-left:756px}.mr-lg-63{margin-right:756px}.pb-lg-63{padding-bottom:378px}.pt-lg-63{padding-top:378px}.pl-lg-63{padding-left:756px}.pr-lg-63{padding-right:756px}.mb-lg-64{margin-bottom:384px}.mt-lg-64{margin-top:384px}.ml-lg-64{margin-left:768px}.mr-lg-64{margin-right:768px}.pb-lg-64{padding-bottom:384px}.pt-lg-64{padding-top:384px}.pl-lg-64{padding-left:768px}.pr-lg-64{padding-right:768px}.mb-lg-65{margin-bottom:390px}.mt-lg-65{margin-top:390px}.ml-lg-65{margin-left:780px}.mr-lg-65{margin-right:780px}.pb-lg-65{padding-bottom:390px}.pt-lg-65{padding-top:390px}.pl-lg-65{padding-left:780px}.pr-lg-65{padding-right:780px}.mb-lg-66{margin-bottom:396px}.mt-lg-66{margin-top:396px}.ml-lg-66{margin-left:792px}.mr-lg-66{margin-right:792px}.pb-lg-66{padding-bottom:396px}.pt-lg-66{padding-top:396px}.pl-lg-66{padding-left:792px}.pr-lg-66{padding-right:792px}.mb-lg-67{margin-bottom:402px}.mt-lg-67{margin-top:402px}.ml-lg-67{margin-left:804px}.mr-lg-67{margin-right:804px}.pb-lg-67{padding-bottom:402px}.pt-lg-67{padding-top:402px}.pl-lg-67{padding-left:804px}.pr-lg-67{padding-right:804px}.mb-lg-68{margin-bottom:408px}.mt-lg-68{margin-top:408px}.ml-lg-68{margin-left:816px}.mr-lg-68{margin-right:816px}.pb-lg-68{padding-bottom:408px}.pt-lg-68{padding-top:408px}.pl-lg-68{padding-left:816px}.pr-lg-68{padding-right:816px}.mb-lg-69{margin-bottom:414px}.mt-lg-69{margin-top:414px}.ml-lg-69{margin-left:828px}.mr-lg-69{margin-right:828px}.pb-lg-69{padding-bottom:414px}.pt-lg-69{padding-top:414px}.pl-lg-69{padding-left:828px}.pr-lg-69{padding-right:828px}.mb-lg-70{margin-bottom:420px}.mt-lg-70{margin-top:420px}.ml-lg-70{margin-left:840px}.mr-lg-70{margin-right:840px}.pb-lg-70{padding-bottom:420px}.pt-lg-70{padding-top:420px}.pl-lg-70{padding-left:840px}.pr-lg-70{padding-right:840px}.mb-lg-71{margin-bottom:426px}.mt-lg-71{margin-top:426px}.ml-lg-71{margin-left:852px}.mr-lg-71{margin-right:852px}.pb-lg-71{padding-bottom:426px}.pt-lg-71{padding-top:426px}.pl-lg-71{padding-left:852px}.pr-lg-71{padding-right:852px}.mb-lg-72{margin-bottom:432px}.mt-lg-72{margin-top:432px}.ml-lg-72{margin-left:864px}.mr-lg-72{margin-right:864px}.pb-lg-72{padding-bottom:432px}.pt-lg-72{padding-top:432px}.pl-lg-72{padding-left:864px}.pr-lg-72{padding-right:864px}.mb-lg-73{margin-bottom:438px}.mt-lg-73{margin-top:438px}.ml-lg-73{margin-left:876px}.mr-lg-73{margin-right:876px}.pb-lg-73{padding-bottom:438px}.pt-lg-73{padding-top:438px}.pl-lg-73{padding-left:876px}.pr-lg-73{padding-right:876px}.mb-lg-74{margin-bottom:444px}.mt-lg-74{margin-top:444px}.ml-lg-74{margin-left:888px}.mr-lg-74{margin-right:888px}.pb-lg-74{padding-bottom:444px}.pt-lg-74{padding-top:444px}.pl-lg-74{padding-left:888px}.pr-lg-74{padding-right:888px}.mb-lg-75{margin-bottom:450px}.mt-lg-75{margin-top:450px}.ml-lg-75{margin-left:900px}.mr-lg-75{margin-right:900px}.pb-lg-75{padding-bottom:450px}.pt-lg-75{padding-top:450px}.pl-lg-75{padding-left:900px}.pr-lg-75{padding-right:900px}.mb-lg-76{margin-bottom:456px}.mt-lg-76{margin-top:456px}.ml-lg-76{margin-left:912px}.mr-lg-76{margin-right:912px}.pb-lg-76{padding-bottom:456px}.pt-lg-76{padding-top:456px}.pl-lg-76{padding-left:912px}.pr-lg-76{padding-right:912px}.mb-lg-77{margin-bottom:462px}.mt-lg-77{margin-top:462px}.ml-lg-77{margin-left:924px}.mr-lg-77{margin-right:924px}.pb-lg-77{padding-bottom:462px}.pt-lg-77{padding-top:462px}.pl-lg-77{padding-left:924px}.pr-lg-77{padding-right:924px}.mb-lg-78{margin-bottom:468px}.mt-lg-78{margin-top:468px}.ml-lg-78{margin-left:936px}.mr-lg-78{margin-right:936px}.pb-lg-78{padding-bottom:468px}.pt-lg-78{padding-top:468px}.pl-lg-78{padding-left:936px}.pr-lg-78{padding-right:936px}.mb-lg-79{margin-bottom:474px}.mt-lg-79{margin-top:474px}.ml-lg-79{margin-left:948px}.mr-lg-79{margin-right:948px}.pb-lg-79{padding-bottom:474px}.pt-lg-79{padding-top:474px}.pl-lg-79{padding-left:948px}.pr-lg-79{padding-right:948px}.mb-lg-80{margin-bottom:480px}.mt-lg-80{margin-top:480px}.ml-lg-80{margin-left:960px}.mr-lg-80{margin-right:960px}.pb-lg-80{padding-bottom:480px}.pt-lg-80{padding-top:480px}.pl-lg-80{padding-left:960px}.pr-lg-80{padding-right:960px}}", ""]);

// exports


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "body{width:100vw!important;overflow-x:hidden!important}.ly_small_aside{width:100%;display:flex;justify-content:space-between;align-items:flex-start}.ly_small_aside section{width:885px}.ly_small_aside aside{width:284px}.ly_large_aside{width:100%;display:flex;justify-content:space-between;align-items:flex-start}.ly_large_aside section{box-sizing:border-box;width:828px}.ly_large_aside aside{width:336px}main{width:1200px;margin:0 auto}@media (min-width:991px) and (max-width:1280px){main{width:calc(100vw - 80px)}}.color{height:30px;border-radius:20px 20px 0 0;overflow:hidden;background:transparent;z-index:1}.color,.color:before{position:absolute;top:0;left:0;width:100%}.color:before{content:\"\";height:4px;background-color:#94C52B85}.boxed{box-sizing:border-box;position:relative;width:822px;border-radius:20px;background:#fff;-webkit-box-shadow:0 3px 20px 0 rgba(0,0,0,.05);-moz-box-shadow:0 3px 20px 0 rgba(0,0,0,.05);box-shadow:0 3px 20px 0 rgba(0,0,0,.05)}.boxed.has-cover{padding-top:340.08px!important}@media (min-width:991px) and (max-width:1280px){.boxed{width:calc(100vw - 461px)}.boxed .cover,.boxed.has-cover{padding-top:calc((100vw - 461px)*0.50)!important}}.boxed .cover{padding-top:327px;position:absolute;top:0;border-radius:20px 20px 0 0;overflow:hidden;left:0;width:100%;background-repeat:no-repeat;background-size:cover;background-position:top;z-index:1}.boxed a{color:#f6495c;font-weight:600;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.boxed a:hover{color:#dd192f}.boxed ul{padding-left:20px;width:96%;margin-left:10px;box-sizing:border-box}@media (max-width:768px){.boxed ul{padding-right:20px}}.boxed ul li{padding-bottom:18px;overflow:visible!important}.boxed ul.cons,.boxed ul.pros{list-style:none}.boxed ul.cons li,.boxed ul.pros li{position:relative;padding-left:4px}.boxed ul.cons li:before,.boxed ul.pros li:before{content:\"\";width:8px;height:8px;top:9px;border-radius:8px;position:absolute;left:-20px;background:#78ca00}.boxed ul.cons li:before{background:#ff5800}.boxed .friendly{transition:all .3s ease;background:#fff;box-sizing:border-box;padding:46px 60px 38px 45.2%;width:110%;overflow:hidden;border-radius:8px;position:relative;left:-5%;border:2px solid #efefef;display:block;letter-spacing:.02em;-webkit-font-smoothing:auto;-moz-osx-font-smoothing:none}.boxed .friendly:before{top:-40px;left:-36%;top:-20%;background:#F6495C10;width:70%;padding-top:70%}.boxed .friendly:after,.boxed .friendly:before{content:\"\";position:absolute;border-radius:1000px;display:block}.boxed .friendly:after{top:5px;left:12px;background:url(\"/public/moni.svg\");background-repeat:no-repeat;background-size:contain;width:210px;background-position:50%;height:100%}.boxed .tips{transition:all .3s ease;background:#fff8f0;padding:42px 60px;width:calc(100% - 40px);border-radius:10px;position:relative;left:-40px;display:block;letter-spacing:.02em;-webkit-font-smoothing:auto;-moz-osx-font-smoothing:none}.boxed .tips a{color:#353c45;font-weight:600;-webkit-font-smoothing:auto}.boxed .tips .cta{text-align:center}.boxed .tips .cta .btn_cta{display:inline-block;color:#fff;padding:16px 22px;margin-left:auto;margin-right:auto;margin-top:22px}@media (max-width:500px){.boxed .tips{width:100%;left:auto;margin-left:auto;padding:12% 10% 11%;box-sizing:border-box}}@media (max-width:768px){.boxed .tips{text-align:center}}.boxed .table{margin-top:30px;margin-bottom:24px;width:calc(100% + 60px);left:-30px;box-sizing:border-box;position:relative;border-collapse:collapse}.boxed .table thead{background:#cdcdcd40;text-align:left}.boxed .table thead th{font-weight:600;font-style:italic;color:#353c45;-webkit-font-smoothing:antialiased}.boxed .table tr td,.boxed .table tr th{padding:10px 10px 10px 20px;font-size:16px}.boxed .table tbody tr td{color:#353c45;padding:22px 0 22px 20px;border-bottom:1px solid #70707040}.boxed .table tbody tr:hover td{background:#fff8f0}@media (max-width:768px){.boxed{width:92%;margin-left:auto;margin-right:auto}.boxed.has-cover{padding-top:51.52%!important}.boxed .cover{padding-top:56%!important}}.boxed img{display:block;width:94%;height:auto;margin-left:auto;margin-right:auto}@media (max-width:768px){.boxed img{width:96%}}.boxed img.out{width:130%;margin-left:-15%}@media (max-width:768px){.boxed img.out{width:120%;margin-left:-10%}}.boxed img.side{width:52%;margin-top:12px;margin-bottom:36px;margin-right:48px;float:left}.boxed img.out+label{margin-left:0}.boxed label{display:inline-block;opacity:.55;position:relative;vertical-align:baseline;top:3px;padding-bottom:4px;font-size:11px;max-width:300px;line-height:18px}.should_content{width:calc(100% + 70px);left:-35px;position:relative;box-sizing:border-box;padding:40px 60px 38px;border:2px solid #efefef;border-radius:8px;font-size:17px!important;font-weight:500}@media (max-width:500px){.should_content{width:calc(100% + 34px);left:-17px;padding:40px 25px 38px}}.should_content b{font-weight:700}.should_content .center{text-align:center}.should_content .btn_cta{display:inline-block;padding:22px 40px;font-size:16px!important;color:#fff;font-weight:700}.should_content .btn_cta:hover{background:#ff9404;color:#fff}.should_content h3{position:relative}.should_content.excellent h3{color:#6cb508;padding-left:32px;display:block;font-weight:600}.should_content.excellent h3:after{background:url(\"/public/picto_excellent.svg\");background-size:contain;height:22px;width:40px;top:2px;left:0;position:absolute;display:block;background-repeat:no-repeat;content:\"\"}.should_content.bad h3{color:#f5313e;padding-left:32px;font-weight:600}.should_content.bad h3:after{background:url(\"/public/picto_bad.svg\");background-size:contain;height:22px;width:44px;top:1px;left:0;position:absolute;display:block;background-repeat:no-repeat;content:\"\"}.aside_widget{padding:14px;box-sizing:border-box;background:#fff;width:100%;border-radius:10px;margin-top:2px;-webkit-box-shadow:0 2px 10px 0 rgba(0,0,0,.03);-moz-box-shadow:0 2px 10px 0 rgba(0,0,0,.03);box-shadow:0 2px 10px 0 rgba(0,0,0,.03);text-align:center}.aside_widget .title{padding-top:32px;padding-bottom:45px;border-radius:10px 10px 0 0;background:#f5f5f5;color:#353c45;font-weight:700;clip-path:polygon(100% 0,100% calc(100% - 25px),50% 100%,0 calc(100% - 25px),0 0);top:36px}.aside_widget p{opacity:.9}.aside_widget .btn_cta{display:block;padding:22px 0;margin:8px;width:calc(100% - 16px)}.aside_widget .should{margin:4px;padding:20px 18px 18px;border:2px solid #efefef;border-radius:8px;position:relative;font-size:16px!important;font-weight:500}.aside_widget .should b{font-size:16px;-webkit-font-smoothing:auto;-moz-osx-font-smoothing:none;font-weight:700;letter-spacing:.02em;line-height:22px;display:block;margin-top:11px;margin-bottom:12px}.aside_widget .should span{display:block;margin-bottom:10px;font-size:17px;-webkit-font-smoothing:auto!important;-moz-osx-font-smoothing:none!important}@media (max-width:500px){.aside_widget .should{font-size:18px!important}.aside_widget .should p{padding-left:3%;padding-right:3%}.aside_widget .should b{font-size:18px}.aside_widget .should span{margin-top:4px;margin-bottom:14px;font-size:20px;font-weight:700!important}}.aside_widget .should.average:before,.aside_widget .should.bad:before,.aside_widget .should.excellent:before,.aside_widget .should.good:before,.aside_widget .should.poor:before{height:22px;width:44px;position:absolute;left:calc(50% - 22px);top:-6px;display:block;background:#fff;content:\"\"}.aside_widget .should.average:after,.aside_widget .should.bad:after,.aside_widget .should.excellent:after,.aside_widget .should.good:after,.aside_widget .should.poor:after{height:22px;width:22px;position:absolute;left:calc(50% - 11px);top:-12px;display:block;background:#fff;content:\"\"}.aside_widget .should.excellent span{color:#6cb508;font-weight:600}.aside_widget .should.excellent:after{background:url(\"/public/picto_excellent.svg\");background-size:contain}.aside_widget .should.bad span{color:#f5313e;font-weight:600}.aside_widget .should.bad:after{background:url(\"/public/picto_bad.svg\");background-repeat:no-repeat;background-size:contain}.aside_widget .should .btn_cta{margin:0;width:100%;font-size:16px;margin-top:18px;letter-spacing:.025em}@media (max-width:500px){.aside_widget .should .btn_cta{font-size:18px}}.boxed .aside_widget{box-shadow:none!important;background:none!important;padding-left:0!important;padding-right:0!important;width:106%;position:relative;left:-3%;display:none}.boxed .aside_widget .btn_cta{color:#fff!important;font-weight:700}@media (max-width:990px){.boxed .aside_widget{display:block}}.btn_cta{background:#ff9d18;color:#fff;text-decoration:none;border-radius:6px;-webkit-box-shadow:0 3px 2px 0 rgba(0,0,0,.1);-moz-box-shadow:0 3px 2px 0 rgba(0,0,0,.1);box-shadow:0 3px 2px 0 rgba(0,0,0,.1)}.btn_cta:hover{background:#ff9404}.shadow{-webkit-box-shadow:0 3px 20px 0 rgba(0,0,0,.05);-moz-box-shadow:0 3px 20px 0 rgba(0,0,0,.05);box-shadow:0 3px 20px 0 rgba(0,0,0,.05)}", ""]);

// exports


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(103);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("4a6f6469", content, true, {});

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(17);
exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "body{background:#f8f8f8;font-family:Avenir Next,-apple-system,system-ui,Segoe UI,Roboto,Ubuntu,Cantarell,Noto Sans,sans-serif;box-sizing:border-box;color:#353c45;max-width:100vw;margin:0}body,header{position:relative}header{border-top:3px solid #8cc42d;overflow-x:hidden;width:100vw}header:before{z-index:-1;top:-927px;background:#fff;width:5452px;height:1050px;left:calc(((5452px - 100vw) / 2) * -1);-webkit-border-radius:150%/95%;-moz-border-radius:150%/95%;border-radius:150%/95%;-webkit-box-shadow:0 3px 20px 0 rgba(0,0,0,.1);-moz-box-shadow:0 3px 20px 0 rgba(0,0,0,.1);box-shadow:0 3px 20px 0 rgba(0,0,0,.1);z-index:1000}header:after,header:before{content:\"\";position:absolute}header:after{z-index:1001;left:0;height:3px;background-color:#8cc42d;width:100vw;top:-3px}nav{position:relative;z-index:1003;max-width:1200px;width:100%;margin:0 auto;overflow:clip;display:flex;justify-content:space-between;align-content:center;margin-top:31px;margin-bottom:72px}@media (min-width:991px) and (max-width:1280px){nav{width:calc(100vw - 80px)}}nav #logo_monito a{display:inline-block;text-indent:-1000px;font-size:1px;background-image:url(" + escape(__webpack_require__(28)) + ");background-repeat:no-repeat;width:180px;margin-left:26px;height:48px;background-size:contain;background-position:50%;z-index:100;vertical-align:middle}nav ul{list-style:none}nav ul,nav ul li{display:inline-block}nav ul li{padding:0 36px}nav ul li a{text-decoration:none;color:#cdcdcd;font-size:13px;color:#6f747a;font-family:Avenir Next,-apple-system,system-ui,Segoe UI,Roboto,Ubuntu,Cantarell,Noto Sans,sans-serif;font-weight:700;letter-spacing:.045em;text-transform:uppercase}nav ul li.langage a{color:#000}nav ul li.langage:after{content:\"\";background-image:url(" + escape(__webpack_require__(29)) + ");background-position:top;margin-left:3px;background-repeat:no-repeat;background-size:contain;width:10px;height:8px;display:inline-block}nav ul li:hover a{transition:all .3s ease;color:#000}@media (max-width:768px){body{background:#efefef}header{width:100%!important;overflow:hidden}header:before{content:\"\";position:absolute;z-index:-1;top:-140px;background:#fff;width:2280px;height:240px;left:calc(((2280px - 100vw) / 2) * -1);-webkit-border-radius:150%/95%;-moz-border-radius:150%/95%;border-radius:150%/95%;-webkit-box-shadow:0 3px 20px 0 rgba(0,0,0,.1);-moz-box-shadow:0 3px 20px 0 rgba(0,0,0,.1);box-shadow:0 3px 20px 0 rgba(0,0,0,.1);z-index:1000}nav{width:100%}nav #logo_monito{width:133px;height:35px}nav ul{display:none}}@media (max-width:500px){header:before{top:-154px}header nav{margin-top:18px;margin-bottom:72px}header nav #logo_monito a{width:120px}header:before{width:1280px;left:calc(((1280px - 100vw) / 2) * -1)}}", ""]);

// exports


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(106);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("46b0d124", content, true, {});

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(17);
exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".hero_element[data-v-6d65c112]{margin-top:-162px;position:relative;left:0!important;overflow:hidden;width:100%}.hero_element .ext_form[data-v-6d65c112]{display:none!important}.hero_element .mask[data-v-6d65c112]{overflow:hidden;position:relative;transform-origin:top left;transform:rotate(-2.2deg);width:120vw;margin-bottom:10px;left:-10vw;-webkit-box-shadow:0 3px 20px 0 rgba(0,0,0,.12);-moz-box-shadow:0 3px 20px 0 rgba(0,0,0,.12);box-shadow:0 3px 20px 0 rgba(0,0,0,.12)}.hero_element .mask .rotate[data-v-6d65c112]{left:calc(10vw - 1px);padding-top:215px;padding-bottom:140px;width:calc(100vw + 1px);transform-origin:top left;transform:rotate(2.2deg);position:relative;background-image:linear-gradient(90deg,#3fb901,#a0d30a);background-size:cover;background-repeat:no-repeat;background-position:50%}.hero_element .mask .rotate.darkmode[data-v-6d65c112]{background-color:#242B34F0;background-image:linear-gradient(90deg,rgba(36,43,52,.941176),rgba(36,43,52,.941176)),url(\"https://www.monito.com/tawipages/images/prismic/9104871750b618a803702b821c687eea5f0c73c1_venmo-international-money-transfer.jpeg\")}.hero_element .mask .rotate.contentpage[data-v-6d65c112]{padding-bottom:220px;background-image:linear-gradient(90deg,#3fb901,#a0d30a);background-size:cover;background-repeat:no-repeat;background-position:50%}.hero_element .mask .rotate.corridor[data-v-6d65c112]{padding-bottom:280px;padding-top:185px}.hero_element .mask .rotate.home .left h1[data-v-6d65c112]{text-shadow:0 3px 12px #00000010}.hero_element .mask .rotate.home .left p[data-v-6d65c112]{text-shadow:0 1px 0 #00000040;line-height:27px}.hero_element .mask .rotate .container[data-v-6d65c112]{width:1070px;margin:0 auto;align-items:center;justify-content:space-between;display:flex}.hero_element .mask .rotate .left[data-v-6d65c112]{width:600px;position:relative}.hero_element .mask .rotate .left p[data-v-6d65c112]{width:490px;color:#fff}.hero_element .mask .rotate .left[data-v-6d65c112]:after{content:\"\";position:absolute;width:157px;height:87px;right:-76px;bottom:0;background-image:url(" + escape(__webpack_require__(41)) + ");background-size:contain;background-position:50%;background-repeat:no-repeat}.hero_element .mask .rotate .form[data-v-6d65c112]{height:399px;width:351px!important}@media (max-width:1280px){.hero_element .mask .rotate .container[data-v-6d65c112]{width:calc(100% - 220px)}.hero_element .mask .rotate .container .left[data-v-6d65c112]:after{bottom:-92px;right:10px}}@media (max-width:990px){.hero_element[data-v-6d65c112]{overflow:visible}.hero_element .ext_form[data-v-6d65c112]{display:block!important;width:90%!important;position:absolute;bottom:-100px;left:5%;margin-left:auto!important;margin-right:auto!important}.hero_element .mask .rotate .container[data-v-6d65c112]{width:90%;display:block;padding-bottom:240px}.hero_element .mask .rotate .container .form[data-v-6d65c112]{display:none!important}.hero_element .mask .rotate .container .left[data-v-6d65c112]{width:100%!important;margin-left:auto;margin-right:auto}.hero_element .mask .rotate .container .left h1[data-v-6d65c112],.hero_element .mask .rotate .container .left p[data-v-6d65c112]{width:547px;margin-left:auto;margin-right:auto;text-align:center}.hero_element .mask .rotate .container .left[data-v-6d65c112]:after{display:none}}@media (max-width:768px){.hero_element .rotate[data-v-6d65c112]{padding-top:142px!important}.hero_element .mask .rotate .container[data-v-6d65c112]{width:90%}.hero_element .mask .rotate .container .left h1[data-v-6d65c112]{width:90%;text-align:center}.hero_element .mask .rotate .container .left p[data-v-6d65c112]{width:90%}.hero_element .mask .rotate .container .left[data-v-6d65c112]:after{display:none}.hero_element .mask .rotate .container .form[data-v-6d65c112]{position:absolute;width:95%!important;left:0;margin-left:auto!important;margin-right:auto!important}}@media (max-width:500px){.hero_element .ext_form[data-v-6d65c112]{bottom:-245px}.hero_element .contentpage[data-v-6d65c112]{padding-bottom:130px!important}.hero_element .mask .rotate .container[data-v-6d65c112]{padding-bottom:80px}}.long_form[data-v-6d65c112]{flex:none;width:1260px;margin:0 auto;margin-bottom:20px;display:block;background:#fff;height:80px;border-radius:10px;left:calc(((100vw - 1260px) / 2) * 1)}.long_form .country[data-v-6d65c112]{width:265px;display:inline-block;padding-left:25px;position:relative;height:80px;border-right:4px solid #f4f4f4}.long_form .country[data-v-6d65c112]:after{content:\"\";display:block;position:absolute;right:23px;top:43px;width:15px;height:10px;background-image:url(" + escape(__webpack_require__(18)) + ");background-repeat:no-repeat;background-size:contain}.long_form .country span[data-v-6d65c112]:not(.label){padding-top:4px}.long_form .country span[data-v-6d65c112]:not(.label):before{display:inline-block;content:\"\";position:relative;top:-3px;padding-right:10px;left:-4px;width:28px;height:23px;background-image:url(" + escape(__webpack_require__(21)) + ");background-position:50%;background-size:contain;background-repeat:no-repeat;vertical-align:middle}.long_form .country.to span[data-v-6d65c112]:not(.label):before{background-image:url(" + escape(__webpack_require__(19)) + ")}.long_form .country span[data-v-6d65c112]{display:block;letter-spacing:.03em;font-size:19px;font-family:Avenir Next;font-weight:700;color:#353c45}.long_form .country span.label[data-v-6d65c112]{padding-top:15px;padding-bottom:2px;text-transform:uppercase;font-size:11px;font-family:Avenir Next,-apple-system,system-ui,Segoe UI,Roboto,Ubuntu,Cantarell,Noto Sans,sans-serif;font-weight:700;color:#797e83cf;letter-spacing:.045em}.long_form .country.usa span[data-v-6d65c112]:not(.label):before{background-image:url(" + escape(__webpack_require__(30)) + ")}.long_form .country.uk span[data-v-6d65c112]:not(.label):before{background-image:url(" + escape(__webpack_require__(21)) + ")}.long_form .country.phil span[data-v-6d65c112]:not(.label):before{background-image:url(" + escape(__webpack_require__(31)) + ")}.long_form .country.nz span[data-v-6d65c112]:not(.label):before{background-image:url(" + escape(__webpack_require__(32)) + ")}.long_form .country.fr span[data-v-6d65c112]:not(.label):before{background-image:url(" + escape(__webpack_require__(19)) + ")}.long_form .country.cam span[data-v-6d65c112]:not(.label):before{background-image:url(" + escape(__webpack_require__(33)) + ")}.long_form .country.aus span[data-v-6d65c112]:not(.label):before{background-image:url(" + escape(__webpack_require__(34)) + ")}.long_form .country.sgp span[data-v-6d65c112]:not(.label):before{background-image:url(" + escape(__webpack_require__(35)) + ")}.long_form .country.ind span[data-v-6d65c112]:not(.label):before{background-image:url(" + escape(__webpack_require__(36)) + ")}.long_form .country.chf span[data-v-6d65c112]:not(.label):before{background-image:url(" + escape(__webpack_require__(37)) + ");width:23px;padding-right:9px}.long_form .amount[data-v-6d65c112]{display:inline-block;box-sizing:border-box;padding-top:12px;position:relative;vertical-align:middle;margin:0 20px 22px;height:54px;width:184px;border:3px solid #e4e4e4;font-size:18px;font-family:Avenir Next;font-weight:700;border-radius:6px}.long_form .amount span[data-v-6d65c112]:not(.currency){padding-left:13px;color:rgba(53,60,69,.5)}.long_form .amount.only_currency[data-v-6d65c112]{width:auto}.long_form .amount.only_currency .currency[data-v-6d65c112]{padding-left:16px;margin-right:34px}.long_form .amount.from[data-v-6d65c112]{position:relative;margin-right:30px}.long_form .amount.from[data-v-6d65c112]:after{content:\"TO\";font-size:12px;font-family:Avenir Next;font-weight:700;color:#797e83cf;letter-spacing:.045em;right:-40px;top:16px;position:absolute}.long_form .amount.active[data-v-6d65c112]{border-color:#79ca0c;padding-left:0}.long_form .amount.active span[data-v-6d65c112]:not(.currency){color:#353c45}.long_form .amount.active span[data-v-6d65c112]:not(.currency):before{display:none}.long_form .amount .currency[data-v-6d65c112]{font-size:16px;position:relative}.long_form .amount .currency[data-v-6d65c112]:after{content:\"\";display:block;position:absolute;right:-20px;top:6px;width:13px;height:8px;background-image:url(" + escape(__webpack_require__(18)) + ");background-repeat:no-repeat;background-size:contain}.long_form .amount span[data-v-6d65c112]:not(.currency){display:inline-block;width:115px;box-sizing:border-box;padding-left:20px;position:relative}.long_form .amount span[data-v-6d65c112]:not(.currency):before{content:\"~\";position:relative;left:-5px}.long_form .amount span[data-v-6d65c112]:not(.currency):after{content:\"\";display:block;position:absolute;width:2px;height:28px;background:#e8e6e6;right:10px;top:-1px}.long_form .button[data-v-6d65c112]{display:inline-block;background:#ff9a00;cursor:pointer;border-radius:6px;height:56px;width:280px;color:#fff;vertical-align:top;margin-top:12px;box-sizing:border-box;font-size:18px;text-align:center;padding-top:16px;letter-spacing:.035em;font-family:Avenir Next;font-weight:600}.long_form .button[data-v-6d65c112]:hover{background:#ff9000}", ""]);

// exports


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hero_element"},[_c('div',{staticClass:"mask"},[_c('div',{class:[_vm.herotype,'rotate']},[(_vm.herotype == 'corridor')?_c('section',{staticClass:"long_form shadow"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"button shadow"},[_vm._v("Compare the providers")])]):_vm._e(),_vm._v(" "),(_vm.herotype !== 'contentpage' && _vm.herotype !== 'corridor' )?_c('div',{staticClass:"container"},[_c('div',{staticClass:"left"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"form"},[_c('monito-widgets-imt-search-form',{attrs:{"powered-by-nf":"off","cta-label":"Find alternatives to Venmo","country-from":"US","country-to":"MX","utm-source":"internal","utm-medium":"internal","utm-content":"hero_widget","utm-campaign":"ABTestVenmo"}})],1)]):_vm._e()])]),_vm._v(" "),(_vm.herotype !== 'contentpage' && _vm.herotype !== 'corridor' )?_c('div',{staticClass:"ext_form"},[_c('monito-widgets-imt-search-form',{attrs:{"powered-by-nf":"off","country-from":"US","country-to":"MX","utm-source":"internal","utm-medium":"internal","utm-content":"hero_widget","utm-campaign":"ABTestVenmo"}})],1):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"from country usa"},[_c('span',{staticClass:"label"},[_vm._v("Sending From")]),_vm._v(" "),_c('span',[_vm._v("United States")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"to country uk"},[_c('span',{staticClass:"label"},[_vm._v("Sending to")]),_vm._v(" "),_c('span',[_vm._v("United Kingdom")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"amount from active"},[_c('span',[_vm._v("400")]),_c('span',{staticClass:"currency"},[_vm._v("USD")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"amount to only_currency"},[_c('span',{staticClass:"currency"},[_vm._v("GBP")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(109);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("43eac04e", content, true, {});

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(17);
exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "footer[data-v-4eb5bd53]{background:#2e3238;width:100%;padding-top:12px;overflow:hidden}p[data-v-4eb5bd53]{color:#fff;text-align:center}.swiss[data-v-4eb5bd53]{position:relative}.swiss span[data-v-4eb5bd53]{content:\"\";left:0;height:17px;width:17px;position:relative;display:inline-block;top:3px;margin-right:9px;background-image:url(" + escape(__webpack_require__(110)) + ");background-size:contain}@media (max-width:768px){.adress[data-v-4eb5bd53]{width:80%;margin-right:auto;margin-left:auto;padding-bottom:36px}}.adress span[data-v-4eb5bd53]{margin-left:5px;margin-right:5px}ul[data-v-4eb5bd53]{padding-left:0;list-style:none;width:1200px;display:flex;align-items:center;justify-content:center;margin-left:auto;margin-right:auto}@media (max-width:768px){ul[data-v-4eb5bd53]{display:none}}ul li[data-v-4eb5bd53]{color:#fff;display:inline-flex;margin:0 17px;position:relative}ul li[data-v-4eb5bd53]:not(:last-child):after{content:\" \\2013   \";font-weight:700;position:absolute;right:-18px}ul li a[data-v-4eb5bd53]{text-decoration:none;font-weight:500}ul li a[data-v-4eb5bd53]:hover{text-decoration:underline}", ""]);

// exports


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "swiss_flag_footer.svg?a87b3b6029bad1a45234f0fac0df5576";

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',{staticClass:"container"},[_c('ul',{staticClass:"fs-14 ls-2 f-anti"},[_c('li',[_c('a',{attrs:{"href":"https://www.monito.com/en/about-monito?utm_source=internal&utm_medium=internal&utm_campaign=ABTest&utm_content=footer"}},[_vm._v("About us")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.monito.com/en/how-it-works?utm_source=internal&utm_medium=internal&utm_campaign=ABTest&utm_content=footer"}},[_vm._v("How it works")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.monito.com/en/wiki/why-you-can-trust-monito?utm_source=internal&utm_medium=internal&utm_campaign=ABTest&utm_content=footer"}},[_vm._v("Why you can trust us")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.monito.com/en/wiki?utm_source=internal&utm_medium=internal&utm_campaign=ABTest&utm_content=footer"}},[_vm._v("Wiki")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.monito.com/en/wiki/contact-us?utm_source=internal&utm_medium=internal&utm_campaign=ABTest&utm_content=footer"}},[_vm._v("Contact")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.monito.com/en/wiki/media-and-awards?utm_source=internal&utm_medium=internal&utm_campaign=ABTest&utm_content=footer"}},[_vm._v("Media")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.monito.com/en/wiki/marketing-partnerships?utm_source=internal&utm_medium=internal&utm_campaign=ABTest&utm_content=footer"}},[_vm._v("Affiliates and partnerships")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.monito.com/en/jobs?utm_source=internal&utm_medium=internal&utm_campaign=ABTest&utm_content=footer"}},[_vm._v("Jobs")])])]),_vm._v(" "),_c('p',{staticClass:"swiss fs-14 fw-demi-bold ls-2 mb-4 mt-4"},[_c('span'),_vm._v("Proudly made in Switzerland")]),_vm._v(" "),_c('ul',{staticClass:"fs-13 ls-2 f-anti mb-2"},[_c('li',[_c('a',{attrs:{"href":""}},[_vm._v("Terms of Service")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":""}},[_vm._v("Privacy Policy")])])]),_vm._v(" "),_c('p',{staticClass:"adress fs-12 pb-4"},[_vm._v("© 2013-2020 "),_c('span',[_vm._v("~")]),_vm._v("   Global Impact Finance Ltd  "),_c('span',[_vm._v("-")]),_vm._v("  Avenue de Montchoisi 35  "),_c('span',[_vm._v("-")]),_vm._v("  1006 Lausanne  "),_c('span',[_vm._v("-")]),_vm._v("  Switzerland")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(113);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("dde3fcd4", content, true, {});

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "section[data-v-593b0e68]{width:1200px;min-height:200px;margin-left:auto;margin-right:auto;z-index:10;margin-top:-100px;background:#fff;border-radius:0 0 20px 20px}@media (max-width:1280px){section[data-v-593b0e68]{width:calc(100% - 80px)}}@media (max-width:768px){section[data-v-593b0e68]{padding-top:200px;width:95%;margin-left:auto;margin-right:auto;text-align:center}}@media (max-width:500px){section[data-v-593b0e68]{padding-top:360px}}", ""]);

// exports


/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"shadow"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(116);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("6ada1840", content, true, {});

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".author[data-v-4d964b2e]{width:calc(100% + 30px);position:relative;left:-15px;border-top:1px solid #ebebeb;border-bottom:1px solid #ebebeb;display:flex;align-items:center;justify-content:space-between}.author .image[data-v-4d964b2e]{width:78px;height:78px;border-radius:100px;position:absolute;top:-25px;left:-25px;background-size:contain;border:16px solid #fff;background-position:50%}.author .portrait[data-v-4d964b2e]{margin-left:90px}.author .portrait .name[data-v-4d964b2e]{margin-bottom:3px}.author .portrait .update[data-v-4d964b2e]{margin-left:-10px}.author .portrait span[data-v-4d964b2e]{margin-right:8px;color:#353C4599}.author .bio[data-v-4d964b2e]{width:330px;padding-right:15px;text-align:right;color:#353C4599;box-sizing:border-box}@media (max-width:768px){.author[data-v-4d964b2e]{display:block}.author .image[data-v-4d964b2e]{top:5px;left:-10px}.author .portrait[data-v-4d964b2e]{margin-left:104px;margin-top:10px}.author .portrait .update[data-v-4d964b2e]{margin-left:0}.author .bio[data-v-4d964b2e]{text-align:left;width:90%;padding-left:15px;margin-left:90px}}@media (max-width:500px){.author[data-v-4d964b2e]{display:block}.author .image[data-v-4d964b2e]{width:58px;height:58px;left:0;top:0}.author .portrait[data-v-4d964b2e]{margin-top:14px;margin-left:90px}.author .bio[data-v-4d964b2e]{text-align:left;width:90%;padding-left:15px;margin-left:auto;margin-right:auto;margin-top:25px;display:none}}", ""]);

// exports


/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"author fs-13  fs-sm-14 f-anti fw-demi-bold ls-1"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(119);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("049060c4", content, true, {});

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(17);
exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".text_and_featured[data-v-131d7e5d]{margin-left:auto;margin-right:auto;min-height:200px;display:flex;justify-content:space-between;align-items:center}.text_and_featured span[data-v-131d7e5d]{display:block}.text_and_featured>div[data-v-131d7e5d]{width:570px;margin-left:125px}.text_and_featured a[data-v-131d7e5d]{display:inline-block;text-decoration:none;outline:none;background:#79ca0c;border:none;border-radius:10px;padding:16px 26px;color:#fff;font-size:15px;font-weight:700;-webkit-box-shadow:0 3px 2px 0 rgba(0,0,0,.1);-moz-box-shadow:0 3px 2px 0 rgba(0,0,0,.1);box-shadow:0 3px 2px 0 rgba(0,0,0,.1);cursor:pointer}.text_and_featured a[data-v-131d7e5d]:hover{background-color:#6fba0a}.text_and_featured aside[data-v-131d7e5d]{width:340px;margin-right:72px}.text_and_featured aside div[data-v-131d7e5d]{background:#f8f8f8;border-radius:10px;padding:32px 30px 32px 115px;color:#353c45f7;position:relative}.text_and_featured aside div.group[data-v-131d7e5d]:before{background-image:url(" + escape(__webpack_require__(120)) + ");top:40px}.text_and_featured aside div.group[data-v-131d7e5d]:before,.text_and_featured aside div.lock[data-v-131d7e5d]:before{content:\"\";position:absolute;width:48px;height:52px;background-repeat:no-repeat;background-size:contain;background-position:50%;left:36px}.text_and_featured aside div.lock[data-v-131d7e5d]:before{background-image:url(" + escape(__webpack_require__(121)) + ");top:38px}.text_and_featured aside div+div[data-v-131d7e5d]{margin-top:25px}@media (max-width:768px){.text_and_featured[data-v-131d7e5d]{display:block}.text_and_featured>div[data-v-131d7e5d]{width:95%;margin-left:auto;margin-right:auto}.text_and_featured a[data-v-131d7e5d]{margin-left:auto;margin-right:auto}.text_and_featured aside[data-v-131d7e5d]{width:100%;margin-right:0;margin-top:40px}.text_and_featured aside div[data-v-131d7e5d]{width:90%;margin-right:auto;margin-left:auto;box-sizing:border-box;text-align:left}}", ""]);

// exports


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "group.svg?800054bb14c5545cb4c9e1098d2be8dd";

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "lock.svg?919a8fefa9af24aaea7a20945c6f10fc";

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text_and_featured"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(124);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("7aaef32d", content, true, {});

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".featured_on[data-v-02b0e71f]{margin:0 auto}.featured_on h3[data-v-02b0e71f]{text-align:center}.featured_on ul[data-v-02b0e71f]{width:740px;padding:0;margin-left:auto;margin-right:auto;list-style:none;display:flex;align-items:center;justify-content:space-between}.featured_on ul li[data-v-02b0e71f]{opacity:.6;height:38px}.featured_on ul li img[data-v-02b0e71f]{height:36px}.featured_on ul li[data-v-02b0e71f]:hover{opacity:1;cursor:pointer;transition:opacity .15s}@media (max-width:768px){.featured_on ul[data-v-02b0e71f]{width:90%;margin-left:auto;margin-right:auto;display:block}.featured_on ul li[data-v-02b0e71f]{margin-bottom:40px}.featured_on ul li img[data-v-02b0e71f]{height:40px}}@media (max-width:500px){.featured_on ul[data-v-02b0e71f]{width:90%;margin-left:auto;margin-right:auto;display:block}.featured_on ul li[data-v-02b0e71f]{margin-bottom:24px;width:49%;display:inline-block}.featured_on ul li img[data-v-02b0e71f]{height:30px}}", ""]);

// exports


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"featured_on"},[_c('h3',{staticClass:"f-19 fw-demi-bold ls-1"},[_vm._v("As featured on")]),_vm._v(" "),_c('ul',{staticClass:"mt-5"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(127);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("63dc9666", content, true, {});

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".little_monito_score .monito_score svg{top:2px!important;left:2px!important}.little_monito_score .score{top:-1px!important;left:0!important}", ""]);

// exports


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(129);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("de6ef3e0", content, true, {});

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".reviews[data-v-9f4d09dc]{margin-top:60px;margin-bottom:50px;height:380px;width:100vw;overflow:hidden}@media (max-width:768px){.reviews[data-v-9f4d09dc]{margin-top:50px;margin-bottom:50px;height:350px;overflow:hidden;width:100%}}@media (max-width:500px){.reviews[data-v-9f4d09dc]{margin-top:30px;margin-bottom:10px;height:350px;overflow:hidden;width:100%}}.container[data-v-9f4d09dc]{width:1030px;margin:0 auto}.container h1[data-v-9f4d09dc]{text-align:left;max-width:55%}@media (max-width:768px){.container[data-v-9f4d09dc]{width:90%;margin-left:auto;margin-right:auto}.container h1[data-v-9f4d09dc],.container span[data-v-9f4d09dc]{display:block;text-align:center;max-width:95%;margin-left:auto;margin-right:auto}}ul[data-v-9f4d09dc]{list-style:none;margin:60px 0 0;width:100vw;display:flex;z-index:1005;padding:0;position:relative;animation-name:slide-data-v-9f4d09dc;animation-duration:75s;animation-timing-function:linear;animation-iteration-count:infinite}@keyframes slide-data-v-9f4d09dc{0%{left:-10vw}to{left:-100vw}}@media (max-width:768px){ul[data-v-9f4d09dc]{animation-duration:20s}@keyframes slide-data-v-9f4d09dc{0%{left:-10vw}to{left:-200vw}}}@media (max-width:500px){ul[data-v-9f4d09dc]{animation-duration:24s}@keyframes slide-data-v-9f4d09dc{0%{left:-10vw}to{left:-200vw}}}@media (min-width:991px){ul[data-v-9f4d09dc]:hover{-webkit-animation-play-state:paused;-moz-animation-play-state:paused;-o-animation-play-state:paused;animation-play-state:paused}}li[data-v-9f4d09dc]{position:relative;flex:none;min-width:130px;height:100px;border-radius:20px;background-color:#fff;margin-left:10px;display:inline-block;margin-right:12px;-webkit-box-shadow:0 3px 20px 0 rgba(0,0,0,.04);-moz-box-shadow:0 3px 20px 0 rgba(0,0,0,.04);box-shadow:0 3px 20px 0 rgba(0,0,0,.04)}@media (max-width:990px){li a[data-v-9f4d09dc]{position:absolute;top:0;left:0;width:100%;height:100px;text-indent:-10000px;font-size:1px}}li .monito_score[data-v-9f4d09dc]{position:absolute;top:-38px;right:-28px;background:#fff;border:6px solid #f8f8f8;border-radius:30px;width:52px;height:52px}@media (max-width:500px){li .monito_score[data-v-9f4d09dc]{border-color:#efefef}}li img.logo[data-v-9f4d09dc]{height:36px;width:auto;padding:30px 35px 25px}@media (max-width:500px){li img.logo[data-v-9f4d09dc]{height:36px}}@media (min-width:991px){li a[data-v-9f4d09dc]{display:none}li[data-v-9f4d09dc]:hover{transform:scale(1.05);transition:all .2s ease;height:155px;position:relative;top:-20px}li:hover a[data-v-9f4d09dc]{background:#ff9a00;width:calc(100% - 30px);display:block;position:absolute;bottom:-2px;opacity:0;left:15px;color:#fff;animation-name:opacity_btn-data-v-9f4d09dc;animation-duration:.25s;animation-timing-function:ease;animation-fill-mode:forwards;text-decoration:none;font-weight:700;font-size:14px;text-align:center;padding:14px 0;border-radius:10px;letter-spacing:.03em;-webkit-box-shadow:0 3px 20px 0 rgba(0,0,0,.1);-moz-box-shadow:0 3px 20px 0 rgba(0,0,0,.1);box-shadow:0 3px 20px 0 rgba(0,0,0,.1);cursor:pointer}@keyframes opacity_btn-data-v-9f4d09dc{0%{opacity:0;bottom:-2px}to{opacity:1;bottom:15px}}li:hover a[data-v-9f4d09dc]:hover{background-color:#ff8100}}", ""]);

// exports


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(131);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("5afa6d64", content, true, {});

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".monito_score[data-v-324120ca]{transform:scale(1.2);width:58px;height:49px;margin-left:7px;margin-right:25px;position:relative}.monito_score svg[data-v-324120ca]{position:absolute;top:-2px;left:-2px}.monito_score .score[data-v-324120ca]{display:inline-block;width:52px;padding-top:17px;left:0;position:relative;box-sizing:border-box;height:52px;text-align:center;font-family:Avenir Next,-apple-system,system-ui,Segoe UI,Roboto,Ubuntu,Cantarell,Noto Sans,sans-serif;font-weight:700}.progress-ring-circle[data-v-324120ca]{transform:rotate(-90deg);transform-origin:50% 50%;stroke:#000}.monito_score.excellent[data-v-324120ca]{color:#00a000}.monito_score.excellent .progress-ring-circle[data-v-324120ca]{stroke:#00a000}.monito_score.good[data-v-324120ca]{color:#76c107}.monito_score.good .progress-ring-circle[data-v-324120ca]{stroke:#76c107}.monito_score.average[data-v-324120ca]{color:#ff9a0a}.monito_score.average .progress-ring-circle[data-v-324120ca]{stroke:#ff9a0a}.monito_score.poor[data-v-324120ca]{color:#ff5b05}.monito_score.poor .progress-ring-circle[data-v-324120ca]{stroke:#ff5b05}.monito_score.bad[data-v-324120ca]{color:#f5313e}.monito_score.bad .progress-ring-circle[data-v-324120ca]{stroke:#f5313e}", ""]);

// exports


/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['monito_score',_vm.getColorScore(_vm.score)]},[_c('svg',{staticClass:"progress-ring",attrs:{"height":_vm.width,"width":_vm.width}},[_c('circle',{attrs:{"stroke":"#D2D1D270","stroke-width":_vm.stroke,"fill":"transparent","r":_vm.half(_vm.width)-_vm.stroke,"cx":_vm.half(_vm.width),"cy":_vm.half(_vm.width)}}),_vm._v(" "),_c('circle',{staticClass:"progress-ring-circle",style:('strokeDasharray: '+  _vm.getMonitoScore(_vm.score) +' '+ Math.round(2 * Math.PI * (_vm.half(_vm.width) - _vm.stroke)) +''),attrs:{"stroke":"#f00","stroke-width":_vm.stroke,"fill":"transparent","r":_vm.half(_vm.width)-_vm.stroke,"cx":_vm.half(_vm.width),"cy":_vm.half(_vm.width)}})]),_vm._v(" "),_c('span',{staticClass:"score f-anti",style:('fontSize:'+_vm.size+'px')},[_vm._v(_vm._s(_vm.score)+" ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"reviews"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"title"},[_vm._t("default")],2)]),_vm._v(" "),_c('ul',[_vm._l((3),function(n){return _vm._l((_vm.providers),function(provider){return _c('li',{staticClass:"little_monito_score"},[_c('img',{staticClass:"logo",attrs:{"src":provider.logo}}),_vm._v(" "),_c('element-circle-score',{attrs:{"score":provider.score,"width":48,"stroke":4,"size":15}}),_vm._v(" "),_c('a',{attrs:{"href":provider.url}},[_vm._v("Read the review")])],1)})}),_vm._v("   s\n       \t")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(135);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("6f678e2c", content, true, {});

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "section[data-v-f9ddf212]{min-height:600px;padding-bottom:40px;margin-top:calc((10vw - 30px) * -1);padding-top:calc(10vw + 50px);background:#f0f0f0;width:100vw;position:relative}@media (max-width:768px){section[data-v-f9ddf212]{width:100%;background:#e8e8e8}}section .bg-transition[data-v-f9ddf212]{height:10vw;width:100vw;background:#f0f0f0;position:absolute;overflow:hidden;margin:0;left:0;top:0}@media (max-width:768px){section .bg-transition[data-v-f9ddf212]{background:#e8e8e8}}section .bg-transition .ovale[data-v-f9ddf212]{position:absolute;background:#f0f0f0;width:800vw;height:200vw;bottom:-190vw;border-radius:400vw/100vw;left:-350vw;z-index:10}@media (max-width:768px){section .bg-transition .ovale[data-v-f9ddf212]{background:#e8e8e8}}section .bg-transition .bloc[data-v-f9ddf212]{width:100%;background:#f8f8f8;height:5vw;z-index:1;top:0;left:0;position:absolute}@media (max-width:768px){section .bg-transition .bloc[data-v-f9ddf212]{background:#efefef}}section .container[data-v-f9ddf212]{width:1200px;margin-left:auto;margin-right:auto}@media (min-width:991px) and (max-width:1280px){section .container[data-v-f9ddf212]{width:calc(100vw - 80px)}}@media (max-width:990px){section .container[data-v-f9ddf212]{width:calc(100vw - 80px)}}@media (max-width:768px){section .container[data-v-f9ddf212]{width:95%}}section ul[data-v-f9ddf212]{width:800px;margin-left:auto;margin-right:auto;padding:0;list-style:none;border-radius:20px}@media (max-width:768px){section ul[data-v-f9ddf212]{width:100%}}section li[data-v-f9ddf212]{background:#fff;padding:40px 80px;overflow:hidden;border-bottom:1px solid #00000020}section li[data-v-f9ddf212]:first-child{border-radius:20px 20px 0 0}section li[data-v-f9ddf212]:last-child{border-radius:0 0 20px 20px}@media (max-width:768px){section li[data-v-f9ddf212]{padding:42px 30px}}section h1[data-v-f9ddf212]{text-align:center}", ""]);

// exports


/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"container"},[_vm._t("default")],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-transition round-top"},[_c('div',{staticClass:"ovale"}),_c('div',{staticClass:"bloc"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(138);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("10e646be", content, true, {});

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".bg-transition[data-v-1fd4444a]{height:10vw;width:100vw;background:#f8f8f8;position:absolute;overflow:hidden;margin:0;left:0;top:0}@media (max-width:768px){.bg-transition[data-v-1fd4444a]{background:#efefef}}.bg-transition .ovale[data-v-1fd4444a]{position:absolute;background:#f0f0f0;width:90vw;height:9vw;top:-3.1vw;border-radius:45vw/4.5vw;left:-22.25vw}@media (max-width:768px){.bg-transition .ovale[data-v-1fd4444a]{background:#e8e8e8}}.bg-transition .ovale+.ovale[data-v-1fd4444a]{left:auto;right:-22.25vw;top:auto;background:#f8f8f8;bottom:-3.1vw;z-index:10}@media (max-width:768px){.bg-transition .ovale+.ovale[data-v-1fd4444a]{background:#efefef}}.bg-transition .bloc[data-v-1fd4444a]{width:100%;background:#f0f0f0;height:5vw;z-index:1;top:0;left:0;position:absolute}@media (max-width:768px){.bg-transition .bloc[data-v-1fd4444a]{background:#e8e8e8}}section[data-v-1fd4444a]{background:#f8f8f8;z-index:100;width:100vw;position:relative;padding-top:calc(10vw + 20px);margin-bottom:120px}@media (max-width:768px){section[data-v-1fd4444a]{background:#efefef}}section .container[data-v-1fd4444a]{width:1256px;position:relative;margin:0 auto}section .container h1[data-v-1fd4444a]{text-align:center}@media (min-width:991px) and (max-width:1280px){section .container[data-v-1fd4444a]{width:calc(100vw - 80px)}}@media (max-width:990px){section .container[data-v-1fd4444a]{width:100%}}.grid[data-v-1fd4444a]{display:flex;align-items:stretch;flex-wrap:wrap;justify-content:space-between}@media (max-width:990px){.grid[data-v-1fd4444a]{overflow:scroll;flex-wrap:no-wrap;width:95%;margin-left:2.5%;margin-right:2.5%}}.grid.grid-7 .article[data-v-1fd4444a],.grid.grid-7 .ghost[data-v-1fd4444a]{width:291px}.grid.grid-7 .article h2[data-v-1fd4444a],.grid.grid-7 .ghost h2[data-v-1fd4444a]{font-size:17px;line-height:22px}@media (min-width:991px) and (max-width:1280px){.grid.grid-7 .article[data-v-1fd4444a],.grid.grid-7 .ghost[data-v-1fd4444a]{width:calc(25% - 20px)}}.grid.grid-7 .article[data-v-1fd4444a]:first-child,.grid.grid-7 .article[data-v-1fd4444a]:nth-child(2),.grid.grid-7 .article[data-v-1fd4444a]:nth-child(3){width:398px;margin-bottom:30px}.grid.grid-7 .article:first-child h2[data-v-1fd4444a],.grid.grid-7 .article:nth-child(2) h2[data-v-1fd4444a],.grid.grid-7 .article:nth-child(3) h2[data-v-1fd4444a]{font-size:20px;line-height:26px;max-height:none;overflow:visible;margin:25px 30px}.grid.grid-7 .article:first-child .author[data-v-1fd4444a],.grid.grid-7 .article:nth-child(2) .author[data-v-1fd4444a],.grid.grid-7 .article:nth-child(3) .author[data-v-1fd4444a]{font-size:13px}.grid.grid-7 .article:first-child .cover[data-v-1fd4444a],.grid.grid-7 .article:nth-child(2) .cover[data-v-1fd4444a],.grid.grid-7 .article:nth-child(3) .cover[data-v-1fd4444a]{padding-top:49%}@media (min-width:991px) and (max-width:1280px){.grid.grid-7 .article[data-v-1fd4444a]:first-child,.grid.grid-7 .article[data-v-1fd4444a]:nth-child(2),.grid.grid-7 .article[data-v-1fd4444a]:nth-child(3){width:calc(33.3333333333% - 20px);margin-bottom:20px}}@media (max-width:990px){.grid.grid-7 .article[data-v-1fd4444a]{display:inline-block!important;flex:40vw!important;margin-bottom:0!important;margin:16px 8px!important}.grid.grid-7 .article[data-v-1fd4444a]:nth-child(odd){margin:16px 12px 16px 8px!important}.grid.grid-7 .article[data-v-1fd4444a]:nth-child(2n){margin:16px 8px 16px 12px!important}.grid.grid-7 .article h2[data-v-1fd4444a]{font-size:17px!important;line-height:21px!important;margin:16px 20px!important}.grid.grid-7 .article .cover[data-v-1fd4444a]{padding-top:49%!important}.grid.grid-7 .ghost[data-v-1fd4444a]{display:inline-block!important;flex:40vw!important;margin-bottom:0!important;margin:16px 8px!important}}@media (max-width:500px){.grid.grid-7 .article[data-v-1fd4444a]{display:inline-block!important;flex:70vw!important;margin-bottom:0!important;margin:10px!important}.grid.grid-7 .article h2[data-v-1fd4444a]{font-size:17px!important;line-height:21px!important;margin:16px 20px!important}.grid.grid-7 .article .cover[data-v-1fd4444a]{padding-top:49%!important}}.grid.grid-4 .article[data-v-1fd4444a]{width:291px}.grid.grid-4 .article h2[data-v-1fd4444a]{font-size:17px;line-height:22px}.grid.grid-4 .ghost[data-v-1fd4444a]{display:none}@media (min-width:991px) and (max-width:1280px){.grid.grid-4 .article[data-v-1fd4444a]{width:calc(25% - 20px)}}@media (max-width:990px){.grid .article[data-v-1fd4444a]{display:inline-block!important;flex:40vw!important;margin-bottom:0!important;margin:16px 8px!important}.grid .article h2[data-v-1fd4444a]{font-size:17px!important;line-height:21px!important;margin:16px 20px!important}.grid .article .cover[data-v-1fd4444a]{padding-top:49%!important}}@media (max-width:500px){.grid .article[data-v-1fd4444a]{display:inline-block!important;flex:70vw!important;margin-bottom:0!important;margin:10px!important}.grid .article h2[data-v-1fd4444a]{font-size:17px!important;line-height:21px!important;margin:16px 20px!important}.grid .article .cover[data-v-1fd4444a]{padding-top:49%!important}.grid .ghost[data-v-1fd4444a]{display:none}}.article[data-v-1fd4444a]{background:#fff;box-sizing:border-box;border-radius:10px;display:inline-block;overflow:hidden;position:relative}.article a[data-v-1fd4444a]{height:100%;text-decoration:none;display:block;padding-bottom:30px}.article h2[data-v-1fd4444a]{margin:20px 30px;max-height:65px;box-sizing:border-box;overflow:hidden}.article .author[data-v-1fd4444a]{position:absolute;bottom:20px;left:30px;opacity:.6}@media (max-width:990px){.article .author[data-v-1fd4444a]{left:21px}}.article[data-v-1fd4444a]:hover{transform:scale(1.02);transition:all .25s}.article .cover[data-v-1fd4444a]{background:#79ca0c;width:100%;padding-top:56%;background-size:cover;background-position:50%;background-repeat:no-repeat}.ghost[data-v-1fd4444a]{background:#EBEBEB99;border-radius:10px}", ""]);

// exports


/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"container"},[_vm._t("default"),_vm._v(" "),_c('div',{class:['grid',_vm.nbrArticle(_vm.articles)]},[_vm._l((_vm.articles),function(article){return _c('article',{staticClass:"article shadow"},[_c('a',{attrs:{"href":article.url}},[_c('div',{staticClass:"cover",style:({backgroundImage:'url('+article.cover+')'})}),_vm._v(" "),_c('h2',{staticClass:"ls-2 f-anti fw-bold"},[_vm._v(_vm._s(article.title))]),_vm._v(" "),_c('p',{staticClass:"author fs-12 f-anti ls-2"},[_vm._v(_vm._s(article.date_author))])])])}),_vm._v(" "),_vm._l(((7 - _vm.articles.length)),function(n){return _c('article',{staticClass:"ghost"})})],2)],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-transition"},[_c('div',{staticClass:"ovale"}),_c('div',{staticClass:"ovale"}),_c('div',{staticClass:"bloc"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',[_c('app-navigation',[_c('h1',{attrs:{"id":"logo_monito"}},[_c('a',{attrs:{"href":"https://monito.com?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=nav"}},[_vm._v("Monito")])]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"https://www.monito.com/en/about-monito?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=nav"}},[_vm._v("About us")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.monito.com/en/wiki/monito-account?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=nav"}},[_vm._v("Alerts")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.monito.com/en/wiki?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=nav"}},[_vm._v("Wiki")])]),_vm._v(" "),_c('li',{staticClass:"langage"},[_c('a',{attrs:{"href":"#"}},[_vm._v("EN")])])])]),_vm._v(" "),_c('app-hero-section',{attrs:{"urlBackground":_vm.urlBackground,"herotype":_vm.herotype}},[_c('h1',{staticClass:"fs-48 fs-md-38 fs-sm-38 lh-9 lh-md-7 lh-sm-7 md-3 mb-6 mt-md-5 mt-sm-3 f-anti",staticStyle:{"color":"#fff"}},[_vm._v("Love Venmo? "),_c('br'),_vm._v(" Sadly it doesn’t work internationally")]),_vm._v(" "),_c('p',{staticClass:"fs-19 fs-sm-19 fw-medium f-anti lh-4 mb-4 ls-1"},[_vm._v("Each Venmo transfer needs the sender and beneficiary to be physically in the US, so you can’t use it to send money abroad to a friend or family.")]),_vm._v(" "),_c('p',{staticClass:"fs-19 fs-sm-19 fw-medium f-anti lh-4 ls-1"},[_vm._v("If you’re looking for the best & "),_c('a',{attrs:{"href":"https://www.monito.com/en/wiki/what-is-the-cheapest-way-to-send-money-abroad?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=hero_section"}},[_vm._v("cheapest way to send money internationally")]),_vm._v(", you can compare all solutions in real-time with "),_c('a',{attrs:{"href":"https://www.monito.com/?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=hero_section"}},[_vm._v("Monito’s money transfer comparison tool.")])])]),_vm._v(" "),_c('app-subhero-section',{staticClass:"pt-20 pb-7 pb-sm-3  mb-4"},[_c('widget-text-featured-block',{staticClass:"mb-9"},[_c('div',[_c('h2',{staticClass:"fs-28 fs-md-25 fs-sm-24 lh-6 ls-sm-2 lh-sm-5 mt-5 mb-1 mb-sm-3"},[_vm._v("Monito is like a travel comparison site, but for money transfers")]),_vm._v(" "),_c('span',{staticClass:"fs-19 fs-md-17 fs-sm-17 italic fw-demi-bold f-anti",staticStyle:{"opacity":"0.88"}},[_vm._v("Compare. Select the best provider. Save money")]),_vm._v(" "),_c('a',{staticClass:"f-anti ls-2 mt-5",attrs:{"href":"https://www.monito.com/en/how-it-works?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=subhero_section"}},[_vm._v("Learn more")])]),_vm._v(" "),_c('aside',[_c('div',{staticClass:"fs-17 fw-demi-bold f-anti ls-1 lock"},[_vm._v("We only recommend companies that are secured and regulated")]),_vm._v(" "),_c('div',{staticClass:"fs-17 fw-demi-bold f-anti ls-1 group"},[_vm._v("Our comparison engine is trusted by 3 million users worldwide")])])]),_vm._v(" "),_c('widget-featured-on',[_c('li',[_c('a',{attrs:{"href":"https://www.forbes.com/sites/davidprosser/2017/11/22/europes-10-most-exciting-technology-smes-for-2018/#7ee7841d35e2"}},[_c('img',{attrs:{"src":"public/forbes_logo.png"}})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://guardian.co.uk/"}},[_c('img',{attrs:{"src":"public/guardian_logo.png"}})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.businessinsider.com/fintech-uses-data-driven-testing-in-every-aspect-of-business-2020-4?r=US&IR=T"}},[_c('img',{attrs:{"src":"public/business_insider_logo.png"}})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.lemonde.fr/"}},[_c('img',{attrs:{"src":"public/le_monde_logo.png"}})])])])],1)],1),_vm._v(" "),_c('widget-providers',{attrs:{"providers":_vm.providers}},[_c('h1',{staticClass:"fs-28 lh-6 mb-1 mt-5\n      fs-sm-24 lh-sm-5  mb-sm-3 ls-sm-2\n    "},[_vm._v("Alternatives to Venmo for sending money outside the US")]),_vm._v(" "),_c('span',{staticClass:"fs-19 italic fs-sm-17 fw-demi-bold f-anti",staticStyle:{"opacity":"0.88"}},[_vm._v("Read our in-depth review about each provider")])]),_vm._v(" "),_c('aside',{staticClass:"scroller mobile"},[_c('monito-widgets-imt-search-form',{attrs:{"powered-by-nf":"off","cta-label":"Find alternatives to Venmo","country-from":"US","country-to":"MX","utm-source":"internal","utm-medium":"internal","utm-content":"main_content_widget","utm-campaign":"ABTestVenmo"}})],1),_vm._v(" "),_c('main',{ref:"main"},[_c('section',{ref:"scroll_zone",staticClass:"\n      boxed \n      pt-4 pl-7 pr-7 pb-10\n      pt-lg-4 pl-lg-5 pr-lg-5 pb-lg-8\n      pt-sm-2 pl-sm-2 pr-sm-2 pb-sm-7 \n      mt-5 mb-5"},[_c('div',{staticClass:"color"}),_vm._v(" "),_c('h1',{staticClass:"f_title mt-3 mb-7 mt-2-sm mb-sm-6"},[_vm._v("If Venmo isn’t an option, what is?")]),_vm._v(" "),_c('widget-author',{staticClass:"mb-6"},[_c('div',{staticClass:"portrait"},[_c('span',{staticClass:"image",staticStyle:{"background-image":"url('public/pascal.png')"}}),_vm._v(" "),_c('p',{staticClass:"name pt-sm-2"},[_c('span',[_vm._v("Written by")]),_c('a',{attrs:{"href":"https://www.monito.com/en/wiki/why-you-can-trust-monito#1?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=main_content"}},[_vm._v("Pascal Briod")])]),_vm._v(" "),_c('p',{staticClass:"update"},[_c('span',[_vm._v("Last updated")]),_vm._v("August 22, 2019")])]),_vm._v(" "),_c('p',{staticClass:"bio mt-2 mb-2 ls-2 pl-sm-1 fw-medium mb-sm-3 f-anti"},[_vm._v("Co-Founder of Monito and money transfer expert, François has been helping Monito’s users navigate the jungle of money transfer fees, bad exchange rates and tricks for the last six years.")])]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("You can’t send money abroad with Venmo, so your first reflex may be to come back to an old-fashioned « bank transfer ». But not only would this option be less convenient, this would cost you a lot of money as banks usually give you a very bad exchange rate (on top of charging you fees for international transfers).")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('h2',{staticClass:"f_subtitle_1"},[_vm._v("Why comparing money transfer fees and exchange rates?")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("When you send money abroad, you will be charged a transfer fee. Bank of America charges $30 for an international wire transfer for example. But it doesn’t stop there. The corresponding banks and the beneficiary’s bank might also charge unpredictable international wire receiving fees and the sending bank will probably give you an exchange rate that is less interesting than what you find on Google. There are better alternatives, Monito compares them all in real time. Compare now to find the best deal:")]),_vm._v(" "),_c('h2',{staticClass:"f_subtitle_1"},[_vm._v("You shouldn’t use PayPal and other digital wallets for international transfers")]),_vm._v(" "),_vm._m(1),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('h2',{staticClass:"f_subtitle_1"},[_vm._v("Digital wallet comparison for international money transfers")]),_vm._v(" "),_c('h3',{staticClass:"f_chapo"},[_vm._v("Venmo")]),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_c('h3',{staticClass:"f_chapo"},[_vm._v("Square Cash App")]),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_c('h3',{staticClass:"f_chapo"},[_vm._v("Zelle")]),_vm._v(" "),_vm._m(13),_vm._v(" "),_vm._m(14),_vm._v(" "),_vm._m(15),_vm._v(" "),_c('h3',{staticClass:"f_chapo"},[_vm._v("PayPal")]),_vm._v(" "),_vm._m(16),_vm._v(" "),_vm._m(17),_vm._v(" "),_vm._m(18)],1),_vm._v(" "),_c('aside',{ref:"scroll_widgets",staticClass:"scroller"},[_c('monito-widgets-imt-search-form',{attrs:{"powered-by-nf":"off","cta-label":"Find alternatives to Venmo","country-from":"US","country-to":"MX","utm-source":"internal","utm-medium":"internal","utm-content":"main_content_widget","utm-campaign":"ABTestVenmo"}})],1)]),_vm._v(" "),_c('widget-faq',[_c('h1',{staticClass:"fs-28 fw-bold f-anti mb-9"},[_vm._v("Here are the most FAQs about Venmo")]),_vm._v(" "),_c('ul',{staticClass:"shadow"},[_c('li',[_c('h3',[_vm._v("Does Venmo work internationally? 🌎")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("No, Venmo is only available for US residents sending money to other US residents in US Dollars. Use "),_c('a',{attrs:{"href":"https://www.monito.com/en/?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=FAQ"}},[_vm._v("Monito.com to compare and find cheap alternative services to send money abroad.")])])]),_vm._v(" "),_c('li',[_c('h3',[_vm._v("Does venmo work in Canada? Can canadians use Venmo? 🍁")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("No, Venmo only work in the USA. You can find ways to "),_c('a',{attrs:{"href":"https://www.monito.com/send-money/united-states/canada/usd/cad?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=FAQ"}},[_vm._v("send money to Canada from the USA here.")])])]),_vm._v(" "),_c('li',[_c('h3',[_vm._v("What's the best way to send money abroad if Venmo is not available? 💸")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("There are plenty of good options, as fancy and user friendly as Venmo, to send money abroad with a mobile phone. Use "),_c('a',{attrs:{"href":"https://www.monito.com/en/?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=FAQ"}},[_vm._v("Monito.com to compare and find cheap alternative services to send money abroad.")])])]),_vm._v(" "),_c('li',[_c('h3',[_vm._v("Does Venmo work in Mexico?")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("No, Venmo is only available for US residents sending money to other US residents in US Dollars. You won't be able to use Venmo to send money to someone in Mexico from the US. But the good news is that there are dozens of good digital services for  "),_c('a',{attrs:{"href":"https://www.monito.com/send-money-to/mexico?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=FAQ"}},[_vm._v("money transfers to Mexico")]),_vm._v(" that you can compare on Monito.")])]),_vm._v(" "),_c('li',[_c('h3',[_vm._v("What countries does Venmo work in?  Does venmo work in other contries?")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("Venmo is only available in the US for US residents.")])]),_vm._v(" "),_c('li',[_c('h3',[_vm._v("Does Venmo work in Nigeria?")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("No, Venmo only work in the USA and for US residents. You can find & compare "),_c('a',{attrs:{"href":"https://www.monito.com/send-money/united-states/nigeria/usd/ngn?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=FAQ"}},[_vm._v("money transfer services from the US to Nigeria here.")])])]),_vm._v(" "),_c('li',[_c('h3',[_vm._v("Does Venmo work in France?")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("No, Venmo only work in the USA and for US residents. You can find & compare "),_c('a',{attrs:{"href":"https://www.monito.com/send-money/united-states/france/usd/eur?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=FAQ"}},[_vm._v("money transfer services from the US to France here.")])])])])]),_vm._v(" "),_c('widget-articles',{attrs:{"articles":_vm.articles}},[_c('h1',{staticClass:"fs-28 fw-bold f-anti mb-9 mb-sm-4 mt-sm-4"},[_vm._v("This might interest you too")])]),_vm._v(" "),_c('app-footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_vm._v("Fortunately, innovative companies are doing what Venmo did locally in the US, but for international transfers. Via their online platforms or mobile apps, they are offering bank-beating exchange rates, very low fees, and a top-notch user experience. Depending on where you want to send money to, companies like "),_c('a',{attrs:{"href":"https://www.monito.com/en/send-money-with/transferwise?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=main_content"}},[_vm._v("TransferWise")]),_vm._v(", "),_c('a',{attrs:{"href":"https://www.monito.com/en/send-money-with/worldremit?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=main_content"}},[_vm._v("WorldRemit")]),_vm._v(", "),_c('a',{attrs:{"href":"https://www.monito.com/en/send-money-with/remitly?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=main_content"}},[_vm._v("Remitly ")]),_vm._v("or "),_c('a',{attrs:{"target":"_blank","rel":"noopener","href":"https://www.monito.com/en/send-money-with/instarem?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=main_content"}},[_vm._v("InstaReM")]),_vm._v(" will probably be your top choice. ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_vm._v("Digital wallets have not only changed the way we pay for things on the Internet, but also how we send money to our friends and family. Specialized companies such as "),_c('a',{attrs:{"href":"https://www.monito.com/en/send-money-with/paypal?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=main_content"}},[_vm._v("PayPal")]),_vm._v(", "),_c('a',{attrs:{"href":"https://transferwise.com/us/blog/square-cash-international-payment?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=main_content"}},[_vm._v("Square Cash")]),_vm._v(", Venmo or tech giants such as Google (with Google Wallet), Apple (with Apple Pay) and "),_c('a',{attrs:{"href":"https://www.monito.com/en/wiki/facebook-finally-authorized-make-money-transfers-europe/?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=main_content"}},[_vm._v("Facebook")]),_vm._v(" (through Messenger), have revolutionized peer-to-peer payments, from the way  we pay back a friend for a loan to how we split the bill at the end of a meal.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_vm._v("\n        The jury is still out when it comes to deciding which service is the best for your day-to-day needs, as it depends on a lot of factors including fees, limits, availability, and user experience. When it comes to "),_c('span',{staticClass:"fw-demi-bold"},[_vm._v("international money transfers")]),_vm._v(" however, the answer is easy:  "),_c('span',{staticClass:"fw-demi-bold"},[_vm._v("none of them!")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_vm._v("We can first easily exclude most of the contenders that are simply not offering international money transfers: "),_c('a',{attrs:{"href":"https://transferwise.com/us/blog/square-cash-international-payment?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=main_content"}},[_vm._v("Square Cash App")]),_vm._v(", Venmo, Google Wallet, Apple Pay, "),_c('a',{attrs:{"href":"https://www.monito.com/en/wiki/zelle-international-money-transfer-alternatives?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=main_content"}},[_vm._v("Zelle ")]),_vm._v("and Messenger. These don’t allow you to send money abroad. In addition, most of them are only available in the US and a few other countries.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_vm._v("Some digital wallets, namely PayPal or the Skrill Wallet (not to mistake with "),_c('a',{attrs:{"href":"https://www.monito.com/en/send-money-with/skrill?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=main_content"}},[_vm._v("Skrill money transfers")]),_vm._v(", which is a really interesting option), do give you the option of sending money between different countries and currencies (they even have an impressive number of supported currencies), and a lot of people are using them to send money abroad. But the convenience of these services comes at a "),_c('span',{staticClass:"fw-demi-bold"},[_vm._v("very high cost")]),_vm._v(".")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_c('a',{attrs:{"href":"https://www.monito.com/en/send-money-with/paypal?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=main_content"}},[_vm._v("PayPal")]),_vm._v(" may seem like good options for transferring money to a friend in another country or paying international freelancers for example, but due to a lot of different fees – most of them hidden – these transfers will cost you much more than if you used companies specializing exclusively in international money transfers.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_vm._v("We calculated that PayPal fees for international money transfers, which includes the transfer fee and the margin taken on the exchange rate, are between 3% and 10%. This means that sending $500 from the US to France might cost you as much as $50! TransferWise, the cheapest solution currently listed in "),_c('a',{attrs:{"href":"https://www.monito.com/send-money/united-states/france/USD/EUR/500?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=main_content"}},[_vm._v("our real-time comparison table")]),_vm._v(" for this same transfer would cost only $5, or ten times less. ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_vm._v("So the next time you’re thinking about making an international transfer with "),_c('a',{attrs:{"href":"https://www.monito.com/en/send-money-with/paypal?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=main_content"}},[_vm._v("PayPal")]),_vm._v(" or any other digital wallet, you’d be much better off making a quick comparison of your options on Monito and picking the current cheapest option.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_vm._v("Can you use Venmo for international transfers ? "),_c('span',{staticClass:"f_chapo"},[_vm._v("No")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_vm._v("Countries where Venmo is available: "),_c('span',{staticClass:"f_chapo"},[_vm._v("US only")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_vm._v("Can you use Square Cash for international transfers ? "),_c('span',{staticClass:"f_chapo"},[_vm._v("No")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_vm._v("Countries where Square Cash is available: "),_c('span',{staticClass:"f_chapo"},[_vm._v("US only")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_vm._v("Find out more about Square Cash App International "),_c('a',{attrs:{"href":"https://www.monito.com/en/wiki/square-cash-international-money-transfer-alternatives?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=main_content"}},[_vm._v("here.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_vm._v("Can you use Zelle for international transfers ? "),_c('span',{staticClass:"f_chapo"},[_vm._v("No")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_vm._v("Countries where Zelle is available: "),_c('span',{staticClass:"f_chapo"},[_vm._v("US only")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_vm._v("Find out more about Zelle "),_c('a',{attrs:{"href":"https://www.monito.com/en/wiki/zelle-international-money-transfer-alternatives?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=main_content"}},[_vm._v("here.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_vm._v("Can you use PayPal for international transfers ?  "),_c('span',{staticClass:"f_chapo"},[_vm._v("Yes")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_vm._v("Countries where PayPal is available:  "),_c('span',{staticClass:"f_chapo"},[_vm._v("Almost everywhere (although money can’t be received or withdrawn in every country)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_vm._v("Total cost of an international money transfer:  "),_c('span',{staticClass:"f_chapo"},[_vm._v("Min 2.8% up to 10%")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(50);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7a01c6e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(150);
function injectStyle (ssrContext) {
  __webpack_require__(142)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7a01c6e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(143);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("15060a28", content, true, {});

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "main{position:relative;z-index:10000}.scroller{width:352px;box-sizing:border-box;position:absolute;right:0;top:0}@media (max-width:768px){body{overflow:scrollY}body,main{width:100%}main h1{text-align:center}.scroller{display:none}}", ""]);

// exports


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(145);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("1a14156d", content, true, {});

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(17);
exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".text_and_featured[data-v-1dfe695a]{margin-left:auto;margin-right:auto;min-height:200px;justify-content:space-between;align-items:center}.text_and_featured .title[data-v-1dfe695a]{width:570px;margin-left:auto;margin-right:auto;text-align:center}.text_and_featured button[data-v-1dfe695a]{display:block;outline:none;background:#79ca0c;border:none;border-radius:10px;padding:16px 26px;color:#fff;font-size:15px;font-weight:700;-webkit-box-shadow:0 3px 2px 0 rgba(0,0,0,.1);-moz-box-shadow:0 3px 2px 0 rgba(0,0,0,.1);box-shadow:0 3px 2px 0 rgba(0,0,0,.1);cursor:pointer}.text_and_featured button[data-v-1dfe695a]:hover{background-color:#6fba0a}.text_and_featured .illustrations[data-v-1dfe695a]{width:94%;margin-left:auto;margin-right:auto;display:flex;justify-content:space-around}.text_and_featured .illustrations div[data-v-1dfe695a]{box-sizing:border-box;background:#f8f8f8;width:30%;text-align:center;border-radius:10px;margin-top:310px;align-items:center;display:inline-block;color:#353c45f7;position:relative}.text_and_featured .illustrations div.save[data-v-1dfe695a]:before{content:\"\";position:absolute;width:254px;height:400px;top:-380px;background-image:url(" + escape(__webpack_require__(146)) + ");background-repeat:no-repeat;background-size:contain;background-position:50%}.text_and_featured .illustrations div.users[data-v-1dfe695a]:before{content:\"\";position:absolute;width:270px;height:350px;top:-295px;background-image:url(" + escape(__webpack_require__(147)) + ");background-repeat:no-repeat;background-size:contain;background-position:50%}.text_and_featured .illustrations div.secure[data-v-1dfe695a]:before{content:\"\";position:absolute;width:248px;height:383px;top:-355px;background-image:url(" + escape(__webpack_require__(148)) + ");background-repeat:no-repeat;background-size:contain;background-position:50%}@media (max-width:768px){.text_and_featured[data-v-1dfe695a]{display:block}.text_and_featured>div[data-v-1dfe695a]{width:95%;margin-left:auto;margin-right:auto}.text_and_featured button[data-v-1dfe695a]{margin-left:auto;margin-right:auto}.text_and_featured aside[data-v-1dfe695a]{width:100%;margin-right:0;margin-top:40px}.text_and_featured aside div[data-v-1dfe695a]{width:90%;margin-right:auto;margin-left:auto;box-sizing:border-box;text-align:left}}", ""]);

// exports


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "illu_save.png?3037507e0fdc6067882cf4c43fa33075";

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "illu_users.png?d7d398e6399be679cbc9f4ebd9a93567";

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "illu_secure.png?e0f788854c7cf824f081192df324770b";

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text_and_featured"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',[_c('app-navigation',[_c('h1',{attrs:{"id":"logo_monito"}},[_c('a',{attrs:{"href":"https://monito.com"}},[_vm._v("Monito")])]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"https://www.monito.com/en/about-monito"}},[_vm._v("About us")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.monito.com/en/wiki/monito-account"}},[_vm._v("Alerts")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.monito.com/en/wiki"}},[_vm._v("Wiki")])]),_vm._v(" "),_c('li',{staticClass:"langage"},[_c('a',{attrs:{"href":"#"}},[_vm._v("EN")])])])]),_vm._v(" "),_c('app-hero-section',{attrs:{"urlBackground":_vm.urlBackground,"herotype":_vm.herotype}},[_c('h1',{staticClass:"fs-48 fs-md-38 fs-sm-36 lh-9 lh-md-7 lh-sm-7 md-3 mb-6 mt-md-5 mt-sm-3 f-anti",staticStyle:{"color":"#fff"}},[_vm._v("Compare the market and stop overpaying when sending money abroad")]),_vm._v(" "),_c('p',{staticClass:"fs-20 fs-sm-19 fw-demi-bold f-anti lh-4 mb-4 ls-1"},[_vm._v("Compare. Select the best provider. Save money")])]),_vm._v(" "),_c('app-subhero-section',{staticClass:"pt-14 pb-7 pb-sm-3 mb-4"},[_c('widget-illustrations',{staticClass:"mb-9"},[_c('div',{staticClass:"title mb-5"},[_c('h2',{staticClass:"fs-28 fs-md-25 fs-sm-24 lh-6 ls-sm-2 lh-sm-5 mt-5 mb-2 mb-sm-3"},[_vm._v("Monito is like a travel comparison site, but for money transfers")]),_vm._v(" "),_c('span',{staticClass:"fs-19 fs-md-17 fs-sm-17 italic fw-demi-bold f-anti",staticStyle:{"opacity":"0.88"}},[_vm._v("Compare. Select the best provider. Save money")])]),_vm._v(" "),_c('div',{staticClass:"illustrations"},[_c('div',{staticClass:"fs-17 fw-demi-bold f-anti ls-1 pt-9 pb-5 pl-3 pr-3 secure"},[_vm._v("We only recommend "),_c('span',{staticClass:"fw-bold"},[_vm._v("regulated and secure companies.")])]),_vm._v(" "),_c('div',{staticClass:"fs-17 fw-demi-bold f-anti ls-1 pt-7 pb-5 pl-3 pr-3 users"},[_vm._v("Our comparison engine is trusted by more than "),_c('span',{staticClass:"fw-bold"},[_vm._v("3 million users")]),_vm._v(" worldwide.")]),_vm._v(" "),_c('div',{staticClass:"fs-17 fw-demi-bold f-anti ls-1 pt-9 pb-5 pl-3 pr-3 save"},[_c('span',{staticClass:"fw-bold"},[_vm._v("Save up to 90%")]),_vm._v(" by choosing the cheapest provider today.")])])]),_vm._v(" "),_c('widget-featured-on',[_c('li',[_c('img',{attrs:{"src":"public/forbes_logo.png"}})]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":"public/guardian_logo.png"}})]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":"public/business_insider_logo.png"}})]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":"public/le_monde_logo.png"}})])])],1)],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('widget-providers',{attrs:{"providers":_vm.providers}},[_c('h1',{staticClass:"fs-28 lh-6 mb-1 mt-5\n      fs-sm-24 lh-sm-5  mb-sm-3 ls-sm-2\n    "},[_vm._v("We compare and review over 300 money transfer companies")]),_vm._v(" "),_c('span',{staticClass:"fs-19 italic fs-sm-17 fw-demi-bold f-anti",staticStyle:{"opacity":"0.88"}},[_vm._v("An easy way to find the good one")])]),_vm._v(" "),_c('main',{ref:"main"},[_c('section',{ref:"scroll_zone",staticClass:"\n      boxed \n      pt-4 pl-7 pr-7 pb-10\n      pt-lg-4 pl-lg-5 pr-lg-5 pb-lg-8\n      pt-sm-2 pl-sm-2 pr-sm-2 pb-sm-7 \n      mt-5 mb-5"},[_c('h1',{staticClass:"f_title mt-3 mb-7 mt-2-sm mb-sm-6"},[_vm._v("Why compare international money transfer services?")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("Sending money abroad could cost you a lot, especially if you aren’t aware of the hidden fees. Money transfer companies and banks earn money by not only charging you a transfer fee, but also usually by offering you an exchange rate with a hidden markup.")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("You could save a lot of money by comparing exchange rates and transfer fees in real-time. With our money transfer comparison tool, you’ll find the best way to send money internationally in just a few clicks.")]),_vm._v(" "),_c('img',{staticClass:"mt-6 mt-6-sm",attrs:{"src":"https://images.prismic.io/monito/0a0d2c4639f1cb8342c63080595b2a4242c2a5ef_bar-chart-transfer-to-india-homepage-english.png"}}),_vm._v(" "),_c('h2',{staticClass:"f_subtitle_1"},[_vm._v("Everyone wins, except expensive solutions")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("With our model, the only losers are the expensive banks or providers you’ll stop using! To ensure our independence, we always use transparent, objective and verifiable criteria in our comparison. No provider can buy their way to the top of our results.")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("We include as many providers as possible in our comparison and have partnerships with almost all major and innovative providers.")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("We make sure you never pay more than if you went directly to the provider of your choice. We even negotiate special offers for you with many of our partners.")])]),_vm._v(" "),_c('aside',{ref:"scroll_widgets",staticClass:"scroller"},[_c('monito-widgets-imt-search-form',{attrs:{"powered-by-nf":"off","country-from":"US","country-to":"PH"}})],1)]),_vm._v(" "),_c('widget-faq',[_c('h1',{staticClass:"fs-28 fw-bold f-anti mb-9"},[_vm._v("Questions you may have")]),_vm._v(" "),_c('ul',{staticClass:"shadow"},[_c('li',[_c('h3',[_vm._v("How can I use Monito to find the best ways to send money?")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("Before you make an international money transfer, compare the costs of the different options on "),_c('a',{attrs:{"href":"https://www.monito.com/en/?utm_source=google&utm_medium=Organic&utm_campaign=FAQ&utm_term=Homepage_EN"}},[_vm._v("Monito")]),_vm._v(". Rates and fees change often, so for the best deal, do a comparison before every transfer — they may have changed since you last sent money. Once you enter the details about where you are sending money from and to, click on compare. You’ll see a list of all the options to send money between two countries. The best option is at the top, but you may want to consider other criteria such as the speed of transaction or the pay-in or payout methods.")])]),_vm._v(" "),_c('li',[_c('h3',[_vm._v("I simply use my bank to send money abroad, do I really need to compare other options?")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("Of course! Banks are usually not the best way to make international money transfers. The fees can be quite low (sometimes even zero), but banks often apply a markup on the exchange rates, a high hidden fee that you can avoid by "),_c('a',{attrs:{"href":"https://www.monito.com/en/?utm_source=google&utm_medium=Organic&utm_campaign=FAQ&utm_term=Homepage_EN"}},[_vm._v("finding better options on Monito")]),_vm._v(". We list as many banks as possible in our results, so you can  compare and find out if you’d be better off switching to another bank or a specialized money transfer company.")])]),_vm._v(" "),_c('li',[_c('h3',[_vm._v("Can I trust a company I found on Monito but have never heard about before?")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("We review money transfer companies and give them a Monito Score, which includes a Credibility and Security component. You can find if a money transfer company is reputable and trustworthy in our comparison results or "),_c('a',{attrs:{"target":"_blank","rel":"noopener","href":"https://www.monito.com/en/money-transfer-services?utm_source=google&utm_medium=Organic&utm_campaign=FAQ&utm_term=Moneygram_EN"}},[_vm._v("on a company's review page")]),_vm._v(". A general rule is that we only list money transfer operators or banks that are fully authorized and monitored by the regulatory authorities of their operating countries.")])]),_vm._v(" "),_c('li',[_c('h3',[_vm._v("Is it possible to send money with Monito, or are you just a service to compare money transfer services?")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_c('a',{attrs:{"href":"https://www.monito.com/en/?utm_source=google&utm_medium=Organic&utm_campaign=FAQ&utm_term=Homepage_EN"}},[_vm._v("Monito ")]),_vm._v("is not a money transfer company. We’re here to help you "),_c('a',{attrs:{"href":"https://www.monito.com/en/?utm_source=google&utm_medium=Organic&utm_campaign=FAQ&utm_term=Homepage_EN"}},[_vm._v("find the best way to send money abroad")]),_vm._v(". Just tell us which country you’re sending money from and which country you want to send money to, and we’ll show you a list of all available services. Once you select the best one for your needs, you'll be redirected to the money transfer provider’s website to get started with your transfer.")])])])]),_vm._v(" "),_c('widget-articles',{attrs:{"articles":_vm.articles}},[_c('h1',{staticClass:"fs-28 fw-bold f-anti mb-9"},[_vm._v("This might interest you too")])]),_vm._v(" "),_c('app-footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trustpilot-widget",attrs:{"data-locale":"en-GB","data-template-id":"5613c9cde69ddc09340c6beb","data-businessunit-id":"5989b7fc0000ff0005a8668a","data-style-height":"100%","data-style-width":"100%","data-theme":"light"}},[_c('a',{attrs:{"href":"https://uk.trustpilot.com/review/monito.com","target":"_blank","rel":"noopener"}},[_vm._v("Trustpilot")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_old_vue__ = __webpack_require__(52);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a54dd156_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_old_vue__ = __webpack_require__(154);
function injectStyle (ssrContext) {
  __webpack_require__(152)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_old_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a54dd156_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_old_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(153);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("a88c6b62", content, true, {});

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "main{position:relative;z-index:10000}.scroller{width:352px;box-sizing:border-box;position:absolute;right:0;top:0}@media (max-width:768px){body{overflow:scrollY}body,main{width:100%}main h1{text-align:center}.scroller{display:none}}", ""]);

// exports


/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',[_c('app-navigation',[_c('h1',{attrs:{"id":"logo_monito"}},[_c('a',{attrs:{"href":"https://monito.com"}},[_vm._v("Monito")])]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"https://www.monito.com/en/about-monito"}},[_vm._v("About us")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.monito.com/en/wiki/monito-account"}},[_vm._v("Alerts")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.monito.com/en/wiki"}},[_vm._v("Wiki")])]),_vm._v(" "),_c('li',{staticClass:"langage"},[_c('a',{attrs:{"href":"#"}},[_vm._v("EN")])])])]),_vm._v(" "),_c('app-hero-section',{attrs:{"urlBackground":_vm.urlBackground,"herotype":_vm.herotype}},[_c('h1',{staticClass:"fs-48 fs-md-38 fs-sm-36 lh-9 lh-md-7 lh-sm-7 md-3 mb-6 mt-md-5 mt-sm-3 f-anti",staticStyle:{"color":"#fff"}},[_vm._v("Stop overpaying when sending money abroad")]),_vm._v(" "),_c('p',{staticClass:"fs-20 fs-sm-19 fw-demi-bold f-anti lh-4 mb-4 ls-1"},[_vm._v("Save on fees, obtain the best exchange rates and find the cheapest transfer provider with our real-time comparison engine.")]),_vm._v(" "),_c('p',{staticClass:"fs-20 fs-sm-19 fw-demi-bold f-anti lh-4 mb-4 ls-1"},[_vm._v("The result? More money arrives.")])]),_vm._v(" "),_c('app-subhero-section',{staticClass:"pt-14 pb-7 pb-sm-3 mb-4"},[_c('widget-illustrations',{staticClass:"mb-9"},[_c('div',{staticClass:"title mb-5"},[_c('h2',{staticClass:"fs-28 fs-md-25 fs-sm-24 lh-6 ls-sm-2 lh-sm-5 mt-5 mb-2 mb-sm-3"},[_vm._v("Monito is like a travel comparison site, but for money transfers")]),_vm._v(" "),_c('span',{staticClass:"fs-19 fs-md-17 fs-sm-17 italic fw-demi-bold f-anti",staticStyle:{"opacity":"0.88"}},[_vm._v("Compare. Select the best provider. Save money")])]),_vm._v(" "),_c('div',{staticClass:"illustrations"},[_c('div',{staticClass:"fs-17 fw-demi-bold f-anti ls-1 pt-9 pb-5 pl-3 pr-3 secure"},[_vm._v("We only recommend "),_c('span',{staticClass:"fw-bold"},[_vm._v("regulated and secure companies.")])]),_vm._v(" "),_c('div',{staticClass:"fs-17 fw-demi-bold f-anti ls-1 pt-7 pb-5 pl-3 pr-3 users"},[_vm._v("Our comparison engine is trusted by more than "),_c('span',{staticClass:"fw-bold"},[_vm._v("3 million users")]),_vm._v(" worldwide.")]),_vm._v(" "),_c('div',{staticClass:"fs-17 fw-demi-bold f-anti ls-1 pt-9 pb-5 pl-3 pr-3 save"},[_c('span',{staticClass:"fw-bold"},[_vm._v("Save up to 90%")]),_vm._v(" by choosing the cheapest provider today.")])])]),_vm._v(" "),_c('widget-featured-on',[_c('li',[_c('img',{attrs:{"src":"public/forbes_logo.png"}})]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":"public/guardian_logo.png"}})]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":"public/business_insider_logo.png"}})]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":"public/le_monde_logo.png"}})])])],1)],1),_vm._v(" "),_c('widget-providers',{attrs:{"providers":_vm.providers}},[_c('h1',{staticClass:"fs-28 lh-6 mb-1 mt-5\n      fs-sm-24 lh-sm-5  mb-sm-3 ls-sm-2\n    "},[_vm._v("We compare and review over 300 money transfer companies")]),_vm._v(" "),_c('span',{staticClass:"fs-19 italic fs-sm-17 fw-demi-bold f-anti",staticStyle:{"opacity":"0.88"}},[_vm._v("An easy way to find the good one")])]),_vm._v(" "),_c('main',{ref:"main"},[_c('section',{ref:"scroll_zone",staticClass:"\n      boxed \n      pt-4 pl-7 pr-7 pb-10\n      pt-lg-4 pl-lg-5 pr-lg-5 pb-lg-8\n      pt-sm-2 pl-sm-2 pr-sm-2 pb-sm-7 \n      mt-5 mb-5"},[_c('h1',{staticClass:"f_title mt-3 mb-7 mt-2-sm mb-sm-6"},[_vm._v("Why compare international money transfer services?")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("Sending money abroad could cost you a lot, especially if you aren’t aware of the hidden fees. Money transfer companies and banks earn money by not only charging you a transfer fee, but also usually by offering you an exchange rate with a hidden markup.")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("You could save a lot of money by comparing exchange rates and transfer fees in real-time. With our money transfer comparison tool, you’ll find the best way to send money internationally in just a few clicks.")]),_vm._v(" "),_c('img',{staticClass:"mt-6 mt-6-sm",attrs:{"src":"https://images.prismic.io/monito/0a0d2c4639f1cb8342c63080595b2a4242c2a5ef_bar-chart-transfer-to-india-homepage-english.png"}}),_vm._v(" "),_c('h2',{staticClass:"f_subtitle_1"},[_vm._v("Everyone wins, except expensive solutions")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("With our model, the only losers are the expensive banks or providers you’ll stop using! To ensure our independence, we always use transparent, objective and verifiable criteria in our comparison. No provider can buy their way to the top of our results.")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("We include as many providers as possible in our comparison and have partnerships with almost all major and innovative providers.")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("We make sure you never pay more than if you went directly to the provider of your choice. We even negotiate special offers for you with many of our partners.")])]),_vm._v(" "),_c('aside',{ref:"scroll_widgets",staticClass:"scroller"},[_c('monito-widgets-imt-search-form',{attrs:{"powered-by-nf":"off","country-from":"US","country-to":"PH"}})],1)]),_vm._v(" "),_c('widget-faq',[_c('h1',{staticClass:"fs-28 fw-bold f-anti mb-9"},[_vm._v("Questions you may have")]),_vm._v(" "),_c('ul',{staticClass:"shadow"},[_c('li',[_c('h3',[_vm._v("How can I use Monito to find the best ways to send money?")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("Before you make an international money transfer, compare the costs of the different options on "),_c('a',{attrs:{"href":"https://www.monito.com/en/?utm_source=google&utm_medium=Organic&utm_campaign=FAQ&utm_term=Homepage_EN"}},[_vm._v("Monito")]),_vm._v(". Rates and fees change often, so for the best deal, do a comparison before every transfer — they may have changed since you last sent money. Once you enter the details about where you are sending money from and to, click on compare. You’ll see a list of all the options to send money between two countries. The best option is at the top, but you may want to consider other criteria such as the speed of transaction or the pay-in or payout methods.")])]),_vm._v(" "),_c('li',[_c('h3',[_vm._v("I simply use my bank to send money abroad, do I really need to compare other options?")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("Of course! Banks are usually not the best way to make international money transfers. The fees can be quite low (sometimes even zero), but banks often apply a markup on the exchange rates, a high hidden fee that you can avoid by "),_c('a',{attrs:{"href":"https://www.monito.com/en/?utm_source=google&utm_medium=Organic&utm_campaign=FAQ&utm_term=Homepage_EN"}},[_vm._v("finding better options on Monito")]),_vm._v(". We list as many banks as possible in our results, so you can  compare and find out if you’d be better off switching to another bank or a specialized money transfer company.")])]),_vm._v(" "),_c('li',[_c('h3',[_vm._v("Can I trust a company I found on Monito but have never heard about before?")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("We review money transfer companies and give them a Monito Score, which includes a Credibility and Security component. You can find if a money transfer company is reputable and trustworthy in our comparison results or "),_c('a',{attrs:{"target":"_blank","rel":"noopener","href":"https://www.monito.com/en/money-transfer-services?utm_source=google&utm_medium=Organic&utm_campaign=FAQ&utm_term=Moneygram_EN"}},[_vm._v("on a company's review page")]),_vm._v(". A general rule is that we only list money transfer operators or banks that are fully authorized and monitored by the regulatory authorities of their operating countries.")])]),_vm._v(" "),_c('li',[_c('h3',[_vm._v("Is it possible to send money with Monito, or are you just a service to compare money transfer services?")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_c('a',{attrs:{"href":"https://www.monito.com/en/?utm_source=google&utm_medium=Organic&utm_campaign=FAQ&utm_term=Homepage_EN"}},[_vm._v("Monito ")]),_vm._v("is not a money transfer company. We’re here to help you "),_c('a',{attrs:{"href":"https://www.monito.com/en/?utm_source=google&utm_medium=Organic&utm_campaign=FAQ&utm_term=Homepage_EN"}},[_vm._v("find the best way to send money abroad")]),_vm._v(". Just tell us which country you’re sending money from and which country you want to send money to, and we’ll show you a list of all available services. Once you select the best one for your needs, you'll be redirected to the money transfer provider’s website to get started with your transfer.")])])])]),_vm._v(" "),_c('widget-articles',{attrs:{"articles":_vm.articles}},[_c('h1',{staticClass:"fs-28 fw-bold f-anti mb-9"},[_vm._v("This might interest you too")])]),_vm._v(" "),_c('app-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Corridor_vue__ = __webpack_require__(53);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f43d7f16_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Corridor_vue__ = __webpack_require__(213);
function injectStyle (ssrContext) {
  __webpack_require__(156)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Corridor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f43d7f16_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Corridor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(157);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("b3d1b618", content, true, {});

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(17);
exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".choosing_filter{width:100vw;display:flex;justify-content:space-around;align-items:center;height:100vh;-webkit-clip-path:ellipse(0 0 at 300% 300%);clip-path:ellipse(0 0 at 300% 300%);position:fixed;left:0;top:0;z-index:100000000;background:linear-gradient(90deg,#17191c,rgba(23,25,28,.98) 50%,rgba(23,25,28,.82));animation:filters_loading 3.2s forwards;animation-delay:2.1s}@keyframes filters_loading{0%{-webkit-clip-path:circle(50% at 50% 400%);clip-path:circle(50% at 50% 400%)}80%{clip-path:circle(300% at 49% 80%);-webkit-clip-path:circle(300% at 49% 80%)}to{clip-path:circle(300% at 49% 80%);-webkit-clip-path:circle(300% at 49% 80%)}}.choosing_filter .container_filters{width:1200px;display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap}.choosing_filter .container_filters>.title{flex:none;display:block;margin-left:auto;margin-right:auto;position:relative;color:#fff;opacity:0;width:570px;animation:box_filter_appear .6s ease-out forwards;animation-delay:3.2s}.choosing_filter .container_filters>.title:after{content:\"\";position:absolute;width:157px;height:87px;right:-40px;bottom:-60px;background-image:url(" + escape(__webpack_require__(41)) + ");background-size:contain;background-position:50%;background-repeat:no-repeat}.choosing_filter .container_filters>.title h1{opacity:.86;position:relative}.choosing_filter .container_filters>.title a{display:inline-block;cursor:pointer}.choosing_filter .container_filters>.title p{text-decoration:underline;opacity:.86}.choosing_filter .container_filters>.title p:hover{opacity:1;cursor:pointer}.choosing_filter .container_filters>aside{opacity:0;position:relative;animation:box_filter_appear .6s ease-out forwards;animation-delay:3.4s;bottom:-20px;right:0;top:auto;left:auto}@keyframes box_filter_appear{0%{bottom:-20px;opacity:0}to{bottom:0;opacity:1}}h1{transition:all 1.5s}h1 span.label{font-weight:600;position:relative;font-style:italic;font-size:30px;top:0;color:#f53449;cursor:pointer}h2 span:hover{text-decoration:underline}h2 span{padding-left:3px;padding-right:3px}main{z-index:1200;position:relative;margin-right:auto;margin-left:auto;margin-top:-260px}.story{margin-top:30px}.apper-enter-active,.flip-list-enter-active{animation:appear_result 1s forwards}.apper-move{transition:all 1.5s}@keyframes appear_result{0%{transform:translateY(14px);opacity:0}90%{opacity:1}to{transform:translateY(0)}}@keyframes barre{0%{width:0}}.end-loading-leave-active{animation:end-loading 1s forwards}@keyframes end-loading{0%{transform:translateY(0);opacity:1}90%{opacity:0}to{transform:translateY(14px);opacity:0}}.main_content{position:relative;width:100%}#app{font-family:Avenir next,Helvetica,Arial,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-align:center;color:#2c3e50;margin-top:60px}.active{border:2px solid blue}button:focus{outline:none}.story{padding-bottom:80px!important}.story a{color:#f53449;font-weight:600}.story h1{width:600px;font-size:28px!important;line-height:38px!important;margin-bottom:60px!important}.story h1,.story p{margin-left:auto;margin-right:auto}.story p{width:630px}aside{z-index:1000;width:284px;position:absolute;right:0;top:50px}aside>div{margin:20px 0;padding:1px 20px;background-color:#fff;border-radius:12px;box-sizing:border-box}aside>div h3{display:block;font-size:16px;font-style:italic;font-family:Avenir Next;font-weight:700;letter-spacing:.025em;margin-top:25px;margin-bottom:20px;text-align:center;color:#353c45}.pick_loading{width:362px;padding-bottom:20px;border-radius:12px;border:3px solid rgba(90,89,89,.09)}.pick_loading h2{padding-left:20px;padding-right:20px;background-color:#fff;width:78%;color:#353c45;margin:-14px auto 26px;font-size:21px;line-height:26px;letter-spacing:.02em}.pick_loading h2,.pick_loading label{text-align:center;font-weight:700;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-style:italic}.pick_loading label{font-size:17px;display:block;padding-top:14px;padding-bottom:14px;margin-bottom:8px;border-radius:200px;width:80%;color:#51575e;margin-left:auto;margin-right:auto;cursor:pointer;letter-spacing:.026em}.pick_loading label:hover{background-color:#ededed80}.pick_loading label.picked{cursor:default;background-color:#ff9d18;color:#fff;-webkit-box-shadow:0 3px 6px 0 rgba(0,0,0,.08);-moz-box-shadow:0 3px 6px 0 rgba(0,0,0,.08);box-shadow:0 3px 6px 0 rgba(0,0,0,.08)}.pick_loading.pick_interest_loading label.picked{background-color:#9bcd09}.pick_loading.pick_payout_loading h2{margin-top:-32px}.my_list{padding:0}.my_list li a{width:205px;padding:15px 20px;background:#9ccd00;border-radius:8px;box-sizing:border-box;display:inline-block;text-decoration:none;font-family:Avenir Next Medium;color:#fff;text-shadow:0 1px 3px #00000020;-webkit-box-shadow:0 3px 6px 0 rgba(0,0,0,.08);-moz-box-shadow:0 3px 6px 0 rgba(0,0,0,.08);box-shadow:0 3px 6px 0 rgba(0,0,0,.08);font-size:15px;letter-spacing:.03em;text-align:center;font-style:italic}.my_list li a:hover{background-color:#00a400}.my_list li a span{font-family:Avenir Next;font-weight:700;letter-spacing:.05em;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.my_list li:after{content:\"\";position:absolute;height:1px;left:25px;width:calc(100% - 50px);bottom:0;background:#efefef}.my_list>li{list-style:none;box-sizing:border-box;position:relative}.my_list>li>.container{width:100%;box-sizing:border-box;padding:13px 36px;overflow:hidden;justify-content:space-between;display:flex;align-items:center}.my_list>li .details{pointer-events:none;width:314px!important;top:-149px;right:-329px;opacity:1;position:absolute;display:none}.my_list>li .details>.container{width:310px!important;background:#2e3238;float:right;min-height:380px;border-radius:12px;-webkit-box-shadow:0 0 6px 20px rgba(0,0,0,.12);-moz-box-shadow:0 0 6px 20px rgba(0,0,0,.12);box-shadow:0 4px 10px 0 rgba(0,0,0,.12);color:#fff;text-align:center;padding-bottom:28px}.my_list>li .details>.container span{display:block;letter-spacing:.031em;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.my_list>li .details>.container span.boxed_info{background:#ffffff1c;padding:10px 28px;margin:6px auto;border-radius:10px;font-weight:600;font-size:16px}.my_list>li .details>.container span.boxed_info.clock{position:relative;padding-left:48px}.my_list>li .details>.container span.boxed_info.clock:before{content:\"\";height:16px;width:16px;position:absolute;left:24px;top:13px;background-image:url(" + escape(__webpack_require__(158)) + ");background-size:contain;background-position:50%;background-repeat:no-repeat}.my_list>li .details>.container>div:first-of-type{margin-bottom:75px;position:relative}.my_list>li .details>.container>div:first-of-type:after{content:\"\";opacity:.6;height:32px;width:12px;position:absolute;bottom:-52px;background-image:url(" + escape(__webpack_require__(159)) + ");background-size:contain;background-position:50%;background-repeat:no-repeat}.my_list>li .details>.container>div{display:flex;flex-direction:column;justify-content:center;align-items:center}.my_list>li .details>.container:before{content:\"\";position:absolute;width:20px;height:50px;z-index:100;background:#2e3238;top:165px;left:4px}.my_list>li .details>.container:after{content:\"\";width:22px;background:#2e3238;height:22px;transform:rotate(45deg) skew(13deg,13deg);-webkit-box-shadow:0 3px 6px 0 rgba(0,0,0,.08);-moz-box-shadow:0 3px 6px 0 rgba(0,0,0,.08);box-shadow:0 3px 6px 0 rgba(0,0,0,.08);left:-6px;top:178px;position:absolute}.my_list>li:hover .details{display:block}.my_list>li:last-child:after{display:none}.my_list>li .logo_provider{min-width:150px;display:inline-flex;align-items:center;height:50px;background-size:contain;background-repeat:no-repeat;background-position:100%;margin-right:26px}.my_list>li .total_cost{border-radius:7px;color:#f53449;width:104px;text-align:center;font-style:italic;font-size:14px;font-family:Avenir Next;font-weight:600;letter-spacing:.005em;position:relative;margin-right:23px;z-index:10}.my_list>li .total_cost:after{content:\"\";background:#e6e6e64d;width:100%;position:absolute;top:-60px;left:0;z-index:-1;height:200px}.my_list>li .amount{font-size:23px;font-family:Avenir Next;font-weight:700;margin-left:22px;margin-right:22px;white-space:nowrap;position:relative}.my_list>li .container_amount{align-items:center;display:inline-flex;flex:1}.my_list>li .container_amount .illustration_amount{width:100%;overflow:hidden;display:inline-flex;height:31px;background:rgba(0,0,0,.04);border-radius:0 30px 30px 0}.my_list>li .container_amount .illustration_amount .anim_element{box-sizing:border-box;padding-left:18px;background-color:red;position:relative;border-radius:0 30px 30px 0}.my_list>li .container_amount .illustration_amount .anim_element.anime{animation-name:opacity_value;animation-duration:1.9s;animation-fill-mode:forwards}@keyframes opacity_value{0%{opacity:0;left:-200px}to{opacity:1;left:0}}.my_list>li.excellent:hover{background:rgba(0,160,0,.1);cursor:default}.my_list>li.excellent .container_amount .illustration_amount .anim_element{background:#00a000!important}.my_list>li.good:hover{background:rgba(118,193,7,.1);cursor:default}.my_list>li.good .container_amount .illustration_amount .anim_element{background:#76c107!important}.my_list>li.average:hover{background:rgba(255,154,0,.1);cursor:default}.my_list>li.average .container_amount .illustration_amount .anim_element{background:#ff9a00!important}.my_list>li.poor:hover{background:rgba(255,88,0,.1);cursor:default}.my_list>li.poor .container_amount .illustration_amount .anim_element{background:#ff5800!important}.my_list>li.bad:hover{background:rgba(255,0,48,.1);cursor:default}.my_list>li.bad .container_amount .illustration_amount .anim_element{background:#ff0030!important}.cheap_list li:first-child>.container{border:3px solid #79ca0c;margin:0 16px;padding-left:17px;padding-right:17px;border-radius:10px;overflow:visible;margin-bottom:4px;width:calc(100% - 32px)}.cheap_list li:first-child>.container .total_cost{background:#e6e6e64d;border-radius:8px;padding-top:20px;padding-bottom:20px}.cheap_list li:first-child>.container .total_cost:after{display:none}.cheap_list li:first-child>.container .total_cost:before{content:\"Total cost\";top:-46px;font-size:15px;position:absolute;display:inline-block;width:130%;left:-15%}.cheap_list li:first-child>.container:before{content:\"Cheapest\";text-transform:uppercase;display:inline-block;position:absolute;background-color:#fff;background-size:3px auto;letter-spacing:.07em;font-weight:700;font-size:14px;padding:0 16px;top:-10px;left:25px;color:#79ca0c}.cheap_list li:nth-child(2) .total_cost:after{top:-28px;border-radius:8px}.cheap_list li:first-child:after{display:none}.container_picker{display:flex;margin:60px 55px;justify-content:space-between;align-items:center}input[type=radio]{display:none}.result{padding-bottom:6px;overflow:visible;min-height:400px;background:#fff;z-index:20000;border-radius:20px;position:relative;width:886px;transition:all 1.5s}.result h1{font-size:38px;text-align:center;max-width:740px;line-height:48px;letter-spacing:.02em}.before_result,.result h1{margin-left:auto;margin-right:auto}.before_result{margin-top:100px}.list-complete-item{transition:all 1s;display:inline-block;margin-right:10px}.list-complete-enter,.list-complete-leave-to{opacity:0;transform:translateY(30px)}.list-complete-leave-active{position:absolute}@font-face{font-family:Monito;src:local(\"Avenir Next\"),\"/_comp/fonts/avenir/7db1f672-3a8f-4d19-9c49-7f61aed450b5-1560902400.woffurl2\" format(\"woff2\"),url(\"/_comp/fonts/avenir/4ab86b35-c0c2-42b5-98ad-4b6eba66b197-1560902400.woff\") format(\"woff\");font-weight:400;font-style:normal;font-display:swap}@font-face{font-family:Monito;src:local(\"Avenir Next\"),url(\"/_comp/fonts/avenir/40d36b4a-60c6-460a-bf43-4c948c23563e-1560902400.woff2\") format(\"woff2\"),url(\"/_comp/fonts/avenir/45b78f45-e639-4836-8612-e0892e120f14-1560902400.woff\") format(\"woff\");font-weight:600;font-style:normal;font-display:swap}@font-face{font-family:Monito;src:local(\"Avenir Next\"),url(\"/_comp/fonts/avenir/4c04fb14-abdb-4f93-82bb-734d1b84307b-1560902400.woff2\") format(\"woff2\"),url(\"/_comp/fonts/avenir/04d2f223-2786-40c9-8481-be9dd47d8e7f-1560902400.woff\") format(\"woff\");font-weight:700;font-style:normal;font-display:swap}", ""]);

// exports


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "clock_white.svg?6a19216cd611b9d70ba82e2e5be4bf81";

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "arrow_black_box.svg?12e8de4e0f7c9fa9ad2a3ed4cd4e636c";

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loading_vue__ = __webpack_require__(54);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e164a00_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__ = __webpack_require__(163);
function injectStyle (ssrContext) {
  __webpack_require__(161)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e164a00_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(162);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("89f7032e", content, true, {});

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".loading{margin:30px 55px 60px;background:#f1f7f1;border-radius:16px;padding:45px}.loading lottie-player{margin:0 auto 30px;display:block}.loading span{text-align:center;display:inline-block;width:100%;font-size:17px;color:#81858b;font-weight:500;letter-spacing:.016em;margin-left:auto;margin-right:auto}", ""]);

// exports


/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('lottie-player',{staticStyle:{"width":"60px","height":"60px"},attrs:{"src":"https://assets5.lottiefiles.com/packages/lf20_tJIvme.json","background":"transparent","speed":"1","loop":"","autoplay":""}}),_vm._v(" "),_c('span',[_vm._v("We're fetching real-time transfer fees and exchange rates....")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cheap_vue__ = __webpack_require__(55);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5f11028_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cheap_vue__ = __webpack_require__(171);
function injectStyle (ssrContext) {
  __webpack_require__(165)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cheap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5f11028_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cheap_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(166);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("08f8f7ee", content, true, {});

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProviderResult_vue__ = __webpack_require__(56);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9209e7c6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProviderResult_vue__ = __webpack_require__(170);
function injectStyle (ssrContext) {
  __webpack_require__(168)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProviderResult_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9209e7c6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProviderResult_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(169);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("e161c6f0", content, true, {});

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.sortedArrayCheap),function(result,index){return (_vm.dataFetch && _vm.minimumLoading)?_c('li',{class:['psp_'+result.psp_id, {
            'debit': Object.keys(result.options.sending)[0]=='debit_card',
            'credit': Object.keys(result.options.sending)[0]=='credit_card',
            'bank': Object.keys(result.options.sending)[0]=='bank_transfer'
          }]},[_vm._v("\n          "+_vm._s(_vm.getPspName(result.psp_id))),_c('span',{staticStyle:{"font-size":"18px","font-weight":"bold","display":"inline-block","margin":"0 20px"}},[_vm._v(_vm._s(_vm.virgule_rec(result.costs.total_received_destination)))]),_c('span',{staticStyle:{"font-weight":"bold","font-size":"14px"}},[_vm._v(_vm._s(_vm.virgule(result.costs.total_fees)))]),_vm._v(" "+_vm._s(Object.values(result.options.sending)[0])+" "+_vm._s(result.transfer_time_product_rate))]):_vm._e()}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('ul',{staticClass:"my_list"},_vm._l((10),function(n,index){return _c('li',{key:index,attrs:{"id":n,"foisSix":_vm.foisSix}},[_vm._v(_vm._s(n))])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Fast_vue__ = __webpack_require__(57);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2793cfa9_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Fast_vue__ = __webpack_require__(177);
function injectStyle (ssrContext) {
  __webpack_require__(173)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2793cfa9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Fast_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2793cfa9_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Fast_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(174);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("54ce0ca6", content, true, {});

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(17);
exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "ul[data-v-2793cfa9]{margin-left:16px;margin-right:16px;border:3px solid #e8e7e7;border-radius:12px;margin-bottom:32px;position:relative}ul li[data-v-2793cfa9]{padding:0 17px}ul li .container[data-v-2793cfa9]{padding-left:0;padding-right:0}ul[data-v-2793cfa9]:before{content:\"\";position:absolute;top:-10px;left:20px;background:#fff;font-size:13px;font-family:Avenir Next;font-weight:700;letter-spacing:.035em;padding-left:36px;padding-right:16px;color:#4c4c4c;text-transform:uppercase;background-image:url(" + escape(__webpack_require__(175)) + ");background-position:12px;background-repeat:no-repeat}ul.minutes[data-v-2793cfa9]{border:3px solid #78ca00}ul.minutes[data-v-2793cfa9]:before{content:\"In minutes\";color:#77ca00;background-image:url(" + escape(__webpack_require__(176)) + ")}ul.minutes li:first-child .container[data-v-2793cfa9]{overflow:visible}ul.minutes li:first-child .total_cost[data-v-2793cfa9]{background:#e6e6e64d;border-radius:8px;padding-top:20px;padding-bottom:20px}ul.minutes li:first-child .total_cost[data-v-2793cfa9]:after{display:none}ul.minutes li:first-child .total_cost[data-v-2793cfa9]:before{content:\"Total cost\";top:-46px;font-size:15px;position:absolute;display:inline-block;width:130%;left:-15%}ul.same[data-v-2793cfa9]:before{content:\"Same day\"}ul.next[data-v-2793cfa9]:before{content:\"Next day\"}ul.two[data-v-2793cfa9]:before{content:\"Two days\"}ul.plus[data-v-2793cfa9]:before{content:\"3-5 days\"}ul li:first-child .container[data-v-2793cfa9]{padding-top:17px}ul li:last-child .container[data-v-2793cfa9]{padding-bottom:17px}", ""]);

// exports


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "clock_fast.svg?12a184d6027d239279b93d2f04ed57c6";

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "clock_fast_green.svg?4ee31ec00805425701d87c6924ea2382";

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"fast_list"},[(_vm.minutes.length > 0)?_c('transition-group',{class:['my_list','minutes'],attrs:{"name":"flip-list","tag":"ul"}},_vm._l((_vm.minutes),function(result,index){return _c('li',{key:index+'_'+result.psp_id,class:['psp_'+result.psp_id, _vm.getTransferScore(result.costs.total_received_usd.toFixed(0)), {
            'debit': Object.keys(result.options.sending)[0]=='debit_card',
            'credit': Object.keys(result.options.sending)[0]=='credit_card',
            'bank': Object.keys(result.options.sending)[0]=='bank_transfer'
       }]},[_c('div',{staticClass:"container"},[_c('span',{staticClass:"logo_provider",style:({backgroundImage: 'url('+ _vm.getLogoPsp(result.psp_id) +')'})}),_vm._v(" "),_c('div',{staticClass:"container_amount"},[_c('div',{staticClass:"illustration_amount impact_green"},[_c('div',{staticClass:"anim_element",style:({width : _vm.getTransferBar(result.costs.total_received_destination)})})])]),_vm._v(" "),_c('span',{staticClass:"amount"},[_vm._v("\n          "+_vm._s(_vm.virgule_rec(result.costs.total_received_destination)))]),_vm._v(" "),_c('span',{staticClass:"total_cost",staticStyle:{"font-weight":"bold","font-size":"14px"}},[_vm._v(_vm._s(_vm.virgule(result.costs.total_fees)))]),_vm._v(" "),_c('a',{attrs:{"href":_vm.getPspLink(result.psp_id)}},[_vm._v("Go to "),_c('span',[_vm._v(_vm._s(_vm.getPspName(result.psp_id)))])])])])}),0):_vm._e(),_vm._v(" "),(_vm.sameDay.length > 0)?_c('transition-group',{class:['my_list','same'],attrs:{"name":"flip-list","tag":"ul"}},_vm._l((_vm.sameDay),function(result,index){return _c('li',{key:index+'_'+result.psp_id,class:['psp_'+result.psp_id, _vm.getTransferScore(result.costs.total_received_usd.toFixed(0)), {
            'debit': Object.keys(result.options.sending)[0]=='debit_card',
            'credit': Object.keys(result.options.sending)[0]=='credit_card',
            'bank': Object.keys(result.options.sending)[0]=='bank_transfer'
       }]},[_c('div',{staticClass:"container"},[_c('span',{staticClass:"logo_provider",style:({backgroundImage: 'url('+ _vm.getLogoPsp(result.psp_id) +')'})}),_vm._v(" "),_c('div',{staticClass:"container_amount"},[_c('div',{staticClass:"illustration_amount impact_green"},[_c('div',{staticClass:"anim_element",style:({width : _vm.getTransferBar(result.costs.total_received_destination)})})])]),_vm._v(" "),_c('span',{staticClass:"amount"},[_vm._v("\n          "+_vm._s(_vm.virgule_rec(result.costs.total_received_destination)))]),_vm._v(" "),_c('span',{staticClass:"total_cost",staticStyle:{"font-weight":"bold","font-size":"14px"}},[_vm._v(_vm._s(_vm.virgule(result.costs.total_fees)))]),_vm._v(" "),_c('a',{attrs:{"href":_vm.getPspLink(result.psp_id)}},[_vm._v("Go to "),_c('span',[_vm._v(_vm._s(_vm.getPspName(result.psp_id)))])])])])}),0):_vm._e(),_vm._v(" "),(_vm.nextDay.length > 0)?_c('transition-group',{class:['my_list','next'],attrs:{"name":"flip-list","tag":"ul"}},_vm._l((_vm.nextDay),function(result,index){return _c('li',{key:index+'_'+result.psp_id,class:['psp_'+result.psp_id, _vm.getTransferScore(result.costs.total_received_usd.toFixed(0)), {
            'debit': Object.keys(result.options.sending)[0]=='debit_card',
            'credit': Object.keys(result.options.sending)[0]=='credit_card',
            'bank': Object.keys(result.options.sending)[0]=='bank_transfer'
       }]},[_c('div',{staticClass:"container"},[_c('span',{staticClass:"logo_provider",style:({backgroundImage: 'url('+ _vm.getLogoPsp(result.psp_id) +')'})}),_vm._v(" "),_c('div',{staticClass:"container_amount"},[_c('div',{staticClass:"illustration_amount impact_green"},[_c('div',{staticClass:"anim_element",style:({width : _vm.getTransferBar(result.costs.total_received_destination)})})])]),_vm._v(" "),_c('span',{staticClass:"amount"},[_vm._v("\n          "+_vm._s(_vm.virgule_rec(result.costs.total_received_destination)))]),_vm._v(" "),_c('span',{staticClass:"total_cost",staticStyle:{"font-weight":"bold","font-size":"14px"}},[_vm._v(_vm._s(_vm.virgule(result.costs.total_fees)))]),_vm._v(" "),_c('a',{attrs:{"href":_vm.getPspLink(result.psp_id)}},[_vm._v("Go to "),_c('span',[_vm._v(_vm._s(_vm.getPspName(result.psp_id)))])])])])}),0):_vm._e(),_vm._v(" "),(_vm.twoDays.length > 0)?_c('transition-group',{class:['my_list','two'],attrs:{"name":"flip-list","tag":"ul"}},_vm._l((_vm.twoDays),function(result,index){return _c('li',{key:index+'_'+result.psp_id,class:['psp_'+result.psp_id, _vm.getTransferScore(result.costs.total_received_usd.toFixed(0)), {
            'debit': Object.keys(result.options.sending)[0]=='debit_card',
            'credit': Object.keys(result.options.sending)[0]=='credit_card',
            'bank': Object.keys(result.options.sending)[0]=='bank_transfer'
       }]},[_c('div',{staticClass:"container"},[_c('span',{staticClass:"logo_provider",style:({backgroundImage: 'url('+ _vm.getLogoPsp(result.psp_id) +')'})}),_vm._v(" "),_c('div',{staticClass:"container_amount"},[_c('div',{staticClass:"illustration_amount impact_green"},[_c('div',{staticClass:"anim_element",style:({width : _vm.getTransferBar(result.costs.total_received_destination)})})])]),_vm._v(" "),_c('span',{staticClass:"amount"},[_vm._v("\n          "+_vm._s(_vm.virgule_rec(result.costs.total_received_destination)))]),_vm._v(" "),_c('span',{staticClass:"total_cost",staticStyle:{"font-weight":"bold","font-size":"14px"}},[_vm._v(_vm._s(_vm.virgule(result.costs.total_fees)))]),_vm._v(" "),_c('a',{attrs:{"href":_vm.getPspLink(result.psp_id)}},[_vm._v("Go to "),_c('span',[_vm._v(_vm._s(_vm.getPspName(result.psp_id)))])])])])}),0):_vm._e(),_vm._v(" "),(_vm.plusThreeDays.length > 0)?_c('transition-group',{class:['my_list','plus'],attrs:{"name":"flip-list","tag":"ul"}},_vm._l((_vm.plusThreeDays),function(result,index){return _c('li',{key:index+'_'+result.psp_id,class:['psp_'+result.psp_id, _vm.getTransferScore(result.costs.total_received_usd.toFixed(0)), {
            'debit': Object.keys(result.options.sending)[0]=='debit_card',
            'credit': Object.keys(result.options.sending)[0]=='credit_card',
            'bank': Object.keys(result.options.sending)[0]=='bank_transfer'
       }]},[_c('div',{staticClass:"container"},[_c('span',{staticClass:"logo_provider",style:({backgroundImage: 'url('+ _vm.getLogoPsp(result.psp_id) +')'})}),_vm._v(" "),_c('div',{staticClass:"container_amount"},[_c('div',{staticClass:"illustration_amount impact_green"},[_c('div',{staticClass:"anim_element",style:({width : _vm.getTransferBar(result.costs.total_received_destination)})})])]),_vm._v(" "),_c('span',{staticClass:"amount"},[_vm._v("\n          "+_vm._s(_vm.virgule_rec(result.costs.total_received_destination)))]),_vm._v(" "),_c('span',{staticClass:"total_cost",staticStyle:{"font-weight":"bold","font-size":"14px"}},[_vm._v(_vm._s(_vm.virgule(result.costs.total_fees)))]),_vm._v(" "),_c('a',{attrs:{"href":_vm.getPspLink(result.psp_id)}},[_vm._v("Go to "),_c('span',[_vm._v(_vm._s(_vm.getPspName(result.psp_id)))])])])])}),0):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BestRated_vue__ = __webpack_require__(58);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32bc3e29_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BestRated_vue__ = __webpack_require__(181);
function injectStyle (ssrContext) {
  __webpack_require__(179)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-32bc3e29"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BestRated_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32bc3e29_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BestRated_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(180);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("7afa65a5", content, true, {});

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".monito_score[data-v-32bc3e29]{transform:scale(1.2);width:58px;height:49px;margin-left:7px;margin-right:25px;position:relative}.monito_score svg[data-v-32bc3e29]{position:absolute;top:-4px;left:0}.monito_score .score[data-v-32bc3e29]{display:inline-block;width:52px;padding-top:15px;left:2px;position:relative;box-sizing:border-box;height:52px;text-align:center;font-size:14px;font-family:Avenir Next;font-weight:700}.progress-ring-circle[data-v-32bc3e29]{transform:rotate(-90deg);transform-origin:50% 50%;stroke:#000}.monito_score.excellent[data-v-32bc3e29]{color:#00a000}.monito_score.excellent .progress-ring-circle[data-v-32bc3e29]{stroke:#00a000}.monito_score.good[data-v-32bc3e29]{color:#76c107}.monito_score.good .progress-ring-circle[data-v-32bc3e29]{stroke:#76c107}.monito_score.average[data-v-32bc3e29]{color:#ff9a0a}.monito_score.average .progress-ring-circle[data-v-32bc3e29]{stroke:#ff9a0a}.monito_score.poor[data-v-32bc3e29]{color:#ff5b05}.monito_score.poor .progress-ring-circle[data-v-32bc3e29]{stroke:#ff5b05}.monito_score.bad[data-v-32bc3e29]{color:#f5313e}.monito_score.bad .progress-ring-circle[data-v-32bc3e29]{stroke:#f5313e}", ""]);

// exports


/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('transition-group',{class:['my_list','minutes'],attrs:{"name":"flip-list","tag":"ul"}},_vm._l((_vm.sortedArray),function(result,index){return _c('li',{key:index+'_'+result.psp_id,class:['psp_'+result.psp_id, _vm.getTransferScore(result.costs.total_received_usd.toFixed(0)), {
            'debit': Object.keys(result.options.sending)[0]=='debit_card',
            'credit': Object.keys(result.options.sending)[0]=='credit_card',
            'bank': Object.keys(result.options.sending)[0]=='bank_transfer'
       }]},[_c('div',{staticClass:"container"},[_c('span',{staticClass:"logo_provider",style:({backgroundImage: 'url('+ _vm.getLogoPsp(result.psp_id) +')'})}),_vm._v(" "),_c('div',{class:['monito_score',_vm.getColorScore(_vm.getScore(result.psp_id))]},[_c('svg',{staticClass:"progress-ring",attrs:{"height":"56","width":"56"}},[_c('circle',{attrs:{"stroke":"#e6e6e64d","stroke-width":"4","fill":"transparent","r":"20","cx":"28","cy":"28"}}),_vm._v(" "),_c('circle',{staticClass:"progress-ring-circle",style:('strokeDasharray: '+  _vm.getMonitoScore(_vm.getScore(result.psp_id)) +' 125'),attrs:{"stroke":"#f00","stroke-width":"4","fill":"transparent","r":"20","cx":"28","cy":"28"}})]),_c('span',{staticClass:"score"},[_vm._v(_vm._s(_vm.getScore(result.psp_id)))])]),_vm._v(" "),_c('div',{staticClass:"container_amount"},[_c('div',{staticClass:"illustration_amount impact_green"},[_c('div',{staticClass:"anim_element",style:({width : _vm.getTransferBar(result.costs.total_received_destination)})})])]),_vm._v(" "),_c('span',{staticClass:"amount"},[_vm._v("\n          "+_vm._s(_vm.virgule_rec(result.costs.total_received_destination)))]),_vm._v(" "),_c('span',{staticClass:"total_cost",staticStyle:{"font-weight":"bold","font-size":"14px"}},[_vm._v(_vm._s(_vm.virgule(result.costs.total_fees)))]),_vm._v(" "),_c('a',{attrs:{"href":_vm.getPspLink(result.psp_id)}},[_vm._v("Go to "),_c('span',[_vm._v(_vm._s(_vm.getPspName(result.psp_id)))])])])])}),0)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PickPayout_vue__ = __webpack_require__(59);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6a234bc_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PickPayout_vue__ = __webpack_require__(185);
function injectStyle (ssrContext) {
  __webpack_require__(183)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c6a234bc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PickPayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6a234bc_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PickPayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(184);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("9adef570", content, true, {});

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "h3[data-v-c6a234bc]{width:85%;margin-left:auto;margin-right:auto}ul[data-v-c6a234bc]{margin:0;padding:0;padding-bottom:20px;list-style:none}li[data-v-c6a234bc]{padding:14px 20px;color:#51575e;font-style:14px;position:relative;font-family:Avenir Next;font-weight:500;text-align:center;display:block;cursor:pointer}li.active[data-v-c6a234bc]{border:none;background-color:#0cc3ca;color:#fff;left:-22px;padding:16px 20px;width:calc(100% + 12px);position:relative;font-weight:600;cursor:default;border-radius:0 8px 8px 0;box-shadow:0 4px 8px 0 rgba(0,0,0,.1);-webkit-box-shadow:0 4px 8px 0 rgba(0,0,0,.1);-moz-box-shadow:0 4px 8px 0 rgba(0,0,0,.1)}li.active[data-v-c6a234bc]:after{content:\"\";width:0;height:0;border-top:27px solid transparent;border-bottom:27px solid transparent;border-right:16px solid #0cc3ca;left:-16px;top:0;position:absolute}", ""]);

// exports


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("The available services we found")]),_vm._v(" "),_c('div',[_c('ul',[_vm._l((_vm.list_payout),function(payout){return [_c('li',{class:{active : _vm.pickReceiving ==payout},on:{"click":function($event){return _vm.changePayout(payout)}}},[_vm._v(_vm._s(_vm.labelPayout(payout)))])]})],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PickInterestFull_vue__ = __webpack_require__(60);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a6ff08c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PickInterestFull_vue__ = __webpack_require__(189);
function injectStyle (ssrContext) {
  __webpack_require__(187)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2a6ff08c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PickInterestFull_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a6ff08c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PickInterestFull_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(188);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("e3ff5388", content, true, {});

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "ul[data-v-2a6ff08c]{width:68%;margin:0 auto;padding-left:6px;padding-right:6px;margin-bottom:20px;background:#f5f5f5;height:58px;overflow:hidden;border-radius:100px;box-sizing:border-box;display:flex;vertical-align:center;justify-content:space-between;margin-top:36px;margin-bottom:58px}li[data-v-2a6ff08c]{flex-grow:1;letter-spacing:.028em;font-size:16px;text-align:center;display:inline-block;padding:12px 2px;border-radius:50px;cursor:pointer;font-family:Avenir Next;font-weight:600;height:46px;box-sizing:border-box;margin-top:6px}li.active_interest[data-v-2a6ff08c]{background:#0cc3ca;color:#fff;overflow:hidden;-webkit-box-shadow:0 3px 6px 0 rgba(0,0,0,.06);-moz-box-shadow:0 3px 6px 0 rgba(0,0,0,.06);box-shadow:0 3px 6px 0 rgba(0,0,0,.06);border-radius:50px;padding:12px 2px;cursor:default;font-weight:600}li[data-v-2a6ff08c]:hover:not(.active_interest){color:#000}", ""]);

// exports


/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',[_c('li',{class:{'active_interest' : _vm.pickInterest == 'cheap'},on:{"click":function($event){return _vm.changeInterest('cheap')}}},[_vm._v("Cheapest")]),_vm._v(" "),_c('li',{class:{'active_interest' : _vm.pickInterest == 'fast'},on:{"click":function($event){return _vm.changeInterest('fast')}}},[_vm._v("Fastest")]),_vm._v(" "),_c('li',{class:{'active_interest' : _vm.pickInterest == 'best'},on:{"click":function($event){return _vm.changeInterest('best')}}},[_vm._v("Best rated")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PickPayin_vue__ = __webpack_require__(62);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e6b1fb6e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PickPayin_vue__ = __webpack_require__(195);
function injectStyle (ssrContext) {
  __webpack_require__(191)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e6b1fb6e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PickPayin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e6b1fb6e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PickPayin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(192);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("6df876d7", content, true, {});

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(17);
exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "h3[data-v-e6b1fb6e]{width:85%;margin-left:auto;margin-right:auto}ul[data-v-e6b1fb6e]{margin:0;padding:0;position:relative}ul li[data-v-e6b1fb6e]{position:relative;box-sizing:border-box;cursor:pointer;margin-left:auto;margin-right:auto;color:#3c424bdb;font-family:Avenir Next;font-weight:500;width:240px;font-size:16px;letter-spacing:.01em;padding:4px 12px 16px;display:inline-block;border-bottom:1px solid hsla(0,0%,80%,.501961)!important}ul li[data-v-e6b1fb6e]:before{position:relative;top:6px;content:\"\";width:23px;height:23px;display:inline-block;margin-right:14px;background-image:url(" + escape(__webpack_require__(61)) + ");background-size:contain;background-position:50%;background-repeat:no-repeat}ul li.bank[data-v-e6b1fb6e]:before{top:5px;background-image:url(" + escape(__webpack_require__(61)) + ")}ul li.credit[data-v-e6b1fb6e]:before{background-image:url(" + escape(__webpack_require__(193)) + ")}ul li.debit[data-v-e6b1fb6e]:before{background-image:url(" + escape(__webpack_require__(194)) + ")}ul li .on_off[data-v-e6b1fb6e]{right:0;top:9px;display:block;width:42px;height:26px;background:#e4e4e4;border-radius:20px;position:absolute}ul li .on_off .pearl[data-v-e6b1fb6e]{transition:all .11s;display:inline-block;width:20px;left:3px;top:3px;position:relative;height:20px;border-radius:20px;background:#fff;-webkit-box-shadow:0 3px 6px 0 rgba(0,0,0,.04);-moz-box-shadow:0 3px 6px 0 rgba(0,0,0,.04);box-shadow:0 3px 6px 0 rgba(0,0,0,.04)}ul li.active[data-v-e6b1fb6e]{border:none;color:#3c424b}ul li.active .on_off[data-v-e6b1fb6e]{background:#0cc3ca}ul li.active .on_off .pearl[data-v-e6b1fb6e]{left:18px}ul li[data-v-e6b1fb6e]:last-child{border:none!important}", ""]);

// exports


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icon_credit_card.svg?4402991d8ba1248f2c1425decabd9da1";

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icon_debit_card.svg?1b8fd1512825f5ebe8cd08db188d3aa9";

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Payment options you agree to use")]),_vm._v(" "),_c('ul',[_c('li',{class:['bank',{active : _vm.bank_transfer}],on:{"click":_vm.bankTransfer}},[_vm._v("by bank transfer"),_vm._m(0)]),_vm._v(" "),_c('li',{class:['debit',{active : _vm.debit_card}],on:{"click":_vm.debitCard}},[_vm._v("by debit card"),_vm._m(1)]),_vm._v(" "),_c('li',{class:['credit',{active : _vm.credit_card}],on:{"click":_vm.creditCard}},[_vm._v("by credit card"),_vm._m(2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"on_off"},[_c('span',{staticClass:"pearl"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"on_off"},[_c('span',{staticClass:"pearl"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"on_off"},[_c('span',{staticClass:"pearl"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(197);

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3);
var bind = __webpack_require__(63);
var Axios = __webpack_require__(198);
var mergeConfig = __webpack_require__(69);
var defaults = __webpack_require__(66);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(70);
axios.CancelToken = __webpack_require__(211);
axios.isCancel = __webpack_require__(65);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(212);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3);
var buildURL = __webpack_require__(64);
var InterceptorManager = __webpack_require__(199);
var dispatchRequest = __webpack_require__(200);
var mergeConfig = __webpack_require__(69);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3);
var transformData = __webpack_require__(201);
var isCancel = __webpack_require__(65);
var defaults = __webpack_require__(66);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(68);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(206);
var combineURLs = __webpack_require__(207);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(70);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.onbording_filters)?_c('div',{staticClass:"choosing_filter"},[_c('div',{staticClass:"container_filters"},[_c('div',{staticClass:"title"},[_c('h1',{staticClass:"f-anti fs-24 fw-demi-bold mt-4 ls-2 lh-5"},[_vm._v("We’re fetching very fresh transfer fees and exchange rates for your comparison")]),_vm._v(" "),_c('h2',{staticClass:"f-anti fs-34 fw-bold mt-3 ls-2 "},[_vm._v("Let's use this short time-out to filter the futur results")]),_vm._v(" "),_c('a',{staticClass:"btn_cta fw-bold f-anti f-19 ls-1 pl-4 pr-4 pt-2 pb-2 fs-18 f-anti mt-6",on:{"click":_vm.closeOnbording}},[_vm._v("Apply and continue")])]),_vm._v(" "),_c('aside',[(_vm.info.results !== undefined)?_c('app-pick-payout',{attrs:{"pickReceiving":_vm.pickReceiving,"list_payout":_vm.list_payout},on:{"changePayout":function($event){_vm.pickReceiving = $event}}}):_vm._e(),_vm._v(" "),_c('app-pick-interest',{attrs:{"pickInterest":_vm.pickInterest},on:{"changeInterest":function($event){_vm.pickInterest = $event}}}),_vm._v(" "),_c('app-pick-payin',{attrs:{"credit_card":_vm.credit_card,"debit_card":_vm.debit_card,"bank_transfer":_vm.bank_transfer},on:{"changeDebitCard":function($event){_vm.debit_card = $event},"changeCreditCard":function($event){_vm.credit_card = $event},"changeBankTransfer":function($event){_vm.bank_transfer = $event}}})],1)])]):_vm._e(),_vm._v(" "),_c('header',[_c('app-navigation',[_c('h1',{attrs:{"id":"logo_monito"}},[_c('a',{attrs:{"href":"https://monito.com"}},[_vm._v("monito")])]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"https://www.monito.com/en/about-monito"}},[_vm._v("About us")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.monito.com/en/wiki/monito-account"}},[_vm._v("Alerts")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.monito.com/en/wiki"}},[_vm._v("Wiki")])]),_vm._v(" "),_c('li',{staticClass:"langage"},[_c('a',{attrs:{"href":"#"}},[_vm._v("EN")])])])]),_vm._v(" "),_c('app-hero-section',{attrs:{"herotype":_vm.herotype}})],1),_vm._v(" "),_c('transition',{attrs:{"name":"apper","appear":""}},[_c('main',{ref:"main"},[_c('section',{ref:"scroll_zone",staticClass:"result shadow"},[_c('div',{staticClass:"color"}),_vm._v(" "),_c('h1',{staticClass:"mb-3 pt-7"},[_vm._v("The best solutions to send money from the United States to the United Kingdom")]),_vm._v(" "),(_vm.info.results !== undefined && !_vm.fake_loading)?_c('h2',{staticClass:"fw-bold f-anti",staticStyle:{"letter-spacing":"0.015em","margin":"0 auto","margin-top":"36px","margin-bottom":"10px","font-size":"22px","-webkit-font-smoothing":"antialiased","-moz-osx-font-smoothing":"grayscale","text-align":"center"}},[_vm._v("Sending "),_c('span',{staticStyle:{"color":"#F53449","cursor":"pointer"},on:{"click":function($event){return _vm.wantChangeAmount()}}},[_vm._v(_vm._s(_vm.virgule_amount_send(_vm.info.amount)))]),_vm._v(" will get your recipient…")]):_vm._e(),_vm._v(" "),(_vm.info.results !== undefined)?_c('app-pick-interest',{attrs:{"pickInterest":_vm.pickInterest},on:{"changeInterest":function($event){_vm.pickInterest = $event}}}):_vm._e(),_vm._v(" "),(_vm.info.results === undefined || _vm.fake_loading)?_c('app-loading'):_vm._e(),_vm._v(" "),(_vm.info.results !== undefined && _vm.bestView && !_vm.fake_loading)?_c('app-best-rated',{attrs:{"info":_vm.info,"sortedArray":_vm.sortedArray,"getTransferScore":_vm.getTransferScore,"getLogoPsp":_vm.getLogoPsp,"getTransferBar":_vm.getTransferBar,"getPspName":_vm.getPspName,"virgule_rec":_vm.virgule_rec,"virgule":_vm.virgule,"getPspLink":_vm.getPspLink}}):_vm._e(),_vm._v(" "),(_vm.info.results !== undefined && _vm.fastView && !_vm.fake_loading)?_c('app-fast',{attrs:{"sortedArray":_vm.sortedArray,"getTransferScore":_vm.getTransferScore,"getLogoPsp":_vm.getLogoPsp,"getTransferBar":_vm.getTransferBar,"getPspName":_vm.getPspName,"virgule_rec":_vm.virgule_rec,"virgule":_vm.virgule,"getPspLink":_vm.getPspLink}}):_vm._e(),_vm._v(" "),(_vm.info.results !== undefined && _vm.cheapView && !_vm.fake_loading)?_c('transition-group',{class:['my_list','cheap_list'],attrs:{"name":"flip-list","tag":"ul"}},_vm._l((_vm.sortedArray),function(result,index){return _c('li',{key:index+'_'+result.psp_id,class:['psp_'+result.psp_id, _vm.getTransferScore(result.costs.total_received_usd.toFixed(0)), {
          'debit': Object.keys(result.options.sending)[0]=='debit_card',
          'credit': Object.keys(result.options.sending)[0]=='credit_card',
          'bank': Object.keys(result.options.sending)[0]=='bank_transfer'
        }]},[_c('div',{staticClass:"container"},[_c('span',{staticClass:"logo_provider",style:({backgroundImage: 'url('+ _vm.getLogoPsp(result.psp_id) +')'})}),_vm._v(" "),_c('div',{staticClass:"container_amount"},[_c('div',{staticClass:"illustration_amount impact_green"},[_c('div',{staticClass:"anim_element",style:({width : _vm.getTransferBar(result.costs.total_received_destination.toFixed(0)),animationDelay: ''+(0.4 + ((index + 0.1) / 8))+'s'})})])]),_vm._v(" "),_c('span',{staticClass:"amount"},[_vm._v("\n        "+_vm._s(_vm.virgule_rec(result.costs.total_received_destination)))]),_vm._v(" "),_c('span',{staticClass:"total_cost",staticStyle:{"font-weight":"bold","font-size":"14px"}},[_c('span',[_vm._v(_vm._s(_vm.virgule(result.costs.total_fees)))])]),_vm._v(" "),_c('a',{attrs:{"href":_vm.getPspLink(result.psp_id)}},[_vm._v("Go to "),_c('span',[_vm._v(_vm._s(_vm.getPspName(result.psp_id)))])])]),_vm._v(" "),_c('div',{staticClass:"details"},[_c('div',{staticClass:"container"},[(false)?_c('span',{staticStyle:{"width":"100%","box-sizing":"border-box","background":"#1E2026","border-radius":"12px 12px 0 0","font-size":"12px","line-height":"16px","font-weight":"700","text-transform":"uppercase","letter-spacing":"0.05em","padding":"18px 20px"}},[_vm._v("About this transfer with "+_vm._s(_vm.getPspName(result.psp_id)))]):_vm._e(),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"font-size":"19px","margin-top":"24px","font-weight":"600"}},[_vm._v("You pay")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"23px","font-weight":"700"}},[_vm._v(_vm._s(_vm.virgule_amount_send(_vm.info.amount)))]),_vm._v(" "),_c('span',{staticClass:"boxed_info"},[_vm._v(_vm._s(_vm.getPayinLabelBlack(Object.keys(result.options.sending)[0])))])]),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"font-size":"23px","font-weight":"700","letter-spacing":"0.035em","-webkit-font-smoothing":"antialiased","-moz-osx-font-smoothing":"grayscale"}},[_vm._v(_vm._s(_vm.virgule_rec(result.costs.total_received_destination)))]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"19px","margin-bottom":"6px","font-weight":"600","max-width":"75%"}},[_vm._v("arrives in the United Kingdom")]),_vm._v(" "),_c('span',{staticClass:"boxed_info clock"},[_vm._v(_vm._s(_vm.getSpeedLabel(result.transfer_time_product_rate)))]),_vm._v(" "),_c('span',{staticClass:"boxed_info"},[_vm._v(_vm._s(_vm.getPayoutLabelBlack(Object.keys(result.options.receiving)[0] )))])])])])])}),0):_vm._e()],1),_vm._v(" "),(_vm.info.results !== undefined && !_vm.fake_loading)?_c('section',{staticClass:"story result boxed shadow"},[_c('div',{staticClass:"color"}),_vm._v(" "),_c('h1',{staticClass:"pt-10"},[_vm._v(_vm._s(_vm.info.story[0]))]),_vm._v(" "),_c('p',{staticClass:"f_chapo",domProps:{"innerHTML":_vm._s(_vm.info.story[1])}}),_vm._v(" "),_c('p',{staticClass:"f_body",domProps:{"innerHTML":_vm._s(_vm.info.story[2])}}),_vm._v(" "),_c('p',{staticClass:"f_body",domProps:{"innerHTML":_vm._s(_vm.info.story[3])}}),_vm._v(" "),_c('p',{staticClass:"f_body",domProps:{"innerHTML":_vm._s(_vm.info.story[4])}}),_vm._v(" "),_c('p',{staticClass:"f_body",domProps:{"innerHTML":_vm._s(_vm.info.story[5])}}),_vm._v(" "),_c('p',{staticClass:"f_body",domProps:{"innerHTML":_vm._s(_vm.info.story[6])}}),_vm._v(" "),_c('p',{staticClass:"f_body",domProps:{"innerHTML":_vm._s(_vm.info.story[7])}})]):_vm._e(),_vm._v(" "),(_vm.info.results !== undefined && !_vm.fake_loading)?_c('aside',{ref:"scroll_widgets"},[_c('app-pick-payout',{attrs:{"pickReceiving":_vm.pickReceiving,"list_payout":_vm.list_payout},on:{"changePayout":function($event){_vm.pickReceiving = $event}}}),_vm._v(" "),(_vm.info.results !== undefined)?_c('app-pick-payin',{attrs:{"credit_card":_vm.credit_card,"debit_card":_vm.debit_card,"bank_transfer":_vm.bank_transfer},on:{"changeDebitCard":function($event){_vm.debit_card = $event},"changeCreditCard":function($event){_vm.credit_card = $event},"changeBankTransfer":function($event){_vm.bank_transfer = $event}}}):_vm._e()],1):_vm._e()])]),_vm._v(" "),_c('widget-providers',{attrs:{"providers":_vm.providers}},[_c('h1',{staticClass:"fs-28 lh-6 mb-1 mt-5\n    fs-sm-24 lh-sm-5  mb-sm-3 ls-sm-2\n  "},[_vm._v("We compare and review over 300 money transfer companies")]),_vm._v(" "),_c('span',{staticClass:"fs-19 italic fs-sm-17 fw-demi-bold f-anti",staticStyle:{"opacity":"0.88"}},[_vm._v("An easy way to find the good one")])]),_vm._v(" "),_c('app-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentPage_vue__ = __webpack_require__(71);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41dee14e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentPage_vue__ = __webpack_require__(217);
function injectStyle (ssrContext) {
  __webpack_require__(215)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41dee14e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(216);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("23192a10", content, true, {});

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "main{position:relative;z-index:10000;margin-top:-290px}@media (max-width:768px){main{margin-top:-170px}}@media (max-width:500px){main{margin-top:-150px}}.scroller{width:352px;box-sizing:border-box;position:absolute;right:0;top:232px}.scroller.article_content{top:655px}.scroller.article_content .aside_widget{padding:0}.scroller.article_content h4{color:#676767}.article_content ul{list-style:none;padding-left:0;margin-left:0}.article_content ul li{padding:12px 50px;color:#353c45;cursor:pointer;transition:all .2s ease}.article_content ul li a{background:#0cc3ca;text-align:center}.article_content ul li a.hide{display:none!important}.article_content ul li a:hover{background:#17d5dc}.article_content ul li a.anime{animation-name:apparition_btn_cta;animation-duration:1s;position:relative}@keyframes apparition_btn_cta{0%{bottom:-10px;opacity:0}to{bottom:0;opacity:1}}.article_content ul li:hover{background:#D3F5F560}.article_content ul li.active{background:#d3f5f5;color:#004660;position:relative;padding-top:24px;padding-bottom:24px;cursor:default}.article_content ul li.active:after{content:\"\";width:0;height:0;border-top:35px solid transparent;border-bottom:37px solid transparent;border-right:14px solid #d3f5f5;left:-14px;top:calc(50% - 35px);position:absolute}@media (max-width:768px){.article_content{display:none}body{overflow:scrollY}body,main{width:100%}main h1{text-align:center}.scroller{width:90%;margin-left:5%;position:relative!important;top:0}}", ""]);

// exports


/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',[_c('app-navigation',[_c('h1',{attrs:{"id":"logo_monito"}},[_c('a',{attrs:{"href":"https://monito.com?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=nav"}},[_vm._v("Monito")])]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"https://www.monito.com/en/about-monito?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=nav"}},[_vm._v("About us")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.monito.com/en/wiki/monito-account?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=nav"}},[_vm._v("Alerts")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.monito.com/en/wiki?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=nav"}},[_vm._v("Wiki")])]),_vm._v(" "),_c('li',{staticClass:"langage"},[_c('a',{attrs:{"href":"#"}},[_vm._v("EN")])])])]),_vm._v(" "),_c('app-hero-section',{attrs:{"urlBackground":_vm.urlBackground,"herotype":_vm.herotype}})],1),_vm._v(" "),_c('main',{ref:"main"},[_c('section',{ref:"scroll_zone"},[_c('section',{staticClass:"\n      boxed has-cover\n      pt-57 pl-7 pr-7 pb-10\n      pl-lg-5 pr-lg-5 pb-lg-8\n      pl-md-5 pr-md-5 pb-md-8\n      pl-sm-3 pr-sm-3 pb-sm-7 \n      mt-5 mb-5"},[_c('div',{staticClass:"color"}),_vm._v(" "),_c('div',{staticClass:"cover",staticStyle:{"background-image":"url('https://maltawinds.com/wp-content/uploads/2017/02/brexit-640x360.jpg')"}}),_vm._v(" "),_c('h1',{staticClass:"f_title mt-5 mb-7 mt-2-sm mb-sm-6",attrs:{"id":"anchor01"}},[_vm._v("How to open a bank account online in the UK (even without proof of residency)")]),_vm._v(" "),_vm._m(0),_vm._v(" "),(false)?_c('div',{staticClass:"aside_widget"},[_vm._m(1)]):_vm._e(),_vm._v(" "),_c('widget-author',{staticClass:"mb-6 mt-3"},[_c('div',{staticClass:"portrait"},[_c('span',{staticClass:"image",staticStyle:{"background-image":"url('https://images.prismic.io/monito%2F7924bad3-5587-466e-8147-b095f0bb33f3_francois+profile+picture.jpg?auto=compress,format&rect=0,105,1401,1401&w=200&h=200')"}}),_vm._v(" "),_c('p',{staticClass:"name pt-sm-2"},[_c('span',[_vm._v("Written by")]),_c('a',{attrs:{"href":"https://www.monito.com/en/wiki/francois-briod?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=main_content"}},[_vm._v("François Briod")])]),_vm._v(" "),_c('p',{staticClass:"pb-sm-3 update"},[_c('span',[_vm._v("Last updated")]),_vm._v("April 16, 2020")])]),_vm._v(" "),_c('p',{staticClass:"bio mt-2 mb-2 ls-2 pl-sm-1 fw-medium mb-sm-3 f-anti"},[_vm._v("Co-Founder of Monito and money transfer expert, François has been helping Monito’s users navigate the jungle of money transfer fees, bad exchange rates and tricks for the last six years.")])]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("Considering a move to the UK? Whether you are moving as a student to attend university, for a new job or to look for work, you may want a local bank account in order to get yourself set up. And in case you heard horror stories about setting up a UK bank account, don’t worry too much.")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('h2',{staticClass:"f_subtitle_1"},[_vm._v("Major traditional banks in the UK or Online Banks?")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("The biggest traditional banks in the UK are HSBC, Lloyds, Royal Bank of Scotland (often referred to as simply RBS), Barclays, NatWest, Santander and Nationwide. By traditional, we mean banks with actual physical branches across the country (versus, say, online banks which provide a UK bank account with a UK account). ")]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('h2',{staticClass:"f_subtitle_1"},[_vm._v("Types of UK accounts")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("There are numerous types of accounts in the UK, but a standard current bank account is what most people want to for basic everyday use such as paying bills and receiving a salary. These accounts generally come with a debit card, a check book and overdraft protection. Savings accounts yield a higher interest rate and are meant for what their name implies—saving money. ")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("There are also basic accounts, which are generally on offer for people with a poor credit history.")]),_vm._v(" "),_c('h3',{staticClass:"f_subtitle_1"},[_vm._v("Documents you need to open a UK bank account")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("In order to open a UK bank account, you generally need two things:")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("Proof of your identity. This can take the form of a passport, drivers licence or national identity card. In general, if you are a foreign national your best bet is to use your passport — EU national identity cards are usually accepted (though how this works after Brexit takes effect is anyone’s guess), but if you are from, say, Australia, your home drivers license may not be accepted.")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("Proof of address. This is generally a recent utility bill, rental contract, council tax bill. Mobile phone bills are generally not accepted.")]),_vm._v(" "),_c('div',{ref:"anchor02",attrs:{"id":"anchor02"}},[_c('h3',{staticClass:"f_subtitle_1 mb-6"},[_vm._v("Monito’s experts recommendations")]),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6)])],1),_vm._v(" "),_c('section',{ref:"anchor03",staticClass:"\n      boxed \n      pt-4 pl-7 pr-7 pb-10\n      pt-lg-4 pl-lg-5 pr-lg-5 pb-lg-8\n      pt-sm-2 pl-sm-2 pr-sm-2 pb-sm-7 \n      mt-5 mb-5",attrs:{"id":"anchor03"}},[_c('div',{staticClass:"color"}),_vm._v(" "),_c('h2',{staticClass:"f_title mt-5 mb-7 mt-2-sm mb-sm-6"},[_vm._v("How to open a UK account without proof of residency")]),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('img',{staticClass:"mt-6 mt-6-sm",attrs:{"src":"https://images.prismic.io/monito/2480ea46-72c1-421c-a46d-e7822f62a134_transferwise_borderless_account_digital_nomads.jpg"}}),_vm._v(" "),_c('label',{staticClass:"ls-1 mb-2-sm fw-demi-bold f6"},[_vm._v("© TransferWise")]),_vm._v(" "),_vm._m(8),_vm._v(" "),_c('p',{staticClass:"f_chapo"},[_vm._v("Once done, here's what you'll get with a TransferWise borderless account:")]),_vm._v(" "),_vm._m(9),_vm._v(" "),_c('p',{staticClass:"f_chapo"},[_vm._v("Let's say that you've just moved from France to the UK and you need GBP. With a borderless account, you can now:")]),_vm._m(10),_vm._v(" "),_c('img',{staticClass:"mt-6 mt-6-sm",attrs:{"src":"https://images.prismic.io/monito/4e3f022f776b6ca602f1f35c718e10af813f2a0e_chrome_2019-07-09_12-04-23.png"}}),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_c('img',{staticClass:"mt-6 mt-6-sm",attrs:{"src":"https://images.prismic.io/monito/e07dae9a32d5c3f76674811cff7f1da23c7fa405_monzo-1.jpeg"}}),_vm._v(" "),_vm._m(13),_vm._v(" "),_c('img',{staticClass:"mt-6 mt-6-sm",attrs:{"src":"https://images.prismic.io/monito/14f6d7a6f864cecd0e4eaac8c333a0159a63e0a3_revolut2.jpeg"}}),_vm._v(" "),_c('label',{staticClass:"ls-1 mb-2-sm fw-demi-bold f6"},[_vm._v("© Revolut")]),_vm._v(" "),_vm._m(14),_vm._v(" "),_vm._m(15),_vm._v(" "),_c('img',{staticClass:"mt-6 mt-6-sm",attrs:{"src":"https://images.prismic.io/monito/ac793bc15e80e2db2cf80c30d662c01d23444ed5_kickstart_1st_contact.jpeg"}}),_vm._v(" "),_c('p',{staticClass:"f_subtitle_2"},[_vm._v("Pay someone to sort out all the details")]),_vm._v(" "),_vm._m(16),_vm._v(" "),_vm._m(17),_vm._v(" "),_vm._m(18),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("But if you really need a proof of address...")])]),_vm._v(" "),_c('section',{ref:"anchor04",staticClass:"\n      boxed \n      pt-4 pl-7 pr-7 pb-10\n      pt-lg-4 pl-lg-5 pr-lg-5 pb-lg-8\n      pt-sm-2 pl-sm-2 pr-sm-2 pb-sm-7 \n      mt-5 mb-5",attrs:{"id":"anchor04"}},[_c('div',{staticClass:"color"}),_vm._v(" "),_c('h2',{staticClass:"f_title mt-5 mb-7 mt-2-sm mb-sm-6"},[_vm._v("How to get a proof of address in the UK")]),_vm._v(" "),_vm._m(19),_vm._v(" "),_c('h3',{staticClass:"f_subtitle_2"},[_vm._v("What document count as a proof of identity?")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("They will require a proof of name, in the form of a Current Signed passport, Original Birth Certificate, EEA member state identity card, Current UK or EEA driving license, Registration card for self-employed individuals, Resident Permit issued by the Home office to EEA nationals, National Identity card or Firearms certificate.\n        ")]),_c('h3',{staticClass:"f_subtitle_2"},[_vm._v("What document count as a proof of address?")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("Then, you might be required to provide 1 or 2 original documents to prove that you live where you claim to live (i.e. your residential address):")]),_vm._v(" "),_vm._m(20),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("Note that credit card statements or provisional driving license will not be accepted.")]),_vm._v(" "),_vm._m(21),_vm._v(" "),_vm._m(22),_vm._v(" "),_vm._m(23)])]),_vm._v(" "),(false)?_c('aside',{staticClass:"scroller"},[_vm._m(24)]):_vm._e(),_vm._v(" "),(true)?_c('aside',{staticClass:"scroller"},[_vm._m(25),_vm._v(" "),(false)?_c('div',{staticClass:"aside_widget"},[_vm._m(26)]):_vm._e()]):_vm._e(),_vm._v(" "),_c('aside',{ref:"scroll_widgets",staticClass:"scroller article_content"},[_c('div',{staticClass:"aside_widget"},[_c('h4',{staticClass:"fw-demi-bold fs-16 pt-5 pb-1 "},[_vm._v("Let's browse through the article")]),_vm._v(" "),_c('ul',{staticClass:"fw-demi-bold f-anti fs-16 pb-3 pt-0"},[_c('li',{staticClass:"active",on:{"click":function($event){return _vm.anchor01()}}},[_vm._v("Introduction")]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.anchor02()}}},[_vm._v("Monito’s recommendation"),_c('a',{staticClass:"btn_cta hide fw-bold f-anti f-19 ls-1",attrs:{"target":"_blank","rel":"noopener","href":"https://go.monito.com/transferwise-borderless?utm_campaign=ABTestBankUK_legacy&utm_source=internal&utm_medium=internal&utm_content=hero_widget_cta&link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3Aukaccount%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com%252Fgb%252Fborderless%252F"}},[_vm._v("Open a TransferWise Borderless Account")])]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.anchor03()}}},[_vm._v("How to open a UK account without proof of residency ?")]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.anchor04()}}},[_vm._v("How to get a proof of address in the UK ?")])])])])]),_vm._v(" "),_c('widget-faq',[_c('ul',{staticClass:"shadow"},[_c('li',[_c('h3',[_vm._v("Which company offers a bank account in the UK if I don't have the proof of address? 🏦")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("There are few companies that offer a bank account in the UK, even when you don't have a proof of address in the UK. With Monzo or Monese, you can open a UK bank account with just a few clicks. All the details about "),_c('a',{attrs:{"target":"_blank","rel":"noopener","href":"https://www.monito.com/en/wiki/open-bank-account-uk-even-without-proof-residency?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=FAQ"}},[_vm._v("opening a bank account in the UK without the proof of address")]),_vm._v(", you will find in our blog post. ")])]),_vm._v(" "),_c('li',[_c('h3',[_vm._v("What is the best UK bank accout for non residents?")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("Expats moving to the UK 🇬🇧might find it difficult to open a traditional bank account. To open a bank account, you need a proof of address, which might be hard to get if you are a non-resident. Good news is that companies liked Monzo or Monese offer a UK bank account without proof of address. You can have a UK bank account with just a few clicks. "),_c('a',{attrs:{"target":"_blank","rel":"noopener","href":"https://www.monito.com/en/wiki/open-bank-account-uk-even-without-proof-residency?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=FAQ"}},[_vm._v("More info about UK bank account for non-residents you will find in our blog post")]),_vm._v(".")])]),_vm._v(" "),_c('li',[_c('h3',[_vm._v("Is it possible to have Euro bank account in the UK? 💶")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("Some UK banks offer bank account in Euro. However, the fees for such accounts are quite high. But we have good news - there is a possibility to open a bank account in Euro for free. Check out our "),_c('a',{attrs:{"target":"_blank","rel":"noopener","href":"https://www.monito.com/en/wiki/open-bank-account-uk-even-without-proof-residency?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=FAQ"}},[_vm._v("blog post about opening a bank account in the UK without proof of address")]),_vm._v(" and get a free UK bank account in Euro. ")])]),_vm._v(" "),_c('li',[_c('h3',[_vm._v("What documents do I need to open a bank account in the UK? 📄  ")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("To open a UK bank account, you generally need two things:"),_c('br'),_vm._v("1️. Proof of your identity - passport, drivers license, or national identity card. In general, if you are a foreign national, your best bet is to use your passport."),_c('br'),_vm._v("2. Proof of the address in the UK. It can be a recent utility bill, rental contract, council tax bill. Mobile phone bills are generally not accepted. "),_c('br'),_c('br'),_vm._v("If you don't have a proof of address, have a look at our "),_c('a',{attrs:{"target":"_blank","rel":"noopener","href":"https://www.monito.com/en/wiki/open-bank-account-uk-even-without-proof-residency?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=FAQ"}},[_vm._v("blog post about opening a bank account in the UK")]),_vm._v(". ")])]),_vm._v(" "),_c('li',[_c('h3',[_vm._v("Can a foreigner open a bank account in the UK? 🇬🇧")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("Foreigners can open a traditional bank account in the UK as long as they have proof of the address, which sometimes it's hard to get. Good news is that there are companies like Monzo or Monese which offer UK bank account even without the proof of the address. All the information about "),_c('a',{attrs:{"target":"_blank","rel":"noopener","href":"https://www.monito.com/en/wiki/open-bank-account-uk-even-without-proof-residency?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=FAQ"}},[_vm._v("opening a bank account in the UK you will find in our blog post")]),_vm._v(". ")])])])]),_vm._v(" "),_c('widget-articles',{attrs:{"articles":_vm.articles}},[_c('h1',{staticClass:"fs-28 fw-bold f-anti mb-9 mb-sm-4 mt-sm-4"},[_vm._v("This might interest you too")])]),_vm._v(" "),_c('app-footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aside_widget mb-4 mb-sm-0"},[_c('div',{staticClass:"should excellent"},[_c('p',[_c('span',[_vm._v("What you should do")]),_c('b',[_vm._v("Take your banking 100% online with TransferWise.")]),_vm._v(" Most high-street banks won't allow you to open a bank account without a proof of residency, so we recommend going with the best online solution who will, like TranserWise Borderless account.")]),_vm._v(" "),_c('a',{staticClass:"btn_cta fw-bold f-anti f-19 ls-1",attrs:{"target":"_blank","rel":"noopener","href":"https://go.monito.com/transferwise-borderless?utm_campaign=ABTestBankUK_legacy&utm_source=internal&utm_medium=internal&utm_content=headerro_widget_cta&link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3Aukaccount%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com%252Fgb%252Fborderless%252F"}},[_vm._v("Take me to TransferWise")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"should bad"},[_c('p',[_c('span',[_vm._v("What you should avoid")]),_c('b',[_vm._v("Don’t go with a high-street bank,")]),_vm._v(" most won’t allow you to open a bank account without a proof of residency and are all around more expensive.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_vm._v("Other country guides: "),_c('a',{attrs:{"target":"_blank","rel":"noopener","href":"https://www.monito.com/en/wiki/open-bank-account-us-even-without-proof-residency?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk\n &utm_content=main_content"}},[_vm._v("How to open a bank account in the US,")]),_vm._v(" "),_c('a',{attrs:{"href":"https://www.monito.com/en/wiki/open-bank-account-canada-even-without-proof-residency?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk\n &utm_content=main_content"}},[_vm._v("Canada ")]),_vm._v("or "),_c('a',{attrs:{"target":"_blank","rel":"noopener","href":"https://www.monito.com/en/wiki/open-bank-account-australia-even-without-proof-residency?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk\n &utm_content=main_content"}},[_vm._v("Australia")]),_vm._v(" as a non-resident.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_vm._v("It used to be notoriously tough to get an account, but it’s recently become more straightforward. Plus, if you are a digital nomad without a fixed address, just want an "),_c('a',{attrs:{"target":"_blank","rel":"noopener","href":"https://www.monito.com/en/wiki/best-international-bank-accounts-digital-nomads?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk\n &utm_content=main_content"}},[_vm._v("international bank account")]),_vm._v(" or struggle to prove that you are a UK resident because you’re lacking specific documentation, there are now a number of alternatives.  Or if the mere thought of relocation admin makes you cringe, don’t fret: There are also a few resources (for a fee, of course!) that will help you with the process of opening a bank account in the UK.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_vm._v("Online bank accounts are great if you simply need to have an account in Pound Sterling with a UK account number and sort code, and many, like "),_c('a',{attrs:{"href":"https://go.monito.com/transferwise-borderless?utm_campaign=ABTestBankUK_legacy&utm_source=internal&utm_medium=internal&utm_content=hero_widget_cta&link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3Aukaccount%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com%252Fgb%252Fborderless%252F"}},[_vm._v("TransferWise’s Borderless Account")]),_vm._v(", also offer debit cards. But if you want or need a bank where you can actually walk into a branch, then you’ll want to consider a traditional bank.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"should_content excellent mt-3"},[_c('h3',{staticClass:"mb-2"},[_vm._v("What you should do")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("We've compared the available online banking options for your current situation and TransferWise is the simplest option to pay and get paid like a local in the UK.")]),_vm._v(" "),_c('h4',{staticClass:"f_chapo"},[_vm._v("Why TransferWise ?")]),_vm._v(" "),_c('ul',{staticClass:"f_body"},[_c('li',[_vm._v("Their pricing is 100% transparent and very competitive")]),_vm._v(" "),_c('li',[_vm._v("Hold money in GBP and 50 other currencies")]),_vm._v(" "),_c('li',[_vm._v("No setup fees or monthly charges")]),_vm._v(" "),_c('li',[_vm._v("You don't need to have a UK to open the account.")])]),_vm._v(" "),_c('div',{staticClass:"center"},[_c('a',{staticClass:"btn_cta fw-bold f-anti f-17 ls-1",attrs:{"target":"_blank","rel":"noopener","href":"https://go.monito.com/transferwise-borderless?utm_campaign=ABTestBankUK_legacy&utm_source=internal&utm_medium=internal&utm_content=hero_widget_cta&link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3Aukaccount%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com%252Fgb%252Fborderless%252F"}},[_vm._v("Take me to TransferWise")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"should_content bad mt-4"},[_c('h3',{staticClass:"mb-2"},[_vm._v("What you should avoid")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("Avoid opening an account at a high-street bank, even if you have proof of residency we still belive its a much less convenient way to do banking while you're living abroadin the UK.")]),_c('p',{staticClass:"f_body"},[_vm._v("An online bank (like the ones we're compared below) is your best option to be in full control of the multiple currencies you have.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_vm._v("If you want to open a bank-like UK account without proof of address, "),_c('a',{attrs:{"href":"https://go.monito.com/transferwise-borderless?utm_campaign=ABTestBankUK&utm_source=internal&utm_medium=internal&utm_content=main_content&link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3Aukaccount%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com%252Fgb%252Fborderless%252F"}},[_vm._v("TransferWise")]),_vm._v(", "),_c('a',{attrs:{"href":"https://www.monito.com/en/send-money-with/monese?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk\n &utm_content=main_content"}},[_vm._v("Monese")]),_vm._v(", "),_c('a',{attrs:{"href":"https://www.monito.com/en/send-money-with/revolut?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk\n &utm_content=main_content"}},[_vm._v("Revolut")]),_vm._v(" and "),_c('a',{attrs:{"href":"https://monzo.com/blog/2018/09/07/open-a-uk-bank-account?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk\n &utm_content=main_content"}},[_vm._v("Monzo")]),_vm._v(" are a few online services that will set up a UK account without proof of residency. All offer UK account numbers and sort codes as well as debits cards you can use in retailers or to pay for items online. Keep in mind that local withdrawals may come with limitations or costs. However, if you want more flexibility, most of them offers the option to upgrade to fee-based accounts with higher limits and more features. If you’re having trouble deciding which is best for you, "),_c('a',{attrs:{"href":"https://www.monito.com/en/wiki/monese-vs-monzo?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk\n &utm_content=main_content"}},[_vm._v("Monzo versus Monese")]),_vm._v(", here’s a round-up of what each offer. Note that even though you don’t have to submit a proof of address, you’ll still need to supply a UK address–this is also where your debit card will be delivered.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_c('a',{attrs:{"href":"https://www.monito.com/en/send-money-with/transferwise-borderless?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk\n &utm_content=main_content"}},[_vm._v("TransferWise Borderless")]),_vm._v(" Account and card let you pay and get paid like a local in the UK. After opening your account online, you'll need to verify your identity through their interface. If you don't have a proof of address yet, here's what "),_c('a',{attrs:{"href":"https://go.monito.com/transferwise-borderless?link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3AAA%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com%252Fgb%252Fblog%252Fhow-to-get-proof-of-address-uk"}},[_vm._v("TransferWise says")]),_vm._v(": \"You can then choose to either supply a proof of address from a standard list of documents, or to send in a selfie, in which you’re holding your proof of ID. This can be a great alternative, if you’re still waiting to move to the UK, or haven’t yet got bills and other paperwork registered in your name.\"")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"f_body"},[_c('li',[_vm._v("Local bank details in the US, Eurozone, UK, Australia, New Zealand and Poland to get paid like a local. ")]),_c('li',[_vm._v("An account to hold up to 40 currencies free and great rates to convert between them.")]),_c('li',[_vm._v("A multi-currency Mastercard debit card great for paying in foreign currencies without the hidden fees")]),_c('li',[_vm._v("Access to TransferWise's powerful international money transfer service right from your account balance.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"f_body",staticStyle:{"list-style-type":"lower-roman"}},[_c('li',[_vm._v(" send EURO from your regular account to your TransferWise Euro account for free")]),_c('li',[_vm._v("convert all or part of it to GBP for a low fee (0.41% or a £4.08 to convert 1,000 EUR to GBP)")]),_c('li',[_vm._v("pay with your TransferWise Debit card, set-up direct debit with UK provider to pay your bills or make a local transfer for free (to pay rent for example)"),_c('br'),_c('br'),_vm._v("You'll also have UK bank details to share with an employer. ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_c('a',{attrs:{"target":"_blank","rel":"noopener","href":"https://go.monito.com/monese"}},[_vm._v("Monese")]),_vm._v(" is an entirely mobile bank, enabling you to do everything from the Monese app. You can also transfer money into 15 different currencies (including Euros and US Dollars) at the standard "),_c('a',{attrs:{"href":"https://www.monito.com/en/wiki/mid-market-exchange-rate?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk\n &utm_content=main_content"}},[_vm._v("mid-market exchange rate")]),_vm._v(". It’s is a handy feature if you need to send money overseas or pay bills (say a mortgage) abroad. They offer three types of current accounts:")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"f_body"},[_c('li',[_c('strong',[_vm._v("Simple: ")]),_vm._v("If you want to limit the up-front costs, go for the Starter account. It’s a full UK current account with no monthly costs and includes a free debit card, but they charge £1 per withdrawal from UK ATMs and a 2% fee on foreign currency exchange transfers.")]),_c('li',[_c('strong',[_vm._v("Classic:")]),_vm._v(" Plus accounts cost £5.95 per month and allow up to 6 free UK ATM withdrawals per month, after that they cost £1 each until the end of the month. Foreign currency exchange transfers incur a 0.5% fee. As with the Starter account, it’s a full UK account with a free debit card.")]),_c('li',[_c('strong',[_vm._v("Premium:")]),_vm._v(" Premium accounts cost £14.95 per month and unlimited UK ATM withdrawals per month and free foreign currency exchange transfers. Again, it’s a full UK account with a free debit card.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_c('a',{attrs:{"target":"_blank","rel":"noopener","href":"https://monzo.com/?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk\n &utm_content=main_content"}},[_vm._v("Monzo")]),_vm._v(" is also a mobile bank that includes a full UK current account and debit card, with everything controlled via their app. They allows up to £200 per month in free withdrawals in both the UK and abroad–after that you’ll be slapped with a 3% fee for each withdrawal you make until the end of the month. Paying with your debit card is free though, including when you are abroad, which is a great perk. Unlike Monese, Monzo only offers one type of account."),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_c('a',{attrs:{"href":"https://www.monito.com/en/send-money-with/revolut?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk\n &utm_content=main_content"}},[_vm._v("Revolut ")]),_vm._v("is a digital banking alternative that enables opening a UK current account without proof of residency plus a debit card.  You can also transfer at the standard "),_c('a',{attrs:{"href":"https://www.monito.com/en/wiki/mid-market-exchange-rate"}},[_vm._v("mid-market exchange rate")]),_vm._v(" and hold money in over 20 currencies.  They offer several types of accounts:")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"f_body"},[_c('li',[_c('strong',[_vm._v("Standard: ")]),_vm._v("With zero up-front costs, the Standard option offers a full UK current (plus an IBAN) account with no monthly costs and includes a free debit card, but they charge no fee UK ATM withdrawals up to £200 per month, after that it costs 2% of value of the ATM withdrawal.")]),_c('li',[_c('strong',[_vm._v("Premium:")]),_vm._v(" Premium accounts cost £6.99 per month including a debit card and they charge no fee UK ATM withdrawals up to £400 per month, after that it costs 2% of value of the ATM withdrawal.")]),_c('li',[_c('strong',[_vm._v("Metal:")]),_vm._v(" Metal accounts cost £12.99 per month including a debit card and they charge no fee UK ATM withdrawals up to £600 per month, after that it costs 2% of value of the ATM withdrawal.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_vm._v("If merely thinking about all of the above options makes you lose your marbles, check out "),_c('a',{attrs:{"target":"_blank","rel":"noopener","href":"https://www.1stcontact.com/kickstart/bank-account?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk\n &utm_content=main_content"}},[_vm._v("1st Contact")]),_vm._v(". The company has relationships with several traditional banks including Lloyds and HSBC and facilitates an introduction to the banks, enabling you to open a UK bank account without the usual proof of residency documents like a utility bill. "),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_c('strong',[_vm._v("1stContact")]),_vm._v(" offers several packages which includes:")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"f_body"},[_c('li',[_c('strong',[_vm._v("UK bank account only:")]),_vm._v(" If you just want to open a UK bank account, you can pay "),_c('strong',[_vm._v("£25 ")]),_vm._v("and get a UK bank account without proof of residency. You just have to provide a valid passport, proof of permission to live and work in the UK, a residential address where you can receive post (this can be a friend or relative you are staying with, you don’t need a utility bill), be 18 or older and able to attend an appointment in London with one of their banking affiliates.")]),_c('li',[_c('strong',[_vm._v("Kickstart Classic UK package:")]),_vm._v(" if you would like UK bank account plus, various bells and whistles, go for the Kickstart package for "),_c('strong',[_vm._v("£35")]),_vm._v(". It includes a bank account, a UK mobile phone SIM, guides to living and working in the UK, a DIY help guide that may provide assistance obtaining a National Insurance (NI) number, help creating a CV, and a free international money transfer, a 5 day gym membership, accommodation assistance and tour discount vouchers. ")]),_c('li',[_c('strong',[_vm._v("Tier5 Visa Kickstart package:")]),_vm._v(" If you want all of the above (including a UK bank account) PLUS help applying for a Tier 5 youth mobility scheme Visa (which replaced the previous UK working holvisa programme), go for this one, which according to 1stContact “allows people between the ages of 18 and 30, from participating countries, to live and work in the UK for two years.” It’s only available to citizens of certain countries (including Australia, New Zealand and Canada).")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_vm._v("Banks and financial institutions, according to the "),_c('a',{attrs:{"href":"https://www.monito.com/en/wiki/financial-crimes-enforcement-network-fincen?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk\n &utm_content=main_content"}},[_vm._v("Money Laundering")]),_vm._v(" Regulations 2017, are required to ask for appropriate Identity Evidence when certain financial transactions take place. "),_c('a',{attrs:{"href":"https://www.gov.uk/government/publications/proof-of-identity-checklist/proof-of-identity-checklist?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk\n &utm_content=main_content"}},[_vm._v("Source Gov.uk")]),_vm._v(" By checking your ID (name) and a proof of address at your name, this minimizes the chance that the account is opened under a false identity. ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"f_body"},[_c('li',[_vm._v("Utility bill, such as electric, satellite, television, landline or gas bill that have been issued in the last three month. Note that a mobile phone bill will not be accepted.")]),_c('li',[_vm._v("Local authority council tax bill for the current council tax year")]),_c('li',[_vm._v("Current UK driving licence")]),_c('li',[_vm._v("Bank, Building Society or Credit Union statement or passbook dated within the last three months")]),_c('li',[_vm._v("Mortgage statement (issued for the last full year)")]),_c('li',[_vm._v("Solicitors letter within the last three month confirming the property purchase (or the land registry confirmation of adress)")]),_c('li',[_vm._v("Council or housing association rent card or tenancy agreement for the current year")]),_c('li',[_vm._v("HMRC self-assessment letters or tax demand dated within the current financial year")]),_c('li',[_vm._v("Electoral Register entry")]),_c('li',[_vm._v("NHS Medical card or letter of confirmation from GP’s practice of registration with the surgery")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_vm._v("According to the "),_c('a',{attrs:{"href":"https://www.monito.com/en/wiki/uk-financial-conduct-authority-fca?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk\n &utm_content=main_content"}},[_vm._v("Financial Conduct Authority (FCA)")]),_vm._v(", if you're unable to provide these documents, you can ask if they accept the following documents:")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"f_body"},[_c('li',[_vm._v("a letter from a care home manager or warden of sheltered accommodation or a refuge")]),_c('li',[_vm._v("a letter from the warden of a homeless shelter")]),_c('li',[_vm._v("a letter from a probation officer or a hostel manager")]),_c('li',[_vm._v("a letter from a prison governor")]),_c('li',[_vm._v("if you are a traveller, a letter from the local authority that verifies your address")]),_c('li',[_vm._v("if you are an international student, a passport or European Economic Area National Identity Card and letter of acceptance or of introduction from a body on the Department for Education list, or")]),_c('li',[_vm._v("if you are an asylum seeker, an application registration card")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_c('a',{attrs:{"href":"https://www.fca.org.uk/consumers/opening-bank-account?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk\n &utm_content=main_content"}},[_vm._v("https://www.fca.org.uk/consumers/opening-bank-account")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aside_widget"},[_c('div',{staticClass:"title fs-20 pl-1 pr-1 ls-1 f-anti"},[_vm._v("💡 Monito's Tip: Open a TransferWise Borderless Account\n")]),_c('p',{staticClass:"fs-17 lh-4 f-anti fw-medium pl-2 pr-2 pt-4"},[_vm._v("Just arrived in the UK or planning to move soon?"),_c('br'),_vm._v(" Do you need to pay or get paid like a local but can't open a bank account without proof of address?")]),_c('p',{staticClass:"fs-17 lh-4 f-anti fw-medium pl-2 pr-2 pt-4 mb-5"},[_vm._v("Open a "),_c('a',{attrs:{"target":"_blank","rel":"noopener","href":"https://go.monito.com/transferwise-borderless?utm_campaign=ABTestBankUK&utm_source=internal&utm_medium=internal&utm_content=hero_widget&link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3Aukaccount%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com%252Fgb%252Fborderless%252F"}},[_vm._v("TransferWise Borderless Account online")]),_vm._v(" and get UK bank details, a multi-currency account and a debit Mastercard.")]),_c('a',{staticClass:"btn_cta fw-bold f-anti f-19 ls-1",attrs:{"target":"_blank","rel":"noopener","href":"https://go.monito.com/transferwise-borderless?utm_campaign=ABTestBankUK&utm_source=internal&utm_medium=internal&utm_content=hero_widget&link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3Aukaccount%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com%252Fgb%252Fborderless%252F"}},[_vm._v("Open your account now")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aside_widget mb-4"},[_c('div',{staticClass:"should excellent"},[_c('p',[_c('span',[_vm._v("What you should do")]),_c('b',[_vm._v("Take your banking 100% online with TransferWise.")]),_vm._v(" Most high-street banks won't allow you to open a bank account without a proof of residency, so we recommend going with the best online solution who will, like TranserWise Borderless account.")]),_vm._v(" "),_c('a',{staticClass:"btn_cta fw-bold f-anti f-19 ls-1",attrs:{"target":"_blank","rel":"noopener","href":"https://go.monito.com/transferwise-borderless?utm_campaign=ABTestBankUK_legacy&utm_source=internal&utm_medium=internal&utm_content=hero_widget_cta&link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3Aukaccount%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com%252Fgb%252Fborderless%252F"}},[_vm._v("Take me to TransferWise")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"should bad"},[_c('p',[_c('span',[_vm._v("What you should avoid")]),_c('b',[_vm._v("Don’t go with a high-street bank,")]),_vm._v(" most won’t allow you to open a bank account without a proof of residency and are all around more expensive.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BureauChange_vue__ = __webpack_require__(72);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_280b8546_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BureauChange_vue__ = __webpack_require__(221);
function injectStyle (ssrContext) {
  __webpack_require__(219)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BureauChange_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_280b8546_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BureauChange_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(220);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("55b1d590", content, true, {});

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "main{position:relative;z-index:10000;margin-top:-290px}@media (max-width:768px){main{margin-top:-170px}}@media (max-width:500px){main{margin-top:-150px}}.scroller{width:352px;box-sizing:border-box;position:absolute;right:0;top:232px}.scroller.article_content{top:232px}.scroller.article_content .aside_widget{padding:0}.scroller.article_content h4{color:#676767}.article_content ul{list-style:none;padding-left:0;margin-left:0}.article_content ul li{padding:12px 50px;color:#353c45;cursor:pointer;transition:all .2s ease}.article_content ul li a{background:#0cc3ca;text-align:center}.article_content ul li a:hover{background:#17d5dc}.article_content ul li a.hide{display:none!important}.article_content ul li a.anime{animation-name:apparition_btn_cta;animation-duration:1s;position:relative}@keyframes apparition_btn_cta{0%{bottom:-10px;opacity:0}to{bottom:0;opacity:1}}.article_content ul li:hover{background:#D3F5F560}.article_content ul li.active{background:#d3f5f5;color:#004660;position:relative;padding-top:24px;padding-bottom:24px;cursor:default}.article_content ul li.active:after{content:\"\";width:0;height:0;border-top:35px solid transparent;border-bottom:37px solid transparent;border-right:14px solid #d3f5f5;left:-14px;top:calc(50% - 35px);position:absolute}@media (max-width:768px){body{overflow:scrollY}body,main{width:100%}main h1{text-align:center}.scroller{width:90%;margin-left:5%;position:relative!important;top:0}}", ""]);

// exports


/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',[_c('app-navigation',[_c('h1',{attrs:{"id":"logo_monito"}},[_c('a',{attrs:{"href":"https://monito.com?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=nav"}},[_vm._v("Monito")])]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"https://www.monito.com/en/about-monito?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=nav"}},[_vm._v("À propos")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.monito.com/en/wiki/monito-account?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=nav"}},[_vm._v("Alerts")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.monito.com/en/wiki?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=nav"}},[_vm._v("Wiki")])]),_vm._v(" "),_c('li',{staticClass:"langage"},[_c('a',{attrs:{"href":"#"}},[_vm._v("FR")])])])]),_vm._v(" "),_c('app-hero-section',{attrs:{"urlBackground":_vm.urlBackground,"herotype":_vm.herotype}})],1),_vm._v(" "),_c('main',{ref:"main"},[_c('section',{ref:"scroll_zone"},[_c('section',{staticClass:"\n      boxed \n      pt-57 pl-7 pr-7 pb-10\n      pl-lg-5 pr-lg-5 pb-lg-8\n      pl-sm-2 pr-sm-2 pb-sm-7 \n      mt-5 mb-5"},[_c('div',{staticClass:"color"}),_vm._v(" "),_c('div',{staticClass:"cover",staticStyle:{"background-image":"url('https://images.prismic.io/monito/16e68983d8b5a2c477b6ca8c091e056af6ca6076_32493215220_47d9497750_k.jpg?auto=compress,format')"}}),_vm._v(" "),_c('h1',{staticClass:"f_title mt-5 mb-7 mt-2-sm mb-sm-6",attrs:{"id":"anchor01"}},[_vm._v("Bureau de change à Paris: où trouver le meilleur taux?")]),_vm._v(" "),_c('widget-author',{staticClass:"mb-6 mt-3"},[_c('div',{staticClass:"portrait"},[_c('span',{staticClass:"image",staticStyle:{"background-image":"url('https://images.prismic.io/monito%2F7924bad3-5587-466e-8147-b095f0bb33f3_francois+profile+picture.jpg?auto=compress,format&rect=0,105,1401,1401&w=200&h=200')"}}),_vm._v(" "),_c('p',{staticClass:"name pt-sm-2"},[_c('span',[_vm._v("Écrit par")]),_c('a',{attrs:{"href":"https://www.monito.com/en/wiki/francois-briod?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=main_content"}},[_vm._v("François Briod")])]),_vm._v(" "),_c('p',{staticClass:"pb-sm-3 update"},[_c('span',[_vm._v("Mis à jour")]),_vm._v("29 mai 2019")])]),_vm._v(" "),_c('p',{staticClass:"bio mt-2 mb-2 ls-2 pl-sm-1 fw-medium mb-sm-3 f-anti"},[_vm._v("Co-fondateur et PDG de Monito, et possède plus de six années d’expérience dans la FinTech et le secteur des Transferts d’Argent.")])]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("Vous êtes de visite à Paris ou dans les derniers préparatifs d’une escapade à l’étranger ? Qu’on vienne d’arriver dans la ville ou qu’on soit sur le départ, la question du change de devise revient régulièrement !")]),_vm._v(" "),_c('div',{ref:"anchor02",staticClass:"f_body tips",attrs:{"id":"anchor02"}},[_vm._m(0),_c('br'),_vm._v("Les cartes multi-devises permettent de payer à l'étranger et retirer des devises étrangères à des meilleurs taux que les bureaux de change. Il est aussi possible d'acheter des devises en ligne meilleur marché.\n\n        "),_vm._m(1)]),_vm._v(" "),_c('h2',{staticClass:"f_subtitle_1"},[_vm._v("Trouver le meilleur bureau de change : une histoire de devise")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("Trouver le meilleur bureau de change veut souvent dire trouver celui qui offre le meilleur taux. Si vous allez aux Etats Unis par exemple, vous pourrez y échanger vos euros contre des dollars. L’affaire pourrait être simple mais les choses se corsent lorsqu’on comprend que chaque bureau de change applique des taux de changes différents et donc des commissions différentes. En effet, il est rare qu’ils s’alignent sur le taux moyen du marché (celui qu’on trouve sur Google par exemple).")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("Ajoutons à cela que les devises changent de valeurs tous les jours - 1 euro peut valoir 0,97 dollar et passer à 0,90 dollar le lendemain !  Le taux de change de devise évolue donc en permanence.")]),_vm._v(" "),_c('h3',{staticClass:"f_subtitle_1"},[_vm._v("Le bureau de change sans commission existe-t-il ?")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("Nombreux sont les établissements bancaires qui proclament fièrement faire des offres sans commissions. Néanmoins, restez vigilant ! S’ils n’appliquent peut-être pas de frais supplémentaires, cela ne les empêche pas d’échanger vos devises à un taux moins favorable que celui avec lequelles ils se fournissent, la différence restant dans leur poche. Vous vous êtes jamais demandé pourquoi les bureaux de changes pouvaient se permettre des vitrines dans des quartiers passants ou touristiques? Il n’y a pas de miracles, le bureau de change sans commission n’existe pas.")])],1),_vm._v(" "),_c('section',{staticClass:"\n      boxed \n      pt-4 pl-7 pr-7 pb-10\n      pl-lg-5 pr-lg-5 pb-lg-8\n      pl-sm-2 pr-sm-2 pb-sm-7 \n      mt-5 mb-5"},[_c('div',{staticClass:"color"}),_vm._v(" "),_c('h2',{ref:"anchor03",staticClass:"f_title mt-5 mb-7 mt-2-sm mb-sm-6",attrs:{"id":"anchor03"}},[_vm._v("Comment lire un tableau de change ?")]),_vm._v(" "),_c('p',{staticClass:"f_chapo"},[_vm._v("Si vous avez déjà observé un tableau de change, vous avez peut-être constaté qu’ils semblent bien compliqué à interpréter quand on ne sait pas comment les lire.")]),_vm._v(" "),_c('img',{staticClass:"mt-6 mt-6-sm",attrs:{"src":"https://images.prismic.io/monito/279c402d7ec422b749bd3724fe6509b858d7e00a_mvimg_20190603_154344.jpg?auto=compress,format"}}),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("Vous devez tout d’abord savoir si vous comptez acheter ou vendre une devise. En règle générale :")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("Mais l’histoire ne s’arrête pas là, ça serait trop simple. Il faut se mettre à la place du bureau de change pour lire le tableau. Si vous achetez des devises, c’est que le bureau vous les vends. Si vous achetez des dollars contre des euros, le bureau de change vous vends des devises étrangères contre des euros, il faut donc regarder le taux de vente.")]),_vm._v(" "),_c('h3',{staticClass:"f_subtitle_1"},[_vm._v("Où trouver un bureau de change à Paris ?")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("Imaginez-vous flâner dans les rues de Paris quand vous vient l’envie pressante de trouver un bureau de change à Montparnasse. Certes, vous aurez peut-être peu d’occasion de vouloir vous rendre dans un bureau de change sur un coup de tête, mais savoir où se trouvent les principaux établissements de la capitale vous aidera à anticiper vos échanges de devise.")])]),_vm._v(" "),_c('section',{staticClass:"\n      boxed \n      pt-4 pl-7 pr-7 pb-10\n      pl-lg-5 pr-lg-5 pb-lg-8\n      pl-sm-2 pr-sm-2 pb-sm-7 \n      mt-5 mb-5"},[_c('div',{staticClass:"color"}),_vm._v(" "),_c('h2',{ref:"anchor04",staticClass:"f_title mt-5 mb-7 mt-2-sm mb-sm-6",attrs:{"id":"anchor04"}},[_vm._v("Les principales agences de bureau de change à Paris")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("Dans Paris, vous pouvez trouver des bureaux de changes dans les agences suivantes :")]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('h2',{ref:"anchor05",staticClass:"f_subtitle_1",attrs:{"id":"anchor05"}},[_vm._v("Comment comparer les taux de change et trouver le meilleur?")]),_vm._v(" "),_vm._m(4),_c('p',{staticClass:"f_chapo"},[_vm._v("“Bonjour, je pars aux États-Unis la semaine prochaine, j'aimerai acheter 500 dollars, combien est-ce que cela me coûtera en Euros?“")]),_c('p',{staticClass:"f_body"},[_vm._v("De même, nous avons demandé à Google ce que 500 dollars coûtent en euros pour comparer.")]),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('label',{staticClass:"ls-1 mb-2-sm fw-demi-bold f6"},[_vm._v("Comparaison de taux de change de bureaux Parisiens - 06.06.19")]),_vm._v(" "),_c('h2',{ref:"anchor06",staticClass:"f_subtitle_1",attrs:{"id":"anchor06"}},[_vm._v("Verdict?")]),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_c('h3',{staticClass:"f_subtitle_2"},[_vm._v("Pas le temps d’aller dans un bureau de change à Paris ? Découvrez la livraison !")]),_vm._v(" "),_c('p',{staticClass:"f_chapo"},[_vm._v("Dans certains cas, il est possible d’accéder à des services de livraison à domicile. Bien pratique si vous ne pouvez pas vous déplacer en agence pour récupérer vos devises !")]),_vm._v(" "),_vm._m(11),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("Cette option est disponible pour tout achat de valeur à partir de 300 euros et le service de livraison coûte 21 euros.")])])]),_vm._v(" "),_c('aside',{ref:"scroll_widgets",staticClass:"scroller article_content"},[_c('div',{staticClass:"aside_widget"},[_c('h4',{staticClass:"fw-demi-bold fs-16 pt-4 pb-1 "},[_vm._v("Un petit saut dans l'article ?")]),_vm._v(" "),_c('ul',{staticClass:"fw-demi-bold f-anti fs-16 pb-3"},[_c('li',{staticClass:"active",on:{"click":function($event){return _vm.anchor01()}}},[_vm._v("Introduction")]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.anchor02()}}},[_vm._v("Notre recommandation "),_vm._m(12)]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.anchor03()}}},[_vm._v("Comment lire un tableau de change ?")]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.anchor04()}}},[_vm._v("Les principales agences de bureau de change à Paris")]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.anchor05()}}},[_vm._v("Comment comparer les taux de change et trouver le meilleur?")]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.anchor06()}}},[_vm._v("Verdict")])])])])]),_vm._v(" "),_c('widget-faq',[_c('ul',{staticClass:"shadow"},[_c('li',[_c('h3',[_vm._v("Which company offers a bank account in the UK if I don't have the proof of address? 🏦")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("There are few companies that offer a bank account in the UK, even when you don't have a proof of address in the UK. With Monzo or Monese, you can open a UK bank account with just a few clicks. All the details about "),_c('a',{attrs:{"target":"_blank","rel":"noopener","href":"https://www.monito.com/en/wiki/open-bank-account-uk-even-without-proof-residency?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=FAQ"}},[_vm._v("opening a bank account in the UK without the proof of address")]),_vm._v(", you will find in our blog post. ")])]),_vm._v(" "),_c('li',[_c('h3',[_vm._v("What is the best UK bank accout for non residents?")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("Expats moving to the UK 🇬🇧might find it difficult to open a traditional bank account. To open a bank account, you need a proof of address, which might be hard to get if you are a non-resident. Good news is that companies liked Monzo or Monese offer a UK bank account without proof of address. You can have a UK bank account with just a few clicks. "),_c('a',{attrs:{"target":"_blank","rel":"noopener","href":"https://www.monito.com/en/wiki/open-bank-account-uk-even-without-proof-residency?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=FAQ"}},[_vm._v("More info about UK bank account for non-residents you will find in our blog post")]),_vm._v(".")])]),_vm._v(" "),_c('li',[_c('h3',[_vm._v("Is it possible to have Euro bank account in the UK? 💶")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("Some UK banks offer bank account in Euro. However, the fees for such accounts are quite high. But we have good news - there is a possibility to open a bank account in Euro for free. Check out our "),_c('a',{attrs:{"target":"_blank","rel":"noopener","href":"https://www.monito.com/en/wiki/open-bank-account-uk-even-without-proof-residency?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=FAQ"}},[_vm._v("blog post about opening a bank account in the UK without proof of address")]),_vm._v(" and get a free UK bank account in Euro. ")])]),_vm._v(" "),_c('li',[_c('h3',[_vm._v("What documents do I need to open a bank account in the UK? 📄  ")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("To open a UK bank account, you generally need two things:"),_c('br'),_vm._v("1️. Proof of your identity - passport, drivers license, or national identity card. In general, if you are a foreign national, your best bet is to use your passport."),_c('br'),_vm._v("2. Proof of the address in the UK. It can be a recent utility bill, rental contract, council tax bill. Mobile phone bills are generally not accepted. "),_c('br'),_c('br'),_vm._v("If you don't have a proof of address, have a look at our "),_c('a',{attrs:{"target":"_blank","rel":"noopener","href":"https://www.monito.com/en/wiki/open-bank-account-uk-even-without-proof-residency?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=FAQ"}},[_vm._v("blog post about opening a bank account in the UK")]),_vm._v(". ")])]),_vm._v(" "),_c('li',[_c('h3',[_vm._v("Can a foreigner open a bank account in the UK? 🇬🇧")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("Foreigners can open a traditional bank account in the UK as long as they have proof of the address, which sometimes it's hard to get. Good news is that there are companies like Monzo or Monese which offer UK bank account even without the proof of the address. All the information about "),_c('a',{attrs:{"target":"_blank","rel":"noopener","href":"https://www.monito.com/en/wiki/open-bank-account-uk-even-without-proof-residency?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=FAQ"}},[_vm._v("opening a bank account in the UK you will find in our blog post")]),_vm._v(". ")])])])]),_vm._v(" "),_c('widget-articles',{attrs:{"articles":_vm.articles}},[_c('h1',{staticClass:"fs-28 fw-bold f-anti mb-9 mb-sm-4 mt-sm-4"},[_vm._v("This might interest you too")])]),_vm._v(" "),_c('app-footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticStyle:{"text-align":"center","display":"block","margin":"0"}},[_vm._v("Notre recommandation : "),_c('b',[_vm._v("optez pour une carte mutli-devises. ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cta"},[_c('a',{staticClass:"btn_cta fw-bold f-anti f-19 ls-1",attrs:{"target":"_blank","rel":"noopener","href":"https://go.monito.com/transferwise-borderless?utm_campaign=ABTestBankUK&utm_source=internal&utm_medium=internal&utm_content=hero_widget&link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3Aukaccount%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com%252Fgb%252Fborderless%252F"}},[_vm._v("Utilisez notre outil de comparaison de cartes")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"f_body"},[_c('li',[_vm._v("si vous êtes en France et que vous voulez échanger vos euros contre une monnaie étrangère, on dira que vous achetez une devise.")]),_vm._v(" "),_c('li',[_vm._v("si vous vous êtes en France mais que vous voulez avoir des euros contre des dollars, parce que vous revenez de voyage par exemple, alors vous serez en train de vendre des  devises.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',[_c('p',[_vm._v("Nom")])]),_c('th',[_c('p',[_vm._v("Adresse")])]),_c('th',[_c('p',[_vm._v("Numéro de téléphone")])])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_c('b',[_vm._v("Travelex Paris")])]),_c('td',[_c('p',[_vm._v("125, av des Champs-Elysées PARIS 75008")])]),_c('td',[_c('p',[_vm._v("01 47 20 25 14")])])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("Change de la Bourse")])]),_c('td',[_c('p',[_vm._v("28 rue Vivienne, 75002 Paris")])]),_c('td',[_c('p',[_vm._v("01 40 28 11 11")])])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("Comptoir Change Opéra")])]),_c('td',[_c('p',[_vm._v("9 Rue Scribe, 75009 Paris")])]),_c('td',[_c('p',[_vm._v("01 47 42 20 96")])])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("CEN Change Dollar ")])]),_c('td',[_c('p',[_vm._v("70 Boulevard de Strasbourg, 75010 Paris")])]),_c('td',[_c('p',[_vm._v("01 40 05 07 11")])])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("Change Magenta")])]),_c('td',[_c('p',[_vm._v("77 Boulevard de Magenta, 75010 Paris")])]),_c('td',[_c('p',[_vm._v("01 42 46 56 93")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_vm._v("Il suffit de poser la question à chaque bureau et comparer avec le vrai taux de change du marché que l'on trouve sur des sites comme "),_c('a',{attrs:{"target":"_blank","rel":"noopener","href":"https://www.google.fr/search?q=500+usd+en+euros&oq=500+usd+en+euros"}},[_vm._v("Google")]),_vm._v(", "),_c('a',{attrs:{"href":"https://www.xe.com/currencyconverter/convert/?Amount=500&From=USD&To=EUR"}},[_vm._v("XE.com")]),_vm._v(" ou "),_c('a',{attrs:{"target":"_blank","rel":"noopener","href":"https://www.monito.com/meilleurs-taux-change/usd/eur"}},[_vm._v("Monito")]),_vm._v(". Vu que ça peut prendre un peu de temps, on a voulu vous faciliter la tâche chez Monito et nous avons fait une comparaison pour vous. Voici la question que nous avons posé à 5 bureaux de change Parisiens:")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',[_c('p',[_vm._v("Nom")])]),_c('th',[_c('p',[_vm._v("Coût de 500 US Dollars en Euros")])]),_c('th',[_c('p',[_vm._v("Commissions Cachée (%)")])]),_c('th',[_c('p',[_vm._v("Commissions Cachée (€)")])])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_c('b',[_vm._v("Taux sur Google")])]),_c('td',[_c('p',[_vm._v("442.78€")])]),_c('td',[_c('p',[_vm._v("0%")])]),_c('td',[_c('p',[_vm._v("0€")])])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("Travelex Champs Élysées")])]),_c('td',[_c('p',[_vm._v("531€")])]),_c('td',[_c('p',[_vm._v("16.6%")])]),_c('td',[_c('p',[_vm._v("88.22€")])])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("Comptoir Change Opéra")])]),_c('td',[_c('p',[_vm._v("470€")])]),_c('td',[_c('p',[_vm._v("5.79%")])]),_c('td',[_c('p',[_vm._v("27.22€")])])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("Multi Change")])]),_c('td',[_c('p',[_vm._v("467€")])]),_c('td',[_c('p',[_vm._v("5.25%")])]),_c('td',[_c('p',[_vm._v("24.52€")])])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("Change de la Bourse")])]),_c('td',[_c('p',[_vm._v("453€")])]),_c('td',[_c('p',[_vm._v("2.32%")])]),_c('td',[_c('p',[_vm._v("10.52€")])])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("CEN Change Dollar ")])]),_c('td',[_c('p',[_vm._v("452.50€")])]),_c('td',[_c('p',[_vm._v("2.15%")])]),_c('td',[_c('p',[_vm._v("9.71€")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_chapo"},[_c('b',[_vm._v("CEN Change Dollar")]),_vm._v(" offre le meilleur taux pour acheter 500$ dans un bureau de change à Paris, mais cela reste une opération qui coûte pas loin de 10€, ce qui représentera plusieurs burgers lors de mon futur voyage aux USA.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_c('b',[_vm._v("Travelex Champs Élysées")]),_vm._v(" de son côté offre les services de change les plus onéreux. C'est 16% des 531€ payés à Travelex qui iront directement dans leur poche, avant qu'ils vous rendent 500$. Choqué, nous avons rappelé après avoir fait la comparaison pour s'assurer qu'il ne s'agissait pas d'une erreur et la personne au téléphone nous a confirmé les chiffrs et a ajouté que le taux sur Google n'était \"accessible que pour les banquiers de Wall Street\". Ce qui est complétement faux, comme vous allez le découvrir.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_vm._v("On constate également que "),_c('a',{attrs:{"href":"https://www.monito.com/fr/wiki/achats-de-devises-en-ligne-ou-trouver-le-meilleur-taux"}},[_vm._v("Travelex en ligne")]),_vm._v(" prend néanmoins moins de commission que  les agences Travelex physiques (5.7% de commissions en ligne vs 15-20% dans les agences de Lyon ou Paris "),_c('a',{attrs:{"href":"https://admin.monito.com/fr/wiki/bureau-de-change-a-paris-ou-trouver-le-meilleur-taux"}}),_vm._v("pour le même échange)!")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_vm._v("De manière générale, la conversion des devises en agence peut vite coûter très cher comme l'a démontré notre comparaison. Au lieu d’acheter des billets en devises étrangères avant votre prochain voyage, pensez à commander une carte multi-devise comme les offres proposées par "),_c('a',{attrs:{"target":"_blank","rel":"noopener","href":"https://go.monito.com/N26"}},[_vm._v("N26")]),_vm._v(", "),_c('a',{attrs:{"target":"_blank","rel":"noopener","href":"https://go.monito.com/monese"}},[_vm._v("Monese")]),_vm._v(", "),_c('a',{attrs:{"target":"_blank","rel":"noopener","href":"https://www.monito.com/fr/wiki/carte-bancaire-transferwise-pourquoi-nous-ladorons"}},[_vm._v("TransferWise ")]),_vm._v("ou "),_c('a',{attrs:{"target":"_blank","rel":"noopener","href":"https://www.monito.com/fr/transferer-avec/revolut"}},[_vm._v("Revolut")]),_vm._v(". Ces dernières permettent d’effectuer des retraits ou des paiement en devise étrangère avec le taux du marché et des commissions bien plus faibles que les bureaux de changes à Paris ou ailleurs ! Leur fonctionnement est très simple, il suffit d'alimenter la carte pré-payée avec un transfert bancaire ou sa carte bleue en Euro, et ensuite on peut payer et retirer de l'argent lors de sont voyage à moindre frais.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_vm._v("Découvrez "),_c('a',{attrs:{"href":"https://www.monito.com/fr/wiki/comparatif-cartes-bancaires-sans-frais-a-l-etranger"}},[_vm._v("notre comparatif des meilleures cartes bancaires à utiliser à l'étranger.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_vm._v("Il suffit d’acheter vos devises en ligne sur un site comme celui de "),_c('a',{attrs:{"href":"https://www.ccopera.com/"}},[_vm._v("Comptoir Change Opéra.")]),_vm._v(" Dans les 24h à 72h ouvrés, vous recevrez vos devises dans une emballage cartonné, sécurisé et neutre dont le format répond aux normes en vigueur. ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn_cta hide fw-bold f-anti f-19 ls-1",attrs:{"target":"_blank","rel":"noopener","href":"https://go.monito.com/transferwise-borderless?utm_campaign=ABTestBankUK&utm_source=internal&utm_medium=internal&utm_content=hero_widget&link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3Aukaccount%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com%252Fgb%252Fborderless%252F"}},[_vm._v("Comparer les cartes "),_c('br'),_vm._v("mutli-devices")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReducePaypal_vue__ = __webpack_require__(73);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b51d1ee8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReducePaypal_vue__ = __webpack_require__(225);
function injectStyle (ssrContext) {
  __webpack_require__(223)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReducePaypal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b51d1ee8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReducePaypal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(224);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("77647690", content, true, {});

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "header .hero_element{margin-top:-242px!important}.bg-transition{display:none}main{position:relative;z-index:10000;margin-top:-190px}@media (max-width:768px){main{margin-top:-170px}}@media (max-width:500px){main{margin-top:-150px}}.scroller{width:352px;box-sizing:border-box;position:absolute;right:0;top:132px}.scroller.article_content{top:558px}.scroller.article_content .aside_widget{padding:0}.scroller.article_content h4{color:#676767}.article_content ul{list-style:none;padding-left:0;margin-left:0}.article_content ul li{padding:12px 50px;color:#353c45;cursor:pointer;transition:all .2s ease}.article_content ul li a{background:#0cc3ca;text-align:center}.article_content ul li a.hide{display:none!important}.article_content ul li a:hover{background:#17d5dc}.article_content ul li a.anime{animation-name:apparition_btn_cta;animation-duration:1s;position:relative}@keyframes apparition_btn_cta{0%{bottom:-10px;opacity:0}to{bottom:0;opacity:1}}.article_content ul li:hover{background:#D3F5F560}.article_content ul li.active{background:#d3f5f5;color:#004660;position:relative;padding-top:24px;padding-bottom:24px;cursor:default}.article_content ul li.active:after{content:\"\";width:0;height:0;border-top:35px solid transparent;border-bottom:37px solid transparent;border-right:14px solid #d3f5f5;left:-14px;top:calc(50% - 35px);position:absolute}@media (max-width:768px){header .hero_element{margin-top:-142px!important}.article_content{display:none}body{overflow:scrollY}body,main{width:100%}main header .hero_element{margin-top:-242px!important}.scroller{width:90%;margin-left:5%;position:relative!important;top:0}}", ""]);

// exports


/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',[_c('app-navigation',[_c('h1',{attrs:{"id":"logo_monito"}},[_c('a',{attrs:{"href":"https://monito.com?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=nav"}},[_vm._v("Monito")])]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"https://www.monito.com/en/about-monito?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=nav"}},[_vm._v("About us")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.monito.com/en/wiki/monito-account?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=nav"}},[_vm._v("Alerts")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.monito.com/en/wiki?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=nav"}},[_vm._v("Wiki")])]),_vm._v(" "),_c('li',{staticClass:"langage"},[_c('a',{attrs:{"href":"#"}},[_vm._v("EN")])])])]),_vm._v(" "),_c('app-hero-section',{attrs:{"urlBackground":_vm.urlBackground,"herotype":_vm.herotype}})],1),_vm._v(" "),_c('main',{ref:"main"},[_c('section',{ref:"scroll_zone"},[_c('section',{staticClass:"\n      boxed\n      pt-2 pl-7 pr-7 pb-10\n      pl-lg-5 pr-lg-5 pb-lg-8\n      pl-md-5 pr-md-5 pb-md-8\n      pl-sm-3 pr-sm-3 pb-sm-7 \n      mt-5 mb-5"},[_c('div',{staticClass:"color"}),_vm._v(" "),_c('h1',{ref:"anchor01",staticClass:"f_title mt-5 mb-7 mt-2-sm mb-sm-6",attrs:{"id":"anchor01"}},[_vm._v("How to reduce PayPal conversion fees & other tricks to save money when you exchange money")]),_vm._v(" "),_vm._m(0),_vm._v(" "),(false)?_c('div',{staticClass:"aside_widget"},[_vm._m(1)]):_vm._e(),_vm._v(" "),_c('widget-author',{staticClass:"mb-6 mt-3"},[_c('div',{staticClass:"portrait"},[_c('span',{staticClass:"image",staticStyle:{"background-image":"url('https://images.prismic.io/monito%2F7924bad3-5587-466e-8147-b095f0bb33f3_francois+profile+picture.jpg?auto=compress,format&rect=0,105,1401,1401&w=200&h=200')"}}),_vm._v(" "),_c('p',{staticClass:"name pt-sm-2"},[_c('span',[_vm._v("Written by")]),_c('a',{attrs:{"href":"https://www.monito.com/en/wiki/francois-briod?utm_source=internal?utm_source=internal&utm_medium=internal&utm_campaign=ABTestReducePaypal&utm_content=main_content"}},[_vm._v("François Briod")])]),_vm._v(" "),_c('p',{staticClass:"pb-sm-3 update"},[_c('span',[_vm._v("Last updated")]),_vm._v("April 16, 2020")])]),_vm._v(" "),_c('p',{staticClass:"bio mt-2 mb-2 ls-2 pl-sm-1 fw-medium mb-sm-3 f-anti"},[_vm._v("Co-Founder of Monito and money transfer expert, François has been helping Monito’s users navigate the jungle of money transfer fees, bad exchange rates and tricks for the last six years.")])]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('h2',{staticClass:"f_subtitle_1"},[_vm._v("The PayPal option: An example with eBay")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("Say you live in France and found an item on eBay from a seller in the US. The item is listed in US dollars. When you adding in international shipping")]),_vm._v(" "),_c('img',{staticClass:"mt-8 mb-8 mt-6-sm",attrs:{"src":"https://images.prismic.io/monito/e6050565c9edca37e69606c42b7089dc42d65303_ebaypaypal1.jpeg"}}),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("Below these details, PayPal offers you payment options. Say you decide to pay in Euros with your local Euro-currency card. You enter the details and PayPal displays the charge in Euros and the exchange rate.")]),_vm._v(" "),_c('img',{staticClass:"mt-8 mb-8 mt-6-sm",attrs:{"src":"https://images.prismic.io/monito/b116a01f8b9392d67bbaeb4955e7fdbe8a27dcf8_ebaypaypal2.jpeg"}}),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('img',{staticClass:"mt-8 mb-8 mt-6-sm",attrs:{"src":"https://images.prismic.io/monito/9f41a6c7ad6778accda28de0a8724bcf98b3fc16_ebaypaypal3-1.jpeg"}}),_vm._v(" "),_c('p',{staticClass:"f_chapo"},[_vm._v("If you switch this to the USD option, you’ll be charged at the currency conversion that your card issuer sets.")]),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("In this case, a few days later the charge came through as €190.20. So in this instance, we saved €5.12.")]),_vm._v(" "),_c('div',{ref:"anchor02",attrs:{"id":"anchor02"}},[_c('h3',{staticClass:"f_subtitle_1 mb-6"},[_vm._v("Monito’s experts recommendations")]),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8)])],1),_vm._v(" "),_c('section',{staticClass:"\n      boxed\n      pt-2 pl-7 pr-7 pb-10\n      pl-lg-5 pr-lg-5 pb-lg-8\n      pl-md-5 pr-md-5 pb-md-8\n      pl-sm-3 pr-sm-3 pb-sm-7 \n      mt-5 mb-0"},[_c('div',{staticClass:"color"}),_vm._v(" "),_c('h1',{staticClass:"f_title mt-5 mb-7 mt-2-sm mb-sm-6"},[_vm._v("How customers can save more money with a multi-currency debit card")]),_vm._v(" "),_c('p',{staticClass:"f_chapo"},[_vm._v("But we could have saved more by avoiding PayPal’s currency conversion completely by paying with a card in the local currency–in other words, in the actual currency of the item that’s being sold online, in this case, US dollars. You can do this with a number of new cards and accounts that enable people to open accounts and own cards that operate in multiple currencies. Which means that you can basically be a local customer in a number of countries across various currencies.")]),_vm._v(" "),_c('h2',{staticClass:"f_subtitle_1"},[_vm._v("International bank accounts")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("These days, there are a bunch of multi-currency or travel cards available that offer great rates to pay in foreign currency. TransferWise’s Borderless account and debit card or a Revolut card enable customers to pay in US dollars instead of Euros (for example), which equals avoiding or reducing the conversion fee charged by the bank or card issuer.")]),_vm._v(" "),_c('h2',{ref:"anchor03",staticClass:"f_subtitle_1 mt-15",attrs:{"id":"anchor03"}},[_vm._v("TransferWise Borderless Account and Debit Card")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("TransferWise Borderless account is great for travellers, freelancers, and people with lives across borders.  After opening an account online, you get:")]),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_c('h2',{ref:"anchor04",staticClass:"f_subtitle_1 mt-15",attrs:{"id":"anchor04"}},[_vm._v("Revolut")]),_vm._v(" "),_vm._m(11),_vm._v(" "),_c('h2',{staticClass:"f_subtitle_1 mt-15"},[_vm._v("Plan ahead and save more money")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("Next time you buy something with PayPal that involves a currency exchange, take a few extra minutes and choose the right option. Or better yet, plan in advance and start saving money for all your international money transactions with a multi-currency card.  \n\n")])])]),_vm._v(" "),(false)?_c('aside',{staticClass:"scroller"},[_vm._m(12)]):_vm._e(),_vm._v(" "),_c('aside',{staticClass:"scroller"},[(false)?_c('div',{staticClass:"aside_widget mb-4"},[_vm._m(13)]):_vm._e(),_vm._v(" "),_vm._m(14)]),_vm._v(" "),_c('aside',{ref:"scroll_widgets",staticClass:"scroller article_content"},[_c('div',{staticClass:"aside_widget"},[_c('h4',{staticClass:"fw-demi-bold fs-16 pt-5 pb-1 "},[_vm._v("Let's browse through the article")]),_vm._v(" "),_c('ul',{staticClass:"fw-demi-bold f-anti fs-16 pb-3 pt-0"},[_c('li',{staticClass:"active",on:{"click":function($event){return _vm.anchor01()}}},[_vm._v("The PayPal option")]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.anchor02()}}},[_vm._v("Monito’s recommendation"),_c('a',{staticClass:"btn_cta hide fw-bold f-anti f-19 ls-1",attrs:{"target":"_blank","rel":"noopener","href":"https://go.monito.com/transferwise-borderless?utm_source=internal&utm_medium=internal&utm_campaign=ABTestReducePaypal&utm_content=main_content_widget_content_article&link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3Aukaccount%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com%252Fgb%252Fborderless%252F"}},[_vm._v("Open a TransferWise Borderless Account")])]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.anchor03()}}},[_vm._v("TransferWise")]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.anchor04()}}},[_vm._v("Revolut")])])])])]),_vm._v(" "),_c('widget-articles',{staticClass:"pt-2",attrs:{"articles":_vm.articles}},[_c('h1',{staticClass:"fs-28 fw-bold f-anti mb-9 mb-sm-4 mt-sm-4"},[_vm._v("This might interest you too")])]),_vm._v(" "),_c('app-footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aside_widget mb-4 mb-sm-0"},[_c('div',{staticClass:"should excellent"},[_c('p',[_c('span',[_vm._v("What you should do")]),_c('b',[_vm._v("Use a multi-currency card like TransferWise’s Borderless Debit Card.")]),_vm._v(" Always pay with a card that can hold the local currency of the seller, like TransferWise's Borderless Debit Card in order to avoid PayPal’s currency conversion completely.")]),_vm._v(" "),_c('a',{staticClass:"btn_cta fw-bold f-anti f-19 ls-1",attrs:{"target":"_blank","rel":"noopener","href":"https://go.monito.com/transferwise-borderless??utm_source=internal&utm_medium=internal&utm_campaign=ABTestReducePaypal&utm_content=main_content_widget&link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3Aukaccount%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com%252Fgb%252Fborderless%252F"}},[_vm._v("Take me to TransferWise")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"should bad"},[_c('p',[_c('span',[_vm._v("What you should avoid")]),_c('b',[_vm._v("Don’t go with a high-street bank,")]),_vm._v(" most won’t allow you to open a bank account without a proof of residency and are all around more expensive.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_vm._v("We’ve all been there. You’re shopping online, find what you want but you need to pay in a currency that is not your own and the transaction occurs via PayPal. When you go to check out, the fine print contains details about the PayPal conversion fees and exchange rate and gives you choice of converting the money with PayPal or the card issuer. What it does not tell you is how much money you can lose if you tick the wrong box. It’s another reason why when it comes to anything involving international currency exchanges, "),_c('a',{attrs:{"href":"https://www.monito.com/en/send-money-with/paypal?utm_source=internal&utm_medium=internal&utm_campaign=ABTestReducePaypal&utm_content=main_content"}},[_vm._v("never recommend PayPal")]),_vm._v(".")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_vm._v("PayPal quotes a rate of 1 euro to 1.09 US dollars. The real mid-market exchange rate on this day is 1 euro to 1.14 US dollars, which would equal 186.60 Euros. Of course, PayPal does not spell this out clearly–it just lists the exchange rate. So unless the customer actually leaves this page and enters the details to manually check how much the real exchange rate is on that day, the customer is not actually aware the total charge is actually €8.72 above what it would cost if the currency conversion was done at the real "),_c('a',{attrs:{"href":"https://www.monito.com/en/wiki/mid-market-exchange-rate"}},[_vm._v("mid-market exchange rate")]),_vm._v(" versus PayPal’s exchange rate.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_vm._v("Here’s where it gets tricky. This card payment exchange rate is the default option, but if you click the blue “More exchange rate options.” you see this screen, which again "),_c('strong',[_vm._v("defaults to PayPal’s exchange rate which has a markup of 3.5%.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_c('b',[_vm._v("The bad news: ")]),_vm._v("most card issuer also make money from the currency conversion and charge more than the current mid-market rate, and you won’t know what that rate is until after you’ve paid.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_c('b',[_vm._v("The good news: ")]),_vm._v("most card issuers or banks will give you a better rate than what PayPal gives you.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"should_content excellent mt-3"},[_c('h3',{staticClass:"mb-2"},[_vm._v("What you should do")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("Always pay with a card that can hold the local currency of the seller, like TransferWise's Borderless Debit Card in order to avoid PayPal’s currency conversion completely.")]),_vm._v(" "),_c('h4',{staticClass:"f_chapo"},[_vm._v("Why TransferWise Borderless Debit Card ?")]),_vm._v(" "),_c('ul',{staticClass:"f_body pros"},[_c('li',[_vm._v("A multi-currency Mastercard debit card great for paying in foreign currencies without the hidden fees like Paypal.")]),_vm._v(" "),_c('li',[_vm._v("An account to hold up to 50 currencies and great rates to convert between them.")]),_vm._v(" "),_c('li',[_vm._v("No setup fees or monthly charges.")]),_vm._v(" "),_c('li',[_vm._v("Local bank details in the US, Eurozone, UK, Australia, New Zealand and Poland to get paid like a local.")])]),_vm._v(" "),_c('div',{staticClass:"center"},[_c('a',{staticClass:"btn_cta fw-bold f-anti f-17 ls-1",attrs:{"target":"_blank","rel":"noopener","href":"https://go.monito.com/transferwise-borderless?utm_source=internal&utm_medium=internal&utm_campaign=ABTestReducePaypal&utm_content=main_content&link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3Aukaccount%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com%252Fgb%252Fborderless%252F"}},[_vm._v("Take me to TransferWise")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"should_content bad mt-4"},[_c('h3',{staticClass:"mb-2"},[_vm._v("What you should avoid")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("Avoid paying with PayPals default option or in your local currency (if it differs from the seller's) to ensure you can pay as close to the mid-market exchange rate as possible, versus PayPals exchange rate.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"f_body"},[_c('li',[_vm._v("A multi-currency Mastercard debit card great for paying in foreign currencies without the hidden fees like Paypal. ")]),_c('li',[_vm._v("An account to hold up to 50 currencies and great rates to convert between them.")]),_c('li',[_vm._v("Local bank details in the US, Eurozone, UK, Australia, New Zealand and Poland to get paid like a local.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_vm._v("So, in this case the Euros could have been uploaded from a local Euro account and converted into US dollars at the current exchange rate plus a small transparent fee. Then, we could have used the card to pay for the transaction in US dollars seamlessly. "),_c('br'),_c('br'),_c('a',{attrs:{"href":"https://go.monito.com/transferwise-borderless?utm_source=internal&utm_medium=internal&utm_campaign=ABTestReducePaypal&utm_content=main_content&link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3A%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com"}},[_vm._v("Learn more about TransferWise's multi-currency account")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_vm._v("Another great option for reducing fees is "),_c('a',{attrs:{"href":"https://www.monito.com/en/send-money-with/revolut?utm_source=internal&utm_medium=internal&utm_campaign=ABTestReducePaypal&utm_content=main_content_widget"}},[_vm._v("Revolut")]),_vm._v(", which offers a debit card with the ability to spend in 150 currencies from your balance in one of the 30 currencies you can hold in your account. Customers receive several accounts including a Euro account, which means you can add money using local bank details in Euros the more you can withdraw each month. If you top up with a debit or credit card that was issued in the European Economic Area (EEA), it’s totally free. And if you top up with a non-EEA issued, you’ll be charged a fee in some cases. (In our tests uploading USD from a US debit card, we were charged a 1.67% fee).")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aside_widget"},[_c('div',{staticClass:"title fs-20 pl-1 pr-1 ls-1 f-anti"},[_vm._v("💡 Monito's Tip: Open a TransferWise Borderless Account\n")]),_c('p',{staticClass:"fs-17 lh-4 f-anti fw-medium pl-2 pr-2 pt-4"},[_vm._v("Just arrived in the UK or planning to move soon?"),_c('br'),_vm._v(" Do you need to pay or get paid like a local but can't open a bank account without proof of address?")]),_c('p',{staticClass:"fs-17 lh-4 f-anti fw-medium pl-2 pr-2 pt-4 mb-5"},[_vm._v("Open a "),_c('a',{attrs:{"target":"_blank","rel":"noopener","href":"https://go.monito.com/transferwise-borderless?utm_source=internal&utm_medium=internal&utm_campaign=ABTestReducePaypal&utm_content=main_content_widget&link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3Aukaccount%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com%252Fgb%252Fborderless%252F"}},[_vm._v("TransferWise Borderless Account online")]),_vm._v(" and get UK bank details, a multi-currency account and a debit Mastercard.")]),_c('a',{staticClass:"btn_cta fw-bold f-anti f-19 ls-1",attrs:{"target":"_blank","rel":"noopener","href":"https://go.monito.com/transferwise-borderless?utm_campaign=ABTestBankUK&utm_source=internal&utm_medium=internal&utm_content=hero_widget&link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3Aukaccount%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com%252Fgb%252Fborderless%252F"}},[_vm._v("Open your account now")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"should bad"},[_c('p',[_c('span',[_vm._v("What you should avoid")]),_c('b',[_vm._v("Use a multi-currency card like TransferWise’s Borderless Debit Card.")]),_vm._v(" Always pay with a card that can hold the local currency of the seller, like TransferWise's Borderless Debit Card in order to avoid PayPal’s currency conversion completely.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aside_widget"},[_c('div',{staticClass:"should excellent"},[_c('p',[_c('span',[_vm._v("What you should do")]),_c('b',[_vm._v("Use a multi-currency card like TransferWise’s Borderless Debit Card.")]),_vm._v(" Always pay with a card that can hold the local currency of the seller, like TransferWise's Borderless Debit Card in order to avoid PayPal’s currency conversion completely.")]),_vm._v(" "),_c('a',{staticClass:"btn_cta fw-bold f-anti f-19 ls-1",attrs:{"target":"_blank","rel":"noopener","href":"https://go.monito.com/transferwise-borderless?utm_source=internal&utm_medium=internal&utm_campaign=ABTestReducePaypal&utm_content=main_content_widget&link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3Aukaccount%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com%252Fgb%252Fborderless%252F"}},[_vm._v("Take me to TransferWise")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReviewTransferwise_vue__ = __webpack_require__(74);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_329b07c6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReviewTransferwise_vue__ = __webpack_require__(240);
function injectStyle (ssrContext) {
  __webpack_require__(227)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReviewTransferwise_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_329b07c6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReviewTransferwise_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(228);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("1dc3267f", content, true, {});

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "header .hero_element{margin-top:-202px!important;left:-2px}.bg-transition{display:none}main{display:flex;margin-top:-195px;position:relative;z-index:1000}aside{width:352px;flex-shrink:0;position:sticky}.container_layout{width:1200px;margin:0 auto;position:relative;display:flex;justify-content:space-between}.main_widget{display:inline-block;vertical-align:top}.monito_score.aside_widget{padding-left:0!important;padding-right:0!important}.scroller{width:352px;display:inline-block;box-sizing:border-box;vertical-align:top;position:sticky;right:0;top:50px}.cta_sticky{position:fixed;z-index:100000;top:-200px;width:100%;height:60px}.cta_sticky:before{width:1100px;left:calc(((1100px - 100vw) / 2) * -1);position:absolute;background:#fff;top:-182px;content:\"\";height:240px;box-shadow:0 3px 20px 0 rgba(0,0,0,.1);z-index:100;border-radius:150%/95%}.cta_sticky a{padding:22px 0;font-size:18px;width:80%;display:inline-block;position:relative;z-index:1000;text-align:center;margin-left:10%}.cta_sticky.active{animation-name:anim_cta_sticky;animation-duration:.7s;animation-fill-mode:forwards}.cta_sticky.remove{animation-name:anim_cta_sticky_remove;animation-duration:.7s;animation-fill-mode:forwards}@keyframes anim_cta_sticky{0%{position:fixed;top:-200px}to{position:fixed;top:0}}@keyframes anim_cta_sticky_remove{to{position:fixed;top:-200px}0%{position:fixed;top:0}}@media (max-width:990px){header .hero_element{margin-top:-222px!important}.article_content{display:none}body{width:100%;overflow:scrollY}.title{width:90%;margin-left:5%}.left_content,.title>div{width:100%!important}.left_content{margin-right:0!important}.left_content>section{width:92%;margin-left:4%;margin-right:4%}.container_layout{width:100%;display:block}main{width:100%}main header .hero_element{margin-top:-242px!important}main{display:block;margin-top:-190px}main .boxed{border-radius:12px}main .boxed .cover{border-radius:12px 12px 0 0}main .boxed h1{text-align:center}main .left_content,main aside{width:100%;display:block}main aside{width:92%;top:0!important;margin-left:4%;margin-right:4%}.scroller,main aside{position:relative!important}.scroller{width:90%;margin-left:5%;top:0}}@media (max-width:768px){header .hero_element{margin-top:-142px!important}}@media (max-width:500px){main{margin-top:-152px!important}header .hero_element{margin-top:-82px!important}}", ""]);

// exports


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(230);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("2ef6ef70", content, true, {});

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".contenaire_monito_score{width:110px;height:110px;background:#fff;right:-24px;top:-40px;z-index:10000;position:absolute;border-radius:100px}.contenaire_monito_score .monito_score{margin:0!important;top:12px!important;left:14px!important}.monito_score svg{top:0!important;left:0!important}.monito_score .score{width:84px!important;top:7px!important;left:-3px!important}.advice{padding-left:58px;padding-right:28px;margin:52px 14px 32px;position:relative}.advice span{font-weight:600}.advice:after{content:\"\";width:155px;height:2px;position:absolute;top:-28px;left:calc(50% - 77.5px);background:#e3e3e3;opacity:.5}.advice.excellent span{color:#67a907}.advice.excellent:before{content:\"\";width:20px;height:20px;background:url(\"/public/picto_excellent.svg\");background-size:contain;position:absolute;display:block;left:26px;top:1px}.advice.good span{color:#78ca00}.advice.good:before{background:url(\"/public/picto_good.svg\");background-size:contain}.advice.average:before,.advice.good:before{content:\"\";width:20px;height:20px;position:absolute;display:block;left:26px;top:1px}.advice.average:before{background:url(\"/public/picto_average.svg\");background-size:contain}.advice.poor:before{background:url(\"/public/picto_poor.svg\");background-size:contain;background-repeat:no-repeat}.advice.bad:before,.advice.poor:before{content:\"\";width:22px;height:20px;position:absolute;display:block;left:25px;top:0}.advice.bad:before{background:url(\"/public/picto_bad.svg\");background-size:contain;background-repeat:no-repeat}", ""]);

// exports


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(232);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("14e0bcf4", content, true, {});

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "img.logo[data-v-38e172a0]{max-width:205px;max-height:50px}.title[data-v-38e172a0]{background-color:#f7f7f7;margin-left:20px;margin-right:20px;margin-top:8px;padding-top:34px!important;padding-bottom:32px!important;clip-path:polygon(100% 0,100% calc(100% - 16px),50% 100%,0 calc(100% - 16px),0 0)}.title h2[data-v-38e172a0]{color:#535353;opacity:.8;margin-bottom:0}.btn_cta[data-v-38e172a0]{margin-left:auto;margin-right:auto;width:calc(100% - 48px);font-size:18px;max-width:430px}ul[data-v-38e172a0]{padding-left:0;list-style:none;text-align:left}ul li[data-v-38e172a0]{margin:0;font-size:16px;font-weight:600;color:#353c45;padding:6px 48px 6px 42px;letter-spacing:.02em;transition:all .3s ease}ul li p[data-v-38e172a0]{opacity:1!important}ul li[data-v-38e172a0]:hover{cursor:pointer;position:relative}ul li:hover p[data-v-38e172a0]{font-weight:700}ul li.active[data-v-38e172a0]{background:#d3f5f5;color:#004660;position:relative;padding-top:24px;padding-bottom:24px;cursor:default}ul li.active p[data-v-38e172a0]{font-weight:700}ul li.active[data-v-38e172a0]:after{content:\"\";width:0;height:0;border-top:44px solid transparent;border-bottom:47px solid transparent;border-right:14px solid #d3f5f5;left:-14px;top:calc(50% - 44px);position:absolute}p[data-v-38e172a0]{font-weight:600;color:#353c45;opacity:1;text-align:left}.sub_score[data-v-38e172a0]{width:10%;display:inline-block;text-align:center;position:relative;right:-20px;font-weight:700}.barre[data-v-38e172a0]{width:90%;height:9px;margin-top:8px;border-radius:5px;position:relative;background:#D2D1D270;display:inline-block}.barre .element_barre[data-v-38e172a0]{height:9px;border-radius:5px;position:absolute;top:0;left:0}.barre .excellent[data-v-38e172a0]{background-color:#78ca00}.barre .good[data-v-38e172a0]{background-color:#00a000}.barre .average[data-v-38e172a0]{background-color:#ff9a00}.barre .poor[data-v-38e172a0]{background-color:#ff5800}.barre .bad[data-v-38e172a0]{background-color:#ff0030}@media (min-width:769px) and (max-width:990px){.title[data-v-38e172a0]{width:calc(100% - 40px);clip-path:polygon(100% 0,100% calc(100% - 30px),50% 100%,0 calc(100% - 30px),0 0)}ul[data-v-38e172a0]{width:50%;display:inline-block;vertical-align:middle}.advices[data-v-38e172a0]{width:43%;box-sizing:border-box;display:inline-block;vertical-align:middle}}@media (max-width:500px){.contenaire_monito_score[data-v-38e172a0]{right:14px;top:-60px}ul[data-v-38e172a0]{width:100%}}", ""]);

// exports


/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-anti"},[_c('div',{staticClass:"contenaire_monito_score shadow-soft"},[_c('element-circle-score',{attrs:{"score":_vm.provider.score,"width":78,"stroke":6,"size":22}})],1),_vm._v(" "),_c('div',{staticClass:"title"},[_c('h2',{staticClass:"fs-16 fs-sm-19 ls-1 fw-demi-bold"},[_vm._v("Monito score for")]),_vm._v(" "),_c('img',{staticClass:"logo mt-1",attrs:{"src":_vm.provider.logo}})]),_vm._v(" "),_c('ul',{staticClass:"mt-3 f-anti"},[_c('li',{on:{"click":function($event){return _vm.anchor01()}}},[_c('p',[_vm._v("Trust & Credibility")]),_c('div',{staticClass:"barre"},[_c('div',{class:['element_barre',_vm.getColorScore(_vm.provider.sub_score_01)],style:('width: '+_vm.provider.sub_score_01*10+'%')})]),_c('span',{staticClass:"sub_score"},[_vm._v(_vm._s(_vm.provider.sub_score_01))])]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.anchor02()}}},[_c('p',[_vm._v("Service Quality")]),_c('div',{staticClass:"barre"},[_c('div',{class:['element_barre',_vm.getColorScore(_vm.provider.sub_score_02)],style:('width: '+_vm.provider.sub_score_02*10+'%')})]),_c('span',{staticClass:"sub_score"},[_vm._v(_vm._s(_vm.provider.sub_score_02))])]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.anchor03()}}},[_c('p',[_vm._v("Customer satisfaction")]),_c('div',{staticClass:"barre"},[_c('div',{class:['element_barre',_vm.getColorScore(_vm.provider.sub_score_03)],style:('width: '+_vm.provider.sub_score_03*10+'%')})]),_c('span',{staticClass:"sub_score"},[_vm._v(_vm._s(_vm.provider.sub_score_03))])]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.anchor04()}}},[_c('p',[_vm._v("Fees & Exchange rates")]),_c('div',{staticClass:"barre"},[_c('div',{class:['element_barre',_vm.getColorScore(_vm.provider.sub_score_04)],style:('width: '+_vm.provider.sub_score_04*10+'%')})]),_c('span',{staticClass:"sub_score"},[_vm._v(_vm._s(_vm.provider.sub_score_04))])])]),_vm._v(" "),_c('div',{staticClass:"advices"},[_c('p',{class:['advice',_vm.provider.country_score],domProps:{"innerHTML":_vm._s(_vm.provider.country)}}),_vm._v(" "),_c('p',{class:['advice',_vm.provider.cost_score],domProps:{"innerHTML":_vm._s(_vm.provider.cost)}})]),_vm._v(" "),(_vm.provider.score >= '7.0')?_c('a',{staticClass:"btn_cta fw-bold f-anti f-18 ls-1 mt-2",attrs:{"target":"_blank","rel":"noopener","href":_vm.provider.url}},[_vm._v("Go to "+_vm._s(_vm.provider.name))]):_vm._e(),_vm._v(" "),(_vm.provider.score < '7.0')?_c('a',{staticClass:"btn_cta fw-bold f-anti f-18 ls-1 mt-2",attrs:{"target":"_blank","rel":"noopener","href":"#"}},[_vm._v("Find an alternative to "+_vm._s(_vm.provider.name))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(235);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("24c29efd", content, true, {});

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".flex[data-v-523bef48]{display:flex;width:90%;padding-left:5%;padding-right:5%;padding-bottom:60px;justify-content:center;align-items:flex-start;position:relative}.title[data-v-523bef48]{width:620px;text-align:center;margin-left:auto;margin-right:auto}.box[data-v-523bef48]{width:345px;background:#fff;margin:0 1.2%;border-radius:12px}.box>a[data-v-523bef48]{text-align:center;color:#f6495c;text-decoration:underline;margin:0 auto;display:block;padding-top:25px;padding-bottom:40px;cursor:pointer}ul[data-v-523bef48]{padding-left:0;list-style:none}li[data-v-523bef48]{padding:22px 18px 22px 26px}li .label[data-v-523bef48]{font-size:16px;font-weight:700;margin-bottom:3px;max-width:84%;letter-spacing:.025em}li .infos[data-v-523bef48]{max-width:84%;font-size:15px;font-weight:500;opacity:.85;line-height:20px;letter-spacing:.02em}li[data-v-523bef48]:last-child{border-bottom:none;padding-bottom:10px}li[data-v-523bef48]:hover{background:#cdcdcd22}h3[data-v-523bef48]{font-size:20px;position:relative;padding-right:30%;box-sizing:border-box;position:sticky;top:0;border-radius:12px;background:#fff;z-index:100000}h3 a[data-v-523bef48]{position:absolute;top:72px;padding-right:30%;left:24px;opacity:.85;font-size:14px;text-decoration:underline}h3 a[data-v-523bef48]:hover{color:#f6495c;cursor:pointer}h3 .big_score[data-v-523bef48]{position:absolute;right:14px;color:#fff;top:45px;font-size:17px;padding:7px 14px 6px;border-radius:40px;background:#ff000060}h3 .big_score.excellent[data-v-523bef48]{background-color:#78ca00}h3 .big_score.good[data-v-523bef48]{background-color:#00a000}h3 .big_score.average[data-v-523bef48]{background-color:#ff9a00}h3 .big_score.poor[data-v-523bef48]{background-color:#ff5800}h3 .big_score.bad[data-v-523bef48]{background-color:#ff0030}.sub_score[data-v-523bef48]{width:10%;position:absolute;display:inline-block;text-align:center;top:-7px;right:-52px;margin-bottom:12px;font-weight:700}.barre[data-v-523bef48]{width:calc(100% - 65px);height:9px;margin-top:8px;border-radius:5px;position:relative;background:#D2D1D270;display:inline-block;margin-bottom:12px}.barre .element_barre[data-v-523bef48]{height:9px;border-radius:5px;position:absolute;top:0;left:0}.barre .excellent[data-v-523bef48]{background-color:#78ca00}.barre .good[data-v-523bef48]{background-color:#00a000}.barre .average[data-v-523bef48]{background-color:#ff9a00}.barre .poor[data-v-523bef48]{background-color:#ff5800}.barre .bad[data-v-523bef48]{background-color:#ff0030}@media (min-width:769px) and (max-width:990px){.box[data-v-523bef48]{width:44%;margin:0 3%;margin-bottom:30px;flex-shrink:0}.box>div[data-v-523bef48]{padding-left:8%;padding-right:8%;width:84%}.flex[data-v-523bef48]{flex-wrap:wrap!important}}@media (max-width:768px){.flex[data-v-523bef48]{padding:0;display:flex;width:100%;justify-content:space-around;flex-flow:column wrap}.box[data-v-523bef48]{box-sizing:border-box;width:92%;height:auto;margin:4%}.box>div[data-v-523bef48]{padding-left:8%;padding-right:8%;width:84%}.title[data-v-523bef48]{width:92%;height:auto;margin:4%}}", ""]);

// exports


/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"details_monito_score mt-16"},[_c('div',{staticClass:"title mb-12"},[_c('h2',{staticClass:"fs-28 fs-md-25 fs-sm-24 lh-6 ls-2 ls-sm-2 lh-sm-5 mt-5 mb-1 mb-sm-3"},[_vm._v("What does a "+_vm._s(_vm.provider.score)+" Monito score for "+_vm._s(_vm.provider.name)+" mean?")]),_vm._v(" "),_c('a',{staticClass:"fs-17 ls-1 underline fs-md-17 fs-sm-17 italic fw-demi-bold f-anti",staticStyle:{"opacity":"0.88"},attrs:{"href":"https://www.monito.com/en/lp/money-transfer-services-review-temporary"}},[_vm._v("Learn more about our scoring methodology")])]),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"box shadow"},[_c('h3',{staticClass:"f-anti pt-8 pl-2 pb-6"},[_vm._v("Trust & Credibility"),_c('span',{class:['big_score f-anti',_vm.getColorScore(_vm.provider.sub_score_01)]},[_vm._v(_vm._s(_vm.provider.sub_score_01))])]),_vm._v(" "),_c('ul',_vm._l((_vm.details_trust),function(detail){return _c('li',{staticClass:"f-anti"},[_c('p',{staticClass:"label"},[_vm._v(_vm._s(detail.label))]),_vm._v(" "),_c('div',{staticClass:"barre"},[_c('div',{class:['element_barre',_vm.getColorScore(detail.score)],style:('width: '+ detail.score * 10+'%')}),_vm._v(" "),_c('span',{staticClass:"sub_score"},[_vm._v(_vm._s(detail.score))])]),_vm._v(" "),_c('p',{staticClass:"infos"},[_vm._v(_vm._s(detail.infos))])])}),0),_vm._v(" "),(!_vm.scrollingActive && !_vm.paragraph_01)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.small_trust)}}):_vm._e(),_vm._v(" "),(!_vm.scrollingActive && _vm.paragraph_01)?_c('div',{staticClass:"pb-8",domProps:{"innerHTML":_vm._s(_vm.trust)}}):_vm._e(),_vm._v(" "),(!_vm.scrollingActive && !_vm.paragraph_01)?_c('a',{on:{"click":function($event){_vm.paragraph_01=!_vm.paragraph_01}}},[_vm._v("Read more")]):_vm._e(),_vm._v(" "),(_vm.scrollingActive)?_c('a',{on:{"click":_vm.anchor01}},[_vm._v("Read more")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"box shadow"},[_c('h3',{staticClass:"f-anti pt-8 pl-2 pb-6"},[_vm._v("Service Quality"),_c('span',{class:['big_score f-anti',_vm.getColorScore(_vm.provider.sub_score_02)]},[_vm._v(_vm._s(_vm.provider.sub_score_02))])]),_vm._v(" "),_c('ul',_vm._l((_vm.details_service),function(detail){return _c('li',{staticClass:"f-anti"},[_c('p',{staticClass:"label"},[_vm._v(_vm._s(detail.label))]),_vm._v(" "),_c('div',{staticClass:"barre"},[_c('div',{class:['element_barre',_vm.getColorScore(detail.score)],style:('width: '+ detail.score * 10+'%')}),_vm._v(" "),_c('span',{staticClass:"sub_score"},[_vm._v(_vm._s(detail.score))])]),_vm._v(" "),_c('p',{staticClass:"infos"},[_vm._v(_vm._s(detail.infos))])])}),0),_vm._v(" "),(!_vm.scrollingActive && !_vm.paragraph_02)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.small_service)}}):_vm._e(),_vm._v(" "),(!_vm.scrollingActive && _vm.paragraph_02)?_c('div',{staticClass:"pb-8",domProps:{"innerHTML":_vm._s(_vm.service)}}):_vm._e(),_vm._v(" "),(!_vm.scrollingActive && !_vm.paragraph_02)?_c('a',{on:{"click":function($event){_vm.paragraph_02=!_vm.paragraph_02}}},[_vm._v("Read more")]):_vm._e(),_vm._v(" "),(_vm.scrollingActive)?_c('a',{on:{"click":_vm.anchor02}},[_vm._v("Read more")]):_vm._e()]),_c('div',{staticClass:"box shadow"},[_c('h3',{staticClass:"f-anti pt-8 pl-2 pb-6"},[_vm._v("Customer satisfaction"),_c('span',{class:['big_score f-anti',_vm.getColorScore(_vm.provider.sub_score_03)]},[_vm._v(_vm._s(_vm.provider.sub_score_03))])]),_vm._v(" "),_c('ul',_vm._l((_vm.details_customer),function(detail){return _c('li',{staticClass:"f-anti"},[_c('p',{staticClass:"label"},[_vm._v(_vm._s(detail.label))]),_vm._v(" "),_c('div',{staticClass:"barre"},[_c('div',{class:['element_barre',_vm.getColorScore(detail.score)],style:('width: '+ detail.score * 10+'%')}),_vm._v(" "),_c('span',{staticClass:"sub_score"},[_vm._v(_vm._s(detail.score))])]),_vm._v(" "),_c('p',{staticClass:"infos"},[_vm._v(_vm._s(detail.infos))])])}),0),_vm._v(" "),(!_vm.scrollingActive && !_vm.paragraph_03)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.small_customer)}}):_vm._e(),_vm._v(" "),(!_vm.scrollingActive && _vm.paragraph_03)?_c('div',{staticClass:"pb-6",domProps:{"innerHTML":_vm._s(_vm.customer)}}):_vm._e(),_vm._v(" "),(!_vm.scrollingActive && !_vm.paragraph_03)?_c('a',{on:{"click":function($event){_vm.paragraph_03=!_vm.paragraph_03}}},[_vm._v("Read more")]):_vm._e(),_vm._v(" "),(_vm.scrollingActive)?_c('a',{on:{"click":_vm.anchor03}},[_vm._v("Read more")]):_vm._e()]),_c('div',{staticClass:"box shadow"},[_c('h3',{staticClass:"f-anti pt-8 pl-2 pb-6"},[_vm._v("Fees & Exchange rates"),_c('span',{class:['big_score f-anti',_vm.getColorScore(_vm.provider.sub_score_04)]},[_vm._v(_vm._s(_vm.provider.sub_score_04))])]),_vm._v(" "),_c('ul',_vm._l((_vm.details_fees),function(detail){return _c('li',{staticClass:"f-anti"},[_c('p',{staticClass:"label"},[_vm._v(_vm._s(detail.label))]),_vm._v(" "),_c('div',{staticClass:"barre"},[_c('div',{class:['element_barre',_vm.getColorScore(detail.score)],style:('width: '+ detail.score * 10+'%')}),_vm._v(" "),_c('span',{staticClass:"sub_score"},[_vm._v(_vm._s(detail.score))])]),_vm._v(" "),_c('p',{staticClass:"infos"},[_vm._v(_vm._s(detail.infos))])])}),0),_vm._v(" "),(!_vm.scrollingActive && !_vm.paragraph_04)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.small_fees)}}):_vm._e(),_vm._v(" "),(!_vm.scrollingActive && _vm.paragraph_04)?_c('div',{staticClass:"pb-6",domProps:{"innerHTML":_vm._s(_vm.fees)}}):_vm._e(),_vm._v(" "),(!_vm.scrollingActive && !_vm.paragraph_04)?_c('a',{on:{"click":function($event){_vm.paragraph_04=!_vm.paragraph_04}}},[_vm._v("Read more")]):_vm._e(),_vm._v(" "),(_vm.scrollingActive)?_c('a',{on:{"click":_vm.anchor04}},[_vm._v("Read more")]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(238);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("7a4e3467", content, true, {});

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".bread[data-v-6fb60fcd]{color:#353C4599}.bread a[data-v-6fb60fcd]{text-decoration:underline;color:#353C4599}.bread a[data-v-6fb60fcd]:hover{cursor:pointer;color:#f6495c}.bread span[data-v-6fb60fcd]:not(.active){display:inline-block;margin-left:10px;margin-right:10px}", ""]);

// exports


/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-6 mb-sm-0 bread f-anti fs-13 fw-demi-bold ls-1"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.scrollingActive)?_c('div',{staticClass:"cta_sticky"},[_c('a',{staticClass:"btn_cta fw-bold f-anti f-18 ls-1 mt-2",attrs:{"target":"_blank","rel":"noopener","href":_vm.provider.url}},[_vm._v("Go to "+_vm._s(_vm.provider.name))])]):_vm._e(),_vm._v(" "),_c('header',[_c('app-navigation',[_c('h1',{attrs:{"id":"logo_monito"}},[_c('a',{attrs:{"href":"https://monito.com?utm_source=internal&utm_medium=internal&utm_campaign=ABTestReview&utm_content=nav"}},[_vm._v("Monito")])]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"https://www.monito.com/en/about-monito?utm_source=internal&utm_medium=internal&utm_campaign=ABTestReview&utm_content=nav"}},[_vm._v("About us")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.monito.com/en/wiki/monito-account?utm_source=internal&utm_medium=internal&utm_campaign=ABTestReview&utm_content=nav"}},[_vm._v("Alerts")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.monito.com/en/wiki?utm_source=internal&utm_medium=internal&utm_campaign=ABTestReview&utm_content=nav"}},[_vm._v("Wiki")])]),_vm._v(" "),_c('li',{staticClass:"langage"},[_c('a',{attrs:{"href":"#"}},[_vm._v("EN")])])])]),_vm._v(" "),_c('app-hero-section',{attrs:{"urlBackground":_vm.urlBackground,"herotype":_vm.herotype}})],1),_vm._v(" "),_c('main',{ref:"main"},[(!_vm.scrollingActive)?_c('aside',{staticClass:"mb-4"},[_c('div',{staticClass:"aside_widget monito_score pl-0 pr-0"},[_c('widget-monito-score',{attrs:{"provider":_vm.provider,"scrollingActive":_vm.scrollingActive}})],1),_vm._v(" "),(false)?_c('monito-widgets-imt-search-form',{attrs:{"powered-by-nf":"off","country-from":"US","title":"It's a title","country-to":"PH"}}):_vm._e(),_vm._v(" "),(false)?_c('div',{staticClass:"aside_widget mt-4 mb-sm-0 pt-14 pl-14 pb-14 pr-14"},[_vm._m(0)]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"left_content",staticStyle:{"display":"inline-block","margin-right":"26px","vertical-align":"top"}},[_c('section',{staticClass:"has-cover\n        boxed\n        pt-2 pl-7 pr-7 pb-10\n        pl-lg-5 pr-lg-5 pb-lg-8\n        pl-md-5 pr-md-5 pb-md-8\n        pl-sm-8_p pr-sm-8_p pb-sm-7"},[_c('div',{staticClass:"cover",staticStyle:{"background-image":"url('/public/illu_transferwise.jpg')"}}),_vm._v(" "),_c('h1',{staticClass:"f_title mt-5 mb-7 mt-2-sm mb-sm-6"},[_vm._v("Monito’s Review of TransferWise")]),_vm._v(" "),_c('widget-author',{staticClass:"mb-2 mt-3"},[_c('div',{staticClass:"portrait"},[_c('span',{staticClass:"image",staticStyle:{"background-image":"url('https://images.prismic.io/monito/aef881966e4f5bbc8a5ffc79819720e3a733b1c9_laurent.png')"}}),_vm._v(" "),_c('p',{staticClass:"name pt-sm-2"},[_c('span',[_vm._v("Written by")]),_c('a',{attrs:{"href":"https://www.monito.com/en/wiki/why-you-can-trust-monito#section0?utm_source=internal&utm_medium=internal&utm_campaign=ABTestReview&utm_content=main_content"}},[_vm._v("Laurent Oberholzer")])]),_vm._v(" "),_c('p',{staticClass:"pb-sm-3 update"},[_c('span',[_vm._v("Last updated")]),_vm._v("May 11, 2020")])]),_vm._v(" "),_c('p',{staticClass:"bio mt-2 mb-2 ls-2 pl-sm-1 fw-medium mb-sm-3 f-anti"},[_vm._v("Co-Founder and Head of Business Development at Monito. He is a recognized expert with over six years of experience in the banking and money transfer industry.")])]),_vm._v(" "),_c('widget-breadcrum',[_c('a',[_vm._v("Home")]),_c('span',[_vm._v(">")]),_c('a',[_vm._v("Money Transfer Provider Reviews")]),_c('span',[_vm._v(">")]),_c('span',{staticClass:"active"},[_vm._v(_vm._s(_vm.provider.name)+" Review")])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("TransferWise is an innovative international money transfer provider that is often dubbed the “Robin Hood” of the money transfer industry.")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("They focus on making bank transfers more affordable than traditional banks by charging low and transparent transfer fees and converting money at the true mid-market exchange rate. ")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("In other words, there’s zero markup on the exchange rate. (As a comparison, banks usually give customers an above-market rate, the margin is part of their fees and in general, they are not transparent about this.)")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("TransferWise mobile apps have great ratings on Apple’s App Store (4.7/5 stars on 19,300 ratings) and Google’s Play Store (4.4/5 on almost 80,000 ratings). According to TransferWise customers, the app is \"an invaluable tool for anyone moving money internationally\".")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("They’ve seen massive growth since 2011 and are an extremely competitive, high-profile disruptor of the traditional money transfer model. TransferWise is frequently referred to as a no-nonsense company that is sparking a revolution.")]),_vm._v(" "),(_vm.scrollingActive)?_c('div',{staticClass:"friendly mt-8 mb-5"},[_c('h2',{staticClass:"fs-20 fw-bold"},[_vm._v("Our friendly recommendation")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3)]):_vm._e(),_vm._v(" "),_c('h2',{staticClass:"f_subtitle_2"},[_vm._v("What we like about TransferWise")]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('h2',{staticClass:"f_subtitle_2"},[_vm._v("What we dislike about TransferWise")]),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6)],1)]),_vm._v(" "),(_vm.scrollingActive)?_c('aside',[_c('div',{staticClass:"aside_widget monito_score pl-0 pr-0"},[_c('widget-monito-score',{attrs:{"provider":_vm.provider,"scrollingActive":_vm.scrollingActive}})],1),_vm._v(" "),(false)?_c('monito-widgets-imt-search-form',{attrs:{"powered-by-nf":"off","country-from":"US","title":"It's a title","country-to":"PH"}}):_vm._e(),_vm._v(" "),(false)?_c('div',{staticClass:"aside_widget mt-4 mb-sm-0 pt-14 pl-14 pb-14 pr-14"},[_vm._m(7)]):_vm._e()],1):_vm._e()]),_vm._v(" "),_c('widget-detail-monito-score',{attrs:{"details_monito_score":_vm.details_monito_score,"details_trust":_vm.details_trust,"details_service":_vm.details_service,"details_customer":_vm.details_customer,"details_fees":_vm.details_fees,"provider":_vm.provider,"small_fees":_vm.small_fees,"small_customer":_vm.small_customer,"small_service":_vm.small_service,"small_trust":_vm.small_trust,"fees":_vm.fees,"customer":_vm.customer,"service":_vm.service,"trust":_vm.trust,"scrollingActive":_vm.scrollingActive}}),_vm._v(" "),(_vm.scrollingActive)?_c('div',{staticClass:"container_layout"},[_c('div',{staticClass:"left_content",staticStyle:{"vertical-align":"top"}},[_c('section',{ref:"anchor01",staticClass:"\n      boxed\n      pt-2 pl-7 pr-7 pb-10\n      pl-lg-5 pr-lg-5 pb-lg-8\n      pl-md-5 pr-md-5 pb-md-8\n      pl-sm-3 pr-sm-3 pb-sm-7\n      mb-5",attrs:{"id":"anchor01"}},[_c('div',{staticClass:"color"}),_vm._v(" "),_c('h2',{staticClass:"f_title mt-5 mb-7 mt-2-sm mb-sm-6"},[_vm._v("Trust & Credibility")]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.trust)}})]),_vm._v(" "),_c('section',{ref:"anchor02",staticClass:"\n      boxed\n      pt-2 pl-7 pr-7 pb-10\n      pl-lg-5 pr-lg-5 pb-lg-8\n      pl-md-5 pr-md-5 pb-md-8\n      pl-sm-3 pr-sm-3 pb-sm-7 \n      mt-5 mb-5",attrs:{"id":"anchor02"}},[_c('div',{staticClass:"color"}),_vm._v(" "),_c('h2',{staticClass:"f_title mt-5 mb-7 mt-2-sm mb-sm-6"},[_vm._v("Service Quality")]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.service)}})]),_vm._v(" "),_c('section',{ref:"anchor03",staticClass:"\n      boxed\n      pt-2 pl-7 pr-7 pb-10\n      pl-lg-5 pr-lg-5 pb-lg-8\n      pl-md-5 pr-md-5 pb-md-8\n      pl-sm-3 pr-sm-3 pb-sm-7 \n      mt-5 mb-5",attrs:{"id":"anchor03"}},[_c('div',{staticClass:"color"}),_vm._v(" "),_c('h2',{staticClass:"f_title mt-5 mb-7 mt-2-sm mb-sm-6"},[_vm._v("Customer satisfaction")]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.customer)}})]),_vm._v(" "),_c('section',{ref:"anchor04",staticClass:"\n      boxed\n      pt-2 pl-7 pr-7 pb-10\n      pl-lg-5 pr-lg-5 pb-lg-8\n      pl-md-5 pr-md-5 pb-md-8\n      pl-sm-3 pr-sm-3 pb-sm-7 \n      mt-5 mb-5",attrs:{"id":"anchor04"}},[_c('div',{staticClass:"color"}),_vm._v(" "),_c('h2',{staticClass:"f_title mt-5 mb-7 mt-2-sm mb-sm-6"},[_vm._v("Fees & Exchange rates")]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.fees)}})])]),_vm._v(" "),(_vm.scrollingActive)?_c('aside',[_c('div',{staticClass:"aside_widget monito_score mb-4 pl-0 pr-0"},[_c('widget-monito-score',{attrs:{"provider":_vm.provider,"scrollingActive":_vm.scrollingActive}})],1)]):_vm._e()]):_vm._e(),_vm._v(" "),_c('widget-providers',{attrs:{"providers":_vm.providers}},[_c('div',{staticStyle:{"width":"900px","margin-left":"auto","margin-right":"auto"}},[_c('h1',{staticClass:"fs-28 lh-6 mb-1 mt-5\n    fs-sm-24 lh-sm-5  mb-sm-3 ls-sm-2\n  ",staticStyle:{"text-align":"center","margin-left":"auto","margin-right":"auto"}},[_vm._v("Alternatives to "+_vm._s(_vm.provider.name))]),_vm._v(" "),_c('span',{staticClass:"fs-19 italic fs-sm-17 fw-demi-bold f-anti",staticStyle:{"text-align":"center","margin-left":"auto","margin-right":"auto","opacity":"0.88","display":"block"}},[_vm._v("Make an informed decision by comparing all the best options")])])]),_vm._v(" "),_c('app-footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"should excellent"},[_c('p',[_c('span',[_vm._v("What you should do")]),_c('b',[_vm._v("Make sure it's the ideal provider for your transfer, make a comparison")]),_vm._v(" Most high-street banks won't allow you to open a bank account without a proof of residency, so we recommend going with the best online solution who will, like TranserWise Borderless account.")]),_vm._v(" "),_c('a',{staticClass:"btn_cta fw-bold f-anti f-19 ls-1",attrs:{"target":"_blank","rel":"noopener","href":"https://go.monito.com/transferwise-borderless?utm_campaign=ABTestReview&utm_source=internal&utm_medium=internal&utm_content=headerro_widget_cta&link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3Aukaccount%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com%252Fgb%252Fborderless%252F"}},[_vm._v("Compare the providers")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_chapo"},[_c('a',{attrs:{"target":"_blank","href":"https://go.monito.com/transferwise"}},[_vm._v("TransferWise")]),_vm._v(" is a great money transfer service recommended by Monito. With more than 7 million customers and 50,000 positive customer reviews, we rate them 9.8/10 on “Trust and Credibility”, 9.5/10 on “Service Quality”, 9.0/10 on “Customer Satisfaction” and 9.5 /10 on “Fees & Exchange rates”. ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_c('b',[_vm._v("TransferWise is great,")]),_vm._v(" but it's good to compare all the providers before each transfer.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_c('a',{attrs:{"href":"https://monito.com?utm_source=internal&utm_medium=internal&utm_campaign=ABTestReview&utm_content=friendy"}},[_vm._v("Our comparison tool")]),_vm._v(" is free and allows you to find the cheapest, fastest or highest ranked supplier for your needs in no time.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"f_body pros"},[_c('li',[_vm._v("You get the true mid-market rate")]),_vm._v(" "),_c('li',[_vm._v("Low and transparent transfer fees")]),_vm._v(" "),_c('li',[_vm._v("Fantastic user experience")]),_vm._v(" "),_c('li',[_vm._v("Exceptional customer reviews on Trustpilot")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"f_body cons"},[_c('li',[_vm._v("You can only send to a bank account")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_c('a',{attrs:{"target":"_blank","href":"https://www.monito.com/en/send-money-with/transferwise-borderless"}},[_vm._v("Click here to read our TransferWise Borderless Account & Card Review.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"should excellent"},[_c('p',[_c('span',[_vm._v("What you should do")]),_c('b',[_vm._v("Make sure it's the ideal provider for your transfer, make a comparison")]),_vm._v(" Most high-street banks won't allow you to open a bank account without a proof of residency, so we recommend going with the best online solution who will, like TranserWise Borderless account.")]),_vm._v(" "),_c('a',{staticClass:"btn_cta fw-bold f-anti f-19 ls-1",attrs:{"target":"_blank","rel":"noopener","href":"https://go.monito.com/transferwise-borderless?utm_campaign=ABTestReview&utm_source=internal&utm_medium=internal&utm_content=headerro_widget_cta&link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3Aukaccount%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com%252Fgb%252Fborderless%252F"}},[_vm._v("Compare the providers")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReviewPaypal_vue__ = __webpack_require__(78);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_777748c5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReviewPaypal_vue__ = __webpack_require__(244);
function injectStyle (ssrContext) {
  __webpack_require__(242)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReviewPaypal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_777748c5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReviewPaypal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(243);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("42a7cd73", content, true, {});

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "header .hero_element{margin-top:-202px!important;left:-2px}.bg-transition{display:none}main{display:flex;margin-top:-195px;position:relative;z-index:1000}aside{width:352px;flex-shrink:0;position:sticky}.container_layout{width:1200px;margin:0 auto;position:relative;display:flex;justify-content:space-between}.main_widget{display:inline-block;vertical-align:top}.monito_score.aside_widget{padding-left:0!important;padding-right:0!important}.scroller{width:352px;display:inline-block;box-sizing:border-box;vertical-align:top;position:sticky;right:0;top:50px}.cta_sticky{position:fixed;z-index:100000;top:-200px;width:100%;height:60px}.cta_sticky:before{width:1100px;left:calc(((1100px - 100vw) / 2) * -1);position:absolute;background:#fff;top:-182px;content:\"\";height:240px;box-shadow:0 3px 20px 0 rgba(0,0,0,.1);z-index:100;border-radius:150%/95%}.cta_sticky a{padding:22px 0;font-size:18px;width:80%;display:inline-block;position:relative;z-index:1000;text-align:center;margin-left:10%}.cta_sticky.active{animation-name:anim_cta_sticky;animation-duration:.7s;animation-fill-mode:forwards}.cta_sticky.remove{animation-name:anim_cta_sticky_remove;animation-duration:.7s;animation-fill-mode:forwards}@keyframes anim_cta_sticky{0%{position:fixed;top:-200px}to{position:fixed;top:0}}@keyframes anim_cta_sticky_remove{to{position:fixed;top:-200px}0%{position:fixed;top:0}}@media (max-width:990px){header .hero_element{margin-top:-142px!important}.article_content{display:none}body{width:100%;overflow:scrollY}.title{width:90%;margin-left:5%}.left_content,.title>div{width:100%!important}.left_content{margin-right:0!important}.left_content>section{width:92%;margin-left:4%;margin-right:4%}.container_layout{width:100%;display:block}main{width:100%}main header .hero_element{margin-top:-242px!important}}@media (max-width:990px) and (max-width:500px){main{display:block;margin-top:-112px}main .boxed{border-radius:12px}main .boxed .cover{border-radius:12px 12px 0 0}main .boxed h1{text-align:center}main .left_content,main aside{width:100%;display:block}main aside{position:relative!important;width:92%;top:0!important;margin-left:4%;margin-right:4%}}@media (max-width:990px){.scroller{width:90%;margin-left:5%;position:relative!important;top:0}}", ""]);

// exports


/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.scrollingActive)?_c('div',{staticClass:"cta_sticky"},[_c('a',{staticClass:"btn_cta fw-bold f-anti f-18 ls-1 mt-2",attrs:{"target":"_blank","rel":"noopener","href":"https://go.monito.com/transferwise-borderless?utm_campaign=ABTestBsankUK&utm_source=internal&utm_medium=internal&utm_content=hero_widget&link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3Aukaccount%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com%252Fgb%252Fborderless%252F"}},[_vm._v("Find an alternative to  "+_vm._s(_vm.provider.name))])]):_vm._e(),_vm._v(" "),_c('header',[_c('app-navigation',[_c('h1',{attrs:{"id":"logo_monito"}},[_c('a',{attrs:{"href":"https://monito.com?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=nav"}},[_vm._v("Monito")])]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"https://www.monito.com/en/about-monito?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=nav"}},[_vm._v("About us")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.monito.com/en/wiki/monito-account?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=nav"}},[_vm._v("Alerts")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.monito.com/en/wiki?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=nav"}},[_vm._v("Wiki")])]),_vm._v(" "),_c('li',{staticClass:"langage"},[_c('a',{attrs:{"href":"#"}},[_vm._v("EN")])])])]),_vm._v(" "),_c('app-hero-section',{attrs:{"urlBackground":_vm.urlBackground,"herotype":_vm.herotype}})],1),_vm._v(" "),_c('main',{ref:"main"},[(!_vm.scrollingActive)?_c('aside',{staticClass:"mb-4"},[_c('div',{staticClass:"aside_widget monito_score pl-0 pr-0"},[_c('widget-monito-score',{attrs:{"provider":_vm.provider}})],1),_vm._v(" "),(false)?_c('monito-widgets-imt-search-form',{attrs:{"powered-by-nf":"off","country-from":"US","title":"It's a title","country-to":"PH"}}):_vm._e(),_vm._v(" "),(false)?_c('div',{staticClass:"aside_widget mt-4 mb-sm-0 pt-14 pl-14 pb-14 pr-14"},[_vm._m(0)]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"left_content",staticStyle:{"display":"inline-block","margin-right":"26px","vertical-align":"top"}},[_c('section',{staticClass:"has-cover\n        boxed\n        pt-2 pl-7 pr-7 pb-10\n        pl-lg-5 pr-lg-5 pb-lg-8\n        pl-md-5 pr-md-5 pb-md-8\n        pl-sm-8_p pr-sm-8_p pb-sm-7"},[_c('div',{staticClass:"cover",staticStyle:{"background-image":"url('https://images.prismic.io/monito/ca011fe5e686e44d279849ebc19f07b5e545e35f_paypal-homepage-laptop.png?auto=compress,format')"}}),_vm._v(" "),_c('h1',{staticClass:"f_title mt-5 mb-7 mt-2-sm mb-sm-6"},[_vm._v("Monito's review of "+_vm._s(_vm.provider.name)+" on their Exchange Rates & Fees Calculator")]),_vm._v(" "),_c('widget-author',{staticClass:"mb-2 mt-3"},[_c('div',{staticClass:"portrait"},[_c('span',{staticClass:"image",staticStyle:{"background-image":"url('https://images.prismic.io/monito/aef881966e4f5bbc8a5ffc79819720e3a733b1c9_laurent.png')"}}),_vm._v(" "),_c('p',{staticClass:"name pt-sm-2"},[_c('span',[_vm._v("Written by")]),_c('a',{attrs:{"href":"https://www.monito.com/en/wiki/why-you-can-trust-monito#section0?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=main_content"}},[_vm._v("Laurent Oberholzer")])]),_vm._v(" "),_c('p',{staticClass:"pb-sm-3 update"},[_c('span',[_vm._v("Last updated")]),_vm._v("May 11, 2020")])]),_vm._v(" "),_c('p',{staticClass:"bio mt-2 mb-2 ls-2 pl-sm-1 fw-medium mb-sm-3 f-anti"},[_vm._v("Co-Founder and Head of Business Development at Monito. He is a recognized expert with over six years of experience in the banking and money transfer industry.")])]),_vm._v(" "),_c('widget-breadcrum',[_c('a',[_vm._v("Home")]),_c('span',[_vm._v(">")]),_c('a',[_vm._v("Money Transfer Provider Reviews")]),_c('span',[_vm._v(">")]),_c('span',{staticClass:"active"},[_vm._v(_vm._s(_vm.provider.name)+" Review")])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("TransferWise is an innovative international money transfer provider that is often dubbed the “Robin Hood” of the money transfer industry.")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("They focus on making bank transfers more affordable than traditional banks by charging low and transparent transfer fees and converting money at the true mid-market exchange rate. ")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("In other words, there’s zero markup on the exchange rate. (As a comparison, banks usually give customers an above-market rate, the margin is part of their fees and in general, they are not transparent about this.)")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("TransferWise mobile apps have great ratings on Apple’s App Store (4.7/5 stars on 19,300 ratings) and Google’s Play Store (4.4/5 on almost 80,000 ratings). According to TransferWise customers, the app is \"an invaluable tool for anyone moving money internationally\".")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("They’ve seen massive growth since 2011 and are an extremely competitive, high-profile disruptor of the traditional money transfer model. TransferWise is frequently referred to as a no-nonsense company that is sparking a revolution.")]),_vm._v(" "),(_vm.scrollingActive)?_c('div',{staticClass:"friendly mt-8 mb-5"},[_c('h2',{staticClass:"fs-20 fw-bold"},[_vm._v("Our friendly recommendation")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3)]):_vm._e(),_vm._v(" "),_c('h2',{staticClass:"f_subtitle_2"},[_vm._v("What we like about TransferWise")]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('h2',{staticClass:"f_subtitle_2"},[_vm._v("What we dislike about TransferWise")]),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6)],1)]),_vm._v(" "),(_vm.scrollingActive)?_c('aside',[_c('div',{staticClass:"aside_widget monito_score pl-0 pr-0"},[_c('widget-monito-score',{attrs:{"provider":_vm.provider}})],1),_vm._v(" "),(false)?_c('monito-widgets-imt-search-form',{attrs:{"powered-by-nf":"off","country-from":"US","title":"It's a title","country-to":"PH"}}):_vm._e(),_vm._v(" "),(false)?_c('div',{staticClass:"aside_widget mt-4 mb-sm-0 pt-14 pl-14 pb-14 pr-14"},[_vm._m(7)]):_vm._e()],1):_vm._e()]),_vm._v(" "),_c('widget-detail-monito-score',{attrs:{"details_monito_score":_vm.details_monito_score,"details_trust":_vm.details_trust,"details_service":_vm.details_service,"details_customer":_vm.details_customer,"details_fees":_vm.details_fees,"provider":_vm.provider,"small_fees":_vm.small_fees,"small_customer":_vm.small_customer,"small_service":_vm.small_service,"small_trust":_vm.small_trust,"fees":_vm.fees,"customer":_vm.customer,"service":_vm.service,"trust":_vm.trust,"scrollingActive":_vm.scrollingActive}}),_vm._v(" "),(_vm.scrollingActive)?_c('div',{staticClass:"container_layout"},[_c('div',{staticClass:"left_content",staticStyle:{"vertical-align":"top"}},[_c('section',{ref:"anchor01",staticClass:"\n      boxed\n      pt-2 pl-7 pr-7 pb-10\n      pl-lg-5 pr-lg-5 pb-lg-8\n      pl-md-5 pr-md-5 pb-md-8\n      pl-sm-3 pr-sm-3 pb-sm-7\n      mb-5",attrs:{"id":"anchor01"}},[_c('div',{staticClass:"color"}),_vm._v(" "),_c('h2',{staticClass:"f_title mt-5 mb-7 mt-2-sm mb-sm-6"},[_vm._v("Trust & Credibility")]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.trust)}})]),_vm._v(" "),_c('section',{ref:"anchor02",staticClass:"\n      boxed\n      pt-2 pl-7 pr-7 pb-10\n      pl-lg-5 pr-lg-5 pb-lg-8\n      pl-md-5 pr-md-5 pb-md-8\n      pl-sm-3 pr-sm-3 pb-sm-7 \n      mt-5 mb-5",attrs:{"id":"anchor02"}},[_c('div',{staticClass:"color"}),_vm._v(" "),_c('h2',{staticClass:"f_title mt-5 mb-7 mt-2-sm mb-sm-6"},[_vm._v("Service Quality")]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.service)}})]),_vm._v(" "),_c('section',{ref:"anchor03",staticClass:"\n      boxed\n      pt-2 pl-7 pr-7 pb-10\n      pl-lg-5 pr-lg-5 pb-lg-8\n      pl-md-5 pr-md-5 pb-md-8\n      pl-sm-3 pr-sm-3 pb-sm-7 \n      mt-5 mb-5",attrs:{"id":"anchor03"}},[_c('div',{staticClass:"color"}),_vm._v(" "),_c('h2',{staticClass:"f_title mt-5 mb-7 mt-2-sm mb-sm-6"},[_vm._v("Customer satisfaction")]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.customer)}})]),_vm._v(" "),_c('section',{ref:"anchor04",staticClass:"\n      boxed\n      pt-2 pl-7 pr-7 pb-10\n      pl-lg-5 pr-lg-5 pb-lg-8\n      pl-md-5 pr-md-5 pb-md-8\n      pl-sm-3 pr-sm-3 pb-sm-7 \n      mt-5 mb-5",attrs:{"id":"anchor04"}},[_c('div',{staticClass:"color"}),_vm._v(" "),_c('h2',{staticClass:"f_title mt-5 mb-7 mt-2-sm mb-sm-6"},[_vm._v("Fees & Exchange rates")]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.fees)}})])]),_vm._v(" "),(_vm.scrollingActive)?_c('aside',[_c('div',{staticClass:"aside_widget monito_score mb-4 pl-0 pr-0"},[_c('widget-monito-score',{attrs:{"provider":_vm.provider}})],1)]):_vm._e()]):_vm._e(),_vm._v(" "),_c('widget-providers',{attrs:{"providers":_vm.providers}},[_c('div',{staticStyle:{"width":"900px","margin-left":"auto","margin-right":"auto"}},[_c('h1',{staticClass:"fs-28 lh-6 mb-1 mt-5\n    fs-sm-24 lh-sm-5  mb-sm-3 ls-sm-2\n  ",staticStyle:{"text-align":"center","margin-left":"auto","margin-right":"auto"}},[_vm._v("Alternatives to "+_vm._s(_vm.provider.name))]),_vm._v(" "),_c('span',{staticClass:"fs-19 italic fs-sm-17 fw-demi-bold f-anti",staticStyle:{"text-align":"center","margin-left":"auto","margin-right":"auto","opacity":"0.88","display":"block"}},[_vm._v("Make an informed decision by comparing all the best options")])])]),_vm._v(" "),_c('app-footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"should excellent"},[_c('p',[_c('span',[_vm._v("What you should do")]),_c('b',[_vm._v("Make sure it's the ideal provider for your transfer, make a comparison")]),_vm._v(" Most high-street banks won't allow you to open a bank account without a proof of residency, so we recommend going with the best online solution who will, like TranserWise Borderless account.")]),_vm._v(" "),_c('a',{staticClass:"btn_cta fw-bold f-anti f-19 ls-1",attrs:{"target":"_blank","rel":"noopener","href":"https://go.monito.com/transferwise-borderless?utm_campaign=ABTestBankUK_legacy&utm_source=internal&utm_medium=internal&utm_content=headerro_widget_cta&link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3Aukaccount%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com%252Fgb%252Fborderless%252F"}},[_vm._v("Compare the providers")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_chapo"},[_c('a',{attrs:{"target":"_blank","href":"https://go.monito.com/transferwise"}},[_vm._v("TransferWise")]),_vm._v(" is a great money transfer service recommended by Monito. With more than 7 million customers and 50,000 positive customer reviews, we rate them 9.8/10 on “Trust and Credibility”, 9.5/10 on “Service Quality”, 9.0/10 on “Customer Satisfaction” and 9.5 /10 on “Fees & Exchange rates”. ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_c('b',[_vm._v("TransferWise is great,")]),_vm._v(" but it's good to compare all the providers before each transfer.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Our magnificent comparison page")]),_vm._v(" is free and allows you to find the cheapest, fastest or highest ranked supplier for your needs in no time.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"f_body pros"},[_c('li',[_vm._v("You get the true mid-market rate")]),_vm._v(" "),_c('li',[_vm._v("Low and transparent transfer fees")]),_vm._v(" "),_c('li',[_vm._v("Fantastic user experience")]),_vm._v(" "),_c('li',[_vm._v("Exceptional customer reviews on Trustpilot")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"f_body cons"},[_c('li',[_vm._v("You can only send to a bank account")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_c('a',{attrs:{"target":"_blank","href":"https://www.monito.com/en/send-money-with/transferwise-borderless"}},[_vm._v("Click here to read our TransferWise Borderless Account & Card Review.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"should excellent"},[_c('p',[_c('span',[_vm._v("What you should do")]),_c('b',[_vm._v("Make sure it's the ideal provider for your transfer, make a comparison")]),_vm._v(" Most high-street banks won't allow you to open a bank account without a proof of residency, so we recommend going with the best online solution who will, like TranserWise Borderless account.")]),_vm._v(" "),_c('a',{staticClass:"btn_cta fw-bold f-anti f-19 ls-1",attrs:{"target":"_blank","rel":"noopener","href":"https://go.monito.com/transferwise-borderless?utm_campaign=ABTestBankUK_legacy&utm_source=internal&utm_medium=internal&utm_content=headerro_widget_cta&link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3Aukaccount%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com%252Fgb%252Fborderless%252F"}},[_vm._v("Compare the providers")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReviewWesternunion_vue__ = __webpack_require__(79);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4aaeb81a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReviewWesternunion_vue__ = __webpack_require__(248);
function injectStyle (ssrContext) {
  __webpack_require__(246)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReviewWesternunion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4aaeb81a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReviewWesternunion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(247);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("416458b4", content, true, {});

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "header .hero_element{margin-top:-202px!important;left:-2px}.bg-transition{display:none}main{display:flex;margin-top:-195px;position:relative;z-index:1000}aside{width:352px;flex-shrink:0;position:sticky}.container_layout{width:1200px;margin:0 auto;position:relative;display:flex;justify-content:space-between}.main_widget{display:inline-block;vertical-align:top}.monito_score.aside_widget{padding-left:0!important;padding-right:0!important}.scroller{width:352px;display:inline-block;box-sizing:border-box;vertical-align:top;position:sticky;right:0;top:50px}.cta_sticky{position:fixed;z-index:100000;top:-200px;width:100%;height:60px}.cta_sticky:before{width:1100px;left:calc(((1100px - 100vw) / 2) * -1);position:absolute;background:#fff;top:-182px;content:\"\";height:240px;box-shadow:0 3px 20px 0 rgba(0,0,0,.1);z-index:100;border-radius:150%/95%}.cta_sticky a{padding:22px 0;font-size:18px;width:80%;display:inline-block;position:relative;z-index:1000;text-align:center;margin-left:10%}.cta_sticky.active{animation-name:anim_cta_sticky;animation-duration:.7s;animation-fill-mode:forwards}.cta_sticky.remove{animation-name:anim_cta_sticky_remove;animation-duration:.7s;animation-fill-mode:forwards}@keyframes anim_cta_sticky{0%{position:fixed;top:-200px}to{position:fixed;top:0}}@keyframes anim_cta_sticky_remove{to{position:fixed;top:-200px}0%{position:fixed;top:0}}@media (max-width:990px){header .hero_element{margin-top:-142px!important}.article_content{display:none}body{width:100%;overflow:scrollY}.title{width:90%;margin-left:5%}.left_content,.title>div{width:100%!important}.left_content{margin-right:0!important}.left_content>section{width:92%;margin-left:4%;margin-right:4%}.container_layout{width:100%;display:block}main{width:100%}main header .hero_element{margin-top:-242px!important}}@media (max-width:990px) and (max-width:500px){main{display:block;margin-top:-112px}main .boxed{border-radius:12px}main .boxed .cover{border-radius:12px 12px 0 0}main .boxed h1{text-align:center}main .left_content,main aside{width:100%;display:block}main aside{position:relative!important;width:92%;top:0!important;margin-left:4%;margin-right:4%}}@media (max-width:990px){.scroller{width:90%;margin-left:5%;position:relative!important;top:0}}", ""]);

// exports


/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.scrollingActive)?_c('div',{staticClass:"cta_sticky"},[_c('a',{staticClass:"btn_cta fw-bold f-anti f-18 ls-1 mt-2",attrs:{"target":"_blank","rel":"noopener","href":"https://go.monito.com/transferwise-borderless?utm_campaign=ABTestBsankUK&utm_source=internal&utm_medium=internal&utm_content=hero_widget&link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3Aukaccount%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com%252Fgb%252Fborderless%252F"}},[_vm._v("Go to "+_vm._s(_vm.provider.name))])]):_vm._e(),_vm._v("s\n  "),_c('header',[_c('app-navigation',[_c('h1',{attrs:{"id":"logo_monito"}},[_c('a',{attrs:{"href":"https://monito.com?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=nav"}},[_vm._v("Monito")])]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"https://www.monito.com/en/about-monito?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=nav"}},[_vm._v("About us")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.monito.com/en/wiki/monito-account?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=nav"}},[_vm._v("Alerts")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.monito.com/en/wiki?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=nav"}},[_vm._v("Wiki")])]),_vm._v(" "),_c('li',{staticClass:"langage"},[_c('a',{attrs:{"href":"#"}},[_vm._v("EN")])])])]),_vm._v(" "),_c('app-hero-section',{attrs:{"urlBackground":_vm.urlBackground,"herotype":_vm.herotype}})],1),_vm._v(" "),_c('main',{ref:"main"},[(!_vm.scrollingActive)?_c('aside',{staticClass:"mb-4"},[_c('div',{staticClass:"aside_widget monito_score pl-0 pr-0"},[_c('widget-monito-score',{attrs:{"provider":_vm.provider}})],1),_vm._v(" "),(false)?_c('monito-widgets-imt-search-form',{attrs:{"powered-by-nf":"off","country-from":"US","title":"It's a title","country-to":"PH"}}):_vm._e(),_vm._v(" "),(false)?_c('div',{staticClass:"aside_widget mt-4 mb-sm-0 pt-14 pl-14 pb-14 pr-14"},[_vm._m(0)]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"left_content",staticStyle:{"display":"inline-block","margin-right":"26px","vertical-align":"top"}},[_c('section',{staticClass:"has-cover\n        boxed\n        pt-2 pl-7 pr-7 pb-10\n        pl-lg-5 pr-lg-5 pb-lg-8\n        pl-md-5 pr-md-5 pb-md-8\n        pl-sm-8_p pr-sm-8_p pb-sm-7"},[_c('div',{staticClass:"cover",staticStyle:{"background-image":"url('https://images.prismic.io/monito/e06dc4db6eb50335ccc4d13519b347b70d74f435_western-union-homepage-laptop.jpeg?auto=compress,format')"}}),_vm._v(" "),_c('h1',{staticClass:"f_title mt-5 mb-7 mt-2-sm mb-sm-6"},[_vm._v("Monito's review of "+_vm._s(_vm.provider.name)+" on their Exchange Rates & Fees Calculator")]),_vm._v(" "),_c('widget-author',{staticClass:"mb-2 mt-3"},[_c('div',{staticClass:"portrait"},[_c('span',{staticClass:"image",staticStyle:{"background-image":"url('https://images.prismic.io/monito/aef881966e4f5bbc8a5ffc79819720e3a733b1c9_laurent.png')"}}),_vm._v(" "),_c('p',{staticClass:"name pt-sm-2"},[_c('span',[_vm._v("Written by")]),_c('a',{attrs:{"href":"https://www.monito.com/en/wiki/why-you-can-trust-monito#section0?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=main_content"}},[_vm._v("Laurent Oberholzer")])]),_vm._v(" "),_c('p',{staticClass:"pb-sm-3 update"},[_c('span',[_vm._v("Last updated")]),_vm._v("May 11, 2020")])]),_vm._v(" "),_c('p',{staticClass:"bio mt-2 mb-2 ls-2 pl-sm-1 fw-medium mb-sm-3 f-anti"},[_vm._v("Co-Founder and Head of Business Development at Monito. He is a recognized expert with over six years of experience in the banking and money transfer industry.")])]),_vm._v(" "),_c('widget-breadcrum',[_c('a',[_vm._v("Home")]),_c('span',[_vm._v(">")]),_c('a',[_vm._v("Money Transfer Provider Reviews")]),_c('span',[_vm._v(">")]),_c('span',{staticClass:"active"},[_vm._v(_vm._s(_vm.provider.name)+" Review")])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("TransferWise is an innovative international money transfer provider that is often dubbed the “Robin Hood” of the money transfer industry.")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("They focus on making bank transfers more affordable than traditional banks by charging low and transparent transfer fees and converting money at the true mid-market exchange rate. ")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("In other words, there’s zero markup on the exchange rate. (As a comparison, banks usually give customers an above-market rate, the margin is part of their fees and in general, they are not transparent about this.)")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("TransferWise mobile apps have great ratings on Apple’s App Store (4.7/5 stars on 19,300 ratings) and Google’s Play Store (4.4/5 on almost 80,000 ratings). According to TransferWise customers, the app is \"an invaluable tool for anyone moving money internationally\".")]),_vm._v(" "),_c('p',{staticClass:"f_body"},[_vm._v("They’ve seen massive growth since 2011 and are an extremely competitive, high-profile disruptor of the traditional money transfer model. TransferWise is frequently referred to as a no-nonsense company that is sparking a revolution.")]),_vm._v(" "),(_vm.scrollingActive)?_c('div',{staticClass:"friendly mt-8 mb-5"},[_c('h2',{staticClass:"fs-20 fw-bold"},[_vm._v("Our friendly recommendation")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3)]):_vm._e(),_vm._v(" "),_c('h2',{staticClass:"f_subtitle_2"},[_vm._v("What we like about TransferWise")]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('h2',{staticClass:"f_subtitle_2"},[_vm._v("What we dislike about TransferWise")]),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6)],1)]),_vm._v(" "),(_vm.scrollingActive)?_c('aside',[_c('div',{staticClass:"aside_widget monito_score pl-0 pr-0"},[_c('widget-monito-score',{attrs:{"provider":_vm.provider}})],1),_vm._v(" "),(false)?_c('monito-widgets-imt-search-form',{attrs:{"powered-by-nf":"off","country-from":"US","title":"It's a title","country-to":"PH"}}):_vm._e(),_vm._v(" "),(false)?_c('div',{staticClass:"aside_widget mt-4 mb-sm-0 pt-14 pl-14 pb-14 pr-14"},[_vm._m(7)]):_vm._e()],1):_vm._e()]),_vm._v(" "),_c('widget-detail-monito-score',{attrs:{"details_monito_score":_vm.details_monito_score,"details_trust":_vm.details_trust,"details_service":_vm.details_service,"details_customer":_vm.details_customer,"details_fees":_vm.details_fees,"provider":_vm.provider,"small_fees":_vm.small_fees,"small_customer":_vm.small_customer,"small_service":_vm.small_service,"small_trust":_vm.small_trust,"fees":_vm.fees,"customer":_vm.customer,"service":_vm.service,"trust":_vm.trust,"scrollingActive":_vm.scrollingActive}}),_vm._v(" "),(_vm.scrollingActive)?_c('div',{staticClass:"container_layout"},[_c('div',{staticClass:"left_content",staticStyle:{"vertical-align":"top"}},[_c('section',{ref:"anchor01",staticClass:"\n      boxed\n      pt-2 pl-7 pr-7 pb-10\n      pl-lg-5 pr-lg-5 pb-lg-8\n      pl-md-5 pr-md-5 pb-md-8\n      pl-sm-3 pr-sm-3 pb-sm-7\n      mb-5",attrs:{"id":"anchor01"}},[_c('div',{staticClass:"color"}),_vm._v(" "),_c('h2',{staticClass:"f_title mt-5 mb-7 mt-2-sm mb-sm-6"},[_vm._v("Trust & Credibility")]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.trust)}})]),_vm._v(" "),_c('section',{ref:"anchor02",staticClass:"\n      boxed\n      pt-2 pl-7 pr-7 pb-10\n      pl-lg-5 pr-lg-5 pb-lg-8\n      pl-md-5 pr-md-5 pb-md-8\n      pl-sm-3 pr-sm-3 pb-sm-7 \n      mt-5 mb-5",attrs:{"id":"anchor02"}},[_c('div',{staticClass:"color"}),_vm._v(" "),_c('h2',{staticClass:"f_title mt-5 mb-7 mt-2-sm mb-sm-6"},[_vm._v("Service Quality")]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.service)}})]),_vm._v(" "),_c('section',{ref:"anchor03",staticClass:"\n      boxed\n      pt-2 pl-7 pr-7 pb-10\n      pl-lg-5 pr-lg-5 pb-lg-8\n      pl-md-5 pr-md-5 pb-md-8\n      pl-sm-3 pr-sm-3 pb-sm-7 \n      mt-5 mb-5",attrs:{"id":"anchor03"}},[_c('div',{staticClass:"color"}),_vm._v(" "),_c('h2',{staticClass:"f_title mt-5 mb-7 mt-2-sm mb-sm-6"},[_vm._v("Customer satisfaction")]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.customer)}})]),_vm._v(" "),_c('section',{ref:"anchor04",staticClass:"\n      boxed\n      pt-2 pl-7 pr-7 pb-10\n      pl-lg-5 pr-lg-5 pb-lg-8\n      pl-md-5 pr-md-5 pb-md-8\n      pl-sm-3 pr-sm-3 pb-sm-7 \n      mt-5 mb-5",attrs:{"id":"anchor04"}},[_c('div',{staticClass:"color"}),_vm._v(" "),_c('h2',{staticClass:"f_title mt-5 mb-7 mt-2-sm mb-sm-6"},[_vm._v("Fees & Exchange rates")]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.fees)}})])]),_vm._v(" "),(_vm.scrollingActive)?_c('aside',[_c('div',{staticClass:"aside_widget monito_score mb-4 pl-0 pr-0"},[_c('widget-monito-score',{attrs:{"provider":_vm.provider}})],1)]):_vm._e()]):_vm._e(),_vm._v(" "),_c('widget-providers',{attrs:{"providers":_vm.providers}},[_c('div',{staticStyle:{"width":"900px","margin-left":"auto","margin-right":"auto"}},[_c('h1',{staticClass:"fs-28 lh-6 mb-1 mt-5\n    fs-sm-24 lh-sm-5  mb-sm-3 ls-sm-2\n  ",staticStyle:{"text-align":"center","margin-left":"auto","margin-right":"auto"}},[_vm._v("Alternatives to "+_vm._s(_vm.provider.name))]),_vm._v(" "),_c('span',{staticClass:"fs-19 italic fs-sm-17 fw-demi-bold f-anti",staticStyle:{"text-align":"center","margin-left":"auto","margin-right":"auto","opacity":"0.88","display":"block"}},[_vm._v("Make an informed decision by comparing all the best options")])])]),_vm._v(" "),_c('app-footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"should excellent"},[_c('p',[_c('span',[_vm._v("What you should do")]),_c('b',[_vm._v("Make sure it's the ideal provider for your transfer, make a comparison")]),_vm._v(" Most high-street banks won't allow you to open a bank account without a proof of residency, so we recommend going with the best online solution who will, like TranserWise Borderless account.")]),_vm._v(" "),_c('a',{staticClass:"btn_cta fw-bold f-anti f-19 ls-1",attrs:{"target":"_blank","rel":"noopener","href":"https://go.monito.com/transferwise-borderless?utm_campaign=ABTestBankUK_legacy&utm_source=internal&utm_medium=internal&utm_content=headerro_widget_cta&link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3Aukaccount%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com%252Fgb%252Fborderless%252F"}},[_vm._v("Compare the providers")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_chapo"},[_c('a',{attrs:{"target":"_blank","href":"https://go.monito.com/transferwise"}},[_vm._v("TransferWise")]),_vm._v(" is a great money transfer service recommended by Monito. With more than 7 million customers and 50,000 positive customer reviews, we rate them 9.8/10 on “Trust and Credibility”, 9.5/10 on “Service Quality”, 9.0/10 on “Customer Satisfaction” and 9.5 /10 on “Fees & Exchange rates”. ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_c('b',[_vm._v("TransferWise is great,")]),_vm._v(" but it's good to compare all the providers before each transfer.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Our magnificent comparison page")]),_vm._v(" is free and allows you to find the cheapest, fastest or highest ranked supplier for your needs in no time.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"f_body pros"},[_c('li',[_vm._v("You get the true mid-market rate")]),_vm._v(" "),_c('li',[_vm._v("Low and transparent transfer fees")]),_vm._v(" "),_c('li',[_vm._v("Fantastic user experience")]),_vm._v(" "),_c('li',[_vm._v("Exceptional customer reviews on Trustpilot")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"f_body cons"},[_c('li',[_vm._v("You can only send to a bank account")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"f_body"},[_c('a',{attrs:{"target":"_blank","href":"https://www.monito.com/en/send-money-with/transferwise-borderless"}},[_vm._v("Click here to read our TransferWise Borderless Account & Card Review.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"should excellent"},[_c('p',[_c('span',[_vm._v("What you should do")]),_c('b',[_vm._v("Make sure it's the ideal provider for your transfer, make a comparison")]),_vm._v(" Most high-street banks won't allow you to open a bank account without a proof of residency, so we recommend going with the best online solution who will, like TranserWise Borderless account.")]),_vm._v(" "),_c('a',{staticClass:"btn_cta fw-bold f-anti f-19 ls-1",attrs:{"target":"_blank","rel":"noopener","href":"https://go.monito.com/transferwise-borderless?utm_campaign=ABTestBankUK_legacy&utm_source=internal&utm_medium=internal&utm_content=headerro_widget_cta&link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3Aukaccount%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com%252Fgb%252Fborderless%252F"}},[_vm._v("Compare the providers")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatedContent_vue__ = __webpack_require__(80);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c1b036f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelatedContent_vue__ = __webpack_require__(252);
function injectStyle (ssrContext) {
  __webpack_require__(250)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatedContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c1b036f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelatedContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(251);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("fb1db0c6", content, true, {});

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "body{background:#f8f8f8;font-family:Avenir Next,-apple-system,system-ui,Segoe UI,Roboto,Ubuntu,Cantarell,Noto Sans,sans-serif;box-sizing:border-box;color:#353c45;max-width:100vw;margin:0}body,main{position:relative}main{z-index:10000}.scroller{width:352px;box-sizing:border-box;position:absolute;right:0;top:0}@media (max-width:768px){body{overflow:scrollY}body,main{width:100%}main h1{text-align:center}.scroller{display:none}}", ""]);

// exports


/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('widget-articles',{attrs:{"articles":_vm.articles}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js